{
  "en": {
    " Identifikátor propojení obchodu ": " Shop connection identifier ",
    " pacientů. Přidáním tohoto pacienta tuto kapacitu překročíte.": " clients. Adding this client will exceed this capacity.",
    ":companyWorkspaceId/pridat-pojistovnu": ":companyWorkspaceId/add-insurance",
    ":companyWorkspaceId/upravit": ":companyWorkspaceId/edit",
    ":companyWorkspaceId/upravit-pojistovnu/:insuranceContractId": ":companyWorkspaceId/edit-insurance/:insuranceContractId",
    ":insuranceApplicantId/upravit": ":insuranceApplicantId/edit",
    ":patientId/popisy-navstev": ":patientId/appointment-descriptions",
    ":serviceGroupId/upravit": ":serviceGroupId/edit",
    ":serviceId/upravit": ":serviceId/edit",
    ":stockItemId/upravit": ":stockItemId/edit",
    ":supplierId/upravit": ":supplierId/edit",
    ":userId/ordinacni-hodiny": ":userId/office-hours",
    ":userId/upravit": ":userId/edit",
    ". Před návštěvou se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": ". Before your visit, please familiarize yourself with our GDPR policy. To view the GDPR details and provide your confirmation, click",
    "(obsazeno)": "(occupied)",
    "(Přišli poprvé)": "(They came for the first time)",
    "@": "@",
    "/akce": "/actions",
    "/cekajici-pacienti": "/waiting-clients",
    "/cviky": "/exercises",
    "/domu": "/home",
    "/historie-akci": "/history-events",
    "/historie-zprav": "/messages-history",
    "/kalendar": "/calendar",
    "/moje-navstevy": "/my-appointments",
    "/moje-profily": "/my-profiles",
    "/moje-udaje": "/my-details",
    "/nastaveni": "/settings",
    "/novinky": "/news",
    "/ordinace": "/office",
    "/pacienti": "/clients",
    "/pacienti/novy": "/clients/new",
    "/platba": "/payment",
    "/platby": "/payments",
    "/pojistovny": "/insurances",
    "/predplatne": "/subscription",
    "/profil": "/profile",
    "/provedene-akce": "/history-events",
    "/pruvodce/": "/guide/",
    "/recenze": "/reviews",
    "/rozcestnik-pruvodce/": "/guide-index/",
    "/rozsireni-kartoteky-zdarma": "/expand-registry-free",
    "/sablony": "/templates",
    "/sklad": "/storage",
    "/skupinove-navstevy/": "/group-appointments/",
    "/soubory": "/files",
    "/statistiky": "/statistics",
    "%": "%",
    "• E-mail: ": "• E-mail: ",
    "• IČO": "• Company ID",
    "+420 315 315 817": "+420 315 315 817",
    "<div>Dobrý den,</div><br/>v příloze zasíláme rozpis termínů fyzioterapie.": "<div>Good day,</div><br/>attached we are sending schedule of therapies sessions.",
    "<div>Dobrý den,</div><br/>v příloze zasíláme zprávu z provedené terapie.": "<div>Good day,</div><br/>attached we are sending the medical report from the performed therapy.",
    "1. čvrtletí": "1. quarter",
    "2. čtvrtletí": "2nd quarter",
    "3 - Úraz způsobený jinou osobou": "3 - Injury caused by another person",
    "3. čtvrtletí": "3rd quarter",
    "4 - Alkohol a omamné látky": "4 - Alcohol and drugs",
    "4. čvrtletí": "4th quarter",
    "5 - Pracovní úraz": "5 - Occupational injury",
    "6 - Sociální důvody hospitalizace": "6 - Social reasons for hospitalization",
    "60 pacientů": "60 clients",
    "7 - Porušení léčebného režimu": "7 - Violation of treatment regimen",
    "8 - Výměna komponent systému ASR_TM": "8 - Replacement of ASR_TM system components",
    "9 - Nemoc z povolání": "9 - Occupational disease",
    "A ROZŠIŘTE SI KARTOTÉKU": "EXPAND YOUR CARD_INDEX",
    "a zaplatit": "Pay",
    "Absolutní": "Flat",
    "Absolutní storno poplatek": "Flat cancellation fee",
    "Admin": "Admin",
    "Admin má neomezený přístup ke všem funkcím v rámci zvoleného tarifu": "Admin has unlimited access to all features within the selected plan",
    "Adresa": "Address",
    "Adresa sídla": "Headquarters address",
    "Adresa:": "Address:",
    "Adresát": "Recipient",
    "Adresu ukládejte ve formátu: Ulice č.p, Město, PSČ": "Save the address in the format: Street no., City, ZIP",
    "Akce": "Action",
    "Aktivace a dostupnost": "Activation and availability",
    "Aktivací zpřístupníte klientský portál. Po naplánování návštěvy nového klienta nebo rezervace klient automaticky obdrží pozvánku do klientského portálu.": "Enabling this makes the client portal available. When a visit for a new client or a reservation is scheduled, the client automatically receives an invitation to the client portal.",
    "Aktivní profil byl změněn": "Active profile has been changed",
    "Aktivní tarif": "Active plan",
    "Aktivovat cesty za pacienty": "Activate home visits",
    "aktualizujte": "Update",
    "Aktuální prostředí:": "Current environment:",
    "anamneza": "anamnesis",
    "Anamnéza": "Anamnesis",
    "Anamnéza zatím nebyla vyplněna.": "Medical history has not been filled in yet.",
    "Anamnézu se nepodařilo načíst": "The medical history could not be loaded.",
    "Anamnézu se nepodařilo uložit": "The medical history could not be saved.",
    "Anamnézy": "Anamneses",
    "Ano": "Yes",
    "API URL:": "API URL:",
    "aplikaci Fyzion na sociálních sítích nebo kdekoliv na webu.": "Use Fyzion app on social networks or anywhere on the web.",
    "Aplikovat na všechny termíny": "Apply to all appointments",
    "Aplikovat změny na toto a všechna budoucí volna": "Apply changes to this and all future availability",
    "Aplikovat změny na tuto a všechny budoucí návštěvy": "Apply changes to this and all future appointments",
    "Aplikovat změny na tuto a všechny budoucí skupinové návštěvy": "Apply changes to this and all future group appointments",
    "Aplikovat změny pouze na toto volno": "Apply changes only for this availability",
    "Aplikovat změny pouze na tuto návštěvu": "Apply changes only for this appointment",
    "Aplikovat změny pouze na tuto skupinovou návštěvu": "Apply changes only to this group appointment",
    "Archivace": "Archiving",
    "Archivovat": "Archive",
    "Automaticky kontaktovat náhradníky při smazání rezervace (pouze pro skupinové návštěvy)": "Automatically contact substitutes when a booking is deleted (group appointments only)",
    "Automaticky odešle klientovi informaci o vytvoření, změně či zrušení návštěvy.": "Automatically sends the client information about the creation, change, or cancellation of the visit.",
    "Automaticky odešle klientovi připomínkovou SMS se zvolenými údaji v Nastavení. Zpráva se odesílá v časovém předstihu podle nastavení, vždy v 9 hodin ráno.": "Automatically sends the client a reminder SMS with the details selected in Settings. The message is sent in advance according to the settings, always at 9 a.m.",
    "Automaticky odešle klientovi připomínku e-mailem s datem a časem návštěvy. Zpráva se odesílá v časovém předstihu podle nastavení, vždy v 9 hodin ráno.": "Automatically sends the client an e-mail reminder with the date and time of the appointment. The message is sent in advance according to the settings, always at 9 a.m.",
    "Automaticky použít permanentku k úhradě návštěvy": "Automatically use a season ticket to pay for the appointment",
    "Balíček zdarma je v základním nastavení limitován počtem pacientů, které je možné mít v kartotéce, na 20. V případě, že jste dosáhli limitu, máte možnost tento limit navýšit až na": "Free package is limited to a maximum of 20 clients in the database by default. If you reach this limit, you have the option to increase this limit up to",
    "Bankovní údaje": "Bank details",
    "Barva": "Color",
    "Barva místnosti": "Room colour",
    "Barva místnosti v kalendáři": "Room color in calendar",
    "Barva služby": "Service colour",
    "Barva terapeuta": "Therapist colour",
    "Barva v kalendáři": "Color in the calendar",
    "barvy-kalendare": "/calendar-colours",
    "Bederní": "Lumbar",
    "Beru na vědomí": "I acknowledge",
    "bezchybně a rychle": "Flawlessly and quickly",
    "bezhotovostně": "cashless",
    "Bezplatná registrace": "Free registration",
    "Bezplatné přesunutí (před návštěvou)": "Free reschedule (before the appointment)",
    "Bezplatné zrušení (před návštěvou)": "Free cancellation (before the appointment)",
    "Bezplatné zrušení nejpozději": "Free cancellation no later than",
    "Blok do kalendáře": "Calendar block",
    "Blok do kalendáře zamezující rezervaci": "Calendar block preventing booking",
    "Bodů": "Points",
    "Bodů celkem": "Total points",
    "Body": "Points",
    "Body:": "Points:",
    "Bude použito i pro variabilní symbol": "Will also be used as the variable symbol",
    "Budeme vás kontaktovat e-mailem nebo telefonicky, pokud se uvolní místo": "We will contact you by e-mail or phone if a place becomes available",
    "Budoucí návštěvy": "Future appointments",
    "Čas": "Time",
    "Čas byl úspěšně vybrán. Vyberte ještě": "Time was successfully selected. Please select another",
    "Čas do je povinný": "Time to is mandatory",
    "Čas od je povinný": "Time from is required",
    "Čas:": "Time:",
    "Časové okno pro rezervace": "Booking time window",
    "Časové okno pro rezervaci hromadných termínů": "Time window for bulk appointment booking",
    "Časový interval před návštěvou, během kterého může klient rezervaci bezplatně přesunout.": "Time interval before the appointment during which the client can reschedule for free.",
    "Časový interval před návštěvou, během kterého může klient rezervaci zrušit bez poplatku.": "Time interval before the appointment during which the client can cancel free of charge.",
    "Časový interval před návštěvou, kdy je možné rezervaci zrušit, ale se storno poplatkem.": "Time interval before the appointment when the booking can be cancelled but a cancellation fee applies.",
    "Částka": "Amount",
    "Částka bude vypočítána jako celková cena všech položek.": "The amount will be calculated as the total price of all items.",
    "Částka k úhradě": "Amount to pay",
    "Částka nesmí být vyšší než cena návštěvy": "Amount cannot be higher than the visit price",
    "Čeká na autorizaci": "Awaiting authorisation",
    "Čeká na platbu": "Awaiting payment",
    "Čeká na zaplacení": "Waiting for payment",
    "Čekající": "Pending clients",
    "Čekající pacienti": "Pending clients",
    "Čekající:": "Waiting:",
    "Celkem": "Total",
    "Celkem k úhradě": "Total to pay",
    "Celkem náhradníků:": "Total substitutes:",
    "Celkem návštěv:": "Total appointments:",
    "Celkový čas návštěvy klienta. Tato doba se zobrazuje klientovi v potvrzení rezervace a v pozvánce.": "Total duration of the client appointment. This time is shown to the client in the booking confirmation and invitation.",
    "Celkový časový blok rezervovaný v kalendáři pro tuto službu. Zahrnuje čas pro pacienta i navazující činnosti (administrativa, úklid, hygienická pauza apod.).": "Total time block reserved in the calendar for this service. Includes time for the client and follow-up activities (administration, cleaning, hygiene break, etc.).",
    "Celkový počet odeslaných SMS": "Total number of SMS messages sent",
    "Celý den": "All day",
    "Cena": "Price",
    "Cena celkem": "Total price",
    "Cena nemůže být nižší než 0": "Price cannot be lower than 0",
    "Cena nesmí být záporná": "Price cannot be negative",
    "Cena permanentky": "Season ticket price",
    "Cena s DPH": "Price with VAT",
    "Cena služby.": "Service price.",
    "Cena za MJ": "Price per unit",
    "Cena:": "Price:",
    "Certifikát": "Certificate",
    "Červená": "Red",
    "Cestovní zdravotní pojištění": "Travel health insurance",
    "Četl/a jsem a souhlasím se": "I have read and agree",
    "Chápeme, že nyní není vhodný čas, k průvodci se můžete kdykoliv vrátit, případně využít tipy a nápovědu.": "We understand that now may not be the right time; you can return to the guide anytime, or use the tips and help.",
    "Charakter": "Character",
    "Charakter dávky": "Batch nature",
    "Chcete pokračovat v zadání návštěvy:": "Do you want to continue with scheduling the appointment:",
    "Chcete-li vytvořit rezervaci nebo spravovat své termíny, přihlaste se ke svému účtu.": "To make a booking or manage your appointments, please log in to your account.",
    "Chci naplánovat": "I want to plan",
    "chyba": "error",
    "Chyba při přesměrování na registraci náhradníka": "Error while redirecting to substitute registration",
    "Cíl": "Destination",
    "Čísla dokladů v dávce od": "Document numbers in batch from",
    "Čísla faktur": "Invoice numbers",
    "Číslo": "Number",
    "Číslo bez lomítka": "Number without slash",
    "Číslo dávky": "Batch number",
    "Číslo dokladu": "Document number",
    "Číslo pojištěnce": "Insured person number",
    "Číslo pojištěnce nemusí být správné": "The policyholder number does not have to be correct",
    "Číslo pojištěnce:": "Insured person number:",
    "Číslo pojišťenec": "Insured person number",
    "Číslo účtu": "Account number",
    "Číslování dokladů": "Document numbering",
    "Číslovat dávky od": "Number doses from",
    "Číslovat faktury od": "Number invoices from",
    "Číslovat paragony od": "Number receipts from",
    "Číst více": "Read more",
    "client photo": "client photo",
    "Co je nového?": "What's new?",
    "CS": "CS",
    "Čtvrtek": "Thursday",
    "Čtvrtletí": "Quarters",
    "Čtvrtletní": "Quarterly",
    "cvik": "exercise",
    "Cvik": "Exercise",
    "cviků": "exercises",
    "cviky": "exercises",
    "Cviky": "Exercises",
    "Cviky na vybraný den": "Exercises for the selected day",
    "Další akce": "Another action",
    "Další krok postupu": "The next step of the procedure",
    "Další položka": "Another item",
    "Další propojení dostupné pouze při": "Additional integrations available only with",
    "Další štítky": "Other labels",
    "Další výkon": "Another performance",
    "Data se načítají...": "Loading data...",
    "Datum": "Date",
    "Datum a čas": "Date and time",
    "Datum expirace": "Expiry date",
    "Datum inventury": "Inventory date",
    "Datum je povinné": "Date is required",
    "Datum narození": "Date of birth",
    "Datum narození:": "Date of birth:",
    "Datum naskladnění": "Loading date",
    "Datum návštěvy": "Appointment date",
    "Datum platnosti budoucí ceny nemůže být v minulosti.": "The future price valid-from date cannot be in the past.",
    "Datum splatnosti:": "Due date:",
    "Datum transakce": "Transaction date",
    "Datum vystavení": "Issue date",
    "Datum začátku cvičení": "Exercise start date",
    "Datum zaplacení": "Payment date",
    "Datum zdanitelného plnění": "Taxable supply date",
    "Datum změny pojištění:": "Insurance change date:",
    "Datum změny pojišťovny": "Insurer's date of change",
    "Datum:": "Date:",
    "Dávek na stránku": "Page views",
    "DÁVKA POUKAZŮ NA VYŠETŘENÍ/OŠETŘENÍ SMÍŠENÁ": "MIXED BATCH OF EXAMINATION/TREATMENT VOUCHERS",
    "DÁVKA VYÚČTOVÁNÍ CEST V NÁVŠTĚVNÍ SLUŽBĚ": "BATCH OF HOME VISIT TRAVEL BILLING",
    "DÁVKA VYÚČTOVÁNÍ VÝKONŮ V AMBULANTNÍ PÉČI": "BATCH OF AMBULATORY CARE PERFORMANCE BILLING",
    "Dávku elektronicky podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "You sign the batch electronically in the Fyzion Signer app and Fyzion then sends it to the health insurance company.",
    "Dávku lze elektronicky odeslat přímo zdravotní pojišťovně, s podpisem certifikátem nebo s ověřením SMS kódem.": "The batch can be sent electronically straight to the health insurance company, signed with a certificate or authorised with an SMS code.",
    "Dávku se nepodařilo vytvořit": "Reservation could not be cancelled",
    "davky": "benefits",
    "Dávky": "Benefits",
    "Dávky jsme zařadili k odeslání pojišťovně. O výsledku vás budeme informovat e-mailem.": "We have queued the batches for sending to the insurance company. We will notify you of the result by e-mail.",
    "Dávky nemůžeme vytvořit, protože jsme nenašli žádné výkony. Změňte výběr období, pojišťoven nebo pracoviště.": "We cannot create benefits because we have not found any performances. Change the selection of period, insurance companies or workplace.",
    "Dávky vytvořeny": "Batches created",
    "DD.MM.RRRR": "DD.MM.YYYY",
    "Deaktivovat": "Deactivate",
    "Deaktivovat terapeuta": "Deactivate user",
    "dekujeme": "thankyou",
    "Děkujeme za vaší recenzi!": "Thank you for your review!",
    "Děkujeme!": "Thank you!",
    "Děkujeme! Souhlas s GDPR byl úspěšně potvrzen.": "Thank you! GDPR consent has been successfully confirmed.",
    "Délka (min.)": "Duration (min.)",
    "den": "day",
    "Den": "Day",
    "Denně": "Daily",
    "detail": "detail",
    "Detail následující návštěvy": "Detail of the following appointment",
    "Detail návštěvy": "Appointment detail",
    "Detail poslední návštěvy": "Last appointment detail",
    "Detail registrace náhradníka": "Substitute registration detail",
    "Detail rezervace": "Reservation detail",
    "Detail vybraného profilu": "Selected profile detail",
    "Diagnóza": "Diagnosis",
    "Diagnózy": "Diagnoses",
    "DIČ": "VAT Number/Tax ID",
    "dne": "on",
    "Dne": "On",
    "Dnes": "Today",
    "dní": "days",
    "dnů": "days",
    "dny": "days",
    "Dny": "Days",
    "do": "to",
    "Do": "To",
    "Do karty pacienta nebyly zatím nahrány žádné formuláře.": "No forms have been uploaded to the client's record yet.",
    "Do karty pacienta nebyly zatím nahrány žádné fotografie.": "No photos have been uploaded to the client's record yet.",
    "Do průvodce": "To the guide",
    "Doba splatnosti": "Due date",
    "Doba trvání": "Duration",
    "Doba trvání pro pacienty": "Duration for clients",
    "Doba trvání:": "Duration:",
    "Dobrý den": "All day",
    "Dodavatel": "Supplier",
    "Dodavatel byl úspěšně smazán": "Supplier was successfully deleted",
    "Dodavatel byl úspěšně upraven": "The reservation has been successfully created.",
    "Dodavatel byl úspěšně vytvořen": "The reservation has been successfully created.",
    "dodavatele": "Suppliers",
    "Dodavatelé": "Suppliers",
    "Dodavatele se nepodařilo smazat": "Reservation could not be cancelled",
    "Dodavatele se nepodařilo upravit": "Reservation could not be cancelled",
    "Dojde k odstranění následujících místností navázaných na tuto pobočku:": "The following rooms linked to this branch will be removed:",
    "Doklady": "Documents",
    "Dokončeno": "Completed",
    "Dokončit odeslání": "Finish sending",
    "Dokončit odeslání dávky": "Finish sending the batch",
    "Dokončit odeslání dávky č. %{number} pro pojišťovnu %{insurance}?": "Finish sending batch no. %{number} for insurance company %{insurance}?",
    "Dokument byl úspěšně nahrán a odeslán": "The document was successfully uploaded and sent",
    "Dokumenty": "Documents",
    "Doplňková služba": "Additional service",
    "dopředu": "in advance",
    "Dosáhli jste maximálního počtu pacientů v kartotéce. ": "You have reached the maximum number of clients in the record.",
    "Dosažen limit SMS": "SMS limit reached",
    "Dosažení maximálního počtu pacientů": "Achieving maximum number of clients",
    "Dotazník": "Questionnaire",
    "Dotazník pro klienta": "Client questionnaire",
    "Dotazník pro klienta (dotazník uvidí klient v klientské sekci, kde ho může vyplnit)": "Client questionnaire (the client will see the questionnaire in the client section, where they can fill it in)",
    "Dotazník pro pacienta": "Client questionnaire",
    "Dotazník uvidí klient v klientské sekci, kde ho může vyplnit": "The client will see the questionnaire in the client section where they can fill it in",
    "Dotazovat se klientů na souhlas se zasíláním novinek v rezervačním systému": "Ask clients for consent to receive news in the booking system",
    "DPH": "VAT",
    "DPH%": "VAT%",
    "Druh péče": "Care type",
    "Druh péče:": "Type of care:",
    "Druh úhrady": "Payment type",
    "Druh úhrady:": "Payment type:",
    "Duplikovat": "Duplicate",
    "E-mail": "E-mail",
    "E-mail se nepodařilo odeslat.": "Reservation could not be cancelled",
    "E-mail úspěšně odeslán": "E-mail successfully sent",
    "E-mailová adresa": "Email address",
    "E-mailová adresa:": "Email address:",
    "Editace údajů pacienta": "Editing client data",
    "Email": "E-mail",
    "Email byl úspěšně poslán": "E-mail successfully sent",
    "Email klientům": "Email to clients",
    "Email odeslán": "E-mail sent",
    "Email pro faktury": "Email for invoices",
    "Emailová adresa": "Email address",
    "EN": "EN",
    "Export bude vygenerován a zaslán na e-mail": "Export will be generated and sent to email",
    "Export transakcí": "Export transactions",
    "Exportovat": "Export",
    "Exportovat data": "Export data",
    "Exportovat ISDOC": "Export ISDOC",
    "Exportovat PDF": "Export PDF",
    "Exportovat platby": "Export payments",
    "Exportovat výkony": "Export",
    "Faktura": "Invoice",
    "Faktura bude vygenerována a zaslána na e-mail": "Invoice will be generated and sent to email",
    "Faktura byla označena jako zaplacená": "Invoice was marked as paid",
    "Fakturace": "Invoicing",
    "Fakturace byla označena jako zaplacená": "Invoice was marked as paid",
    "Fakturace úspěšně přidána": "Invoice successfully added",
    "Fakturace úspěšně upravena": "Invoice successfully updated",
    "Fakturace za období": "Invoicing for period",
    "Fakturace za období:": "Invoicing for period:",
    "Fakturační údaje": "Billing details",
    "fakturacni-udaje": "billing-information",
    "Fakturováno": "Invoiced",
    "fakturu č.": "invoice no.",
    "faktury": "invoices",
    "Faktury": "Invoices",
    "Filtrovat": "Filter",
    "Filtrovat pacienty": "Filter clients",
    "Filtrujte cviky podle jména": "Filter exercises by name",
    "finance": "finance",
    "Finance": "Finance",
    "firemni-udaje": "billing-information",
    "flag": "flag",
    "Formulář úspěšně nahrán": "Form successfully uploaded",
    "Formuláře se nepodařilo načíst": "The forms could not be loaded",
    "Fotka FT poukazu": "FT photo voucher",
    "Fotka FT poukazu byla úspěšně nahrána": "FT voucher photo has been successfully uploaded",
    "Fotku obrazovky s Vaším sdílením": "Screenshot with your sharing",
    "Fotky": "Photos",
    "Fotogalerie": "Photo Gallery",
    "fotografie": "photos",
    "Fotografie se nepodařilo načíst.": "The photograph failed to load.",
    "Fotografie se zobrazí na veřejné stránce v sekci zaměstnanci": "The photo will be shown on the public page in the staff section",
    "Fotografie smazána": "Photo deleted",
    "Fotografie úspěšně nahrána": "Photo successfully uploaded",
    "Fotografie ze dne": "Photos from day",
    "FT poukaz": "FT voucher",
    "FT Poukaz": "FT Voucher",
    "FT poukaz byl úspěšně vytvořen": "FT voucher was successfully created",
    "FT poukaz není možné vytvořit. Zkontrolujte, jestli je vše správně vyplněno na kartě pacienta.": "FT voucher cannot be created. Please check if everything is filled in correctly on the client card.",
    "FT poukaz úspěšně smazán": "FT voucher successfully deleted",
    "FT poukaz úspěšně upraven": "FT voucher successfully updated",
    "FT poukazy": "FT vouchers",
    "Funkce pro větší instituce, se kterými spolupracujete. Mohou u vás mít „kredit“ a čerpat ho za vaše služby.": "A feature for larger institutions you work with. They can have a “credit” with you and use it for your services.",
    "Fyzion – moderní software pro fyzioterapii": "Fyzion – modern software for physiotherapy",
    "Fyzion funguje": "Physion works",
    "Fyzion premium function": "Fyzion premium function",
    "Fyzion running away": "Fyzion running away",
    "fyzion-faktura.pdf": "fyzion-invoice.pdf",
    "fyzion-zalohova-faktura.pdf": "fyzion-backup-invoice.pdf",
    "Fyzioterapeut": "Therapist",
    "Fyzioterapeut a místnost": "Therapist and room",
    "Fyzioterapeut je povinný": "Therapist is mandatory",
    "Fyzioterapeut nemá vyplněné ordinační hodiny": "Therapist has no office hours filled",
    "Fyzioterapeut:": "Therapist:",
    "fyzioterapeuti": "Therapists",
    "Fyzioterapeuti": "Therapists",
    "Fyzioterapeuti úspěšně resetováni podle diagnózy": "Therapists successfully reset according to diagnosis",
    "GDPR": "GDPR",
    "GDPR souhlas": "GDPR consent",
    "GDPR úspěšně potvrzeno.": "GDPR successfully confirmed.",
    "GDPR:": "GDPR:",
    "Generováno": "Generated",
    "Generuji PDF pro tisk…": "Generating PDF for print…",
    "Google kalendář": "Google calendar",
    "Hesla se neshodují": "Passwords do not match",
    "Heslo": "Password",
    "Heslo bylo úspěšně nastaveno": "Password has been set successfully",
    "Heslo bylo úspěšně změněno": "The password has been successfully changed",
    "Heslo bylo úspěšně změněno. Přihlaste se prosím znovu novým heslem.": "Your password has been changed. Please log in again with your new password.",
    "Heslo musí obsahovat minimálně 8 znaků a alespoň 1 číslici.": "The password must contain at least 8 characters and at least 1 digit.",
    "Historie akcí": "Action history",
    "Historie akcí, odeslané zprávy.": "Action history, sent messages.",
    "Historie cvičení": "Exercise history",
    "Historie emailů a SMS": "History of emails and SMS",
    "Historie návštěv": "Appointment history",
    "Historie rezervací": "Booking history",
    "historie-akci": "/history-events",
    "Hledanému výrazu neodpovídá žádná diagnóza": "No diagnosis found for the searched term",
    "Hledanému výrazu neodpovídá žádné pracoviště": "No location matches the search term",
    "Hledanému výrazu neodpovídá žádný pacient": "No client matches the given expression",
    "Hledanému výrazu neodpovídá žádný poukaz": "No voucher matches the search term",
    "Hledanému výrazu neodpovídá žádný výkon": "No results found for the given query",
    "Hledat klienta": "Search for a client",
    "Hledat...": "Search...",
    "hod": "hr",
    "hodin": "hours",
    "hodinu": "hour",
    "hodiny": "hours",
    "Hodnota bodu": "Point value",
    "Hodnota bodu:": "Point value:",
    "Hotově": "Cash",
    "Hotovo": "Done",
    "Hromadné odeslání dávek pojišťovně selhalo": "Bulk sending of batches to the insurance company failed",
    "Hrudní": "Thoracic",
    "HTML kód na web": "HTML code for website",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Podminky_ochrany_osobnich_udaju.pdf": "https://fyzion.cz/ochrana-osobnich-udaju/",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Vseobbecne_obchodni_podminky_edit_2025_v2.pdf": "https://fyzion.cz/vop/",
    "https://fyzion.cz/cs/sdilejte-nas-a-rozsirte-si-kartoteku-zdarma/": "https://fyzion.cz/en/share-us-and-expand-your-database-for-free/",
    "https://fyzion.cz/cs/webinar/": "https://fyzion.cz/en/webinar/",
    "https://fyzion.cz/navod-pojistovny": "https://fyzion.cz/insurance-guide",
    "https://fyzion.cz/navod-purobot": "https://fyzion.cz/navod-purobot",
    "https://kb.fyzion.cz/cs/": "https://kb.fyzion.cz/cs/",
    "https://kb.fyzion.cz/cs/article/databaze-cviku-a-jak-je-poslat-pacientovi-ue0fjk/": "https://kb.fyzion.cz/cs/article/databaze-cviku-a-jak-je-poslat-pacientovi-ue0fjk/",
    "https://kb.fyzion.cz/cs/article/fakturacni-udaje-1phelsb/": "https://kb.fyzion.cz/cs/article/fakturacni-udaje-1phelsb/",
    "https://kb.fyzion.cz/cs/article/jak-vyuzit-predplatne-ve-fyzionu-darkove-poukazy-benefity-a-firemni-fakturace-1xlifqz/": "https://kb.fyzion.cz/cs/article/jak-vyuzit-predplatne-ve-fyzionu-darkove-poukazy-benefity-a-firemni-fakturace-1xlifqz/",
    "https://kb.fyzion.cz/cs/article/kartoteka-pacientu-1bjloyh/": "https://kb.fyzion.cz/cs/article/kartoteka-pacientu-1bjloyh/",
    "https://kb.fyzion.cz/cs/article/nastaveni-terapeutu-sauigy/": "https://kb.fyzion.cz/cs/article/nastaveni-terapeutu-sauigy/",
    "https://kb.fyzion.cz/cs/article/permanentky-17qqddn/": "https://kb.fyzion.cz/cs/article/permanentky-17qqddn/",
    "https://kb.fyzion.cz/cs/article/platby-z33ojo/": "https://kb.fyzion.cz/cs/article/platby-z33ojo/",
    "https://kb.fyzion.cz/cs/article/platebni-brana-comgate-149e3gy/": "https://kb.fyzion.cz/cs/article/platebni-brana-comgate-149e3gy/",
    "https://kb.fyzion.cz/cs/article/platebni-brana-fyzion-1i889t1/": "https://kb.fyzion.cz/cs/article/platebni-brana-fyzion-1i889t1/",
    "https://kb.fyzion.cz/cs/article/pobocky-ve-fyzionu-vetsi-svoboda-pro-terapeuty-prehlednost-pro-klienty-1vwg90a/": "https://kb.fyzion.cz/cs/article/pobocky-ve-fyzionu-vetsi-svoboda-pro-terapeuty-prehlednost-pro-klienty-1vwg90a/",
    "https://kb.fyzion.cz/cs/article/pojistovny-16i7uc6/": "https://kb.fyzion.cz/cs/article/pojistovny-16i7uc6/",
    "https://kb.fyzion.cz/cs/article/propojeni-kalendare-s-googlem-h9fpzi/": "https://kb.fyzion.cz/cs/article/propojeni-kalendare-s-googlem-h9fpzi/",
    "https://kb.fyzion.cz/cs/article/recenze-1okedp6/": "https://kb.fyzion.cz/cs/article/recenze-1okedp6/",
    "https://kb.fyzion.cz/cs/article/sablony-jcwt6d/": "https://kb.fyzion.cz/cs/article/sablony-jcwt6d/",
    "https://kb.fyzion.cz/cs/article/sluzby-jak-nastavit-vase-sluzby-13wrswq/": "https://kb.fyzion.cz/cs/article/sluzby-jak-nastavit-vase-sluzby-13wrswq/",
    "https://kb.fyzion.cz/cs/article/sprava-skladu-a-fakturace-1dfkoro/": "https://kb.fyzion.cz/cs/article/sprava-skladu-a-fakturace-1dfkoro/",
    "https://www.fyzion.cz/cs/navod-fyzion": "https://kb.fyzion.cz/en/",
    "https://www.google.com/chrome/": "https://www.google.com/chrome/",
    "IBAN": "IBAN",
    "IČ": "ID/Company number",
    "IČO": "ID/Company number",
    "IČP": "IČP",
    "IČP žadatele": "Applicant's PID",
    "IČZ": "IČZ",
    "id": "id",
    "iframe na web": "iframe for website",
    "Ignorovat automatické přepsání": "Ignore automatic overwrite",
    "info@fyzion.cz": "info@fyzion.cz",
    "Informace o návštěvách": "Appointment information",
    "Informace o Vaší registraci jsme Vám poslali na e-mail": "Information about your registration has been sent to your e-mail",
    "Informace o Vaší rezervaci jsme Vám poslali na e-mail": "Information about your reservation has been sent to your e-mail",
    "inventura": "inventory",
    "Inventura": "Inventory",
    "Inventura zboží": "Inventory goods",
    "Inventura zboží úspěšně provedena": "Inventory of goods successfully done",
    "Inventuru zboží se nepodařilo uložit": "Reservation could not be cancelled",
    "Jak chcete pokračovat?": "How do you want to proceed?",
    "Jak chcete provedené změny aplikovat?": "How do you want to apply the changes?",
    "Jak funguje platební brána?": "How does the payment gateway work?",
    "Jak fungují permanentky?": "How do season tickets work?",
    "Jak fungují recenze?": "How do reviews work?",
    "Jak na propojení s PURObotem?": "How to connect with PURObot?",
    "Jak na to": "How to do it",
    "Jak nastavit fakturační údaje?": "How to set up billing details?",
    "Jak nastavit online rezervace?": "How to set up online bookings?",
    "Jak nastavit pobočky?": "How to set up branches?",
    "Jak nastavit služby?": "How to set up services?",
    "Jak nastavit terapeuta?": "How to set up a therapist?",
    "Jak navýšit limit kartotéky pacientů?": "How to increase the client database limit?",
    "Jak používat šablony?": "How to use templates?",
    "Jak pracovat s kartotekou?": "How to work with the client database?",
    "Jak pracovat s platbami?": "How to work with payments?",
    "Jak pracovat se cviky?": "How to work with exercises?",
    "Jak propojit kalendář s Googlem?": "How to connect the calendar with Google?",
    "Jak si přejete aplikovat tuto šablonu?": "Do you really want to overwrite the template text?",
    "Jak spravovat sklad?": "How to manage stock?",
    "Jak vykazovat na pojišťovny?": "How to report to insurance companies?",
    "Jak využít předplatné?": "How to use subscriptions?",
    "Jaké služby poskytuje?": "Offered services",
    "Jakýkoliv": "Any",
    "Jde o duplicitní kartu?": "Is it a duplicate card?",
    "Jdeme na to teď!": "Let's do it now!",
    "Je-li funkce zapnuta a pacient ještě nemá potvrzené GDPR, systém mu ho automaticky odesílá k potvrzení den před budoucí návštěvou.": "If the function is enabled and the client does not have confirmed GDPR yet, the system automatically sends it to the client for confirmation one day before their future appointment.",
    "Je-li tato funkce vypnuta, fyzioterapeut vidí návštěvy ostatních fyzioterapeutů, ale nemůže se prokliknout do jejich detailu": "If this feature is turned off, the therapist can see appointments of other therapists, but cannot navigate to their detail",
    "Jestliže splníte tyto tři úkoly dříve, než vyprší čas, jako odměnu od nás dostanete tarif Standard na tři měsíce": "If you complete these three tasks before time runs out, you will receive a Standard plan for three months as a reward from us",
    "Jméno": "First name",
    "Jméno pojištěnce": "Insured person's name",
    "Jméno/název": "Name/title",
    "Jméno/Název": "Name/Title",
    "Jsou předepsané výkony": "Agreed performances",
    "K návštěvě existuje více než jedna platba": "There is more than one payment for a appointment",
    "K platbě": "To pay",
    "K poukazu zatím není zapsaný žádný výkon": "The voucher does not have any performance recorded yet",
    "K přihlášení použijte váš e-mail, na který Vám zasíláme potvrzení o rezervacích.": "To log in, use your e-mail address to which we send booking confirmations.",
    "K této cvičební položce nejsou k dispozici žádné obrázky ani videa.": "There are no pictures or videos available for this exercise item.",
    "K této cvičební poloze nejsou k dispozici žádné další informace.": "No additional information is available for this exercise position.",
    "K této návštěvě nebyl zatím přidán žádný popis.": "No description has been added to this appointment yet.",
    "K této recenzi nebyl přidán žádný text.": "No text has been added to this review.",
    "K vytvoření stvrzenky je potřeba návštěva": "Creating a receipt requires a appointment",
    "K vytvoření stvrzenky je potřeba pacient a návštěva": "Creating an invoice requires a client and a appointment",
    "k_batches.confirm_delete_k_batch_modal.confirm_text": "Remove",
    "k_batches.confirm_delete_k_batch_modal.heading_with_invoice": "Remove batch and invoice?",
    "k_batches.confirm_delete_k_batch_modal.heading_without_invoice": "Remove batch?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_with_invoice": "Do you really want to remove batch no. %{batchNumber} and invoice no. %{invoiceNumber}?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_without_invoice": "Do you really want to remove batch no. %{batchNumber}?",
    "k_batches.corrective_k_batch.get_ft_tickets_for_corrective_k_batch_failed.notification": "k_batches.corrective_k_batch.get_ft_tickets_for_corrective_k_batch_failed.notification",
    "k_batches.k_batch_document.get_k_batch_document_list_failed.notification": "Batch could not be removed",
    "k_batches.k_batch.create_corrective_batch_successful.notification": "Corrective batch created",
    "k_batches.k_batch.create_corrective_k_batch_btn.label": "Create corrective batch",
    "k_batches.k_batch.delete_failed.notification": "Batch could not be removed",
    "k_batches.k_batch.delete_k_batch_btn.label": "Remove batch",
    "k_batches.k_batch.delete_successful.notification": "Batch removed successfully",
    "k_batches.k_batch.new_receipt_btn.label": "k_batches.k_batch.new_receipt_btn.label",
    "K-Poukaz": "K-Voucher",
    "Kalendář": "Calendar",
    "Kalendář byl úspěšně synchronizován": "Calendar was successfully synchronized",
    "Kalendář je již synchronizovaný": "Calendar is already synchronized",
    "Kalendář místností": "Room calendar",
    "Kalendář skupinových": "Group calendar",
    "Kalendář terapeutů": "Therapist calendar",
    "Kapacita": "Capacity",
    "Kapacita:": "Capacity:",
    "Karta klienta": "Client card",
    "Karta pacienta": "Client card",
    "karta-pacienta": "client-card",
    "Kartou": "Card Payment",
    "Kartou online": "By card online",
    "Karty byly sloučeny": "Cards were merged",
    "Karty se nepodařilo sloučit": "Cards could not be merged",
    "kategorie": "category",
    "Kategorie": "Category",
    "Kč": "CZK",
    "Kdokoliv dostupný": "Anyone available",
    "Klient": "Client",
    "Klient platí za službu osobně během návštěvy.": "The client pays for the service in person during the appointment.",
    "Klient si může vybrat, zda zaplatí online předem, nebo až při návštěvě.": "The client can choose whether to pay online in advance or at the time of the appointment.",
    "Klienti a klientská sekce": "Clients and client section",
    "Klienti dostanou odkaz na přihlašovací stránku do klientského portálu od svého terapeuta.": "Clients will receive a link to the client portal login page from their therapist.",
    "Klientská sekce": "Client section",
    "Klientská sekce je vypnutá. Zapnout ji můžete v": "The client section is turned off. You can turn it on in",
    "Klientský portál": "Client portal",
    "klientů": "clients",
    "km)": "km)",
    "Kód": "Code",
    "Kód ": "Code",
    "Kód a název pojišťovny": "Code and name of insurance company",
    "Kód a název zboží": "Code and name of the product",
    "Kód a název zboží, počet": "Code and name of product, quantity",
    "kód banky": "Bank code",
    "Kód banky": "Bank code",
    "Kód náhrady": "Reimbursement code",
    "Kód pojišťovny": "Insurance code",
    "Kód zboží": "Product code",
    "Končetiny dolní": "Lower limbs",
    "Končetiny horní": "Upper limbs",
    "Konec": "The end",
    "Kontakt na pacienta": "Contact with client",
    "Kontaktní osoba": "Contact person",
    "Kontaktní údaje": "Contact details",
    "kontaktni-udaje": "contact-details",
    "Kontaktovat": "Contact",
    "Kontaktovat náhradníky s nabídkou termínu?": "Contact substitutes with an available slot?",
    "Kontaktujte nás": "Contact us",
    "Kontaktujte nás a rádi vám Fyzion představíme <br>během 15 minutového online hovoru.": "Contact us and we will be happy to introduce Fyzion to you <br>during a 15-minute online call.",
    "Kontaktujte naši podporu": "Contact our support",
    "Kontrola": "Review",
    "Kontrolní spis se nepodařilo vytvořit": "Control record could not be created",
    "Kopírovat": "Copy",
    "Krční": "Cervical",
    "Kredit": "Credit",
    "krok cviku": "exercise step",
    "ks": "pcs",
    "ks x": "pcs x",
    "label": "label",
    "lekcí": "sessions",
    "Limit": "Limit",
    "Limit dluhu předplatného bude překročen.": "Subscription limit will be exceeded.",
    "Limit dlužné částky": "Limit of the amount due",
    "Limit dlužné částky:": "Debt limit:",
    "Limit pacientů můžete zvýšit, když nám pomůžete sdílet aplikaci mezi Vaše kolegy, ": "You can increase the client limit if you help us share the app with your colleagues,",
    "Logo": "Logo",
    "Logo aplikace Fyzion": "Fyzion application logo",
    "Logo firmy": "Company logo",
    "Luboš Truhlář": "Luboš Truhlář",
    "mailto:info@fyzion.cz": "mailto:info@fyzion.cz.",
    "Mají tel.": "They have phone.",
    "Mastercard ikona": "Mastercard icon",
    "Máte již vlastní IČO?": "Do you already have your own company ID?",
    "máte naplánovanou návštěvu v ordinaci fyzioterapie": "you have a scheduled appointment at the therapy office",
    "Máte neuhrazenou objednávku za pronájem aplikace!": "You have an unpaid order for the application rental!",
    "Máte objednány tyto návštěvy": "You have booked these appointments",
    "Máte zde neuložené změny, chcete je před odchodem uložit?": "You have unsaved changes, do you want to save them before leaving?",
    "Max. 9 výkonů": "performances",
    "Maximální kapacita": "Maximum capacity",
    "Maximální kapacita návštěvy je ": "Maximum appointment capacity is ",
    "Maximální počet klientů": "Maximum number of clients",
    "Maximální počet objednaných rezervací": "Maximum number of booked reservations",
    "Maximální počet rezervací": "Maximum number of bookings",
    "Maximální počet rezervací za den": "Maximum number of bookings per day",
    "Maximální počet termínů, které si může klient rezervovat v jedné objednávce. Pokud není vyplněno, počet rezervací není omezen.": "Maximum number of appointments a client can book in a single order. If left blank, the number of bookings is not limited.",
    "Maximální počet účastníků skupinové služby.": "Maximum number of participants in a group service.",
    "Maximální úhrada": "Maximum payment",
    "McKenzie formuláře byly úspěšně aktivovány": "McKenzie forms have been successfully activated",
    "McKenzie spisy": "McKenzie files",
    "měsíc": "month",
    "Měsíc": "Month",
    "měsíce": "months",
    "Měsíce": "Months",
    "Měsíčně": "Monthly",
    "Měsíční": "Monthly",
    "měsíců": "month(s)",
    "Město": "City",
    "mezi vaše kolegy nebo přechodem na ": "Among your colleagues or switching to",
    "mezi Vaše kolegy, nebo přechodem na ": "Among your colleagues, or transition to",
    "min": "min",
    "min.": "min.",
    "Min. 1 výkon": "Min. 1 action",
    "min/terapie": "min/therapy",
    "Minimální počet objednaných rezervací": "Minimum number of booked reservations",
    "Minimální počet rezervací": "Minimum number of bookings",
    "Minimální počet termínů, které musí klient při jedné online rezervaci vybrat. Běžně je nastaveno na 1.": "Minimum number of appointments the client must select in one online booking. Usually set to 1.",
    "Minulý měsíc": "Last month",
    "Minulý rok": "Last year",
    "Minulý týden": "Last week",
    "minut": "minutes",
    "Místnost": "Room",
    "Místnost bude odstraněna z pracovní doby.": "The room will be removed from working hours.",
    "Místnost byla úspěšně smazána": "Room was successfully deleted",
    "Místnost byla úspěšně upravena": "Room was successfully adjusted",
    "Místnost byla úspěšně vytvořena": "Room was successfully created",
    "mistnosti": "rooms",
    "Místnosti": "Rooms",
    "MJ": "Units",
    "Množství": "Quantity",
    "Modrá": "Blue",
    "Moduly": "Modules",
    "Moje profily": "My profiles",
    "Moje údaje": "My details",
    "Momentálně využívá": "Currently using",
    "Možnost dluhu": "Debt option",
    "Možnost platit online předem nebo na místě": "Option to pay online in advance or on-site",
    "Mřížka": "Grid",
    "Můj tarif": "My plan",
    "Můj tarif, platby za předplatné.": "My plan, subscription payments.",
    "Musí být alespoň 1": "Must be at least 1",
    "Musí být menší než 1000.": "It must be greater than 0.",
    "Musí být větší než 0.": "It must be greater than 0.",
    "Muž": "Male",
    "Můžete vložit obrázek s vaším razítkem nebo podpisem, který se následně vloží na generované doklady pro pacienty.": "You can insert an image with your stamp or signature, which will then be inserted on the generated documents for clients.",
    "Muži": "Men",
    "Muži (budoucí)": "Men (scheduled)",
    "na info@fyzion.cz.": "at info@fyzion.cz.",
    "Nabízené permanentky": "Offered season tickets",
    "Nabízené služby": "Offered services",
    "Načíst další": "Load more",
    "Načíst údaje z ARES": "Load data from ARES",
    "Načíst výkony": "Load performances",
    "Nadcházející návštěva": "Next appointment",
    "Nadpis bloku": "Block heading",
    "Náhradník": "Substitute",
    "Náhradník odebrán": "Substitute removed",
    "Náhradník přidán": "Substitute added",
    "Náhradníka se nepodařilo odebrat": "Substitute could not be removed",
    "Náhradníka se nepodařilo přidat": "Substitute could not be added",
    "Nahrané dokumenty zde není možné vidět.": "Uploaded documents cannot be viewed here.",
    "Nahrání dat do systému": "Uploading data to the system",
    "Nahrání obrázku se nezdařilo": "Image upload failed",
    "Nahrát dávku do Purobota": "Upload a batch to Purobot",
    "Nahrát fotku": "Upload photo",
    "Nahrát soubor": "Upload file",
    "Nahrát soubor typu jpeg nebo png": "Upload file of type jpeg or png",
    "Nahrávání souborů, prosím nezavírejte stránku...": "Uploading files, please do not close the page...",
    "Nákupní (s DPH)": "Shopping (VAT included)",
    "Nákupní cena a počet": "Purchase price and quantity",
    "Nákupní cena s DPH": "Purchase price with VAT",
    "Nákupní hodnota (s DPH)": "Purchase value (VAT included)",
    "Napište nám na email:": "Write to us at email:",
    "Napište poznámku…": "Write a note…",
    "Naplánovat změnu ceny od zvoleného data": "Schedule a price change from the selected date",
    "Nápověda": "Help",
    "např. číslo dávky, dokladu, pojištěnce": "For example batch number, document, insured person",
    "Např. kód, název zboží": "For example, code, item name",
    "např. název, IČP, telefonní číslo": "e.g. name, IC, phone number",
    "např. název, instituce, IČO": "e.g. client",
    "např. RČ pacienta, e-mail": "e.g. name, email",
    "Např. RČ pacienta, e-mailová adresa": "E.g. client's ID, email address",
    "naší aplikaci či facebookovou skupinu Fyzion na internetu. Za každé takové sdílení Vám zdarma rozšíříme kartotéku o dalších pět pacientů. Jako potvrzení, že jste sdílení provedli, nám prosím zašlete screenshot (fotku obrazovky) sdíleného příspěvku na info@fyzion.cz a uveďte, o jakého fyzioterapeuta se jedná.": "Share our application or Facebook group Fyzion online. For each such share, we will extend your client list by another five clients for free. As a confirmation of your share, please send us a screenshot of the shared post to info@fyzion.cz and specify which therapist it concerns.",
    "naskladneni": "stocking",
    "Naskladnění": "Stocking",
    "Naskladnění zboží": "Goods receipt",
    "Následující návštěva:": "Next appointment:",
    "Nasmlouvané výkony": "Agreed performances",
    "nastaveni": "settings",
    "Nastavení": "Settings",
    "Nastavení - Fakturační údaje": "Settings - Invoicing details",
    "NASTAVENÍ - KONTAKTNÍ ÚDAJE.": "SETTINGS - CONTACT DETAILS.",
    "Nastavení hesla": "Password settings",
    "Nastavení IČPE": "IČPE settings",
    "Nastavení nového hesla": "Setting a new password",
    "Nastavení platby": "Payment settings",
    "Nastavení předplatného": "Subscription settings",
    "Nastavení uloženo": "Settings saved",
    "Nastavit": "Set up",
    "Nastavit heslo": "Set password",
    "Nastavit jako výchozí službu": "Set as default service",
    "Nastavit přesun podle": "Set reschedule by",
    "Nastavit text emailu": "Set email text",
    "Nastavit text SMS": "Set SMS text",
    "Nastavit zrušení podle": "Set cancellation by",
    "Nastavuje počáteční číslo pro faktury": "Sets the starting number for invoices",
    "Nastavuje počáteční číslo pro paragony": "Sets the starting number for receipts",
    "Návod": "Guide",
    "Návrat do aplikace": "Return to application",
    "Návštěv na stránku": "Appointment to page",
    "návštěva": "appointment",
    "Návštěva": "Appointment",
    "Návštěva byla označena jako zaplacená": "Appointment was marked as paid",
    "Návštěva byla úspěšně zaplacena": "Appointment was successfully paid",
    "Návštěva je zamknuta": "Appointment is locked",
    "Návštěva nemůže mít datum po konci platnosti FT poukazu": "The appointment cannot be dated after the FT voucher expiry date",
    "Návštěva nenalezena": "Appointment not found",
    "Návštěva obsahuje nahrané formuláře": "Appointment contains uploaded forms",
    "Návštěva obsahuje nahrané fotografie": "Appointment contains uploaded photos",
    "Návštěva odemknuta": "Appointment unlocked",
    "Návštěva pacienta": "Client appointment",
    "Návštěva smazána": "Appointment deleted",
    "Návštěva úspěšně přidána": "Appointment successfully added",
    "Návštěva zamknuta": "Appointment locked",
    "Návštěvu se nepodařilo uložit": "Reservation could not be cancelled",
    "Návštěvu se nepodařilo uložit! Zkuste to prosím znovu.": "Reservation could not be cancelled",
    "navstevy": "appointments",
    "Návštěvy": "Appointments",
    "návštěvy pacientů": "Client appointments",
    "Návštěvy pacientů": "Client appointments",
    "Návštěvy podle fyzioterapeutů": "Appointments by therapists",
    "návštěvy vloží do správné karty.": "Insert appointments into the correct tab.",
    "navstevy-pacienta": "client-appointments",
    "Název": "Title",
    "Název cviku": "Name of exercise",
    "Název firmy": "Company name",
    "Název instituce": "Customer/Client name",
    "Název kategorie": "Category title",
    "Název kliniky": "Clinic name",
    "Název místnosti": "Room name",
    "Název permanentky": "Membership title",
    "Název pobočky": "Branch name",
    "Název podkategorie": "Subcategory title",
    "Název pojišťovny": "Insurance company name",
    "Název pracoviště": "Location name",
    "Název předplatného": "Subscription title",
    "Název šablony": "Template name",
    "Název služby": "Service name",
    "Název v angličtině": "Name in English",
    "Název v češtině": "Name in Czech",
    "Název v polštině": "Name in Polish",
    "Název ve slovenštině": "Name in Slovak",
    "Název zboží": "Product title",
    "Ne": "No",
    "nebo": "or",
    "nebo přechodem na pokročilý tarif. ": "Or by switching to advanced tariff.",
    "Nebyly nalezeny žádné recenze.": "No reviews found",
    "Něco se pokazilo": "Something went wrong",
    "Neděle": "Sunday",
    "Nedorazil:": "Client did not arrive:",
    "Nejčastější sady výkonů můžete definovat v sekci POJIŠŤOVNY → ŠABLONY.": "The most common performance sets can be defined in the INSURANCE → TEMPLATES section.",
    "Nejméně 8 znaků a alespoň 1 malé písmeno": "At least 8 characters and at least 1 lowercase letter",
    "Nejprve vyberte návštěvy k zaplacení": "First select the appointments to pay for",
    "Nejprve vyberte šablonu výkonů": "First select a performance template",
    "Nejsou dostupné žádné místnosti": "No rooms available",
    "Nejsou dostupné žádné pobočky": "No branches available",
    "Nejsou dostupné žádné předplatné": "No subscription available",
    "Nejsou dostupné žádné transakce": "No transactions available",
    "Nejsou dostupní žádní uživatelé": "No users available",
    "Nejsou dostupní žádní žadatelé": "No applicants available",
    "Nejsou k dispozici žádná data": "No data available",
    "Nejsou k dispozici žádné fotografie": "No photos available",
    "Některé funkce aplikace Fyzion vám": "Some functions of Fyzion app",
    "Některé z povinných údajů chybí": "Some of the required information is missing",
    "Nelze odebrat zamčený výkon": "No document found",
    "Nelze přesunout volno k jinému fyzioterapeutovi.": "It is not possible to reschedule the availability to another therapist.",
    "Nelze smazat - zboží je na skladě.": "Cannot delete - product is in stock.",
    "Nelze vytvořit kontrolní spis: Chybí ID pacienta v M-Spisech": "Cannot create control record: Client ID missing in M-Records",
    "Nelze vytvořit kontrolní spis: doplňte rodné číslo k pacientovi": "Cannot create control record: please add the client's birth number",
    "Nelze vytvořit nový spis: Chybí ID pacienta v M-Spisech": "Cannot create new record: Client ID missing in M-Records",
    "Nelze vytvořit nový spis: doplňte rodné číslo k pacientovi": "Cannot create new record: please add the client's birth number",
    "Nemají tel.": "They don't have phone.",
    "Nemáte dostatečné oprávnění pro tuto akci.": "You do not have sufficient permission to perform this action.",
    "Nemáte oprávnění na smazání cizí návštěvy": "You are not authorized to delete someone else's appointment",
    "Nemáte oprávnění na smazání návštěvy": "You are not authorized to delete an appointment",
    "Nemáte oprávnění na úpravu jiného fyzioterapeuta": "You do not have permission to edit another therapist",
    "Nemáte oprávnění na úpravu jiných ordinačních hodin": "You do not have permission to edit other appointments slots",
    "Nemáte oprávnění na úpravu permanentky": "You do not have permission to edit the season pass",
    "Nemáte oprávnění na úpravu služby": "You do not have permission to modify service",
    "Nemáte oprávnění na zaplacení cizí návštěvy": "You are not authorized to pay for someone else's appointment",
    "Nemáte oprávnění na zrušení cizí návštěvy": "You are not authorized to cancel someone else's appointment",
    "Nemáte oprávnění pro odemknutí výkonu": "You do not have permission to unlock performance",
    "Nemáte oprávnění prohlížet anamnézu pacienta": "You do not have permission to see medical history",
    "Nemáte vytvořenou smlouvu s touto pojišťovnou. Pro tuto pojišťovnu se dávka nevytvoří.": "You do not have a contract created with this insurance company. A claim will not be created for this insurance company.",
    "Nemáte žádné objednané návštěvy.": "You have no booked appointments.",
    "nemusí správně fungovat.": "It does not have to work correctly.",
    "Nemůže být záporné": "It can't be negative",
    "Nenalezen žádný dodavatel": "No supplier found",
    "Nenalezen žádný doklad": "No document found",
    "Nenalezen žádný FT poukaz pro načtení výkonů": "No FT voucher found to load performances",
    "Nenalezen žádný klient": "No client found",
    "Nenalezen žádný pacient": "No client found",
    "Nenalezen žádný výkon": "No document found",
    "Nenalezen žádný záznam": "No record found",
    "Nenalezena shoda se jménem žádného cviku.": "No match found for any exercise name.",
    "Nenalezena žádná akce": "No action found",
    "Nenalezena žádná dávka": "No batch found",
    "Nenalezena žádná návštěva": "No appointment found",
    "Nenalezena žádná pracoviště": "No locations found",
    "Nenalezena žádná šablona": "No template found",
    "Nenalezena žádná stvrzenka": "No receipt found",
    "Nenalezena žádná zpráva": "No message found",
    "Nenalezeno žádné další zboží": "No more items found",
    "Nenalezeny žádná výkony": "No performances found",
    "Nenalezeny žádné další služby": "No additional services found",
    "Nenalezeny žádné položky": "No items found",
    "Nenalezeny žádné zásoby": "No resources found",
    "Není dostupná žádná šablona výkonů": "No performance template available",
    "Není dostupný žádný platný FT poukaz": "No subscription available",
    "Není dostupný žádný výkon": "Power is not available",
    "Není možné změnit tarif, protože máte v kartotéce více pacientů,": "It is not possible to change the tariff because you have multiple clients in the database,",
    "Není nahrána žádná fotka": "No photo uploaded",
    "Není naplánována další návštěva": "No further appointment scheduled",
    "Neočekávaná chyba": "Unexpected error",
    "Neomezený počet pacientů": "Unlimited number of clients",
    "Neopakuje se": "Non-recurring",
    "Neplátce DPH": "Non-VAT payer",
    "Nepodařilo se aktualizovat cviky v návštěvě": "Failed to update exercises in appointment",
    "Nepodařilo se aktualizovat den se cvičením": "Failed to update exercise day",
    "Nepodařilo se aktualizovat šablonu": "Failed to update the template.",
    "Nepodařilo se načíst AI shrnutí": "Failed to load AI summary",
    "Nepodařilo se načíst AI shrnutí.": "Failed to load AI summary.",
    "Nepodařilo se načíst budoucí návštěvy.": "Failed to load upcoming appointments.",
    "Nepodařilo se načíst celkové hodnoty naskladněných položek": "Failed to load total values of stocked items",
    "Nepodařilo se načíst cesty za pacientem": "Failed to load home visit routes",
    "Nepodařilo se načíst cviky": "Failed to load exercises",
    "Nepodařilo se načíst data": "Failed to load data",
    "Nepodařilo se načíst data ze systému": "Failed to load data",
    "Nepodařilo se načíst dávku": "Failed to load data",
    "Nepodařilo se načíst dávky": "Failed to load data",
    "Nepodařilo se načíst detail poukazu": "Failed to load voucher detail",
    "Nepodařilo se načíst diagnózy": "Failed to load diagnoses",
    "Nepodařilo se načíst dodavatele": "Failed to load data",
    "Nepodařilo se načíst dostupné fyzioterapeuty": "Unable to load available therapists",
    "Nepodařilo se načíst druhy péče": "Failed to load care types",
    "Nepodařilo se načíst FT poukazy": "Failed to load services",
    "Nepodařilo se načíst hromadnou návštěvu": "Failed to load data",
    "Nepodařilo se načíst kategorie cviků": "Failed to load exercise categories",
    "Nepodařilo se načíst kategorii cviků": "Failed to load exercise category",
    "Nepodařilo se načíst místnost": "Failed to load room",
    "Nepodařilo se načíst místnosti": "Failed to load rooms",
    "Nepodařilo se načíst návrh platby": "Failed to load payment draft",
    "Nepodařilo se načíst návštěvu pacienta": "Failed to load client appointment",
    "Nepodařilo se načíst návštěvy pacienta": "Failed to load client appointments",
    "Nepodařilo se načíst novinku": "Failed to load the news item.",
    "Nepodařilo se načíst novinky": "Failed to load news items",
    "Nepodařilo se načíst odbornosti": "Failed to load data",
    "Nepodařilo se načíst ordinaci na této adrese": "Unable to load surgery at this address",
    "Nepodařilo se načíst pacienty": "Failed to load clients",
    "Nepodařilo se načíst permanentku": "Failed to load data",
    "Nepodařilo se načíst permanentky pacienta": "Failed to load client's subscriptions",
    "Nepodařilo se načíst platbu": "Failed to load payment",
    "Nepodařilo se načíst platby": "Failed to load payments",
    "Nepodařilo se načíst platební údaje": "Failed to load payment data",
    "Nepodařilo se načíst pojišťovnu": "Failed to load data",
    "Nepodařilo se načíst pojišťovny": "Failed to load services",
    "Nepodařilo se načíst položku": "Failed to load services",
    "Nepodařilo se načíst poukazy": "Failed to load vouchers",
    "Nepodařilo se načíst pracoviště": "Failed to load data",
    "Nepodařilo se načíst předplatné": "Failed to load subscription",
    "Nepodařilo se načíst recenze": "Failed to load reviews",
    "Nepodařilo se načíst šablonu": "Failed to load template",
    "Nepodařilo se načíst šablony": "Failed to load templates",
    "Nepodařilo se načíst šablony FT poukazů": "Failed to load FT voucher templates",
    "Nepodařilo se načíst seznam diagnóz": "Failed to load diagnoses",
    "Nepodařilo se načíst seznam návštěv.": "Failed to load appointments",
    "Nepodařilo se načíst seznam uživatelů": "Failed to load list of users",
    "Nepodařilo se načíst skupiny služeb": "Failed to load services",
    "Nepodařilo se načíst služby": "Failed to load services",
    "Nepodařilo se načíst transakce": "Failed to load transactions",
    "Nepodařilo se načíst transakci": "Failed to load transaction",
    "Nepodařilo se načíst volné termíny": "Failed to load available dates",
    "Nepodařilo se načíst výkony": "Failed to load performances",
    "Nepodařilo se načíst žadatele": "Failed to load applicant",
    "Nepodařilo se načíst zaměstnance": "Failed to load employees",
    "Nepodařilo se načíst zásoby": "Failed to load services",
    "Nepodařilo se načíst země": "Failed to load countries",
    "Nepodařilo se načíst zemi": "Failed to load the country.",
    "Nepodařilo se nahrát dávku do Purobota": "Failed to upload batch to Purobot",
    "Nepodařilo se nahrát fotku FT poukazu": "Failed to upload FT voucher photo",
    "Nepodařilo se nahrát soubor": "Failed to upload the file",
    "Nepodařilo se odebrat štítek": "Failed to remove the label",
    "Nepodařilo se odemknout výkon": "Failed to unlock the performance",
    "Nepodařilo se odeslat recenzi. Zkuste to prosím znovu.": "Failed to save note. Please try again.",
    "Nepodařilo se označit fakturu jako zaplacenou": "Failed to load data",
    "Nepodařilo se přidat fakturaci": "Failed to add billing",
    "Nepodařilo se přidat předplatné": "Failed to add subscription",
    "Nepodařilo se smazat cvik": "Failed to delete exercise",
    "Nepodařilo se smazat místnost": "Failed to delete the room",
    "Nepodařilo se smazat platbu": "Failed to load data",
    "Nepodařilo se smazat pojišťovnu": "Failed to delete insurance",
    "Nepodařilo se smazat pracoviště": "Failed to load data",
    "Nepodařilo se smazat předplatné": "Failed to delete subscription",
    "Nepodařilo se smazat recenzi": "Failed to load data",
    "Nepodařilo se smazat šablonu": "Failed to delete the template",
    "Nepodařilo se smazat štítek": "Failed to delete the label",
    "Nepodařilo se spustit platbu. Zkuste to prosím znovu.": "Failed to start payment. Please try again.",
    "Nepodařilo se uložit pracoviště žadatele": "Failed to save the applicant's workplace.",
    "Nepodařilo se upravit cvik.": "Failed to modify the exercise.",
    "Nepodařilo se upravit dostupnost": "Failed to update availability.",
    "Nepodařilo se upravit fakturaci": "Failed to update billing",
    "Nepodařilo se upravit místnost": "Failed to update the room",
    "Nepodařilo se upravit platbu": "Failed to update payment",
    "Nepodařilo se upravit pobočku": "Failed to update the branch",
    "Nepodařilo se upravit předplatné": "Failed to update subscription",
    "Nepodařilo se vygenerovat export": "Failed to generate export",
    "Nepodařilo se vygenerovat fakturu": "Failed to load data",
    "Nepodařilo se vygenerovat platební odkaz": "Failed to generate payment link",
    "Nepodařilo se vygenerovat zprávu": "Failed to generate report",
    "Nepodařilo se vylepšit popis návštěvy": "Failed to enhance the appointment description",
    "Nepodařilo se vytvořit cvik.": "Failed to create an exercise.",
    "Nepodařilo se vytvořit dodavatele": "Failed to load data",
    "Nepodařilo se vytvořit hromadnou návštěvu": "Failed to load data",
    "Nepodařilo se vytvořit kategorii.": "Failed to create a category.",
    "Nepodařilo se vytvořit místnost": "Failed to create the room",
    "Nepodařilo se vytvořit platbu": "Failed to create the payment",
    "Nepodařilo se vytvořit pracoviště žadatele": "Failed to create the applicant's workplace",
    "Nepodařilo se vytvořit registraci jako náhradník": "Failed to create substitute registration",
    "Nepodařilo se vytvořit šablonu": "Failed to create the template.",
    "Nepodařilo se vytvořit štítek": "Failed to create the label",
    "Nepodařilo se vytvořit uživatele": "Failed to create user",
    "Nepodařilo se zaplatit návštěvu": "Failed to pay for the appointment",
    "Nepodařilo se získat cviky pacienta": "Unable to obtain the client's exercises",
    "Nepodařilo se změnit nastavení rezervací pacienta": "Failed to change the client's reservation settings.",
    "Nepodařilo se zrušit platbu": "Failed to cancel payment",
    "Nepodařilo se zrušit platbu za návštěvu": "Failed to cancel the payment for the appointment",
    "Nepodporovaný typ prohlížeče": "Unsupported browser type",
    "nepodporovaný typ prohlížeče.": "Unsupported browser type.",
    "Nepovinné": "Optional",
    "Nepravidelné ordinační hodiny": "Irregular office hours",
    "Nepřišel": "He did not come",
    "Nesouhlasili": "Did not agree",
    "Neuhrazená objednávka": "Unpaid order",
    "Neuhrazeno": "Unpaid",
    "Neukládat": "Do not save",
    "Nevíte jak na to? Podívejte se na náš návod, přihlašte se na webinář nebo kontaktujte podporu.": "Do not you know how to do it? Check out our guide, sign up for a webinar or contact support.",
    "Nevystaveno": "Not exposed",
    "Nezaplaceno": "Unpaid",
    "notifikace": "notifications",
    "Notifikace": "Notifications",
    "Notifikace ordinaci": "Clinic notifications",
    "nova": "new",
    "Nová cena": "New price",
    "Nová cena s DPH": "New price with VAT",
    "Nová cena se použije pro návštěvy od zvoleného data. Do té doby platí současná cena služby. Vypnutím naplánovanou změnu zrušíte.": "The new price applies to visits from the selected date. Until then, the current service price applies. Turning this off cancels the scheduled change.",
    "Nová fakturace": "New invoicing",
    "Nová místnost": "New room",
    "Nová návštěva": "New appointment",
    "Nová operace": "New operation",
    "Nová šablona": "New template",
    "Nová skupinová návštěva": "New group appointment",
    "Nová událost": "New event",
    "nova-navsteva": "new-appointment",
    "nova-opravna": "new-repair",
    "nova-skupinova-navsteva": "new-group-appointment",
    "nove": "new",
    "Nové heslo": "New password",
    "Nové pracoviště žadatele": "Applicant's new workplace",
    "Nové předplatné": "New subscription",
    "Novinky": "News",
    "novy": "new",
    "Nový pacient": "New client",
    "Nový spis": "New record",
    "Nový žadatel": "New applicant",
    "novy-ft-poukaz": "new-ft-voucher",
    "O nás": "About us",
    "Období": "Period",
    "obecne": "currently",
    "Obecné": "General",
    "obecného nastavení firmy": "general company settings",
    "obecném nastavení": "general settings",
    "Objednat návštěvu": "Book an appointment",
    "Objednat se na": "Make an appointment at",
    "Objekt": "Service",
    "Obměna": "Variation",
    "obnova-hesla": "password-reset",
    "Obnovit tabulku": "Refresh table",
    "Obrázek byl smazán": "Picture was deleted",
    "Obrázky": "Pictures",
    "Obsah": "Content",
    "Ochrana osobních údajů": "Personal data protection",
    "Od": "From",
    "Odběratel/klient": "Subscriber/client",
    "Odběratel/Klient": "Subscriber/Client",
    "Odbornost": "Expertise",
    "Odcvičeno a přejít na další cvik": "Completed and proceed to the next exercise",
    "Odebrat": "Remove",
    "Odebrat náhradníka": "Remove substitute",
    "Odebrat pacienta": "Remove client",
    "Odebrat položku": "Remove item",
    "Odebrat výkon": "Remove power",
    "Odebrat z čekajících": "Remove from waiting list",
    "Odebrat zastávku na cestě": "Remove route stop",
    "Odemknout": "Unlock",
    "Odemknout výkon": "Unlock power",
    "Odesílat email": "Send email",
    "Odesílat email připomínku před návštěvou": "Send email reminder before the appointment",
    "Odesílat připomínku e-mailem": "Send e-mail reminder",
    "Odesílat SMS": "Send SMS",
    "Odesílat SMS předem": "Send SMS in advance",
    "Odesílat SMS připomínku před návštěvou": "Send SMS reminder before the appointment",
    "Odesílat stvrzenky klientům": "Send receipts to clients",
    "Odesílat upozornění e-mailem o vytvoření, změně, zrušení návštěvy": "Send e-mail notification about visit creation, change, or cancellation",
    "Odesílat žádost o recenzi": "Send review request",
    "Odeslali jsme vám e-mail s instrukcemi k resetování hesla.": "We have sent you an email with instructions to reset your password.",
    "Odeslané zprávy": "Sent messages",
    "Odeslání dávek s přihlášením pomocí SMS kódu v tuto chvíli není podporované.": "Sending batches with SMS code login is not supported at the moment.",
    "Odeslání dávky pojišťovně selhalo": "Sending the batch to the insurance company failed",
    "Odeslání emailu": "Sending email",
    "Odeslání emailu 1 pacientovi": "Sending email 1 to client",
    "Odeslání emailu pacientovi": "Sending email to client",
    "Odeslání SMS": "Sending SMS",
    "Odeslání SMS 1 pacientovi": "Sending SMS 1 to client",
    "Odeslání SMS pacientovi": "Sending SMS to client",
    "Odeslání zůstalo nedokončené": "Sending was left unfinished",
    "Odesláno": "Sent",
    "Odesláno na ": "Sent to ",
    "Odeslat": "Send",
    "Odeslat 1 stvrzenku": "Send 1 receipt",
    "Odeslat email": "Send email",
    "Odeslat GDPR mailem": "Send GDPR by email",
    "Odeslat klientovi": "Send to client",
    "Odeslat pacientovi": "Send to client",
    "Odeslat potvrzení o platbě": "Send payment confirmation",
    "Odeslat pouze zvoleným klientům.": "Send only to selected clients.",
    "Odeslat připomínku platby (před návštěvou)": "Send payment reminder (before the appointment)",
    "Odeslat SMS": "Send SMS",
    "Odeslat SMS pomocí telefonu": "Send SMS via phone",
    "Odeslat soubory": "Send files",
    "Odeslat znovu emailem": "Send email",
    "odešlete": "Send",
    "Odhlásit": "Sign out",
    "Odkaz na formulář pro rezervaci čekajících pacientů": "Link to the waiting client booking form",
    "Odkaz na kalendář s přehledem vámi nabízených skupinových lekcí": "Link to the calendar with an overview of your group sessions",
    "Odkaz na přístup do klientské sekce": "Link to access the client section",
    "Odkaz na rezervaci byl zkopírován do schránky": "The reservation link has been copied to the clipboard.",
    "Odkaz na váš online rezervační systém": "Link to your online booking system",
    "Odkaz na vaší stránku ordinace obsahující rozcestník služeb, recenze, ordinační dobu i kontaktní údaje": "Link to your clinic page with a service overview, reviews, opening hours and contact details",
    "Odkud jste se o nás dozvěděli?": "Where did you hear about us?",
    "Odpovědi posílat na email": "Send replies to email",
    "Odstranit časový interval": "Remove time interval",
    "Ohodnoťte kvalitu naší služby": "Rate the quality of our service",
    "Omezuje počet rezervací této služby na jeden den. Vhodné pro časově nebo fyzicky náročné služby.": "Limits the number of bookings for this service per day. Suitable for time-intensive or physically demanding services.",
    "Omlouváme se, ale v aplikaci Fyzion došlo k nečekané chybě. Někdy i ty nejlepší svaly potřebují chvilku na odpočinek.": "We apologise, but an unexpected error has occurred in the Fyzion application. Sometimes even the best muscles need a moment to rest.",
    "Online platba": "Online Payment",
    "Online rezervace": "Online bookings",
    "Opakování": "Recurrence",
    "Opakovat heslo": "Repeat password",
    "Opakovat jednou za": "Repeat once after",
    "Opravdu si přejete archivovat pacienta?": "Do you really want to archive the client?",
    "Opravdu si přejete dokument smazat?": "Are you sure you want to delete the document?",
    "Opravdu si přejete formulář smazat?": "Do you really want to delete the form?",
    "Opravdu si přejete fotografii smazat?": "Do you really want to delete the photograph?",
    "Opravdu si přejete FT poukaz smazat?": "Do you really want to delete FT voucher?",
    "Opravdu si přejete místnost smazat?": "Are you sure you want to delete the room?",
    "Opravdu si přejete náhradníka odebrat?": "Are you sure you want to remove the substitute?",
    "Opravdu si přejete obrázek smazat?": "Are you sure you want to delete the image?",
    "Opravdu si přejete pacienta odebrat?": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete permanentku smazat?": "Do you really want to delete the season pass?",
    "Opravdu si přejete platbu zrušit?": "Do you really want to cancel the payment?",
    "Opravdu si přejete pobočku smazat?": "Are you sure you want to delete the branch?",
    "Opravdu si přejete pojišťovnu smazat?": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete poukaz smazat?": "Are you sure you want to delete the voucher?",
    "Opravdu si přejete pracoviště smazat?": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete recenzi smazat?": "Do you really want to delete the vacation?",
    "Opravdu si přejete rezervaci zrušit?": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete šablonu smazat?": "Do you really want to delete the template?",
    "Opravdu si přejete smazat cvik": "Do you really want to delete the exercise",
    "Opravdu si přejete smazat kategorii cviků?": "Do you really wish to delete the exercise category?",
    "Opravdu si přejete smazat kategorii služeb": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete smazat platbu č.": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete smazat předplatné": "Are you sure you want to delete subscription",
    "Opravdu si přejete smazat službu": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete stornovat stvrzenku?": "Are you sure you want to cancel your reservation?",
    "Opravdu si přejete synchronizaci odebrat?": "Do you really want to remove the synchronization?",
    "Opravdu si přejete terapeuta deaktivovat?": "Are you sure you want to deactivate user?",
    "Opravdu si přejete video smazat?": "Do you really want to delete the video?",
    "Opravdu si přejete volno smazat?": "Do you really want to delete the vacation?",
    "Opravdu si přejete zboží smazat?": "Are you sure you want to delete this product?",
    "Opravná": "Correction",
    "Opravná dávka": "Correction batch",
    "Opustit průvodce": "Exit the guide",
    "Ordinace": "Practice",
    "ordinační hodiny": "Working hours",
    "Ordinační hodiny": "Office hours",
    "Origin:": "Origin:",
    "Osobní údaje": "Personal data",
    "Osobní údaje, přihlašovací údaje, propojení s GC.": "Personal details, login credentials, Google Calendar integration.",
    "Ostatní diagnózy": "Other diagnoses",
    "Ostatní služby": "Other services",
    "Otevírací doba": "Opening hours",
    "Otevřeno": "Open",
    "Otevřít": "Open",
    "Otevřít nápovědu": "Open help",
    "Otevřít návštěvu": "Open the visit",
    "Otevřít v novém okně": "Open in new window",
    "Ověření": "Authorisation",
    "Označeno:": "Marked:",
    "Označit jako zaplacené": "Mark as paid",
    "Pacient": "Client",
    "Pacient byl archivován. Jestliže chcete jeho kartu obnovit, kontaktujte podporu": "Client has been archived. If you want to restore his card, please contact support",
    "Pacient byl úspěšně přidán": "Client was successfully added",
    "Pacient ještě nepotvrdil GDPR": "Client has not confirmed GDPR yet",
    "Pacient již GDPR potvrdil": "Client has already confirmed GDPR",
    "Pacient má platný FT poukaz do %{date}.": "Client has valid FT voucher until %{date}.",
    "Pacient nemá nastavenou příští návštěvu": "The client has no upcoming appointment set",
    "Pacient odebrán": "Client taken",
    "Pacient odhlášen z odběru novinek": "Client unsubscribed from newsletter",
    "Pacient přídán": "Client added",
    "Pacient přihlášen k odběru novinek": "Client subscribed to newsletter",
    "Pacient úspěšně archivován": "Client successfully archived",
    "Pacient úspěšně odebrán z čekajících pacientů": "Client successfully removed from waiting clients",
    "Pacient úspěšně přidán do čekajících pacientů": "Client successfully added to waiting clients",
    "Pacient úspěšně upraven": "Client successfully adjusted",
    "Pacient zde zatím nemá žádnou návštěvu a k ní vytvořené popisy.": "The client does not have any appointment or related descriptions here yet.",
    "Pacienta se nepodařilo archivovat": "Failed to archive client",
    "Pacienta se nepodařilo odebrat": "Reservation could not be cancelled",
    "Pacienta se nepodařilo přidat do čekajících pacientů. Zkuste prosím znovu.": "The client could not be added to the waiting list. Please try again.",
    "Pacienta se nepodařilo přihlásit k odběru novinek. Zkuste to prosím znovu.": "The client could not be signed up for newsletter. Please try again.",
    "Pacienti": "Clients",
    "Pacienti úspěšně odebráni z čekajících pacientů": "Clients successfully removed from the waiting list",
    "Pacienti, kteří přišli poprvé": "New clients",
    "Pacientovi pošleme potvrzení o platbě na jeho email": "We will send the client a payment confirmation to their email",
    "Pacientů na stránku": "Clients to page",
    "pacientům": "clients",
    "Paragon": "Receipt",
    "paragon č.": "receipt no.",
    "Paragony": "Receipts",
    "Parametry příští návštěvy upraveny": "Next appointment parameters updated",
    "Pátek": "Friday",
    "Patička faktury": "Invoice footer",
    "Paušální": "Flat",
    "PDF": "PDF",
    "PDF se nepodařilo vygenerovat. Zkuste to prosím znovu.": "The PDF could not be generated. Please try again.",
    "Permanentka aktualizována": "Subscription updated",
    "Permanentka byla označena jako zaplacená": "Subscription was marked as paid",
    "Permanentka umožňuje nastavit předplacené návštěvy na vybrané služby. Klientovi ji lze přiřadit v jeho kartě a při platbě využít. V kartě klienta uvidíte i počet zbývajících předplacených návštěv.": "Memberships: Memberships allow you to set up prepaid visits for selected services. You can assign a membership to a client in their client card and use it when processing payments. The client card also shows the number of remaining prepaid visits.",
    "Permanentka úspěšně odebrána pacientovi.": "Subscription successfully removed for the client.",
    "Permanentka úspěšně přidána pacientovi.": "Pass successfully added to the client.",
    "Permanentka úspěšně vytvořena": "Subscription successfully created",
    "Permanentkou": "Membership Card",
    "Permanentku se nepodařilo pacientovi odebrat. Zkuste prosím znovu.": "Failed to collect the subscription from the client. Please try again.",
    "Permanentku se nepodařilo pacientovi přidat. Zkuste prosím znovu.": "Failed to add subscription to the client. Please try again.",
    "Permanentku se nepodařilo upravit.": "Reservation could not be cancelled",
    "Permanentku se nepodařilo vytvořit": "Failed to create the membership card",
    "Permanentky": "Memberships",
    "PL": "PL",
    "planovani": "planning",
    "Plánování": "Planning",
    "planovani-mistnosti": "room-planning",
    "Platba": "Payment",
    "Platba byla smazána": "Payment was deleted",
    "Platba byla zrušena": "Payment was canceled",
    "Platba pouze na místě při terapii": "Payment on-site during the therapy only",
    "Platba předem": "Prepayment",
    "Platba předplatným": "Subscription",
    "Platba za návštěvu byla úspěšně zrušena": "Payment for the appointment was successfully canceled",
    "platby": "payments",
    "Platby": "Payments",
    "Platby za předplatné": "Subscription payments",
    "Platby za pronájem aplikace": "Payment overview",
    "Plátce DPH": "VAT payer",
    "Plateb na stránku": "Payment for page",
    "Platební brána": "Payment gateway",
    "Platební brána byla úspěšně nastavena": "Payment gateway has been set up successfully",
    "Platební brána Comgate": "Comgate payment gateway",
    "Platební brána Fyzion": "Fyzion payment gateway",
    "Platební brána se používá jen v případě, že jsou u služby zapnuté platby předem.": "The payment gateway is only used when prepayment is enabled for the service.",
    "Platební informace": "Payment information",
    "Platná do:": "Expiry date:",
    "Platnost (v měsících)": "Validity (in months)",
    "Platnost do": "Expiry date",
    "Platnost musí být větší nebo rovna 1.": "Validity must be greater than or equal to 1.",
    "Platnost nové ceny od": "New price valid from",
    "Platnost vašeho odkazu vypršela. Zažádejte si o nastavení nového hesla": "Your link has expired. Please request a new password setup",
    "Po": "After",
    "Po rezervaci budete přesměrování na platební bránu pro uhrazení ceny terapie.": "After the reservation, you will be redirected to the payment gateway to pay for the therapy.",
    "Po skončení návštěvy se klientovi automaticky odešle žádost o zpětnou vazbu.": "After the visit ends, a feedback request is automatically sent to the client.",
    "Po sloučení se všechny minulé i budoucí": "After merging all past and future",
    "Po třech dnech": "After three days",
    "Po vložení kódu na váš web se zobrazí okno s rezervací": "After inserting the code into your website, a reservation window will appear",
    "Po vložení kódu na váš web se zobrazí tlačítko s rezervací": "After inserting the code into your website, a reservation button will be displayed",
    "pobočka": "branch",
    "Pobočka": "Branch",
    "Pobočka byla úspěšně smazána": "Branch was successfully deleted",
    "Pobočka byla úspěšně upravena": "Branch was successfully updated",
    "Pobočka byla úspěšně vytvořena": "Branch was successfully created",
    "pobocky": "branches",
    "Pobočky": "Branches",
    "Počet": "Quantity",
    "Počet dní do konce:": "Number of days left:",
    "Počet dní před návštěvou se odešle připomínka při nezaplacené rezervaci.": "Number of days before the appointment when a reminder is sent for an unpaid booking.",
    "Počet návštěv": "Number of appointments",
    "Počet návštěv musí být větší nebo rovno 1.": "The number of appointments must be greater than or equal to 1.",
    "Počet povolených rezervací je naplněn.": "The allowed number of reservations has been reached.",
    "Počet výkonů": "Number of performances",
    "Počet zbývajících vstupů:": "Remaining inputs:",
    "Počty návštěv": "Number of appointments",
    "Podání nebylo pojišťovně odesláno. Po smazání můžete dávku upravit a odeslat znovu.": "The submission has not been sent to the insurance company. Once it is deleted, you can edit the batch and send it again.",
    "Podepisování tohoto podání zůstalo nedokončené. Dávku podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Signing of this submission was left unfinished. You sign the batch in the Fyzion Signer app and Fyzion then sends it to the health insurance company.",
    "Podepsat a odeslat": "Sign and send",
    "Podívám se později": "I'll look later",
    "Podkategorie": "Subcategory",
    "Podmínky užití": "Terms of use",
    "Podpis": "Signature",
    "Podpis/razítko firmy": "Signature/Company stamp",
    "Podpora": "Support",
    "podpora@fyzion.cz": "podpora@fyzion.cz.",
    "Podrobnosti": "Details",
    "Podrobný popis služby, který se zobrazí klientům při výběru služby v online rezervacích.": "Detailed description of the service shown to clients when selecting a service in online bookings.",
    "Pohlaví": "Sex",
    "Pohlaví:": "Sex:",
    "Pohyb zboží": "Stock movement",
    "Pojištění EU a mezinárodní smlouvy": "EU insurance and international agreements",
    "Pojišťovna": "Insurance",
    "Pojišťovna byla smazána": "Insurance was deleted",
    "Pojišťovna přidána": "Insurer added",
    "Pojišťovna upravena": "Insurer adjusted",
    "Pojišťovna:": "Insurance:",
    "Pojišťovnou": "By the insurance company",
    "Pojišťovny": "Insurances",
    "Pokladna": "Cash register",
    "Pokračovat": "Continue",
    "Pokročilá funkce": "Advanced feature",
    "pokročilý tarif.": "Advanced tariff.",
    "Pokud": "If",
    "Pokud budete chtít nastavit jinou šablonu pro tuto zprávu, tak nás kontaktujte na": "If you would like to set a different template for this message, please contact us at",
    "Pokud je lekce plně obsazena, klienti se mohou zapsat jako náhradníci.": "If the session is fully booked, clients can sign up as substitutes.",
    "Pokud je zapnuto, klient musí poznámku vyplnit, aby mohl rezervaci dokončit.": "If enabled, the client must fill in the note to complete the booking.",
    "Pokud má klient aktivní permanentku, platba za návštěvu se automaticky odečte z ní.": "If the client has an active season ticket, the payment for the appointment is automatically deducted from it.",
    "Pokud má pacient trvalé bydliště v ČR, zadejte jeho rodné číslo bez lomítka.": "If the client has a permanent address in the Czech Republic, enter their birth number without a slash.",
    "Pokud máte jakékoliv dotazy, neváhejte nás kontaktovat na": "If you have any questions, do not hesitate to contact us at",
    "Pokud pracujete jako FO, ve zdravotnické dokumentaci budeme uvádět Vaše identifikační údaje. Pokud ne, ve zdravotnické dokumentaci budou údaje firmy.": "If you work as a FO, we will include your identification details in the medical documentation. If not, company details will be included in the medical documentation.",
    "Pokud problém přetrvává, napište nám na": "If the problem persists, write to us at",
    "Pokud si kdykoliv v budoucnu nebudete vědět rady, můžete se k průvodci aplikací vrátit.": "If you ever need help in the future, you can return to theapp's guide.",
    "Pokud účet ještě nemáte, zvolte možnost registrace.": "If you do not have an account yet, choose the registration option.",
    "Pole je povinné": "The field is required",
    "Položka byla úspěšně smazána": "Item was successfully deleted",
    "Položka byla úspěšně upravena": "The reservation has been successfully created.",
    "Položka byla úspěšně vytvořena": "The reservation has been successfully created.",
    "Položku se nepodařilo smazat": "Item could not be deleted",
    "polozky": "items",
    "Položky": "Items",
    "Pondělí": "Monday",
    "Popis": "Description",
    "Popis cviku": "Exercise description",
    "Popis služby": "Service description",
    "Popisy návštěv": "Appointment descriptions",
    "Porovnat fotky": "Compare photos",
    "Porovnat fotografie": "Compare photos",
    "Porovnat můžete maximálně 2 fotografie.": "You can compare up to 2 photos.",
    "Porovnat vybrané fotografie": "Compare selected photos",
    "porovnavac": "comparator",
    "Porovnávač": "Comparer",
    "Poslat firmě email": "Send email to the company",
    "Poslat firmě SMS": "Send SMS to the company",
    "Poslat terapeutovi email": "Send email to the therapist",
    "Poslat terapeutovi SMS": "Send SMS to the therapist",
    "Poslední fakturace": "Last invoicing",
    "Poslední návštěva": "Last appointment",
    "Poslední návštěva:": "Last appointment:",
    "Potvrdit": "Confirm",
    "Potvrdit nové heslo": "Confirm new password",
    "Potvrďte nové heslo": "Confirm new password",
    "Potvrzení GDPR před návštěvou fyzioterapie": "GDPR confirmation before attending physiotherapy",
    "Potvrzení zrušení platby": "Payment cancellation confirmation",
    "Potvrzeno": "Confirmed",
    "potvrzuji": "I confirm",
    "Potvrzuji": "I confirm",
    "Poukaz byl úspěšně vytvořen": "Voucher was successfully created",
    "Poukaz na lázně": "Spa voucher",
    "Poukaz úspěšně smazán": "Voucher successfully deleted",
    "poukazy": "vouchers",
    "Použít": "Use",
    "Použito pro všechny": "Used for all",
    "Používáte": "You use",
    "Povinná platba online při rezervaci": "Mandatory online payment at booking",
    "povolení online rezervací": "enabling online bookings",
    "Povolí přístup do klientské sekce pouze klientům, jejichž email máte v kartotéce": "Allows access to the client section only to clients whose email is in your database",
    "Povolit odpovědi na SMS": "Allow SMS replies",
    "Povolit online rezervace": "Enable online bookings",
    "Povolit registraci pacientů pouze s emailem z kartotéky": "Allow client registration only with an email from the database",
    "Povolit rezervace": "Allow bookings",
    "Povolit rezervace na státní svátky": "Allow bookings on public holidays",
    "Povolit rezervace pro nepřihlášené uživatele v klientském portále": "Allow bookings for non-logged-in users in the client portal",
    "Povolit skupinovou službu": "Enable group service",
    "Povolit zobrazení detailu cizí návštěvy": "Permission to view Client Cards of other users",
    "Povolit zrušení rezervace": "Allow booking cancellation",
    "Poznámka": "Note",
    "Poznámka k návštěvě": "Appointment note",
    "Poznámka úspěšně smazána": "Note successfully deleted",
    "Poznámka úspěšně uložena": "Note successfully saved",
    "Poznámka:": "Note:",
    "Poznámku se nepodařilo uložit": "The note could not be saved",
    "Poznámku se nepodařilo uložit. Zkuste to prosím znovu.": "Failed to save note. Please try again.",
    "Pozor, blížíte se k maximálnímu počtu pacientů.": "Beware, you are approaching the maximum number of clients.",
    "Pozor, blížíte se maximálnímu počtu pacientů.": "Beware, you are approaching the maximum number of clients.",
    "Pozor, chystáte se zaplatit za návštěvu, která ještě neproběhla.": "Beware, you are about to pay for an appointment that has not happened yet.",
    "Pozor! Snažíte se vytvořit návštěvu, která porušuje nastavení u Fyzioterapeuta, Služby nebo Místnosti nebo dochází ke konfliktu v kalendáři.": "Beware! You are trying to create an appointment that violates the settings for Therapist, Service or Room or there is a calendar conflict.",
    "Pozor! Upravujete globální cvik vytvořený aplikací Fyzion. Po uložení této úpravy vznikne duplicitní cvik v databázi. Původní cvik bude zachován v nezměněné podobě.": "Warning! You are editing a global exercise created by the Fyzion app. Saving this modification will create a duplicate exercise in the database. The original exercise will remain unchanged.",
    "pracoviste": "workplace",
    "Pracoviště": "Location",
    "Pracoviště bylo smazáno": "Location was deleted",
    "Pracoviště pro pojišťovny": "Reservation successfully created",
    "Pracoviště upraveno": "Location adjusted",
    "Pracoviště vytvořeno": "Reservation successfully created",
    "Pracoviště žadatele bylo úspěšně uloženo": "Applicant's workplace was saved successfully",
    "Pracoviště žadatele bylo úspěšně vytvořeno": "Applicant's workplace was created successfully",
    "Pracovní dny": "Working days",
    "Pracovní doba": "Working hours",
    "Pracovníci": "Workers",
    "Pracuji jako fyzická osoba": "I work as a natural person",
    "Pravidelné terapie": "Regular therapies",
    "Pravidla rušení rezervací": "Booking cancellation rules",
    "Před návštěvou ordinace se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": "Before visiting the clinic, please review the GDPR policy. To view the full text and confirm, click",
    "Před pokračováním vyplňte formulář": "Fill in the form before proceeding",
    "Před pokračováním zadejte rodné číslo": "Enter your birth number before proceeding.",
    "Před registrací musíte potvrdit souhlas se Všeobecnými obchodními podmínkami": "Before registration, you must confirm your consent to the General Terms and Conditions",
    "před termínem": "before the appointment",
    "Předem děkuji a budu se těšit na Vaši návštěvu.": "Thank you in advance and I look forward to your appointment.",
    "Předmět": "Subject",
    "Předmět emailu": "Email subject",
    "předplacené (permice)": "Prepaid (Membership)",
    "predplatne": "subscription",
    "Předplatné": "Subscription",
    "Předplatné Fyzion": "Fyzion Mind subscription",
    "Předplatné smazáno": "Subscription deleted",
    "Předplatné úspěšně přidáno": "Subscription successfully added",
    "Předplatné úspěšně upraveno": "Subscription successfully updated",
    "Předplatných na stránku": "Subscriptions on page",
    "Předplatným": "Subscription",
    "Předvolba": "Dialcode",
    "Předvolba země chybí. Zkuste to prosím znovu.": "Country prefix is missing. Please try again.",
    "Předvyplněn kód zadaný v %{time}. Platí obvykle 30 minut.": "Code entered at %{time} is prefilled. It is usually valid for 30 minutes.",
    "Preferovaná místnost": "Preferred room",
    "Preferovaná pobočka": "Preferred branch",
    "Preferovaná služba": "Preferred service",
    "Přehled cviků": "Exercise overview",
    "Přehled dávek": "Benefits overview",
    "Přehled položek": "Items overview",
    "Přehled pracovišť": "Locations overview",
    "Přehled transakcí": "Transaction overview",
    "Přehled výkonů": "Performance overview",
    "prehled-vykonu": "/performance-overview",
    "Přejete si vystavit doklad?": "Do you want to issue a document?",
    "Přejete si vystavit fakturu na storno poplatek?": "Do you want to issue an invoice for the cancellation fee?",
    "Přejete si vystavit storno doklad?": "Do you want to issue a refund receipt?",
    "Přejít do aplikace": "Go to the app",
    "Přejít do profilu": "Go to profile",
    "Přejít na tarif": "Switch to plan",
    "Překlady": "Translations",
    "Překlady názvu kategorie": "Category name translations",
    "Překlady názvu služby": "Service name translations",
    "Premium registrace": "Premium registration",
    "Přeskočit": "Skip",
    "Přesun rezervace": "Reschedule booking",
    "Přesun rezervací se řídí obecným nastavením firmy.": "Booking rescheduling follows the general company settings.",
    "Přesunout rezervaci": "Reschedule reservation",
    "Přesuňte některé pacienty do archivu a pak objednejte tarif znovu.": "Move some clients to archive and then reorder the tariff again.",
    "Převodem": "Bank transfer",
    "Převodem (QR kód)": "Bank transfer (QR code)",
    "při roční platbě": "with annual payment",
    "Při vytvoření online rezervace:": "When creating an online booking:",
    "Při zrušení online rezervace:": "When cancelling an online booking:",
    "Přidá po skončení rezervace časový blok, během kterého nebude možné vytvářet další rezervace (např. čas na úklid nebo pauzu).": "Adds a time block after the booking ends during which no further bookings can be created (e.g. time for cleaning or a break).",
    "Přidán na seznam": "Added to the list",
    "Přidáno": "Added",
    "Přidat": "Add",
    "Přidat 3 pacienty": "Add 3 clients",
    "Přidat časový interval": "Add time interval",
    "Přidat čekajícího": "Add pending client",
    "Přidat cvik": "Add exercise",
    "Přidat dodavatele": "Add supplier",
    "Přidat dokument": "Add document",
    "Přidat doplňkový text do e-mailů klientům": "Add additional text to client emails",
    "Přidat fotku": "Add photo",
    "Přidat FT poukaz": "Add FT voucher",
    "Přidat fyzioterapeuta": "Add user",
    "Přidat k návštěvě": "Add to appointment",
    "Přidat kategorii": "Add category",
    "Přidat místnost": "Add room",
    "Přidat náhradníka": "Add substitute",
    "Přidat náhradníka jako účastníka návštěvy": "Add substitute as appointment participant",
    "Přidat náhradníka jako účastníka návštěvy?": "Add substitute as appointment participant?",
    "Přidat návštěvu": "Add appointment",
    "Přidat nového čekajícího": "Add new pending client",
    "Přidat nového pacienta": "Add new client",
    "Přidat pacientovi permanentku": "Add subscription to the client",
    "Přidat peníze": "Add money",
    "Přidat permanentku": "Add membership",
    "Přidat platbu": "Add payment",
    "Přidat pobočku": "Add branch",
    "Přidat podkategorii": "Add subcategory",
    "Přidat pojišťovnu": "Add insurance",
    "Přidat položku": "Add item",
    "Přidat poznámku": "Add note",
    "Přidat pracoviště": "Add workplace",
    "Přidat předplatné": "Add subscription",
    "Přidat skupinovou návštěvu": "Add group appointment",
    "Přidat službu": "Add service",
    "Přidat soubor": "Add file",
    "Přidat štítek...": "Add label...",
    "Přidat údaj": "Add detail",
    "Přidat výkon": "Add power",
    "Přidat zboží": "Add product",
    "pridat-permanentku": "add-subscription",
    "pridat-volno": "add-leave",
    "Přidejte vlastní informace, které klienti potřebují vědět před návštěvou – například kde najdou vchod, co si mají vzít s sebou nebo jaké jsou storno podmínky. Informace se zobrazí pod detailem rezervace v e-mailu s potvrzením návštěvy a v její připomínce.": "Add your own information that clients need to know before their visit – for example where to find the entrance, what to bring, or what the cancellation terms are. The information is shown below the booking details in the visit confirmation email and in its reminder.",
    "Přihlášení jako nesprávný typ uživatele": "Logging as incorrect user type",
    "Přihlásit": "Sign in",
    "Přihlásit se": "Sign in",
    "Přihlašovací jméno": "Login",
    "Přihlašovací údaje": "Login details",
    "Přihlašovací údaje k portálům pojišťoven se nepodařilo načíst": "Login details for the insurance company portals could not be loaded",
    "Přihlašovací údaje se nepodařilo smazat": "Login details could not be deleted",
    "Přihlašovací údaje se nepodařilo uložit": "Login details could not be saved",
    "Přijat": "Accepted",
    "Příjemce": "Recipient",
    "Příjemce:": "Recipient:",
    "Přijmení": "Surname",
    "Příjmení": "Last name",
    "Přijmout do péče": "Accept into care",
    "Přijmout FT poukaz": "Accept FT voucher",
    "Příjmy": "Revenue",
    "Příjmy (budoucí)": "Upcoming revenue",
    "Příjmy fyzioterapeutů": "Therapist income",
    "Příjmy z nabízených služeb": "Income from offered services",
    "Přiložený soubor se nepodařilo nahrát": "Failed to upload the attached file.",
    "Primární barva události": "Primary event colour",
    "Primární barva události v rozvrhu místnosti": "Primary event colour in the room schedule",
    "Případně kontaktujte naši podporu na ": "Alternatively, contact our support at",
    "Připojištění": "Insurance",
    "Připomínka platby": "Payment reminder",
    "Připravujeme": "Upon request",
    "Přiřazené služby": "Assigned services",
    "Přišel/Přijde": "He/She came/Will come",
    "Příští návštěva": "Next appointment",
    "Příští objednání": "Next order",
    "Příští služba": "Next service",
    "Přítomen": "Present",
    "Pro dokončení rezervace je nutné souhlasit se zásadami zpracování osobních údajů.": "To complete the reservation, you must agree to the personal data processing policy.",
    "Pro export kartotéky kontaktujte naší podporu na": "To export the client database, contact our support at",
    "Pro individuální nastavení textace emailů vašim klientům kontaktujte naši technickou podporu na": "For individual email text customization for your clients, please contact our technical support at",
    "Pro individuální nastavení textace emailů vašim pacientům kontaktujte naši technickou podporu na": "For individual email text customization for your clients, please contact our technical support at",
    "Pro nastavení časového úseku, kdy je možné tuto službu rezervovat online, kontaktujte naší podporu na": "For setting the time slot when this service can be booked online, please contact our support at",
    "Pro nastavení otevírací doby místnosti kontaktujte naší podporu na": "For room opening hours setup please contact our support at",
    "Pro odeslání potvrzení o platbě zadejte email pacienta": "To send payment confirmation please enter client's email",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu %{portal}.": "To authorise with an SMS code, first save your login details for the %{portal} portal in your profile.",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu pojišťovny.": "To authorise with an SMS code, first save your login details for the insurance company portal in your profile.",
    "Pro platby převodem systém automaticky vystaví fakturu namísto stvrzenky.": "For bank transfer payments, the system automatically issues an invoice instead of a receipt.",
    "Pro přihlášení je potřeba přejít na správné URL klientského portálu. Kontaktujte svého poskytovatele služeb.": "To log in, you need to go to the correct client portal URL. Contact your service provider.",
    "Pro správné fungování aplikace je potřeba základní nastavení. Nebojte, základní nastavení aplikace a projití funkcí vám zabere jen pár minut!": "For the app to function properly, basic settings are required. Don't worry, setting up the basics and going through the features will only take a few minutes!",
    "Pro tohoto pacienta jste zatím nevytvořili žádný FT poukaz": "For this client, you have not created any PT referral yet",
    "Pro tohoto pacienta jste zatím nevytvořili žádný poukaz": "You have not created any voucher for this client yet",
    "Pro zobrazení platebního QR kódu vyplňte v": "Please fill in to display the payment QR code",
    "Proběhlé návštěvy": "Past appointments",
    "Probíhá synchronizace Vašeho kalendáře": "Calendar synchronization in progress",
    "Procentuální": "Percentage",
    "Prodané permanentky": "Sold season tickets",
    "Prodej zboží": "Product sales",
    "Prodejní cena (s DPH)": "Sale price (VAT included)",
    "Prodejní cena s DPH": "Sale price with VAT",
    "Prodejní cena zboží za ks (s DPH)": "Unit selling price of goods (VAT included)",
    "Prodejní hodnota (s DPH)": "Sales value (VAT included)",
    "Profil": "Profile",
    "Profilová fotografie": "Profile photo",
    "Profilový obrázek byl úspěšně nahrán": "Profile picture has been successfully uploaded",
    "Profily": "Profiles",
    "Proklik na skupinovou návštěvu": "Click to schedule group appointment",
    "Propojené aplikace": "Connected applications",
    "Propojení": "Integration",
    "Propojeno": "Connected",
    "Propojit": "Connect",
    "Prosím": "Please",
    "Prosíme o její úhradu co nejdříve.": "Please settle it as soon as possible.",
    "Provedeme vás, nastavíme základní parametry, přidáme první klienty.": "We'll guide you, set up basic parameters, and add your first clients.",
    "Provedené akce": "Actions performed",
    "Průměrná nákupní cena zboží na skladě za ks (s DPH)": "Average purchase price of goods in stock per piece (VAT included)",
    "Průvodce": "Guide",
    "Průvodce a nápovědu případně navštivte prostřednictvím odkazu v horním menu. Zde naleznete vše co vás zajímá přehledně na jednom místě.": "You can visit the guide and help through the link in the top menu. Here, you'll find everything you're interested in, clearly organized in one place.",
    "PSČ": "ZIP code",
    "Purobot API klíč": "Purobot API key",
    "Původní": "Original",
    "Původní dávka": "Original dose",
    "qr": "qr",
    "RČ / Datum narození": "NID / Date of birth",
    "Recenze": "Review",
    "Recenze byla smazána": "Review was deleted",
    "Recenze návštěv": "Client reviews",
    "recenzí": "reviews",
    "Recepční": "Receptionist",
    "Recepční vidí kalendáře uživatelů a statistiky, ale nemá přístup ke kartám klientů": "The receptionist can view user calendars and statistics but does not have access to client records",
    "Registrace": "Registration",
    "Registrace náhradníka byla úspěšně vytvořena.": "Substitute registration was successfully created.",
    "Registrace proběhla úspěšně": "Registration was successful",
    "Registrace proběhla úspěšně. Prosím potvrďte ještě svojí emailovou adresu kliknutím na odkaz ve vašem emailu!": "Registration was successful. Please confirm your email address by clicking on link in your email!",
    "Registrace se nepovedla": "Registration failed",
    "registrace-zdarma": "signup-free",
    "Registrace/Přihlášení": "Registration/Login",
    "Registrovat jako náhradník": "Register as substitute",
    "Registrovat se": "Sign up",
    "Resetování hesla": "Reset password",
    "Resetovat": "Reset",
    "Resetovat fyzioterapeuty dle diagnózy": "Reset therapists according to the diagnosis",
    "Resetovat heslo": "Reset password",
    "resetpassword/:uid/:token": "resetpassword/:uid/:token",
    "Řešíte jiný problém?": "Are you dealing with another issue?",
    "Rezarvace byla úspěšně změněna na": "The reservation was successfully changed to",
    "rezervace": "booking",
    "Rezervace": "Booking",
    "Rezervace byla úspěšně vytvořena.": "The reservation has been successfully created.",
    "Rezervace byla zrušena": "The reservation has been cancelled",
    "Rezervace čekajících": "Waiting list bookings",
    "Rezervace je potvrzena až po úspěšné online platbě.": "The booking is confirmed only after successful online payment.",
    "Rezervace nejdříve": "Earliest booking",
    "Rezervace nejpozději": "Latest booking",
    "Rezervace nemohla být vytvořena": "Reservation could not be created",
    "Rezervace pacienta jsou povoleny": "Client reservations are allowed.",
    "Rezervace pacienta jsou zablokovány": "Client reservations are blocked.",
    "Rezervace úspěšně vytvořena": "Reservation successfully created",
    "rezervací": "reservations",
    "Rezervaci již nelze zrušit online": "Reservations can no longer be cancelled online",
    "Rezervaci můžete zrušit do": "You can cancel your reservation until",
    "Rezervaci nebylo možné dokončit": "Booking could not be completed",
    "Rezervaci nelze zrušit online": "Reservation cannot be cancelled online",
    "Rezervaci se nepodařilo zrušit": "Reservation could not be cancelled",
    "Rezervační formulář": "Booking form",
    "Rezervační systém": "Booking system",
    "Rezervační tlačítko": "Booking button",
    "Rezervovat": "Book",
    "Rezervovat jako náhradník": "Book as substitute",
    "Rezervujte si termín": "Book your appointment",
    "Rezervujte si termín online": "Book your appointment online",
    "Rezervujte si termín u": "Book your appointment with",
    "Režim zobrazení": "Display mode",
    "Roční": "Year",
    "Rodné číslo": "Personal identification number",
    "Rodné číslo pacienta": "Client's birth number",
    "Rodné číslo:": "Personal identification number:",
    "Rok": "Year",
    "Roky": "Years",
    "Role": "Role",
    "Rozpis termínů fyzioterapie": "Schedule of physiotherapy appointments",
    "Rozpracovaná návštěva uložena": "Ongoing appointment saved",
    "Rozpracované podání bylo smazáno": "The unfinished submission has been deleted",
    "Rozpracované podání se nepodařilo smazat": "The unfinished submission could not be deleted",
    "Rozvrh místností": "Room schedule",
    "Rozvrh skupinových lekcí": "Group session schedule",
    "s GDPR, klikněte níže na tlačítko": "with GDPR, click the button below",
    "S jakým problémem k nám přicházíte?": "What issue are you coming to us with?",
    "S nezaplacenými návštěvami": "With unpaid appointments",
    "Šablon na stránku": "Page template",
    "Šablona": "Template",
    "Šablona byla úspěšně aktualizována": "Template was successfully updated",
    "Šablona byla úspěšně smazána": "Template was successfully deleted",
    "Šablona byla úspěšně upravena": "Template was successfully updated",
    "Šablona byla úspěšně vytvořena": "Template was created successfully",
    "Šablona FT výkonů": "FT performance template",
    "Šablona neobsahuje žádné výkony": "The template contains no performances",
    "Šablona výkonů": "Performance template",
    "Šablona výkonů FT": "FT performance template",
    "Šablona výkonů pro návštěvy": "Performance template for appointments",
    "sablony": "templates",
    "Šablony": "Templates",
    "Šablony výkonů FT": "FT performance templates",
    "Šablony výkonů pro návštěvy": "Performance templates for appointments",
    "Sada cviků byla odeslána klientovi": "The set of exercises has been sent to the client",
    "Sazba DPH": "VAT rate",
    "Sdílejte": "Share",
    "SDÍLEJTE NÁS": "SHARE US",
    "Sdílení": "Sharing",
    "sdílet": "Share",
    "sdílet aplikaci": "Share application",
    "Sekundární barva události": "Secondary event colour",
    "Shrnutí historie návštěv": "Appointment history summary",
    "Shrnutí návštěv": "Appointment summary",
    "SK": "SK",
    "Sklad": "Warehouse",
    "Skrýt": "Hide",
    "Skupina služeb": "Service group",
    "Skupinová návštěva": "Group appointment",
    "Skupinová návštěva smazána": "Group appointment deleted",
    "Skupinové lekce se nepodařilo načíst": "Failed to load group sessions",
    "Skupinovka": "Group",
    "Skutečně si přejete změnit tarif?": "Do you really want to change the tariff?",
    "Sloučení karet": "Card merging",
    "Sloučit karty": "Merge cards",
    "Služba": "Service",
    "Služba nenalezena": "Reservation not found",
    "Služba:": "Service:",
    "sluzby": "services",
    "Služby": "Services",
    "Služby dle kategorií celkem za rok": "Services by Categories - Annual Total",
    "Služby nebudou smazány, kategorie jim bude pouze odebrána.": "Services will not be deleted, only their category will be removed.",
    "Služby:": "Services:",
    "Smazání": "Deletion",
    "Smazání obrázku se nezdařilo": "Image deletion failed",
    "Smazáno": "Deleted",
    "Smazat": "Delete",
    "Smazat cvik": "Delete exercise",
    "Smazat dodavatele": "Delete supplier",
    "Smazat dokument": "Delete document",
    "Smazat formulář": "Delete form",
    "Smazat fotku": "Delete photo",
    "Smazat fotografii": "Delete photo",
    "Smazat kategorii cviků": "Delete exercises category",
    "Smazat kategorii služeb": "Delete service category",
    "Smazat místnost": "Delete room",
    "Smazat návštěvu": "Delete appointment",
    "Smazat nezaplacenou návštěvu před termínem": "Delete unpaid appointment before the date",
    "Smazat obrázek": "Delete image",
    "Smazat permanentku": "Delete season ticket",
    "Smazat pobočku": "Delete branch",
    "Smazat podání": "Delete submission",
    "Smazat podpis": "Delete signature",
    "Smazat pojišťovnu": "Delete insurance",
    "Smazat položku": "Delete item",
    "Smazat pouze toto volno": "Delete only this availability",
    "Smazat pouze tuto návštěvu": "Delete only this appointment",
    "Smazat pouze tuto skupinovou návštěvu": "Delete only this group appointment",
    "Smazat pracoviště": "Delete workplace",
    "Smazat předplatné": "Delete subscription",
    "Smazat přihlašovací údaje k portálu %{portal}?": "Delete the login details for the %{portal} portal?",
    "Smazat recenzi": "Delete review",
    "Smazat rozpracované podání": "Delete unfinished submission",
    "Smazat rozpracované podání?": "Delete the unfinished submission?",
    "Smazat šablonu": "Delete template",
    "Smazat službu": "Delete service",
    "Smazat soubor": "Delete file",
    "Smazat stávající zápis": "Delete existing entry",
    "Smazat toto a všechna budoucí volna": "Delete this and all future availability",
    "Smazat tuto a všechny budoucí návštěvy": "Delete this and all future appointments",
    "Smazat tuto a všechny budoucí skupinové návštěvy": "Delete this and all future group appointments",
    "Smazat video": "Delete video",
    "Smazat volno": "Delete time off",
    "Smazat zboží": "Delete product",
    "Smaže rozpracované podání, např. abyste mohli dávku upravit a odeslat znovu": "Deletes the unfinished submission, e.g. so you can edit the batch and send it again",
    "Smluvní pojištění": "Contract insurance",
    "SMS": "SMS",
    "SMS byla úspěšně odeslána": "SMS was sent successfully",
    "SMS byly úspěšně odeslána": "The reservation has been successfully created.",
    "SMS čekajícímu": "SMS to be sent",
    "SMS klientům": "SMS to clients",
    "SMS kód": "SMS code",
    "SMS kód se nepodařilo vyžádat": "The SMS code could not be requested",
    "SMS odpovědi od klientů budou přeposílány na zvolený email": "SMS replies from clients will be forwarded to the selected email",
    "SMS se nepodařilo odeslat": "Failed to send SMS",
    "SMS tento měsíc": "SMS this month",
    "Sobota": "Saturday",
    "Soubor se nepodařilo stáhnout": "The file could not be downloaded",
    "Soubor se zobrazí zákazníkům v posledním kroku online rezervace.": "The file will be shown to customers in the last step of the online booking.",
    "Soubory úspěšně nahrány": "Files successfully uploaded",
    "Současné heslo": "Current password",
    "Souhlas GDPR": "GDPR consent",
    "Souhlas s GDPR": "Consent with GDPR",
    "Souhlas s GDPR odesílat automaticky": "Send GDPR consent automatically",
    "Souhlas s novinkami:": "Consent to receiving newsletters:",
    "Souhlas se zpracováním osobních údajů": "Consent to the processing of personal data",
    "Souhlas udělen": "Consent granted",
    "Souhlasil s novinkami": "Agreed with the newsletter",
    "Souhlasili": "Agreed",
    "Souhlasím s vytvořením karty pacienta v souladu s": "I agree to the creation of a client record in accordance with",
    "Souhlasím se": "I agree to",
    "Souhlasím se zasíláním novinek a zajímavých nabídek": "I agree to receive news and interesting offers",
    "souhlasíte": "you agree",
    "Spis byl načten": "Record was loaded",
    "Spis se nepodařilo načíst": "Failed to load the record",
    "Spis se nepodařilo vytvořit": "Failed to create the record",
    "Spisy": "Records",
    "Spisy byly synchronizovány": "Records have been synchronised",
    "Spisy se nepodařilo načíst": "Failed to load records",
    "Splatnost": "Due date",
    "Splatnost faktury": "Invoice due",
    "Spočítat": "Calculate",
    "Stačí": "Just",
    "Stáhnout": "Download",
    "Stáhnout fakturu": "Download invoice",
    "Stáhnout soubory": "Download files",
    "Stáhnout zálohovou fakturu": "Download backup invoice",
    "Start": "Start",
    "STATISTICS": "STATISTICS",
    "Statistiky": "Statistics",
    "Status": "Status",
    "Stav": "Status",
    "Stav bude změněn v obou případech. Volbou „Ano“ se doklad vystaví společně se změnou stavu.": "The status changes either way. Choosing “Yes” issues the document together with the status change.",
    "Stav bude změněn v obou případech. Volbou „Ano“ se faktura vystaví společně se změnou stavu.": "The status changes either way. Choosing “Yes” issues the invoice together with the status change.",
    "Stav návštěvy byl změněn": "Visit status changed",
    "Stav platby": "Payment status",
    "Stejné jako fakturační": "Same as billing",
    "Štítek byl úspěšně odebrán": "Label was successfully removed",
    "Štítek byl úspěšně smazán": "Label was successfully deleted",
    "Štítek byl úspěšně vytvořen": "Label was successfully created",
    "Štítky": "Labels",
    "Štítky návštěv": "Appointment labels",
    "Štítky pacientů": "Client labels",
    "Storno": "Cancel",
    "Storno poplatek": "Cancellation fee",
    "Stornovaná faktura": "Cancelled invoice",
    "stornovanou fakturu č.": "invoice no.",
    "Stornovaný paragon": "Cancelled receipt",
    "stornovaný paragon č.": "receipt no.",
    "Stornovat": "Continue",
    "stránka někam utekla...": "Page somewhere escaped...",
    "Stránka ordinace": "/office",
    "Středa": "Wednesday",
    "Stvrzenek na stránku": "Toggle to page",
    "svůj prohlížeč nebo si nainstalujte jiný.": "Enable your browser or install another.",
    "Synchronizace kalendáře byla zrušena": "Calendar synchronization has been canceled",
    "Synchronizace s Google kalendářem": "Sync with Google calendar",
    "Synchronizace se nezdařila": "Synchronization failed",
    "synchronizace-kalendare": "calendar-sync",
    "Synchronizovat události z Google kalendáře do Fyzionu": "Sync events from Google Calendar to Fyzion",
    "Synchronizujte svůj Fyzion kalendář s kalendářem Google": "Sync your Fyzion calendar with Google calendar",
    "Systém bude při automatickém vystavování dokladů používat výhradně fakturu místo stvrzenky.": "The system will use exclusively invoices instead of receipts when automatically issuing documents.",
    "Tarif": "Pricing plan",
    "Tarify": "Pricing plans",
    "Tato akce může ovlivnit rezervační systém.": "This action may affect the booking system.",
    "Tato funkce je dostupná pouze v placeném tarifu.": "This function is only available in paid subscription.",
    "Tato funkce je dostupná pouze v placeném tarifu. Placené tarify ukrývají spoustu pokročilých funkcí, které Vám ulehčí práci.": "This function is available only in advanced subscription. Advanced subscriptions unlock many advanced features to make your work easier.",
    "Tato karta se smaže.": "This card will be erased.",
    "Tato přihlašovací stránka je určena pouze terapeutům.": "This login page is for therapists only.",
    "Tato služba bude automaticky předvyplněna při vytváření nové návštěvy.": "This service will be automatically pre-filled when creating a new appointment.",
    "Tato zpráva bude účtována jako 2 SMS": "This message will be charged as 2 SMS",
    "Tato zpráva bude účtována jako 3 SMS": "This message will be charged as 3 SMS",
    "Tel.:": "Tel.:",
    "Telefon": "Phone number",
    "Telefonní číslo": "Phone number",
    "Telefonní číslo:": "Phone number:",
    "Tento měsíc": "This month",
    "Tento pacient má nezaplacenou návštěvu, která nebyla omluvená.": "This client has an unpaid appointment that was not excused.",
    "Tento profil zatím nemá žádné permanentky.": "This profile has no season tickets yet.",
    "Tento rok": "This year",
    "Tento týden": "This week",
    "Terapeut": "Therapist",
    "Terapeut nemá přiřazené pracoviště pro pojišťovny. Přiřaďte pracoviště v profilu terapeuta a zkontrolujte nastavení pracoviště": "The therapist has no workplace assigned for insurance companies. Assign a workplace in the therapist profile and check the workplace settings",
    "Termín můžete přesunout do": "You can reschedule the appointment untill",
    "Termín přidán. Nyní je možné pokračovat k potvrzení rezervací.": "Appointment added. You can now proceed to confirm the reservations.",
    "Termín pro zaplacení": "Payment deadline",
    "termínů": "appointments",
    "Text": "Text",
    "Text s instrukcemi pro klienta, co má do poznámky uvést (např. Uveďte své zdravotní potíže nebo omezení).": "Text with instructions for the client on what to include in the note (e.g. Please describe your health issues or limitations).",
    "Text SMS překročil maximální povolený limit znaků.": "SMS text has exceeded the maximum allowed character limit.",
    "Těžší varianta": "Harder version",
    "theme_company": "Fyzion",
    "Tisk": "Print",
    "Tisk GDPR": "Print GDPR",
    "Tisk karty pacienta": "Print client card",
    "Tisk návštěv": "Print visits",
    "Tisk návštěvy": "Appointment print",
    "Tisk rozpisu termínů návštěv": "Print schedule of appointment dates",
    "Toto okno můžete zavřít.": "You can close this window.",
    "Toto podání už na autorizaci nečeká, mezitím se dokončilo.": "This submission is no longer awaiting authorisation, it has been completed in the meantime.",
    "Toto pole je povinné": "This field is required",
    "Trvání služby v minutách": "Duration of service in minutes",
    "týden": "week",
    "Týdně": "Weekly",
    "týdnů": "weeks",
    "týdny": "weeks",
    "Týdny": "Weeks",
    "Typ akce": "Action type",
    "Typ dávky": "Batch type",
    "Typ dokladu": "Document type",
    "Typ permanentky": "Season ticket",
    "Typ platby": "Payment type",
    "Typ platební brány": "Payment gateway type",
    "Typ poukazu": "Voucher type",
    "Typ připojištění": "Insurance type",
    "Typ připojištění:": "Type of insurance:",
    "Typ šablony": "Template type",
    "Typ spisu": "Record type",
    "Typ subjektu": "Subject type",
    "Typ transakce": "Transaction type",
    "Typ výkonu": "Power type",
    "Typ vyšetření": "Service",
    "Typ vyšetření a délka": "Examination type and duration",
    "Typ záznamu": "Record type",
    "Tyto informace jsou vaše soukromé kontaktní údaje. Změnu veřejných kontaktních údajů, které vidí pacienti, uděláte v ": "These are your private contact details. To change the public contact details visible to clients, go to SETTINGS - CONTACT DETAILS.",
    "Účast pacienta": "Client's participation",
    "Údaje": "Details",
    "Údaje instituce": "Billing information",
    "Údaje o pojištění": "Insurance details",
    "Údaje pro platbu převodem": "Data for bank transfer",
    "Údaje úspěšně změněny": "Data successfully changed",
    "Úhloměr": "Protractor",
    "Uhradit": "Pay",
    "Uhrazeno": "Paid",
    "Ukázat cvik": "Show exercise",
    "Ulice": "Street",
    "Ulice a č. p.": "Street and house number",
    "Ulice a č.p.": "Street and house number",
    "Uložené heslo vám nikdy nezobrazíme. Ponechte pole prázdné, pokud ho nechcete měnit.": "We will never show you the saved password. Leave the field empty if you do not want to change it.",
    "Uložené šablony": "Saved templates",
    "Uloženo": "Saved",
    "uložit": "save",
    "Uložit": "Save",
    "Uložit a zamknout": "Save and lock",
    "Uložit jako PDF do karty pacienta": "Save as PDF to the client’s record",
    "Uložit rozpracované": "Save in progress",
    "Uložit změny": "Save changes",
    "Umožní rezervaci více klientů na jeden termín.": "Allows multiple clients to book a single appointment slot.",
    "Umožnit rezervaci náhradníkům": "Allow substitutes to book",
    "Upozornit klienta při vytvoření, změně a zrušení návštěvy": "Notify the client when an appointment is created, changed or cancelled",
    "Upozornit terapeuta na akce provedené jinym terapeutem": "Notify the therapist of actions performed by another therapist",
    "Úprava": "Edit",
    "Úprava příští návštěvy": "Edit next appointment",
    "upravit": "edit",
    "Upravit": "Edit",
    "Upravit cvik": "Edit exercise",
    "Upravit dodavatele": "Edit supplier",
    "Upravit dostupnost": "Edit availability",
    "Upravit fakturaci": "Edit billing",
    "Upravit FT poukaz": "Edit FT voucher",
    "Upravit fyzioterapeuta": "Edit therapist",
    "Upravit kategorii": "Edit category",
    "Upravit kategorii cviků": "Edit exercises category",
    "Upravit kategorii služeb": "Edit service categories",
    "Upravit místnost": "Edit room",
    "Upravit ordinační hodiny": "Edit office hours",
    "Upravit pacientovu permanentku": "Edit client's season ticket",
    "Upravit permanentku": "Edit season ticket",
    "Upravit platbu č.": "Edit payment n.",
    "Upravit pobočku": "Edit branch",
    "Upravit podkategorii": "Edit subcategory",
    "Upravit pojišťovnu": "Edit insurance",
    "Upravit položku": "Edit item",
    "Upravit pracoviště": "Edit workplace",
    "Upravit pracoviště žadatele": "Edit applicant's workplace",
    "Upravit šablonu": "Edit template",
    "Upravit šablonu výkonů": "Edit performance template",
    "Upravit službu": "Edit service",
    "Upravit štítky": "Edit labels",
    "Upravit uživatele": "Edit user",
    "Upravit žadatele": "Edit requester",
    "Upravit zboží": "Edit product",
    "upravit-ft-poukaz/:ticketId": "edit-ft-voucher/:ticketId",
    "upravit-permanentku/:ticketId": "edit-subscription/:ticketId",
    "upravit-volno": "edit-leave",
    "Určuje maximální počet pacientů na skupinovou návštěvu. Hodnota 0 se rovná neomezenému počtu pacientů.": "Specifies the maximum number of clients for group appointment. Value 0 equals unlimited number of clients.",
    "Určuje základní stav odesílání stvrzenek. Toto nastavení můžete ještě individuálně upravovat před samotnou platbou za návštěvu.": "It determines the basic state of sending receipts. You can still adjust this setting individually before the actual payment for the appointment.",
    "Určuje, kolik dní před návštěvou musí být provedena platba. Pokud není zaplaceno včas, návštěva se automaticky smaže. (0 dní = nikdy nedojde ke smazání)": "Specifies how many days before the appointment payment must be made. If not paid on time, the appointment is automatically deleted. (0 days = never deleted)",
    "Určuje, v jakém časovém rozmezí (počet dní) musí být všechny rezervace v rámci jedné objednávky.": "Specifies the time range (number of days) within which all bookings in a single order must fall.",
    "Určuje, zda musí být během služby přítomen terapeut. Vypíná se např. u služeb bez přímé obsluhy (vana, infrasauna apod.).": "Specifies whether a therapist must be present during the service. Disable for unattended services (e.g. bath, infrared sauna, etc.).",
    "user.form.role.worker.tooltip": "The worker does not have access to the Settings, Statistics and Insurance tab. Furthermore, he cannot change the selected tariff",
    "Úspěšně jste byli zaregistrováni jako náhradník": "You have been successfully registered as a substitute",
    "Úspěšně nahrána dávka do Purobota": "Batch successfully uploaded to Purobot",
    "Úterý": "Tuesday",
    "Už mám odcvičeno:": "I have already completed my exercise:",
    "Územní pracoviště VZP": "VZP territorial workplace",
    "Uživatel": "User",
    "Uživatel byl deaktivován": "The user has been deactivated",
    "Uživatel byl úspěšně přidán": "User was successfully added",
    "Uživatelé": "Users",
    "v angličtině": "in English",
    "v češtině": "in Czech",
    "V historii cvičení nejsou žádné záznamy.": "There are no records in the exercise history.",
    "V historii rezervací zatím není žádná absolvovaná návštěva.": "There are no completed appointments in the reservation history yet.",
    "V měsících, ode dne zakoupení": "In months, from day of purchase",
    "v nejnovější verzi Google Chrome, kterou můžete zdarma stáhnout na": "In the latest version of Google Chrome, which you can download for free at",
    "V ordinaci hotově/kartou": "In the office by cash/card",
    "v polštině": "in Polish",
    "V případě neuhrazení může dojít k dočasnému zablokování Vašeho účtu.": "Failure to pay may result in temporary suspension of your account.",
    "V případě, že je tato volba zapnuta, pacientům automaticky odchází i stvrzenky za zakoupené permanentky.": "If this option is enabled, receipts for purchased passes are automatically sent to clients as well.",
    "V případě, že přejdete na některý z pokročilých tarifů spolupráce, automaticky se ruší limit na počet pacientů v aplikaci.": "If you switch to any of the advanced cooperation tariffs, the limit on the number of clients in the application is automatically removed.",
    "V případě, že se nemůžete dostavit, volejte na": "If you are unable to attend, please call",
    "V tomto období se počet návštěv u každého z fyzioterapeutů rovná nule": "During this period, the number of appointment to each of the therapists is zero",
    "V tuto chvíli není možné GDPR potvrdit. Zkuste to znovu později.": "At this moment it is not possible to confirm GDPR. Please try again later.",
    "Vám navýšíme limit kartotéky pacientů v balíčku Freemium.": "We will increase the client record limit in the Freemium package for you.",
    "Variabilní symbol": "Variable symbol",
    "Variabilní symbol:": "Variable symbol:",
    "Váš prohlížeč nepodporuje datový formát tohoto videa.": "Your browser does not support the data format of this video.",
    "vaše číslo účtu nebo IBAN.": "Your account number.",
    "Vaše heslo bylo úspěšně změněno.": "Your password has been successfully changed.",
    "Vaše heslo bylo úspěšně změněno. Nyní se můžete přihlásit.": "Your password has been successfully changed. You can now log in.",
    "Vaše kategorie služeb byla smazána": "Your service category has been deleted",
    "Vaše platba proběhla v pořádku. Mockrát děkujeme, že využíváte aplikaci Fyzion.": "Your payment has been successful. Thank you for using Fyzion app.",
    "Vaše platba se bohužel nezdařila. Zkuste platbu opakovat. Jestliže platba opět neproběhne v pořádku, můžete zkusit zaplatit převodem.": "Your payment was unsuccessful. Please try the payment again. If the payment fails again, you can try to pay by bank transfer.",
    "Vaše rodné číslo potřebujeme k vytvoření vaší karty pacienta, nebo abychom ověřili, že u nás už kartu máte. S rodným číslem nakládáme v souladu s vyhláškou o zdravotnické dokumentaci.": "We need your birth number to create your client record or to verify that you already have a record with us. We handle birth numbers in accordance with the medical documentation regulations.",
    "Vaše služba byla smazána": "Your service has been deleted",
    "Vaše zpráva": "Your message",
    "Vaši rezervaci už nelze zrušit online!": "Your reservation can no longer be cancelled online!",
    "Včera": "Yesterday",
    "včetně prodeje zboží": "including the sale of goods",
    "ve slovenštině": "in Slovak",
    "Veřejné zdravotní pojištění": "Public health insurance",
    "Video": "Video",
    "Video a obrázky cviku": "Exercise video and images ",
    "Visa ikona": "Visa icon",
    "Vítáme vás v aplikaci Fyzion": "Welcome to the Fyzion app",
    "Vítejte na přihlašovací stránce klientského portálu CortexApp.": "Welcome to the FyzionApp client portal login page.",
    "Vítejte v CortexApp": "Welcome to FyzionApp",
    "Vlastní": "Custom",
    "Vložit konečnou (zkopírovat první) zastávku": "Insert final stop (copy first)",
    "Vložit pod stávající zápis": "Insert under existing entry",
    "Vložit zastávku cesty": "Insert route stop",
    "Vložit zpáteční (zkopírovat předchozí) zastávku": "Insert return stop (copy previous)",
    "Volno (Dovolená)": "Vacation (Holiday)",
    "Volno odstraněno": "Leave removed",
    "VOP úspěšně nahrány": "Terms and conditions successfully uploaded",
    "VOP úspěšně odebrány": "Terms and conditions successfully removed",
    "Vrátit do průvodce?": "Return to the guide?",
    "Vše": "All",
    "Všechny": "All",
    "Všechny doklady": "All documents",
    "Všechny jeho návštěvy zůstanou nadále ve Vašem kalendáři, ale nebude již možné vytvářet nové návštěvy pacientovi ani se Vám nebude pacient nabízet v seznamu pacientů.": "All their appointments will remain in your calendar, but it will no longer be possible to create new appointments for the client or for the client to appear in the client list.",
    "Všechny místnosti": "All rooms",
    "Všechny naplánované návštěvy na této pobočce zůstanou zachovány.": "All scheduled appointments at this branch will be preserved.",
    "Všechny naplánované návštěvy v této místnosti zůstanou zachovány.": "All scheduled appointments in this room will be preserved.",
    "Všechny pobočky": "All branches",
    "Všechny poukazy": "All vouchers",
    "Všechny pracoviště": "All locations",
    "Všechny služby": "All services",
    "Všechny typy služeb": "All types",
    "Všeobecné obchodní podmínky": "General terms and conditions",
    "všeobecnými obchodními podmínkami": "general terms and conditions",
    "Všeobecnými obchodními podmínkami": "By general terms and conditions",
    "Všichni": "All",
    "Všichni klienti": "All clients",
    "Všichni pacienti": "All clients",
    "Vyberte": "Select",
    "Vyberte alespoň jednu službu": "Please select at least one service",
    "Vyberte dokumenty": "Select documents",
    "Vyberte FT poukaz": "Select FT voucher",
    "Vyberte kategorii služby podle jejího typu (např. masáže, skupinové cvičení). Kategorie ovlivňuje přehlednost a zobrazení služeb v online rezervacích.": "Select the service category by its type (e.g. massages, group exercise). The category affects clarity and how services are displayed in online bookings.",
    "Vyberte klienta jako náhradníka": "Select a client as substitute",
    "Vyberte obrázky": "Select images",
    "Vyberte pacienta": "Select client",
    "Vyberte předplatné": "Choose subscription",
    "Vyberte prosím alespoň 1 fotografii.": "Please select at least 1 photo.",
    "Vyberte šablonu": "Choose a template",
    "Vyberte soubor": "Choose a file",
    "Vyberte soubory k nahrání do systému": "Select files to upload to the system",
    "Vyberte termín": "Select a date",
    "Vyberte typ poukazu": "Select voucher type",
    "Vyberte typ spisu": "Select record type",
    "Vyberte typ výkonu z číselníku ÚZIS. Povinné pole sloužící pro statistiky a vykazování.": "Select the performance type from the ÚZIS code list. Required field used for statistics and reporting.",
    "Vyberte video": "Select video",
    "Vyberte zboží...": "Select product...",
    "Vybraná šablona nebyla nalezena": "The selected template was not found",
    "Vybraná šablona neobsahuje žádné výkony": "The selected template contains no performances",
    "Vybrané dávky elektronicky podepíšete v aplikaci Fyzion Signer — jedním podpisem, v němž dávky nejprve projdete. Fyzion je poté odešle zdravotní pojišťovně a o výsledku vás bude informovat e-mailem.": "You sign the selected batches electronically in the Fyzion Signer app, with one signature in which you review the batches first. Fyzion then sends them to the health insurance company and notifies you of the result by e-mail.",
    "Vybrané dávky odešlete s ověřením jedním SMS kódem. Hromadně lze odeslat jen dávky pojišťoven jednoho portálu. O výsledku vás budeme informovat e-mailem.": "Send the selected batches authorised with one SMS code. Only batches of insurance companies of one portal can be sent in bulk. We will notify you of the result by e-mail.",
    "Vybrané termíny": "Selected dates",
    "Vybráni všichni klienti seznamu, celkem": "All clients in the list selected, total",
    "Vybráno cviků": "Selected exercises",
    "Vybraný terapeut neprovádí zvolenou službu. Prosím vyberte jinou službu nebo terapeuta.": "The selected therapist does not perform the selected service. Please select another service or therapist.",
    "Vybrat": "Select",
    "Vybrat barvu": "Select color",
    "Vybrat barvu štítku": "Select label colour",
    "Vybrat diagnózu": "Select diagnosis",
    "Vybrat dodavatele": "Select supplier",
    "Vybrat druh péče": "Select type of care",
    "Vybrat druh úhrady": "Select type of payment",
    "Vybrat IČP": "Select IČP",
    "Vybrat kategorii": "Select category",
    "Vybrat kód": "Select code",
    "Vybrat období": "Select",
    "Vybrat odbornost": "Select expertise",
    "Vybrat ostatní diagnózy": "Select other diagnoses",
    "Vybrat pacienta": "Select client",
    "Vybrat podkategorii": "Select subcategory",
    "Vybrat pracoviště": "Select workplace",
    "Vybrat pracovníky": "Select workers",
    "Vybrat šablonu": "Select template",
    "Vybrat správnou kartu": "Choose the right card",
    "Vybrat vše": "Select all",
    "Vybrat všechny klienty seznamu, celkem": "Select all clients in the list, total",
    "Vybrat výkon": "Select power",
    "Výchozí": "Default",
    "Výchozí šablona": "Default template",
    "Vyčistit filtr": "Clean filter",
    "Vygenerovat fakturu": "Generate invoice",
    "Vyhledat": "Search",
    "Vyhledat diagnózu": "Search for diagnosis",
    "Vykázat výkon bez FT poukazu": "Report performance without FT voucher",
    "Výkon": "Power",
    "Výkon je odemknutý": "Power is unlocked",
    "Výkon je zamknutý": "Power is locked",
    "Výkon nelze upravit, protože je již přiřazen k návštěvě.": "The performance cannot be modified as it is already assigned to an appointment.",
    "Výkonová": "Power",
    "výkonů": "performances",
    "Výkonů na stránku": "Documents per page",
    "vykony": "performances",
    "Výkony": "Performances",
    "Výkony nezapsané na návštěvě budou smazány.": "Performances not entered on the appointment will be deleted.",
    "Vylepšení textu se nezdařilo.": "Text enhancement failed.",
    "Vylepšený text": "Enhanced text",
    "Vylepšit s AI": "Enhance with AI",
    "Vylepšit zprávu": "Enhance message",
    "Vyplňte ve formátu +420 123 456 789": "Please fill in the format +420 123 456 789",
    "Vyplňte ve formátu DD.MM.RRRR": "Please fill in the format DD.MM.YYYY",
    "Vyplňte ve formátu HH:mm": "Please fill in as HH:mm",
    "Vyplňte, pokud pacient změnil pojišťovnu, abychom mohli správně vytvořit dávku.": "Please fill in if the client has changed insurance company so that we can create the prescription correctly.",
    "Výše kreditu:": "Credit amount:",
    "Výše max. úhrady": "Maximum reimbursement",
    "Výše max. úhrady:": "Maximum reimbursement amount:",
    "Výše paušálu:": "Amount of flat rate:",
    "Výše storno poplatku účtovaného při zrušení rezervace.": "Amount of the cancellation fee charged when a booking is cancelled.",
    "výskytech": "outbreaks",
    "výskytu": "occurrence",
    "Vystavovat fakturu pro platby převodem": "Issue invoice for bank transfer payments",
    "Vystavovat faktury místo stvrzenek": "Issue invoices instead of receipts",
    "vytisknout": "print",
    "Vytisknout": "Print",
    "Vytváření rezervace": "Creating a booking",
    "Vytvoření": "Creation",
    "Vytvořeno": "Create a reservation",
    "Vytvořit": "Create a reservation",
    "Vytvořit 3 návštěvy": "Create 3 appointments",
    "Vytvořit a tisknout": "Create and print",
    "Vytvořit dávku": "Create a reservation",
    "Vytvořit dávky": "Create a reservation",
    "Vytvořit faktury": "Create a reservation",
    "Vytvořit FT poukaz": "Create FT voucher",
    "Vytvořit novou kategorii": "Create a new reservation",
    "Vytvořit novou podkategorii": "Create a new subcategory",
    "Vytvořit novou rezervaci": "Create a new reservation",
    "Vytvořit novou službu": "Create a new service",
    "Vytvořit nový cvik": "Create a new exercise",
    "Vytvořit opravnou dávku": "Create a reservation",
    "Vytvořit platbu": "Create payment",
    "Vytvořit pobočku": "Create branch",
    "Vytvořit poukaz": "Create voucher",
    "Vytvořit rezervaci": "Create a reservation",
    "Vytvořit šablonu výkonů": "Create performance template",
    "Vytvořit zprávu": "Create a report",
    "Využívat klientský portál": "Use client portal",
    "Vyžádat SMS kód": "Request SMS code",
    "Vyžadovat poznámku": "Require note",
    "Vyžaduje přítomnost terapeuta": "Requires therapist presence",
    "Vyzkoušejte Fyzion Zdarma!": "Try Fyzion for Free!",
    "Vyzkoušejte si Fyzion zdarma a přesvědčte se sami proč ho používá více jak 1000 fyzioterapetů v ČR. Stačí vyplnit několik údajů ve formuláři níže a můžete začít. Později můžete snadno upgradovat na vyšší tarif.": "Try Fyzion for free and see for yourself why more than 3000 physiotherapists in the Czech Republic use it. Just fill in a few details in the form below and you are ready to go. You can easily upgrade to a higher tariff.",
    "Vzdálenost (km)": "Distance (km)",
    "Vzdálenost od předchozí zastávky v km": "Distance from the previous stop in km",
    "Vždy uvádějte jméno pacienta (i v případě dítěte)": "Always state the client's name (even in the case of a child)",
    "Webinář": "Webinar",
    "white-mark": "white-mark",
    "x": "x",
    "z": "z",
    "z ceny aplikace": "from the application price",
    "z toho v hotovosti": "from that in cash",
    "Z-Poukaz": "Z-Voucher",
    "Začínáme": "Let's get started",
    "Zadané telefonní číslo je neplatné.": "The phone number entered is invalid.",
    "zadatele": "requester",
    "Žadatelé": "Applicants",
    "Žadatelé na stránku": "Applicants to page",
    "Zadejte název služby, kterou nabízíte (např. individuální fyzioterapie, elektroléčba, dětská fyzioterapie, zdravotní cvičení). Název se zobrazuje v kalendáři i v online rezervačním systému.": "Enter the name of the service you offer (e.g. individual physiotherapy, electrotherapy, paediatric physiotherapy, therapeutic exercise). The name is displayed in the calendar and in the online booking system.",
    "Zadejte nové heslo": "Enter new password",
    "Zadejte platnou e-mailovou adresu": "Please enter a valid email address",
    "Zadejte prosím e-mail, na který Vám zašleme informace k obnovení hesla.": "Please enter your email to receive information for password reset.",
    "Zadejte SMS kód z portálu pojišťovny. Platný kód, který už máte, můžete použít znovu, nový si vyžádejte jen tehdy, když žádný nemáte.": "Enter the SMS code from the insurance company portal. You can reuse a valid code you already have, request a new one only if you do not have any.",
    "Zadejte validní tel. číslo": "Enter valid phone number",
    "Žádná pobočka není k dispozici": "No branch available",
    "Žádná služba není k dispozici": "No service available",
    "Žádné akce k zobrazení": "No actions to display",
    "Žádné dávky k zobrazení": "No doses to display",
    "Žádné doklady k zobrazení": "No documents to show",
    "Žádné možnosti nebyly nalezeny": "No options found",
    "Žádné návštěvy k zobrazení": "No appointments to display",
    "Žádné stvrzenky k zobrazení": "No receipts to display",
    "Žádné výkony k zobrazení": "No doses to display",
    "Žádné výsledky": "No results",
    "Žádné zpráva k zobrazení": "No message to display",
    "Žádný fyzioterapeut není dostupný": "No therapist is available",
    "Žádný typ služby není k dispozici": "No service type available",
    "Zahrnuté služby": "Included services",
    "Základní diagnóza": "Basic diagnosis",
    "Zákonný zástupce": "Legal representative",
    "Zákonný zástupce:": "Legal representative:",
    "Zákres": "Scope",
    "Zaměstnanci": "Employees",
    "Zaměstnanec": "User",
    "Zamezit online rezervace:": "Disable online booking",
    "Zamknutou návštěvu nelze měnit.": "A locked visit cannot be changed.",
    "Zaplaceno": "Paid",
    "Zaplaceno:": "Paid:",
    "zaplatit": "Pay",
    "Zaplatit": "Pay",
    "Zaplatit permanentkou": "Pay with season ticket",
    "Zaplatit pomocí QR kódu": "Pay using QR code",
    "Zaplatit QR kódem": "Pay with QR code",
    "Zaplaťte pomocí QR kódu": "Pay using QR code",
    "Zaplaťte předplatným, jestliže ho některá instituce poskytuje": "Pay the subscription if it is provided by any institution",
    "Zapnutím povolíte klientům rušení rezervací této služby.": "Enabling this will allow clients to cancel bookings for this service.",
    "Zapnutím povolíte zobrazování služby v online rezervačním systému. Bez zapnutí nebude možné službu rezervovat online.": "Enabling this will allow the service to be displayed in the online booking system. Without enabling it, the service cannot be booked online.",
    "Zapnutím této funkce aktivujete integraci s McKenzie formuláři. Toto nastavení nelze po aktivaci vypnout.": "Enabling this feature activates the McKenzie forms integration. This setting cannot be disabled after activation.",
    "Zapomněli jste heslo?": "Have you forgotten the password?",
    "Zapsáno": "Written",
    "Zapsat cestu": "Log route",
    "Zapsat výkon": "Write performance",
    "zásadami zpracování osobních údajů": "the personal data processing policy",
    "Zásob na stránku": "Page stock",
    "zasoby": "resources",
    "Zásoby": "Assets",
    "Zásoby na skladě": "Stock on warehouse",
    "Zastávka": "Stop",
    "Zatím nebyl nahrán žádný dokument.": "No document has been uploaded yet.",
    "Zatím nebyla nahrána žádná videa.": "No videos have been uploaded yet.",
    "Zatím nebyly nahrány žádné obrázky.": "No images have been uploaded yet.",
    "Zatím nebyly vytvořeny žádné permanentky": "No season tickets have been created yet",
    "Zatím nejsou nahrána žádná videa.": "No videos have been uploaded yet.",
    "Zatím nejsou naplánovány žádné cviky.": "No exercises are scheduled yet.",
    "Zatím nejsou žádné recenze.": "There are no reviews yet.",
    "Zatím nemáte naplánované žádné pacienty": "You don't have any clients scheduled yet",
    "Zatím zde nejsou žádné cviky": "There are no exercises here yet",
    "Zatím zde nejsou žádné položky": "No items here yet",
    "Zatím zde nejsou žádné předplatné": "No subscriptions yet",
    "Zatím zde nejsou žádné proběhlé návštěvy": "No appointments have occurred yet",
    "Zatím zde nejsou žádné šablony": "No templates available yet",
    "Zatím zde nejsou žádné služby": "No services available yet",
    "Zatím zde nejsou žádné spisy": "There are no records here yet",
    "Zatím zde nejsou žádné zásoby": "No stocks available yet",
    "Zatím zde nejsou žádné záznamy": "There are no entries here yet",
    "Zatím zde nejsou žádní dodavatelé": "No suppliers available yet",
    "Zatím zde nejsou žádní pacienti": "No clients here yet",
    "Zavolat do ordinace": "Call the office",
    "Zavolat na číslo": "Call the number",
    "Zavolejte nám na telefon:": "Call us at:",
    "Zavřeno": "Closed",
    "Zavřít": "Close",
    "Zavřít menu": "Close menu",
    "Zavřít platbu": "Close payment",
    "Zavřít zboží": "Close product",
    "Záznamů na stránku": "Records per page",
    "zaznamy": "/records",
    "Zboží": "Goods",
    "Zboží bylo úspěšně naskladněno": "Product was successfully stocked",
    "Zboží se nepodařilo naskladnit": "Product failed to stock",
    "Zbývající počet znaků": "Remaining characters",
    "Zbývajících vstupů": "Remaining inputs",
    "Zdá se, že nám hledaná": "It seems that we",
    "Zdarma": "Free",
    "ZDARMA": "FREE",
    "ZDE": "HERE",
    "Zde můžete nahrát dokumenty, které se týkají vybraného profilu.": "Here you can upload documents related to the selected profile.",
    "Zde prosím nahrajte svá data, která chcete nahrát do systému.": "Please upload the data you want to import into the system here.",
    "Zde se zobrazují všechny dokumenty, které jste v rámci návštěv daného pacienta nahráli": "Here you can see all the documents you have uploaded during the client's visits",
    "Zdravotní pojišťovna": "Health insurance",
    "Zdravotní pojišťovna podání odmítla, protože certifikát, kterým byla dávka podepsána, není zaveden u vašeho účtu na jejím portále. Podepište podání certifikátem, který máte na portále zdravotní pojišťovny zavedený, a dávku odešlete znovu.": "The health insurance company rejected the submission because the certificate the batch was signed with is not registered on your account on its portal. Sign the submission with a certificate registered on the health insurance company portal and send the batch again.",
    "Zdravotní pojišťovna podání odmítla, protože SMS kód byl neplatný nebo mu vypršela platnost. Vyžádejte si nový kód a dávku odešlete znovu.": "The health insurance company rejected the submission because the SMS code was invalid or has expired. Request a new code and send the batch again.",
    "Zelená": "Green",
    "Země": "Country",
    "Žena": "Female",
    "Ženy": "Women",
    "Ženy (budoucí)": "Women (scheduled)",
    "Zjistit více": "Find out more",
    "Zkontrolujte prosím zadanou adresu v prohlížeči.": "Please check the entered address in the browser.",
    "Zkopírováno": "Copied",
    "Zkopírovat": "Copy",
    "Zkopírovat kód": "Copy code",
    "Zkopírovat odkaz do schránky": "Copy link to clipboard",
    "Zkopírovat odkaz na rezervaci této služby": "Copy the reservation link for this service",
    "Zkuste to znovu": "Try again",
    "Žlutá": "Yellow",
    "Změna hesla": "Change password",
    "Změna se nezdařila. Prosím zkontrolujte údaje ve formuláři": "The change failed. Please check the information in the form.",
    "Změna tarifu není možná": "Tariff change is not possible",
    "Změnit": "Change",
    "Změnit heslo": "Change password",
    "Změnit konfiguraci": "Change configuration",
    "Změnit stav": "Change status",
    "Změnit stav na „%{status}“?": "Change the status to \"%{status}\"?",
    "Změnit typ platby nebo částku můžete v editaci plateb.": "You can change the payment type or amount in the payment editor.",
    "Zobrazit": "Show",
    "Zobrazit méně": "Show less",
    "Zobrazit starší": "Show older",
    "Zobrazit všechny recenze": "Show all reviews",
    "Zobrazit všechny zaměstnance": "Show all employees",
    "Zobrazovat bloky v kalendáři po 15 minutách": "Display calendar in 15-minute intervals",
    "Zobrazovat jednotlivé terapeuty v online rezervačním systému": "Display individual therapists in the online booking system",
    "Zobrazovat jména ve formátu PŘÍJMENÍ JMÉNO v kartotéce": "Display names in SURNAME FIRST NAME format in the client database",
    "zpět": "back",
    "Zpět": "Back",
    "Zpět do aplikace": "Back to application",
    "Zpět na cviky": "Back to the list of doses",
    "Zpět na přihlášení": "Back to sign in",
    "Zpět na seznam dávek": "Back to the list of doses",
    "Zpráva od terapeuta": "Therapy report",
    "zpravy": "/messages",
    "Způsob platby": "Payment method",
    "Způsob platby při rezervaci online": "Payment method for online booking",
    "Zrušená fakturace": "Cancelled invoicing",
    "Zrušená návštěva klienta": "Client appointment cancelled",
    "Zrušení rezervace": "Booking cancellation",
    "Zrušení rezervací se bude řídit obecným nastavením firmy.": "Booking cancellations will follow the general company settings.",
    "Zrušení se storno poplatkem": "Cancellation with a fee",
    "Zrušení se storno poplatkem (před návštěvou)": "Cancellation with a fee (before the appointment)",
    "Zrušením platby stornujete vytvořenou stvrzenku, vrátíte vstup na permanentku nebo vrátíte kredity na předplatné. Záleží na předchozím typu platby.": "By canceling the payment, you will cancel the created receipt, return an entry to a season ticket, or refund credits to a subscription. It depends on the previous payment method.",
    "Zrušeno": "Cancel",
    "Zrušeno terapeutem": "Cancelled by the therapist",
    "Zrušit": "Cancel",
    "Zrušit dle storno podmínek": "Cancel according to cancellation terms",
    "ZRUŠIT FILTR": "CANCEL FILTER",
    "Zrušit návštěvu": "Cancel an appointment",
    "Zrušit platbu": "Cancel payment",
    "Zrušit přijetí": "Cancel acceptance",
    "Zrušit rezervaci": "Cancel reservation",
    "Zůstat na stránce": "Stay on the page",
    "Zvolit": "Choose",
    "Zvolit fyzioterapeuta": "Choose a therapist",
    "Zvolit pobočku": "Choose location",
    "Zvolit službu": "Choose a service",
    "Zvolit typ služby": "Choose a service type",
    "Zvolte alespoň jeden výkon": "Choose at least one power",
    "Zvolte alespoň jednu pojišťovnu": "Please select at least one insurance company",
    "Zvolte ANO, pokud spolupracujete s pojišťovnami. Umožníme vám zapisování výkonů a tvorbu dávek a faktur.": "Select YES if you cooperate with insurance companies. We will enable you to record performances and create batches and invoices.",
    "Zvolte barvu, kterou bude služba označena v kalendáři a rezervačním systému.": "Choose the colour by which the service will be marked in the calendar and booking system.",
    "Zvolte čas": "Choose the time",
    "Zvolte datum": "Select the date",
    "Zobrazovat jméno vyšetřujícího v dokumentech": "Show examiner's name in documents",
    "Platí pro dokument návštěvy a kartu klienta. Pokud je zapnuto, zobrazí se u každé návštěvy, kdo ji vyšetřil.": "Applies to the visit document and the client card. If enabled, they show who examined each visit.",
    "Hrazeno pojišťovnou": "Covered by insurance"
  },
  "cs": {
    " Identifikátor propojení obchodu ": " Identifikátor propojení obchodu ",
    " pacientů. Přidáním tohoto pacienta tuto kapacitu překročíte.": " klientů. Přidáním tohoto klienta tuto kapacitu překročíte.",
    ":companyWorkspaceId/pridat-pojistovnu": ":companyWorkspaceId/pridat-pojistovnu",
    ":companyWorkspaceId/upravit": ":companyWorkspaceId/upravit",
    ":companyWorkspaceId/upravit-pojistovnu/:insuranceContractId": ":companyWorkspaceId/upravit-pojistovnu/:insuranceContractId",
    ":insuranceApplicantId/upravit": ":insuranceApplicantId/upravit",
    ":patientId/popisy-navstev": ":patientId/popisy-navstev",
    ":serviceGroupId/upravit": ":serviceGroupId/upravit",
    ":serviceId/upravit": ":serviceId/upravit",
    ":stockItemId/upravit": ":stockItemId/upravit",
    ":supplierId/upravit": ":supplierId/upravit",
    ":userId/ordinacni-hodiny": ":userId/ordinacni-hodiny",
    ":userId/upravit": ":userId/upravit",
    ". Před návštěvou se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": ". Před návštěvou se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte",
    "(obsazeno)": "(obsazeno)",
    "(Přišli poprvé)": "(Přišli poprvé)",
    "@": "@",
    "/akce": "/akce",
    "/cekajici-pacienti": "/cekajici-klienti",
    "/cviky": "/cviky",
    "/domu": "/domu",
    "/historie-akci": "/historie-akci",
    "/historie-zprav": "/historie-zprav",
    "/kalendar": "/kalendar",
    "/moje-navstevy": "/moje-navstevy",
    "/moje-profily": "/moje-profily",
    "/moje-udaje": "/moje-udaje",
    "/nastaveni": "/nastaveni",
    "/novinky": "/novinky",
    "/ordinace": "/ordinace",
    "/pacienti": "/klienti",
    "/pacienti/novy": "/klienti/novy",
    "/platba": "/platba",
    "/platby": "/platby",
    "/pojistovny": "/pojistovny",
    "/predplatne": "/predplatne",
    "/profil": "/profil",
    "/provedene-akce": "/provedene-akce",
    "/pruvodce/": "/pruvodce/",
    "/recenze": "/recenze",
    "/rozcestnik-pruvodce/": "/rozcestnik-pruvodce/",
    "/rozsireni-kartoteky-zdarma": "/rozsireni-kartoteky-zdarma",
    "/sablony": "/sablony",
    "/sklad": "/sklad",
    "/skupinove-navstevy/": "/skupinove-navstevy/",
    "/soubory": "/soubory",
    "/statistiky": "/statistiky",
    "%": "%",
    "• E-mail: ": "• E-mail: ",
    "• IČO": "• IČO",
    "+420 315 315 817": "+420 315 315 817",
    "<div>Dobrý den,</div><br/>v příloze zasíláme rozpis termínů fyzioterapie.": "<div>Dobrý den,</div><br/>v příloze zasíláme rozpis termínů terapie.",
    "<div>Dobrý den,</div><br/>v příloze zasíláme zprávu z provedené terapie.": "<div>Dobrý den,</div><br/>v příloze zasíláme zprávu z provedené terapie.",
    "1. čvrtletí": "1. čvrtletí",
    "2. čtvrtletí": "2. čtvrtletí",
    "3 - Úraz způsobený jinou osobou": "3 - Úraz způsobený jinou osobou",
    "3. čtvrtletí": "3. čtvrtletí",
    "4 - Alkohol a omamné látky": "4 - Alkohol a omamné látky",
    "4. čvrtletí": "4. čvrtletí",
    "5 - Pracovní úraz": "5 - Pracovní úraz",
    "6 - Sociální důvody hospitalizace": "6 - Sociální důvody hospitalizace",
    "60 pacientů": "60 klientů",
    "7 - Porušení léčebného režimu": "7 - Porušení léčebného režimu",
    "8 - Výměna komponent systému ASR_TM": "8 - Výměna komponent systému ASR_TM",
    "9 - Nemoc z povolání": "9 - Nemoc z povolání",
    "A ROZŠIŘTE SI KARTOTÉKU": "A ROZŠIŘTE SI KARTOTÉKU",
    "a zaplatit": "a zaplatit",
    "Absolutní": "Absolutní",
    "Absolutní storno poplatek": "Absolutní storno poplatek",
    "Admin": "Admin",
    "Admin má neomezený přístup ke všem funkcím v rámci zvoleného tarifu": "Admin má neomezený přístup ke všem funkcím v rámci zvoleného tarifu",
    "Adresa": "Adresa",
    "Adresa sídla": "Adresa sídla",
    "Adresa:": "Adresa:",
    "Adresát": "Adresát",
    "Adresu ukládejte ve formátu: Ulice č.p, Město, PSČ": "Adresu ukládejte ve formátu: Ulice č.p, Město, PSČ",
    "Akce": "Akce",
    "Aktivace a dostupnost": "Aktivace a dostupnost",
    "Aktivací zpřístupníte klientský portál. Po naplánování návštěvy nového klienta nebo rezervace klient automaticky obdrží pozvánku do klientského portálu.": "Aktivací zpřístupníte klientský portál. Po naplánování návštěvy nového klienta nebo rezervace klient automaticky obdrží pozvánku do klientského portálu.",
    "Aktivní profil byl změněn": "Aktivní profil byl změněn",
    "Aktivní tarif": "Aktivní tarif",
    "Aktivovat cesty za pacienty": "Aktivovat cesty za klienty",
    "aktualizujte": "aktualizujte",
    "Aktuální prostředí:": "Aktuální prostředí:",
    "anamneza": "anamneza",
    "Anamnéza": "Anamnéza",
    "Anamnéza zatím nebyla vyplněna.": "Anamnéza zatím nebyla vyplněna.",
    "Anamnézu se nepodařilo načíst": "Anamnézu se nepodařilo načíst",
    "Anamnézu se nepodařilo uložit": "Anamnézu se nepodařilo uložit",
    "Anamnézy": "Anamnézy",
    "Ano": "Ano",
    "API URL:": "API URL:",
    "aplikaci Fyzion na sociálních sítích nebo kdekoliv na webu.": "aplikaci Fyzion na sociálních sítích nebo kdekoliv na webu.",
    "Aplikovat na všechny termíny": "Aplikovat na všechny termíny",
    "Aplikovat změny na toto a všechna budoucí volna": "Aplikovat změny na toto a všechna budoucí volna",
    "Aplikovat změny na tuto a všechny budoucí návštěvy": "Aplikovat změny na tuto a všechny budoucí návštěvy",
    "Aplikovat změny na tuto a všechny budoucí skupinové návštěvy": "Aplikovat změny na tuto a všechny budoucí skupinové návštěvy",
    "Aplikovat změny pouze na toto volno": "Aplikovat změny pouze na toto volno",
    "Aplikovat změny pouze na tuto návštěvu": "Aplikovat změny pouze na tuto návštěvu",
    "Aplikovat změny pouze na tuto skupinovou návštěvu": "Aplikovat změny pouze na tuto skupinovou návštěvu",
    "Archivace": "Archivace",
    "Archivovat": "Archivovat",
    "Automaticky kontaktovat náhradníky při smazání rezervace (pouze pro skupinové návštěvy)": "Automaticky kontaktovat náhradníky při smazání rezervace (pouze pro skupinové návštěvy)",
    "Automaticky odešle klientovi informaci o vytvoření, změně či zrušení návštěvy.": "Automaticky odešle klientovi informaci o vytvoření, změně či zrušení návštěvy.",
    "Automaticky odešle klientovi připomínkovou SMS se zvolenými údaji v Nastavení. Zpráva se odesílá v časovém předstihu podle nastavení, vždy v 9 hodin ráno.": "Automaticky odešle klientovi připomínkovou SMS se zvolenými údaji v Nastavení. Zpráva se odesílá v časovém předstihu podle nastavení, vždy v 9 hodin ráno.",
    "Automaticky odešle klientovi připomínku e-mailem s datem a časem návštěvy. Zpráva se odesílá v časovém předstihu podle nastavení, vždy v 9 hodin ráno.": "Automaticky odešle klientovi připomínku e-mailem s datem a časem návštěvy. Zpráva se odesílá v časovém předstihu podle nastavení, vždy v 9 hodin ráno.",
    "Automaticky použít permanentku k úhradě návštěvy": "Automaticky použít balíček k úhradě návštěvy",
    "Balíček zdarma je v základním nastavení limitován počtem pacientů, které je možné mít v kartotéce, na 20. V případě, že jste dosáhli limitu, máte možnost tento limit navýšit až na": "Balíček zdarma je v základním nastavení limitován počtem klientů, které je možné mít v kartotéce, na 20. V případě, že jste dosáhli limitu, máte možnost tento limit navýšit až na",
    "Bankovní údaje": "Bankovní údaje",
    "Barva": "Barva",
    "Barva místnosti": "Barva místnosti",
    "Barva místnosti v kalendáři": "Barva místnosti v kalendáři",
    "Barva služby": "Barva služby",
    "Barva terapeuta": "Barva terapeuta",
    "Barva v kalendáři": "Barva v kalendáři",
    "barvy-kalendare": "barvy-kalendare",
    "Bederní": "Bederní",
    "Beru na vědomí": "Beru na vědomí",
    "bezchybně a rychle": "bezchybně a rychle",
    "bezhotovostně": "bezhotovostně",
    "Bezplatná registrace": "Bezplatná registrace",
    "Bezplatné přesunutí (před návštěvou)": "Bezplatné přesunutí (před návštěvou)",
    "Bezplatné zrušení (před návštěvou)": "Bezplatné zrušení (před návštěvou)",
    "Bezplatné zrušení nejpozději": "Bezplatné zrušení nejpozději",
    "Blok do kalendáře": "Blok do kalendáře",
    "Blok do kalendáře zamezující rezervaci": "Blok do kalendáře zamezující rezervaci",
    "Bodů": "Bodů",
    "Bodů celkem": "Bodů celkem",
    "Body": "Body",
    "Body:": "Body:",
    "Bude použito i pro variabilní symbol": "Bude použito i pro variabilní symbol",
    "Budeme vás kontaktovat e-mailem nebo telefonicky, pokud se uvolní místo": "Budeme vás kontaktovat e-mailem nebo telefonicky, pokud se uvolní místo",
    "Budoucí návštěvy": "Budoucí návštěvy",
    "Čas": "Čas",
    "Čas byl úspěšně vybrán. Vyberte ještě": "Čas byl úspěšně vybrán. Vyberte ještě",
    "Čas do je povinný": "Čas do je povinný",
    "Čas od je povinný": "Čas od je povinný",
    "Čas:": "Čas:",
    "Časové okno pro rezervace": "Časové okno pro rezervace",
    "Časové okno pro rezervaci hromadných termínů": "Časové okno pro rezervaci hromadných termínů",
    "Časový interval před návštěvou, během kterého může klient rezervaci bezplatně přesunout.": "Časový interval před návštěvou, během kterého může klient rezervaci bezplatně přesunout.",
    "Časový interval před návštěvou, během kterého může klient rezervaci zrušit bez poplatku.": "Časový interval před návštěvou, během kterého může klient rezervaci zrušit bez poplatku.",
    "Časový interval před návštěvou, kdy je možné rezervaci zrušit, ale se storno poplatkem.": "Časový interval před návštěvou, kdy je možné rezervaci zrušit, ale se storno poplatkem.",
    "Částka": "Částka",
    "Částka bude vypočítána jako celková cena všech položek.": "Částka bude vypočítána jako celková cena všech položek.",
    "Částka k úhradě": "Částka k úhradě",
    "Částka nesmí být vyšší než cena návštěvy": "Částka nesmí být vyšší než cena návštěvy",
    "Čeká na autorizaci": "Čeká na autorizaci",
    "Čeká na platbu": "Čeká na platbu",
    "Čeká na zaplacení": "Čeká na zaplacení",
    "Čekající": "Čekající",
    "Čekající pacienti": "Čekající klienti",
    "Čekající:": "Čekající:",
    "Celkem": "Celkem",
    "Celkem k úhradě": "Celkem k úhradě",
    "Celkem náhradníků:": "Celkem náhradníků:",
    "Celkem návštěv:": "Celkem návštěv:",
    "Celkový čas návštěvy klienta. Tato doba se zobrazuje klientovi v potvrzení rezervace a v pozvánce.": "Celkový čas návštěvy klienta. Tato doba se zobrazuje klientovi v potvrzení rezervace a v pozvánce.",
    "Celkový časový blok rezervovaný v kalendáři pro tuto službu. Zahrnuje čas pro pacienta i navazující činnosti (administrativa, úklid, hygienická pauza apod.).": "Celkový časový blok rezervovaný v kalendáři pro tuto službu. Zahrnuje čas pro klienta i navazující činnosti (administrativa, úklid, hygienická pauza apod.).",
    "Celkový počet odeslaných SMS": "Celkový počet odeslaných SMS",
    "Celý den": "Celý den",
    "Cena": "Cena",
    "Cena celkem": "Cena celkem",
    "Cena nemůže být nižší než 0": "Cena nemůže být nižší než 0",
    "Cena nesmí být záporná": "Cena nesmí být záporná",
    "Cena permanentky": "Cena balíčku",
    "Cena s DPH": "Cena s DPH",
    "Cena služby.": "Cena služby.",
    "Cena za MJ": "Cena za MJ",
    "Cena:": "Cena:",
    "Certifikát": "Certifikát",
    "Červená": "Červená",
    "Cestovní zdravotní pojištění": "Cestovní zdravotní pojištění",
    "Četl/a jsem a souhlasím se": "Četl/a jsem a souhlasím se",
    "Chápeme, že nyní není vhodný čas, k průvodci se můžete kdykoliv vrátit, případně využít tipy a nápovědu.": "Chápeme, že nyní není vhodný čas, k průvodci se můžete kdykoliv vrátit, případně využít tipy a nápovědu.",
    "Charakter": "Charakter",
    "Charakter dávky": "Charakter dávky",
    "Chcete pokračovat v zadání návštěvy:": "Chcete pokračovat v zadání návštěvy:",
    "Chcete-li vytvořit rezervaci nebo spravovat své termíny, přihlaste se ke svému účtu.": "Chcete-li vytvořit rezervaci nebo spravovat své termíny, přihlaste se ke svému účtu.",
    "Chci naplánovat": "Chci naplánovat",
    "chyba": "chyba",
    "Chyba při přesměrování na registraci náhradníka": "Chyba při přesměrování na registraci náhradníka",
    "Cíl": "Cíl",
    "Čísla dokladů v dávce od": "Čísla dokladů v dávce od",
    "Čísla faktur": "Čísla faktur",
    "Číslo": "Číslo",
    "Číslo bez lomítka": "Číslo bez lomítka",
    "Číslo dávky": "Číslo dávky",
    "Číslo dokladu": "Číslo dokladu",
    "Číslo pojištěnce": "Číslo pojištěnce",
    "Číslo pojištěnce nemusí být správné": "Číslo pojištěnce nemusí být správné",
    "Číslo pojištěnce:": "Číslo pojištěnce:",
    "Číslo pojišťenec": "Číslo pojištěnce",
    "Číslo účtu": "Číslo účtu",
    "Číslování dokladů": "Číslování dokladů",
    "Číslovat dávky od": "Číslovat dávky od",
    "Číslovat faktury od": "Číslovat faktury od",
    "Číslovat paragony od": "Číslovat paragony od",
    "Číst více": "Číst více",
    "client photo": "client photo",
    "Co je nového?": "Co je nového?",
    "CS": "CS",
    "Čtvrtek": "Čtvrtek",
    "Čtvrtletí": "Čtvrtletí",
    "Čtvrtletní": "Čtvrtletní",
    "cvik": "cvik",
    "Cvik": "Cvik",
    "cviků": "cvičení",
    "cviky": "cvičení",
    "Cviky": "Cvičení",
    "Cviky na vybraný den": "Cvičení na vybraný den",
    "Další akce": "Další akce",
    "Další krok postupu": "Další krok postupu",
    "Další položka": "Další položka",
    "Další propojení dostupné pouze při": "Další propojení dostupné pouze při",
    "Další štítky": "Další štítky",
    "Další výkon": "Další výkon",
    "Data se načítají...": "Data se načítají...",
    "Datum": "Datum",
    "Datum a čas": "Datum a čas",
    "Datum expirace": "Datum expirace",
    "Datum inventury": "Datum inventury",
    "Datum je povinné": "Datum je povinné",
    "Datum narození": "Datum narození",
    "Datum narození:": "Datum narození:",
    "Datum naskladnění": "Datum naskladnění",
    "Datum návštěvy": "Datum návštěvy",
    "Datum platnosti budoucí ceny nemůže být v minulosti.": "Datum platnosti budoucí ceny nemůže být v minulosti.",
    "Datum splatnosti:": "Datum splatnosti:",
    "Datum transakce": "Datum transakce",
    "Datum vystavení": "Datum vystavení",
    "Datum začátku cvičení": "Datum začátku cvičení",
    "Datum zaplacení": "Datum zaplacení",
    "Datum zdanitelného plnění": "Datum zdanitelného plnění",
    "Datum změny pojištění:": "Datum změny pojištění:",
    "Datum změny pojišťovny": "Datum změny pojišťovny",
    "Datum:": "Datum:",
    "Dávek na stránku": "Dávek na stránku",
    "DÁVKA POUKAZŮ NA VYŠETŘENÍ/OŠETŘENÍ SMÍŠENÁ": "DÁVKA POUKAZŮ NA VYŠETŘENÍ/OŠETŘENÍ SMÍŠENÁ",
    "DÁVKA VYÚČTOVÁNÍ CEST V NÁVŠTĚVNÍ SLUŽBĚ": "DÁVKA VYÚČTOVÁNÍ CEST V NÁVŠTĚVNÍ SLUŽBĚ",
    "DÁVKA VYÚČTOVÁNÍ VÝKONŮ V AMBULANTNÍ PÉČI": "DÁVKA VYÚČTOVÁNÍ VÝKONŮ V AMBULANTNÍ PÉČI",
    "Dávku elektronicky podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Dávku elektronicky podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.",
    "Dávku lze elektronicky odeslat přímo zdravotní pojišťovně, s podpisem certifikátem nebo s ověřením SMS kódem.": "Dávku lze elektronicky odeslat přímo zdravotní pojišťovně, s podpisem certifikátem nebo s ověřením SMS kódem.",
    "Dávku se nepodařilo vytvořit": "Dávku se nepodařilo vytvořit",
    "davky": "davky",
    "Dávky": "Dávky",
    "Dávky jsme zařadili k odeslání pojišťovně. O výsledku vás budeme informovat e-mailem.": "Dávky jsme zařadili k odeslání pojišťovně. O výsledku vás budeme informovat e-mailem.",
    "Dávky nemůžeme vytvořit, protože jsme nenašli žádné výkony. Změňte výběr období, pojišťoven nebo pracoviště.": "Dávky nemůžeme vytvořit, protože jsme nenašli žádné výkony. Změňte výběr období, pojišťoven nebo pracoviště.",
    "Dávky vytvořeny": "Dávky vytvořeny",
    "DD.MM.RRRR": "DD.MM.RRRR",
    "Deaktivovat": "Deaktivovat",
    "Deaktivovat terapeuta": "Deaktivovat terapeuta",
    "dekujeme": "dekujeme",
    "Děkujeme za vaší recenzi!": "Děkujeme za vaší recenzi!",
    "Děkujeme!": "Děkujeme!",
    "Děkujeme! Souhlas s GDPR byl úspěšně potvrzen.": "Děkujeme! Souhlas s GDPR byl úspěšně potvrzen.",
    "Délka (min.)": "Délka (min.)",
    "den": "den",
    "Den": "Den",
    "Denně": "Denně",
    "detail": "detail",
    "Detail následující návštěvy": "Detail následující návštěvy",
    "Detail návštěvy": "Detail návštěvy",
    "Detail poslední návštěvy": "Detail poslední návštěvy",
    "Detail registrace náhradníka": "Detail registrace náhradníka",
    "Detail rezervace": "Detail rezervace",
    "Detail vybraného profilu": "Detail vybraného profilu",
    "Diagnóza": "Diagnóza",
    "Diagnózy": "Diagnózy",
    "DIČ": "DIČ",
    "dne": "dne",
    "Dne": "Dne",
    "Dnes": "Dnes",
    "dní": "dní",
    "dnů": "dnů",
    "dny": "dny",
    "Dny": "Dny",
    "do": "do",
    "Do": "Do",
    "Do karty pacienta nebyly zatím nahrány žádné formuláře.": "Do karty klienta nebyly zatím nahrány žádné formuláře.",
    "Do karty pacienta nebyly zatím nahrány žádné fotografie.": "Do karty klienta nebyly zatím nahrány žádné fotografie.",
    "Do průvodce": "Do průvodce",
    "Doba splatnosti": "Doba splatnosti",
    "Doba trvání": "Doba trvání",
    "Doba trvání pro pacienty": "Doba trvání pro klienty",
    "Doba trvání:": "Doba trvání:",
    "Dobrý den": "Dobrý den",
    "Dodavatel": "Dodavatel",
    "Dodavatel byl úspěšně smazán": "Dodavatel byl úspěšně smazán",
    "Dodavatel byl úspěšně upraven": "Dodavatel byl úspěšně upraven",
    "Dodavatel byl úspěšně vytvořen": "Dodavatel byl úspěšně vytvořen",
    "dodavatele": "dodavatele",
    "Dodavatelé": "Dodavatelé",
    "Dodavatele se nepodařilo smazat": "Dodavatele se nepodařilo smazat",
    "Dodavatele se nepodařilo upravit": "Dodavatele se nepodařilo upravit",
    "Dojde k odstranění následujících místností navázaných na tuto pobočku:": "Dojde k odstranění následujících místností navázaných na tuto pobočku:",
    "Doklady": "Doklady",
    "Dokončeno": "Dokončeno",
    "Dokončit odeslání": "Dokončit odeslání",
    "Dokončit odeslání dávky": "Dokončit odeslání dávky",
    "Dokončit odeslání dávky č. %{number} pro pojišťovnu %{insurance}?": "Dokončit odeslání dávky č. %{number} pro pojišťovnu %{insurance}?",
    "Dokument byl úspěšně nahrán a odeslán": "Dokument byl úspěšně nahrán a odeslán",
    "Dokumenty": "Dokumenty",
    "Doplňková služba": "Doplňková služba",
    "dopředu": "dopředu",
    "Dosáhli jste maximálního počtu pacientů v kartotéce. ": "Dosáhli jste maximálního počtu klientů v kartotéce. ",
    "Dosažen limit SMS": "Dosažen limit SMS",
    "Dosažení maximálního počtu pacientů": "Dosažení maximálního počtu klientů",
    "Dotazník": "Dotazník",
    "Dotazník pro klienta": "Dotazník pro klienta",
    "Dotazník pro klienta (dotazník uvidí klient v klientské sekci, kde ho může vyplnit)": "Dotazník pro klienta (dotazník uvidí klient v klientské sekci, kde ho může vyplnit)",
    "Dotazník pro pacienta": "Dotazník pro klienta",
    "Dotazník uvidí klient v klientské sekci, kde ho může vyplnit": "Dotazník uvidí klient v klientské sekci, kde ho může vyplnit",
    "Dotazovat se klientů na souhlas se zasíláním novinek v rezervačním systému": "Dotazovat se klientů na souhlas se zasíláním novinek v rezervačním systému",
    "DPH": "DPH",
    "DPH%": "DPH%",
    "Druh péče": "Druh péče",
    "Druh péče:": "Druh péče:",
    "Druh úhrady": "Druh úhrady",
    "Druh úhrady:": "Druh úhrady:",
    "Duplikovat": "Duplikovat",
    "E-mail": "E-mail",
    "E-mail se nepodařilo odeslat.": "E-mail se nepodařilo odeslat.",
    "E-mail úspěšně odeslán": "E-mail úspěšně odeslán",
    "E-mailová adresa": "E-mailová adresa",
    "E-mailová adresa:": "E-mailová adresa:",
    "Editace údajů pacienta": "Editace údajů klienta",
    "Email": "Email",
    "Email byl úspěšně poslán": "Email byl úspěšně poslán",
    "Email klientům": "Email klientům",
    "Email odeslán": "Email odeslán",
    "Email pro faktury": "Email pro faktury",
    "Emailová adresa": "E-mailová adresa",
    "EN": "EN",
    "Export bude vygenerován a zaslán na e-mail": "Export bude vygenerován a zaslán na e-mail",
    "Export transakcí": "Export transakcí",
    "Exportovat": "Exportovat",
    "Exportovat data": "Exportovat data",
    "Exportovat ISDOC": "Exportovat ISDOC",
    "Exportovat PDF": "Exportovat PDF",
    "Exportovat platby": "Exportovat platby",
    "Exportovat výkony": "Exportovat výkony",
    "Faktura": "Faktura",
    "Faktura bude vygenerována a zaslána na e-mail": "Faktura bude vygenerována a zaslána na e-mail",
    "Faktura byla označena jako zaplacená": "Faktura byla označena jako zaplacená",
    "Fakturace": "Fakturace",
    "Fakturace byla označena jako zaplacená": "Fakturace byla označena jako zaplacená",
    "Fakturace úspěšně přidána": "Fakturace úspěšně přidána",
    "Fakturace úspěšně upravena": "Fakturace úspěšně upravena",
    "Fakturace za období": "Fakturace za období",
    "Fakturace za období:": "Fakturace za období:",
    "Fakturační údaje": "Fakturační údaje",
    "fakturacni-udaje": "fakturacni-udaje",
    "Fakturováno": "Fakturováno",
    "fakturu č.": "fakturu č.",
    "faktury": "faktury",
    "Faktury": "Faktury",
    "Filtrovat": "Filtrovat",
    "Filtrovat pacienty": "Filtrovat klienty",
    "Filtrujte cviky podle jména": "Filtrujte cvičení podle jména",
    "finance": "finance",
    "Finance": "Finance",
    "firemni-udaje": "firemni-udaje",
    "flag": "flag",
    "Formulář úspěšně nahrán": "Formulář úspěšně nahrán",
    "Formuláře se nepodařilo načíst": "Formuláře se nepodařilo načíst",
    "Fotka FT poukazu": "Fotka FT poukazu",
    "Fotka FT poukazu byla úspěšně nahrána": "Fotka FT poukazu byla úspěšně nahrána",
    "Fotku obrazovky s Vaším sdílením": "Fotku obrazovky s Vaším sdílením",
    "Fotky": "Fotky",
    "Fotogalerie": "Fotogalerie",
    "fotografie": "fotografie",
    "Fotografie se nepodařilo načíst.": "Fotografie se nepodařilo načíst.",
    "Fotografie se zobrazí na veřejné stránce v sekci zaměstnanci": "Fotografie se zobrazí na veřejné stránce v sekci zaměstnanci",
    "Fotografie smazána": "Fotografie smazána",
    "Fotografie úspěšně nahrána": "Fotografie úspěšně nahrána",
    "Fotografie ze dne": "Fotografie ze dne",
    "FT poukaz": "FT poukaz",
    "FT Poukaz": "FT Poukaz",
    "FT poukaz byl úspěšně vytvořen": "FT poukaz byl úspěšně vytvořen",
    "FT poukaz není možné vytvořit. Zkontrolujte, jestli je vše správně vyplněno na kartě pacienta.": "FT poukaz není možné vytvořit. Zkontrolujte, jestli je vše správně vyplněno na kartě klienta.",
    "FT poukaz úspěšně smazán": "FT poukaz úspěšně smazán",
    "FT poukaz úspěšně upraven": "FT poukaz úspěšně upraven",
    "FT poukazy": "FT poukazy",
    "Funkce pro větší instituce, se kterými spolupracujete. Mohou u vás mít „kredit“ a čerpat ho za vaše služby.": "Funkce pro větší instituce, se kterými spolupracujete. Mohou u vás mít „kredit“ a čerpat ho za vaše služby.",
    "Fyzion – moderní software pro fyzioterapii": "Fyzion – moderní software pro terapii",
    "Fyzion funguje": "Fyzion funguje",
    "Fyzion premium function": "Fyzion premium function",
    "Fyzion running away": "Fyzion running away",
    "fyzion-faktura.pdf": "fyzion-faktura.pdf",
    "fyzion-zalohova-faktura.pdf": "fyzion-zalohova-faktura.pdf",
    "Fyzioterapeut": "Terapeut",
    "Fyzioterapeut a místnost": "Terapeut a místnost",
    "Fyzioterapeut je povinný": "Terapeut je povinný",
    "Fyzioterapeut nemá vyplněné ordinační hodiny": "Terapeut nemá vyplněné ordinační hodiny",
    "Fyzioterapeut:": "Terapeut:",
    "fyzioterapeuti": "terapeuti",
    "Fyzioterapeuti": "Terapeuti",
    "Fyzioterapeuti úspěšně resetováni podle diagnózy": "Terapeuti úspěšně resetováni podle diagnózy",
    "GDPR": "GDPR",
    "GDPR souhlas": "GDPR souhlas",
    "GDPR úspěšně potvrzeno.": "GDPR úspěšně potvrzeno.",
    "GDPR:": "GDPR:",
    "Generováno": "Generováno",
    "Generuji PDF pro tisk…": "Generuji PDF pro tisk…",
    "Google kalendář": "Google kalendář",
    "Hesla se neshodují": "Hesla se neshodují",
    "Heslo": "Heslo",
    "Heslo bylo úspěšně nastaveno": "Heslo bylo úspěšně nastaveno",
    "Heslo bylo úspěšně změněno": "Heslo bylo úspěšně změněno",
    "Heslo bylo úspěšně změněno. Přihlaste se prosím znovu novým heslem.": "Heslo bylo úspěšně změněno. Přihlaste se prosím znovu novým heslem.",
    "Heslo musí obsahovat minimálně 8 znaků a alespoň 1 číslici.": "Heslo musí obsahovat minimálně 8 znaků a alespoň 1 číslici.",
    "Historie akcí": "Historie akcí",
    "Historie akcí, odeslané zprávy.": "Historie akcí, odeslané zprávy.",
    "Historie cvičení": "Historie cvičení",
    "Historie emailů a SMS": "Historie emailů a SMS",
    "Historie návštěv": "Historie návštěv",
    "Historie rezervací": "Historie rezervací",
    "historie-akci": "historie-akci",
    "Hledanému výrazu neodpovídá žádná diagnóza": "Hledanému výrazu neodpovídá žádná diagnóza",
    "Hledanému výrazu neodpovídá žádné pracoviště": "Hledanému výrazu neodpovídá žádné pracoviště",
    "Hledanému výrazu neodpovídá žádný pacient": "Hledanému výrazu neodpovídá žádný klient",
    "Hledanému výrazu neodpovídá žádný poukaz": "Hledanému výrazu neodpovídá žádný poukaz",
    "Hledanému výrazu neodpovídá žádný výkon": "Hledanému výrazu neodpovídá žádný výkon",
    "Hledat klienta": "Hledat klienta",
    "Hledat...": "Hledat...",
    "hod": "hod",
    "hodin": "hodin",
    "hodinu": "hodinu",
    "hodiny": "hodiny",
    "Hodnota bodu": "Hodnota bodu",
    "Hodnota bodu:": "Hodnota bodu:",
    "Hotově": "Hotově",
    "Hotovo": "Hotovo",
    "Hromadné odeslání dávek pojišťovně selhalo": "Hromadné odeslání dávek pojišťovně selhalo",
    "Hrudní": "Hrudní",
    "HTML kód na web": "HTML kód na web",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Podminky_ochrany_osobnich_udaju.pdf": "https://fyzion.cz/ochrana-osobnich-udaju/",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Vseobbecne_obchodni_podminky_edit_2025_v2.pdf": "https://fyzion.cz/vop/",
    "https://fyzion.cz/cs/sdilejte-nas-a-rozsirte-si-kartoteku-zdarma/": "https://fyzion.cz/cs/sdilejte-nas-a-rozsirte-si-kartoteku-zdarma/",
    "https://fyzion.cz/cs/webinar/": "https://fyzion.cz/cs/webinar/",
    "https://fyzion.cz/navod-pojistovny": "https://fyzion.cz/navod-pojistovny",
    "https://fyzion.cz/navod-purobot": "https://fyzion.cz/navod-purobot",
    "https://kb.fyzion.cz/cs/": "https://kb.fyzion.cz/cs/",
    "https://kb.fyzion.cz/cs/article/databaze-cviku-a-jak-je-poslat-pacientovi-ue0fjk/": "https://kb.fyzion.cz/cs/article/databaze-cviku-a-jak-je-poslat-pacientovi-ue0fjk/",
    "https://kb.fyzion.cz/cs/article/fakturacni-udaje-1phelsb/": "https://kb.fyzion.cz/cs/article/fakturacni-udaje-1phelsb/",
    "https://kb.fyzion.cz/cs/article/jak-vyuzit-predplatne-ve-fyzionu-darkove-poukazy-benefity-a-firemni-fakturace-1xlifqz/": "https://kb.fyzion.cz/cs/article/jak-vyuzit-predplatne-ve-fyzionu-darkove-poukazy-benefity-a-firemni-fakturace-1xlifqz/",
    "https://kb.fyzion.cz/cs/article/kartoteka-pacientu-1bjloyh/": "https://kb.fyzion.cz/cs/article/kartoteka-pacientu-1bjloyh/",
    "https://kb.fyzion.cz/cs/article/nastaveni-terapeutu-sauigy/": "https://kb.fyzion.cz/cs/article/nastaveni-terapeutu-sauigy/",
    "https://kb.fyzion.cz/cs/article/permanentky-17qqddn/": "https://kb.fyzion.cz/cs/article/permanentky-17qqddn/",
    "https://kb.fyzion.cz/cs/article/platby-z33ojo/": "https://kb.fyzion.cz/cs/article/platby-z33ojo/",
    "https://kb.fyzion.cz/cs/article/platebni-brana-comgate-149e3gy/": "https://kb.fyzion.cz/cs/article/platebni-brana-comgate-149e3gy/",
    "https://kb.fyzion.cz/cs/article/platebni-brana-fyzion-1i889t1/": "https://kb.fyzion.cz/cs/article/platebni-brana-fyzion-1i889t1/",
    "https://kb.fyzion.cz/cs/article/pobocky-ve-fyzionu-vetsi-svoboda-pro-terapeuty-prehlednost-pro-klienty-1vwg90a/": "https://kb.fyzion.cz/cs/article/pobocky-ve-fyzionu-vetsi-svoboda-pro-terapeuty-prehlednost-pro-klienty-1vwg90a/",
    "https://kb.fyzion.cz/cs/article/pojistovny-16i7uc6/": "https://kb.fyzion.cz/cs/article/pojistovny-16i7uc6/",
    "https://kb.fyzion.cz/cs/article/propojeni-kalendare-s-googlem-h9fpzi/": "https://kb.fyzion.cz/cs/article/propojeni-kalendare-s-googlem-h9fpzi/",
    "https://kb.fyzion.cz/cs/article/recenze-1okedp6/": "https://kb.fyzion.cz/cs/article/recenze-1okedp6/",
    "https://kb.fyzion.cz/cs/article/sablony-jcwt6d/": "https://kb.fyzion.cz/cs/article/sablony-jcwt6d/",
    "https://kb.fyzion.cz/cs/article/sluzby-jak-nastavit-vase-sluzby-13wrswq/": "https://kb.fyzion.cz/cs/article/sluzby-jak-nastavit-vase-sluzby-13wrswq/",
    "https://kb.fyzion.cz/cs/article/sprava-skladu-a-fakturace-1dfkoro/": "https://kb.fyzion.cz/cs/article/sprava-skladu-a-fakturace-1dfkoro/",
    "https://www.fyzion.cz/cs/navod-fyzion": "https://www.fyzion.cz/cs/navod-fyzion",
    "https://www.google.com/chrome/": "https://www.google.com/chrome/",
    "IBAN": "IBAN",
    "IČ": "IČ",
    "IČO": "IČO",
    "IČP": "IČP",
    "IČP žadatele": "IČP žadatele",
    "IČZ": "IČZ",
    "id": "id",
    "iframe na web": "iframe na web",
    "Ignorovat automatické přepsání": "Ignorovat automatické přepsání",
    "info@fyzion.cz": "podpora@fyzion.cz",
    "Informace o návštěvách": "Informace o návštěvách",
    "Informace o Vaší registraci jsme Vám poslali na e-mail": "Informace o Vaší registraci jsme Vám poslali na e-mail",
    "Informace o Vaší rezervaci jsme Vám poslali na e-mail": "Informace o Vaší rezervaci jsme Vám poslali na e-mail",
    "inventura": "inventura",
    "Inventura": "Inventura",
    "Inventura zboží": "Inventura zboží",
    "Inventura zboží úspěšně provedena": "Inventura zboží úspěšně provedena",
    "Inventuru zboží se nepodařilo uložit": "Inventuru zboží se nepodařilo uložit",
    "Jak chcete pokračovat?": "Jak chcete pokračovat?",
    "Jak chcete provedené změny aplikovat?": "Jak chcete provedené změny aplikovat?",
    "Jak funguje platební brána?": "Jak funguje platební brána?",
    "Jak fungují permanentky?": "Jak fungují balíčky?",
    "Jak fungují recenze?": "Jak fungují recenze?",
    "Jak na propojení s PURObotem?": "Jak na propojení s PURObotem?",
    "Jak na to": "Jak na to",
    "Jak nastavit fakturační údaje?": "Jak nastavit fakturační údaje?",
    "Jak nastavit online rezervace?": "Jak nastavit online rezervace?",
    "Jak nastavit pobočky?": "Jak nastavit pobočky?",
    "Jak nastavit služby?": "Jak nastavit služby?",
    "Jak nastavit terapeuta?": "Jak nastavit terapeuta?",
    "Jak navýšit limit kartotéky pacientů?": "Jak navýšit limit kartotéky klientů?",
    "Jak používat šablony?": "Jak používat šablony?",
    "Jak pracovat s kartotekou?": "Jak pracovat s kartotekou?",
    "Jak pracovat s platbami?": "Jak pracovat s platbami?",
    "Jak pracovat se cviky?": "Jak pracovat s cvičením?",
    "Jak propojit kalendář s Googlem?": "Jak propojit kalendář s Googlem?",
    "Jak si přejete aplikovat tuto šablonu?": "Jak si přejete aplikovat tuto šablonu?",
    "Jak spravovat sklad?": "Jak spravovat sklad?",
    "Jak vykazovat na pojišťovny?": "Jak vykazovat na pojišťovny?",
    "Jak využít předplatné?": "Jak využít předplatné?",
    "Jaké služby poskytuje?": "Jaké služby poskytuje?",
    "Jakýkoliv": "Jakýkoliv",
    "Jde o duplicitní kartu?": "Jde o duplicitní kartu?",
    "Jdeme na to teď!": "Jdeme na to teď!",
    "Je-li funkce zapnuta a pacient ještě nemá potvrzené GDPR, systém mu ho automaticky odesílá k potvrzení den před budoucí návštěvou.": "Je-li funkce zapnuta a klient ještě nemá potvrzené GDPR, systém mu ho automaticky odesílá k potvrzení den před budoucí návštěvou.",
    "Je-li tato funkce vypnuta, fyzioterapeut vidí návštěvy ostatních fyzioterapeutů, ale nemůže se prokliknout do jejich detailu": "Je-li tato funkce vypnuta, terapeut vidí návštěvy ostatních terapeutů, ale nemůže se prokliknout do jejich detailu",
    "Jestliže splníte tyto tři úkoly dříve, než vyprší čas, jako odměnu od nás dostanete tarif Standard na tři měsíce": "Jestliže splníte tyto tři úkoly dříve, než vyprší čas, jako odměnu od nás dostanete tarif Standard na tři měsíce",
    "Jméno": "Jméno",
    "Jméno pojištěnce": "Jméno pojištěnce",
    "Jméno/název": "Jméno/název",
    "Jméno/Název": "Jméno/Název",
    "Jsou předepsané výkony": "Jsou předepsané výkony",
    "K návštěvě existuje více než jedna platba": "K návštěvě existuje více než jedna platba",
    "K platbě": "K platbě",
    "K poukazu zatím není zapsaný žádný výkon": "K poukazu zatím není zapsaný žádný výkon",
    "K přihlášení použijte váš e-mail, na který Vám zasíláme potvrzení o rezervacích.": "K přihlášení použijte váš e-mail, na který Vám zasíláme potvrzení o rezervacích.",
    "K této cvičební položce nejsou k dispozici žádné obrázky ani videa.": "K této cvičební položce nejsou k dispozici žádné obrázky ani videa.",
    "K této cvičební poloze nejsou k dispozici žádné další informace.": "K této cvičební poloze nejsou k dispozici žádné další informace.",
    "K této návštěvě nebyl zatím přidán žádný popis.": "K této návštěvě nebyl zatím přidán žádný popis.",
    "K této recenzi nebyl přidán žádný text.": "K této recenzi nebyl přidán žádný text.",
    "K vytvoření stvrzenky je potřeba návštěva": "K vytvoření stvrzenky je potřeba návštěva",
    "K vytvoření stvrzenky je potřeba pacient a návštěva": "K vytvoření stvrzenky je potřeba klient a návštěva",
    "k_batches.confirm_delete_k_batch_modal.confirm_text": "Smazat",
    "k_batches.confirm_delete_k_batch_modal.heading_with_invoice": "Smazat dávku a fakturu?",
    "k_batches.confirm_delete_k_batch_modal.heading_without_invoice": "Smazat dávku?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_with_invoice": "Opravdu si přejete smazat dávku č. %{batchNumber} a fakturu č. %{invoiceNumber}?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_without_invoice": "Opravdu si přejete smazat dávku č. %{batchNumber}?",
    "k_batches.corrective_k_batch.get_ft_tickets_for_corrective_k_batch_failed.notification": "Nepodařilo se načíst FT poukazy pro opravnou dávku",
    "k_batches.k_batch_document.get_k_batch_document_list_failed.notification": "Dávku se nepodařilo smazat",
    "k_batches.k_batch.create_corrective_batch_successful.notification": "Opravná dávka vytvořena",
    "k_batches.k_batch.create_corrective_k_batch_btn.label": "Vytvořit opravnou dávku",
    "k_batches.k_batch.delete_failed.notification": "Dávku se nepodařilo smazat",
    "k_batches.k_batch.delete_k_batch_btn.label": "Smazat dávku",
    "k_batches.k_batch.delete_successful.notification": "Dávka smazána",
    "k_batches.k_batch.new_receipt_btn.label": "Vytvořit fakturu z dávky",
    "K-Poukaz": "K-Poukaz",
    "Kalendář": "Kalendář",
    "Kalendář byl úspěšně synchronizován": "Kalendář byl úspěšně synchronizován",
    "Kalendář je již synchronizovaný": "Kalendář je již synchronizovaný",
    "Kalendář místností": "Kalendář místností",
    "Kalendář skupinových": "Kalendář skupinových",
    "Kalendář terapeutů": "Kalendář terapeutů",
    "Kapacita": "Kapacita",
    "Kapacita:": "Kapacita:",
    "Karta klienta": "Karta klienta",
    "Karta pacienta": "Karta klienta",
    "karta-pacienta": "karta-klienta",
    "Kartou": "Kartou",
    "Kartou online": "Kartou online",
    "Karty byly sloučeny": "Karty byly sloučeny",
    "Karty se nepodařilo sloučit": "Karty se nepodařilo sloučit",
    "kategorie": "kategorie",
    "Kategorie": "Kategorie",
    "Kč": "Kč",
    "Kdokoliv dostupný": "Kdokoliv dostupný",
    "Klient": "Klient",
    "Klient platí za službu osobně během návštěvy.": "Klient platí za službu osobně během návštěvy.",
    "Klient si může vybrat, zda zaplatí online předem, nebo až při návštěvě.": "Klient si může vybrat, zda zaplatí online předem, nebo až při návštěvě.",
    "Klienti a klientská sekce": "Klienti a klientská sekce",
    "Klienti dostanou odkaz na přihlašovací stránku do klientského portálu od svého terapeuta.": "Klienti dostanou odkaz na přihlašovací stránku do klientského portálu od svého terapeuta.",
    "Klientská sekce": "Klientská sekce",
    "Klientská sekce je vypnutá. Zapnout ji můžete v": "Klientská sekce je vypnutá. Zapnout ji můžete v",
    "Klientský portál": "Klientský portál",
    "klientů": "klientů",
    "km)": "km)",
    "Kód": "Kód",
    "Kód ": "Kód ",
    "Kód a název pojišťovny": "Kód a název pojišťovny",
    "Kód a název zboží": "Kód a název zboží",
    "Kód a název zboží, počet": "Kód a název zboží, počet",
    "kód banky": "kód banky",
    "Kód banky": "Kód banky",
    "Kód náhrady": "Kód náhrady",
    "Kód pojišťovny": "Kód pojišťovny",
    "Kód zboží": "Kód zboží",
    "Končetiny dolní": "Končetiny dolní",
    "Končetiny horní": "Končetiny horní",
    "Konec": "Konec",
    "Kontakt na pacienta": "Kontakt na klienta",
    "Kontaktní osoba": "Kontaktní osoba",
    "Kontaktní údaje": "Kontaktní údaje",
    "kontaktni-udaje": "kontaktni-udaje",
    "Kontaktovat": "Kontaktovat",
    "Kontaktovat náhradníky s nabídkou termínu?": "Kontaktovat náhradníky s nabídkou termínu?",
    "Kontaktujte nás": "Kontaktujte nás",
    "Kontaktujte nás a rádi vám Fyzion představíme <br>během 15 minutového online hovoru.": "Kontaktujte nás a rádi vám Fyzion představíme <br>během 15 minutového online hovoru.",
    "Kontaktujte naši podporu": "Kontaktujte naši podporu",
    "Kontrola": "Kontrola",
    "Kontrolní spis se nepodařilo vytvořit": "Kontrolní spis se nepodařilo vytvořit",
    "Kopírovat": "Kopírovat",
    "Krční": "Krční",
    "Kredit": "Kredit",
    "krok cviku": "krok cviku",
    "ks": "ks",
    "ks x": "ks x",
    "label": "label",
    "lekcí": "lekcí",
    "Limit": "Limit",
    "Limit dluhu předplatného bude překročen.": "Limit dluhu předplatného bude překročen.",
    "Limit dlužné částky": "Limit dlužné částky",
    "Limit dlužné částky:": "Limit dlužné částky:",
    "Limit pacientů můžete zvýšit, když nám pomůžete sdílet aplikaci mezi Vaše kolegy, ": "Limit klientů můžete zvýšit, když nám pomůžete sdílet aplikaci mezi Vaše kolegy, ",
    "Logo": "Logo",
    "Logo aplikace Fyzion": "Logo aplikace Fyzion",
    "Logo firmy": "Logo firmy",
    "Luboš Truhlář": "Luboš Truhlář",
    "mailto:info@fyzion.cz": "mailto:podpora@fyzion.cz",
    "Mají tel.": "Mají tel.",
    "Mastercard ikona": "Mastercard ikona",
    "Máte již vlastní IČO?": "Máte již vlastní IČO?",
    "máte naplánovanou návštěvu v ordinaci fyzioterapie": "máte naplánovanou návštěvu v ordinaci terapie",
    "Máte neuhrazenou objednávku za pronájem aplikace!": "Máte neuhrazenou objednávku za pronájem aplikace!",
    "Máte objednány tyto návštěvy": "Máte objednány tyto návštěvy",
    "Máte zde neuložené změny, chcete je před odchodem uložit?": "Máte zde neuložené změny, chcete je před odchodem uložit?",
    "Max. 9 výkonů": "Max. 9 výkonů",
    "Maximální kapacita": "Maximální kapacita",
    "Maximální kapacita návštěvy je ": "Maximální kapacita návštěvy je ",
    "Maximální počet klientů": "Maximální počet klientů",
    "Maximální počet objednaných rezervací": "Maximální počet objednaných rezervací",
    "Maximální počet rezervací": "Maximální počet rezervací",
    "Maximální počet rezervací za den": "Maximální počet rezervací za den",
    "Maximální počet termínů, které si může klient rezervovat v jedné objednávce. Pokud není vyplněno, počet rezervací není omezen.": "Maximální počet termínů, které si může klient rezervovat v jedné objednávce. Pokud není vyplněno, počet rezervací není omezen.",
    "Maximální počet účastníků skupinové služby.": "Maximální počet účastníků skupinové služby.",
    "Maximální úhrada": "Maximální úhrada",
    "McKenzie formuláře byly úspěšně aktivovány": "McKenzie formuláře byly úspěšně aktivovány",
    "McKenzie spisy": "McKenzie spisy",
    "měsíc": "měsíc",
    "Měsíc": "Měsíc",
    "měsíce": "měsíce",
    "Měsíce": "Měsíce",
    "měsíčně": "měsíčně",
    "Měsíčně": "Měsíčně",
    "Měsíční": "Měsíční",
    "měsíců": "měsíců",
    "Město": "Město",
    "mezi vaše kolegy nebo přechodem na ": "mezi vaše kolegy nebo přechodem na ",
    "mezi Vaše kolegy, nebo přechodem na ": "mezi Vaše kolegy, nebo přechodem na ",
    "min": "min",
    "min.": "min.",
    "Min. 1 výkon": "Min. 1 výkon",
    "min/terapie": "min/terapie",
    "Minimální počet objednaných rezervací": "Minimální počet objednaných rezervací",
    "Minimální počet rezervací": "Minimální počet rezervací",
    "Minimální počet termínů, které musí klient při jedné online rezervaci vybrat. Běžně je nastaveno na 1.": "Minimální počet termínů, které musí klient při jedné online rezervaci vybrat. Běžně je nastaveno na 1.",
    "Minulý měsíc": "Minulý měsíc",
    "Minulý rok": "Minulý rok",
    "Minulý týden": "Minulý týden",
    "minut": "minut",
    "Místnost": "Místnost",
    "Místnost bude odstraněna z pracovní doby.": "Místnost bude odstraněna z pracovní doby.",
    "Místnost byla úspěšně smazána": "Místnost byla úspěšně smazána",
    "Místnost byla úspěšně upravena": "Místnost byla úspěšně upravena",
    "Místnost byla úspěšně vytvořena": "Místnost byla úspěšně vytvořena",
    "mistnosti": "mistnosti",
    "Místnosti": "Místnosti",
    "MJ": "MJ",
    "Množství": "Množství",
    "Modrá": "Modrá",
    "Moduly": "Moduly",
    "Moje profily": "Moje profily",
    "Moje údaje": "Moje údaje",
    "Momentálně využívá": "Momentálně využívá",
    "Možnost dluhu": "Možnost dluhu",
    "Možnost platit online předem nebo na místě": "Možnost platit online předem nebo na místě",
    "Mřížka": "Mřížka",
    "Můj tarif": "Můj tarif",
    "Můj tarif, platby za předplatné.": "Můj tarif, platby za předplatné.",
    "Musí být alespoň 1": "Musí být alespoň 1",
    "Musí být menší než 1000.": "Musí být menší než 1000.",
    "Musí být větší než 0.": "Musí být větší než 0.",
    "Muž": "Muž",
    "Můžete vložit obrázek s vaším razítkem nebo podpisem, který se následně vloží na generované doklady pro pacienty.": "Můžete vložit obrázek s vaším razítkem nebo podpisem, který se následně vloží na generované doklady pro klienty.",
    "Muži": "Muži",
    "Muži (budoucí)": "Muži (objednaní)",
    "na info@fyzion.cz.": "na podpora@fyzion.cz.",
    "Nabízené permanentky": "Nabízené balíčky",
    "Nabízené služby": "Nabízené služby",
    "Načíst další": "Načíst další",
    "Načíst údaje z ARES": "Načíst údaje z ARES",
    "Načíst výkony": "Načíst výkony",
    "Nadcházející návštěva": "Nadcházející návštěva",
    "Nadpis bloku": "Nadpis bloku",
    "Náhradník": "Náhradník",
    "Náhradník odebrán": "Náhradník odebrán",
    "Náhradník přidán": "Náhradník přidán",
    "Náhradníka se nepodařilo odebrat": "Náhradníka se nepodařilo odebrat",
    "Náhradníka se nepodařilo přidat": "Náhradníka se nepodařilo přidat",
    "Nahrané dokumenty zde není možné vidět.": "Nahrané dokumenty zde není možné vidět.",
    "Nahrání dat do systému": "Nahrání dat do systému",
    "Nahrání obrázku se nezdařilo": "Nahrání obrázku se nezdařilo",
    "Nahrát dávku do Purobota": "Nahrát dávku do Purobota",
    "Nahrát fotku": "Nahrát fotku",
    "Nahrát soubor": "Nahrát soubor",
    "Nahrát soubor typu jpeg nebo png": "Nahrát soubor typu jpeg nebo png",
    "Nahrávání souborů, prosím nezavírejte stránku...": "Nahrávání souborů, prosím nezavírejte stránku...",
    "Nákupní (s DPH)": "Nákupní (s DPH)",
    "Nákupní cena a počet": "Nákupní cena a počet",
    "Nákupní cena s DPH": "Nákupní cena s DPH",
    "Nákupní hodnota (s DPH)": "Nákupní hodnota (s DPH)",
    "Napište nám na email:": "Napište nám na email:",
    "Napište poznámku…": "Napište poznámku…",
    "Naplánovat změnu ceny od zvoleného data": "Naplánovat změnu ceny od zvoleného data",
    "Nápověda": "Nápověda",
    "např. číslo dávky, dokladu, pojištěnce": "např. číslo dávky, dokladu, pojištěnce",
    "Např. kód, název zboží": "Např. kód, název zboží",
    "např. název, IČP, telefonní číslo": "např. název, IČP, telefonní číslo",
    "např. název, instituce, IČO": "např. klient",
    "např. RČ pacienta, e-mail": "např. jméno, e-mail",
    "Např. RČ pacienta, e-mailová adresa": "Např. RČ klienta, e-mailová adresa",
    "naší aplikaci či facebookovou skupinu Fyzion na internetu. Za každé takové sdílení Vám zdarma rozšíříme kartotéku o dalších pět pacientů. Jako potvrzení, že jste sdílení provedli, nám prosím zašlete screenshot (fotku obrazovky) sdíleného příspěvku na info@fyzion.cz a uveďte, o jakého fyzioterapeuta se jedná.": "naší aplikaci či facebookovou skupinu Fyzion na internetu. Za každé takové sdílení Vám zdarma rozšíříme kartotéku o dalších pět klientů. Jako potvrzení, že jste sdílení provedli, nám prosím zašlete screenshot (fotku obrazovky) sdíleného příspěvku na podpora@fyzion.cz a uveďte, o jakého terapeuta se jedná.",
    "naskladneni": "naskladneni",
    "Naskladnění": "Naskladnění",
    "Naskladnění zboží": "Naskladnění zboží",
    "Následující návštěva:": "Následující návštěva:",
    "Nasmlouvané výkony": "Nasmlouvané výkony",
    "nastaveni": "nastaveni",
    "Nastavení": "Nastavení",
    "Nastavení - Fakturační údaje": "Nastavení - Fakturační údaje",
    "NASTAVENÍ - KONTAKTNÍ ÚDAJE.": "NASTAVENÍ - KONTAKTNÍ ÚDAJE.",
    "Nastavení hesla": "Nastavení hesla",
    "Nastavení IČPE": "Nastavení IČPE",
    "Nastavení nového hesla": "Nastavení nového hesla",
    "Nastavení platby": "Nastavení platby",
    "Nastavení předplatného": "Nastavení předplatného",
    "Nastavení uloženo": "Nastavení uloženo",
    "Nastavit": "Nastavit",
    "Nastavit heslo": "Nastavit heslo",
    "Nastavit jako výchozí službu": "Nastavit jako výchozí službu",
    "Nastavit přesun podle": "Nastavit přesun podle",
    "Nastavit text emailu": "Nastavit text emailu",
    "Nastavit text SMS": "Nastavit text SMS",
    "Nastavit zrušení podle": "Nastavit zrušení podle",
    "Nastavuje počáteční číslo pro faktury": "Nastavuje počáteční číslo pro faktury",
    "Nastavuje počáteční číslo pro paragony": "Nastavuje počáteční číslo pro paragony",
    "Návod": "Návod",
    "Návrat do aplikace": "Návrat do aplikace",
    "Návštěv na stránku": "Návštěv na stránku",
    "návštěva": "návštěva",
    "Návštěva": "Návštěva",
    "Návštěva byla označena jako zaplacená": "Návštěva byla označena jako zaplacená",
    "Návštěva byla úspěšně zaplacena": "Návštěva byla úspěšně zaplacena",
    "Návštěva je zamknuta": "Návštěva je zamknuta",
    "Návštěva nemůže mít datum po konci platnosti FT poukazu": "Návštěva nemůže mít datum po konci platnosti FT poukazu",
    "Návštěva nenalezena": "Návštěva nenalezena",
    "Návštěva obsahuje nahrané formuláře": "Návštěva obsahuje nahrané formuláře",
    "Návštěva obsahuje nahrané fotografie": "Návštěva obsahuje nahrané fotografie",
    "Návštěva odemknuta": "Návštěva odemknuta",
    "Návštěva pacienta": "Návštěva klienta",
    "Návštěva smazána": "Návštěva smazána",
    "Návštěva úspěšně přidána": "Návštěva úspěšně přidána",
    "Návštěva zamknuta": "Návštěva zamknuta",
    "Návštěvu se nepodařilo uložit": "Návštěvu se nepodařilo uložit",
    "Návštěvu se nepodařilo uložit! Zkuste to prosím znovu.": "Návštěvu se nepodařilo uložit! Zkuste to prosím znovu.",
    "navstevy": "navstevy",
    "Návštěvy": "Návštěvy",
    "návštěvy pacientů": "návštěvy klientů",
    "Návštěvy pacientů": "Návštěvy klientů",
    "Návštěvy podle fyzioterapeutů": "Návštěvy podle terapeutů",
    "návštěvy vloží do správné karty.": "návštěvy vloží do správné karty.",
    "navstevy-pacienta": "navstevy-klienta",
    "Název": "Název",
    "Název cviku": "Název cviku",
    "Název firmy": "Název firmy",
    "Název instituce": "Odběratel/klient",
    "Název kategorie": "Název kategorie",
    "Název kliniky": "Název firmy",
    "Název místnosti": "Název místnosti",
    "Název permanentky": "Název balíčku",
    "Název pobočky": "Název pobočky",
    "Název podkategorie": "Název podkategorie",
    "Název pojišťovny": "Název pojišťovny",
    "Název pracoviště": "Název pracoviště",
    "Název předplatného": "Název předplatného",
    "Název šablony": "Název šablony",
    "Název služby": "Název služby",
    "Název v angličtině": "Název v angličtině",
    "Název v češtině": "Název v češtině",
    "Název v polštině": "Název v polštině",
    "Název ve slovenštině": "Název ve slovenštině",
    "Název zboží": "Název zboží",
    "Ne": "Ne",
    "nebo": "nebo",
    "nebo přechodem na pokročilý tarif. ": "nebo přechodem na pokročilý tarif. ",
    "Nebyly nalezeny žádné recenze.": "Nebyly nalezeny žádné recenze.",
    "Něco se pokazilo": "Něco se pokazilo",
    "Neděle": "Neděle",
    "Nedorazil:": "Nedorazil:",
    "Nejčastější sady výkonů můžete definovat v sekci POJIŠŤOVNY → ŠABLONY.": "Nejčastější sady výkonů můžete definovat v sekci POJIŠŤOVNY → ŠABLONY.",
    "Nejméně 8 znaků a alespoň 1 malé písmeno": "Nejméně 8 znaků a alespoň 1 malé písmeno",
    "Nejprve vyberte návštěvy k zaplacení": "Nejprve vyberte návštěvy k zaplacení",
    "Nejprve vyberte šablonu výkonů": "Nejprve vyberte šablonu výkonů",
    "Nejsou dostupné žádné místnosti": "Nejsou dostupné žádné místnosti",
    "Nejsou dostupné žádné pobočky": "Nejsou dostupné žádné pobočky",
    "Nejsou dostupné žádné předplatné": "Nejsou dostupné žádné předplatné",
    "Nejsou dostupné žádné transakce": "Nejsou dostupné žádné transakce",
    "Nejsou dostupní žádní uživatelé": "Nejsou dostupní žádní uživatelé",
    "Nejsou dostupní žádní žadatelé": "Nejsou dostupní žádní žadatelé",
    "Nejsou k dispozici žádná data": "Nejsou k dispozici žádná data",
    "Nejsou k dispozici žádné fotografie": "Nejsou k dispozici žádné fotografie",
    "Některé funkce aplikace Fyzion vám": "Některé funkce aplikace Fyzion vám",
    "Některé z povinných údajů chybí": "Některé z povinných údajů chybí",
    "Nelze odebrat zamčený výkon": "Nelze odebrat zamčený výkon",
    "Nelze přesunout volno k jinému fyzioterapeutovi.": "Nelze přesunout volno k jinému terapeutovi.",
    "Nelze smazat - zboží je na skladě.": "Nelze smazat - zboží je na skladě.",
    "Nelze vytvořit kontrolní spis: Chybí ID pacienta v M-Spisech": "Nelze vytvořit kontrolní spis: Chybí ID klienta v M-Spisech",
    "Nelze vytvořit kontrolní spis: doplňte rodné číslo k pacientovi": "Nelze vytvořit kontrolní spis: doplňte rodné číslo ke klientovi",
    "Nelze vytvořit nový spis: Chybí ID pacienta v M-Spisech": "Nelze vytvořit nový spis: Chybí ID klienta v M-Spisech",
    "Nelze vytvořit nový spis: doplňte rodné číslo k pacientovi": "Nelze vytvořit nový spis: doplňte rodné číslo ke klientovi",
    "Nemají tel.": "Nemají tel.",
    "Nemáte dostatečné oprávnění pro tuto akci.": "Nemáte dostatečné oprávnění pro tuto akci.",
    "Nemáte oprávnění na smazání cizí návštěvy": "Nemáte oprávnění na smazání cizí návštěvy",
    "Nemáte oprávnění na smazání návštěvy": "Nemáte oprávnění na smazání návštěvy",
    "Nemáte oprávnění na úpravu jiného fyzioterapeuta": "Nemáte oprávnění na úpravu jiného terapeuta",
    "Nemáte oprávnění na úpravu jiných ordinačních hodin": "Nemáte oprávnění na úpravu jiných ordinačních hodin",
    "Nemáte oprávnění na úpravu permanentky": "Nemáte oprávnění na úpravu balíčku",
    "Nemáte oprávnění na úpravu služby": "Nemáte oprávnění na úpravu služby",
    "Nemáte oprávnění na zaplacení cizí návštěvy": "Nemáte oprávnění na zaplacení cizí návštěvy",
    "Nemáte oprávnění na zrušení cizí návštěvy": "Nemáte oprávnění na zrušení cizí návštěvy",
    "Nemáte oprávnění pro odemknutí výkonu": "Nemáte oprávnění pro odemknutí výkonu",
    "Nemáte oprávnění prohlížet anamnézu pacienta": "Nemáte oprávnění prohlížet anamnézu klienta",
    "Nemáte vytvořenou smlouvu s touto pojišťovnou. Pro tuto pojišťovnu se dávka nevytvoří.": "Nemáte vytvořenou smlouvu s touto pojišťovnou. Pro tuto pojišťovnu se dávka nevytvoří.",
    "Nemáte žádné objednané návštěvy.": "Nemáte žádné objednané návštěvy.",
    "nemusí správně fungovat.": "nemusí správně fungovat.",
    "Nemůže být záporné": "Nemůže být záporné",
    "Nenalezen žádný dodavatel": "Nenalezen žádný dodavatel",
    "Nenalezen žádný doklad": "Nenalezen žádný doklad",
    "Nenalezen žádný FT poukaz pro načtení výkonů": "Nenalezen žádný FT poukaz pro načtení výkonů",
    "Nenalezen žádný klient": "Nenalezen žádný klient",
    "Nenalezen žádný pacient": "Nenalezen žádný klient",
    "Nenalezen žádný výkon": "Nenalezen žádný výkon",
    "Nenalezen žádný záznam": "Nenalezen žádný záznam",
    "Nenalezena shoda se jménem žádného cviku.": "Nenalezena shoda se jménem žádného cviku.",
    "Nenalezena žádná akce": "Nenalezena žádná akce",
    "Nenalezena žádná dávka": "Nenalezena žádná dávka",
    "Nenalezena žádná návštěva": "Nenalezena žádná návštěva",
    "Nenalezena žádná pracoviště": "Nenalezena žádná pracoviště",
    "Nenalezena žádná šablona": "Nenalezena žádná šablona",
    "Nenalezena žádná stvrzenka": "Nenalezena žádná stvrzenka",
    "Nenalezena žádná zpráva": "Nenalezena žádná zpráva",
    "Nenalezeno žádné další zboží": "Nenalezeno žádné další zboží",
    "Nenalezeny žádná výkony": "Nenalezeny žádné výkony",
    "Nenalezeny žádné další služby": "Nenalezeny žádné další služby",
    "Nenalezeny žádné položky": "Nenalezeny žádné položky",
    "Nenalezeny žádné zásoby": "Nenalezeny žádné zásoby",
    "Není dostupná žádná šablona výkonů": "Není dostupná žádná šablona výkonů",
    "Není dostupný žádný platný FT poukaz": "Není dostupný žádný platný FT poukaz",
    "Není dostupný žádný výkon": "Není dostupný žádný výkon",
    "Není možné změnit tarif, protože máte v kartotéce více pacientů,": "Není možné změnit tarif, protože máte v kartotéce více klientů,",
    "Není nahrána žádná fotka": "Není nahrána žádná fotka",
    "Není naplánována další návštěva": "Není naplánována další návštěva",
    "Neočekávaná chyba": "Neočekávaná chyba",
    "Neomezený počet pacientů": "Neomezený počet klientů",
    "Neopakuje se": "Neopakuje se",
    "Neplátce DPH": "Neplátce DPH",
    "Nepodařilo se aktualizovat cviky v návštěvě": "Nepodařilo se aktualizovat cvičení v návštěvě",
    "Nepodařilo se aktualizovat den se cvičením": "Nepodařilo se aktualizovat den se cvičením",
    "Nepodařilo se aktualizovat šablonu": "Nepodařilo se aktualizovat šablonu",
    "Nepodařilo se načíst AI shrnutí": "Nepodařilo se načíst AI shrnutí",
    "Nepodařilo se načíst AI shrnutí.": "Nepodařilo se načíst AI shrnutí.",
    "Nepodařilo se načíst budoucí návštěvy.": "Nepodařilo se načíst budoucí návštěvy.",
    "Nepodařilo se načíst celkové hodnoty naskladněných položek": "Nepodařilo se načíst celkové hodnoty naskladněných položek",
    "Nepodařilo se načíst cesty za pacientem": "Nepodařilo se načíst cesty za klientem",
    "Nepodařilo se načíst cviky": "Nepodařilo se načíst cvičení",
    "Nepodařilo se načíst data": "Nepodařilo se načíst data",
    "Nepodařilo se načíst data ze systému": "Nepodařilo se načíst data ze systému",
    "Nepodařilo se načíst dávku": "Nepodařilo se načíst dávku",
    "Nepodařilo se načíst dávky": "Nepodařilo se načíst dávky",
    "Nepodařilo se načíst detail poukazu": "Nepodařilo se načíst detail poukazu",
    "Nepodařilo se načíst diagnózy": "Nepodařilo se načíst diagnózy",
    "Nepodařilo se načíst dodavatele": "Nepodařilo se načíst dodavatele",
    "Nepodařilo se načíst dostupné fyzioterapeuty": "Nepodařilo se načíst dostupné terapeuty",
    "Nepodařilo se načíst druhy péče": "Nepodařilo se načíst druhy péče",
    "Nepodařilo se načíst FT poukazy": "Nepodařilo se načíst FT poukazy",
    "Nepodařilo se načíst hromadnou návštěvu": "Nepodařilo se načíst hromadnou návštěvu",
    "Nepodařilo se načíst kategorie cviků": "Nepodařilo se načíst kategorie cvičení",
    "Nepodařilo se načíst kategorii cviků": "Nepodařilo se načíst kategorii cvičení",
    "Nepodařilo se načíst místnost": "Nepodařilo se načíst místnost",
    "Nepodařilo se načíst místnosti": "Nepodařilo se načíst místnosti",
    "Nepodařilo se načíst návrh platby": "Nepodařilo se načíst návrh platby",
    "Nepodařilo se načíst návštěvu pacienta": "Nepodařilo se načíst návštěvu klienta",
    "Nepodařilo se načíst návštěvy pacienta": "Nepodařilo se načíst návštěvy klienta",
    "Nepodařilo se načíst novinku": "Nepodařilo se načíst novinku",
    "Nepodařilo se načíst novinky": "Nepodařilo se načíst novinky",
    "Nepodařilo se načíst odbornosti": "Nepodařilo se načíst odbornosti",
    "Nepodařilo se načíst ordinaci na této adrese": "Nepodařilo se načíst ordinaci na této adrese",
    "Nepodařilo se načíst pacienty": "Nepodařilo se načíst klienty",
    "Nepodařilo se načíst permanentku": "Nepodařilo se načíst balíček",
    "Nepodařilo se načíst permanentky pacienta": "Nepodařilo se načíst balíčky klienta",
    "Nepodařilo se načíst platbu": "Nepodařilo se načíst platbu",
    "Nepodařilo se načíst platby": "Nepodařilo se načíst platby",
    "Nepodařilo se načíst platební údaje": "Nepodařilo se načíst platební údaje",
    "Nepodařilo se načíst pojišťovnu": "Nepodařilo se načíst pojišťovnu",
    "Nepodařilo se načíst pojišťovny": "Nepodařilo se načíst pojišťovny",
    "Nepodařilo se načíst položku": "Nepodařilo se načíst položku",
    "Nepodařilo se načíst poukazy": "Nepodařilo se načíst poukazy",
    "Nepodařilo se načíst pracoviště": "Nepodařilo se načíst pracoviště",
    "Nepodařilo se načíst předplatné": "Nepodařilo se načíst předplatné",
    "Nepodařilo se načíst recenze": "Nepodařilo se načíst recenze",
    "Nepodařilo se načíst šablonu": "Nepodařilo se načíst šablonu",
    "Nepodařilo se načíst šablony": "Nepodařilo se načíst šablony",
    "Nepodařilo se načíst šablony FT poukazů": "Nepodařilo se načíst šablony FT poukazů",
    "Nepodařilo se načíst seznam diagnóz": "Nepodařilo se načíst seznam diagnóz",
    "Nepodařilo se načíst seznam návštěv.": "Nepodařilo se načíst seznam návštěv.",
    "Nepodařilo se načíst seznam uživatelů": "Nepodařilo se načíst seznam uživatelů",
    "Nepodařilo se načíst skupiny služeb": "Nepodařilo se načíst skupiny služeb",
    "Nepodařilo se načíst služby": "Nepodařilo se načíst služby",
    "Nepodařilo se načíst transakce": "Nepodařilo se načíst transakce",
    "Nepodařilo se načíst transakci": "Nepodařilo se načíst transakci",
    "Nepodařilo se načíst volné termíny": "Nepodařilo se načíst volné termíny",
    "Nepodařilo se načíst výkony": "Nepodařilo se načíst výkony",
    "Nepodařilo se načíst žadatele": "Nepodařilo se načíst žadatele",
    "Nepodařilo se načíst zaměstnance": "Nepodařilo se načíst zaměstnance",
    "Nepodařilo se načíst zásoby": "Nepodařilo se načíst zásoby",
    "Nepodařilo se načíst země": "Nepodařilo se načíst země",
    "Nepodařilo se načíst zemi": "Nepodařilo se načíst zemi",
    "Nepodařilo se nahrát dávku do Purobota": "Nepodařilo se nahrát dávku do Purobota",
    "Nepodařilo se nahrát fotku FT poukazu": "Nepodařilo se nahrát fotku FT poukazu",
    "Nepodařilo se nahrát soubor": "Nepodařilo se nahrát soubor",
    "Nepodařilo se odebrat štítek": "Nepodařilo se odebrat štítek",
    "Nepodařilo se odemknout výkon": "Nepodařilo se odemknout výkon",
    "Nepodařilo se odeslat recenzi. Zkuste to prosím znovu.": "Nepodařilo se odeslat recenzi. Zkuste to prosím znovu.",
    "Nepodařilo se označit fakturu jako zaplacenou": "Nepodařilo se označit fakturu jako zaplacenou",
    "Nepodařilo se přidat fakturaci": "Nepodařilo se přidat fakturaci",
    "Nepodařilo se přidat předplatné": "Nepodařilo se přidat předplatné",
    "Nepodařilo se smazat cvik": "Nepodařilo se smazat cvik",
    "Nepodařilo se smazat místnost": "Nepodařilo se smazat místnost",
    "Nepodařilo se smazat platbu": "Nepodařilo se smazat platbu",
    "Nepodařilo se smazat pojišťovnu": "Nepodařilo se smazat pojišťovnu",
    "Nepodařilo se smazat pracoviště": "Nepodařilo se smazat pracoviště",
    "Nepodařilo se smazat předplatné": "Nepodařilo se smazat předplatné",
    "Nepodařilo se smazat recenzi": "Nepodařilo se smazat recenzi",
    "Nepodařilo se smazat šablonu": "Nepodařilo se smazat šablonu",
    "Nepodařilo se smazat štítek": "Nepodařilo se smazat štítek",
    "Nepodařilo se spustit platbu. Zkuste to prosím znovu.": "Nepodařilo se spustit platbu. Zkuste to prosím znovu.",
    "Nepodařilo se uložit pracoviště žadatele": "Nepodařilo se uložit pracoviště žadatele",
    "Nepodařilo se upravit cvik.": "Nepodařilo se upravit cvik.",
    "Nepodařilo se upravit dostupnost": "Nepodařilo se upravit dostupnost",
    "Nepodařilo se upravit fakturaci": "Nepodařilo se upravit fakturaci",
    "Nepodařilo se upravit místnost": "Nepodařilo se upravit místnost",
    "Nepodařilo se upravit platbu": "Nepodařilo se upravit platbu",
    "Nepodařilo se upravit pobočku": "Nepodařilo se upravit pobočku",
    "Nepodařilo se upravit předplatné": "Nepodařilo se upravit předplatné",
    "Nepodařilo se vygenerovat export": "Nepodařilo se vygenerovat export",
    "Nepodařilo se vygenerovat fakturu": "Nepodařilo se vygenerovat fakturu",
    "Nepodařilo se vygenerovat platební odkaz": "Nepodařilo se vygenerovat platební odkaz",
    "Nepodařilo se vygenerovat zprávu": "Nepodařilo se vygenerovat zprávu",
    "Nepodařilo se vylepšit popis návštěvy": "Nepodařilo se vylepšit popis návštěvy",
    "Nepodařilo se vytvořit cvik.": "Nepodařilo se vytvořit cvik.",
    "Nepodařilo se vytvořit dodavatele": "Nepodařilo se vytvořit dodavatele",
    "Nepodařilo se vytvořit hromadnou návštěvu": "Nepodařilo se vytvořit hromadnou návštěvu",
    "Nepodařilo se vytvořit kategorii.": "Nepodařilo se vytvořit kategorii.",
    "Nepodařilo se vytvořit místnost": "Nepodařilo se vytvořit místnost",
    "Nepodařilo se vytvořit platbu": "Nepodařilo se vytvořit platbu",
    "Nepodařilo se vytvořit pracoviště žadatele": "Nepodařilo se vytvořit pracoviště žadatele",
    "Nepodařilo se vytvořit registraci jako náhradník": "Nepodařilo se vytvořit registraci jako náhradník",
    "Nepodařilo se vytvořit šablonu": "Nepodařilo se vytvořit šablonu",
    "Nepodařilo se vytvořit štítek": "Nepodařilo se vytvořit štítek",
    "Nepodařilo se vytvořit uživatele": "Nepodařilo se vytvořit uživatele",
    "Nepodařilo se zaplatit návštěvu": "Nepodařilo se zaplatit návštěvu",
    "Nepodařilo se získat cviky pacienta": "Nepodařilo se získat cvičení klienta",
    "Nepodařilo se změnit nastavení rezervací pacienta": "Nepodařilo se změnit nastavení rezervací klienta",
    "Nepodařilo se zrušit platbu": "Nepodařilo se zrušit platbu",
    "Nepodařilo se zrušit platbu za návštěvu": "Nepodařilo se zrušit platbu za návštěvu",
    "Nepodporovaný typ prohlížeče": "Nepodporovaný typ prohlížeče",
    "nepodporovaný typ prohlížeče.": "nepodporovaný typ prohlížeče.",
    "Nepovinné": "Nepovinné",
    "Nepravidelné ordinační hodiny": "Nepravidelná pracovní doba",
    "Nepřišel": "Nepřišel",
    "Nesouhlasili": "Nesouhlasili",
    "Neuhrazená objednávka": "Neuhrazená objednávka",
    "Neuhrazeno": "Neuhrazeno",
    "Neukládat": "Neukládat",
    "Nevíte jak na to? Podívejte se na náš návod, přihlašte se na webinář nebo kontaktujte podporu.": "Nevíte jak na to? Podívejte se na náš návod, přihlašte se na webinář nebo kontaktujte podporu.",
    "Nevystaveno": "Nevystaveno",
    "Nezaplaceno": "Nezaplaceno",
    "notifikace": "notifikace",
    "Notifikace": "Notifikace",
    "Notifikace ordinaci": "Notifikace ordinaci",
    "nova": "nova",
    "Nová cena": "Nová cena",
    "Nová cena s DPH": "Nová cena s DPH",
    "Nová cena se použije pro návštěvy od zvoleného data. Do té doby platí současná cena služby. Vypnutím naplánovanou změnu zrušíte.": "Nová cena se použije pro návštěvy od zvoleného data. Do té doby platí současná cena služby. Vypnutím naplánovanou změnu zrušíte.",
    "Nová fakturace": "Nová fakturace",
    "Nová místnost": "Nová místnost",
    "Nová návštěva": "Nová návštěva",
    "Nová operace": "Nová operace",
    "Nová šablona": "Nová šablona",
    "Nová skupinová návštěva": "Nová skupinová návštěva",
    "Nová událost": "Nová událost",
    "nova-navsteva": "nova-navsteva",
    "nova-opravna": "nova-opravna",
    "nova-skupinova-navsteva": "nova-skupinova-navsteva",
    "nove": "nove",
    "Nové heslo": "Nové heslo",
    "Nové pracoviště žadatele": "Nové pracoviště žadatele",
    "Nové předplatné": "Nové předplatné",
    "Novinky": "Novinky",
    "novy": "novy",
    "Nový pacient": "Nový klient",
    "Nový spis": "Nový spis",
    "Nový žadatel": "Nový žadatel",
    "novy-ft-poukaz": "novy-ft-poukaz",
    "O nás": "O nás",
    "Období": "Období",
    "obecne": "obecne",
    "Obecné": "Obecné",
    "obecného nastavení firmy": "obecného nastavení firmy",
    "obecném nastavení": "obecném nastavení",
    "Objednat návštěvu": "Objednat návštěvu",
    "Objednat se na": "Objednat se na",
    "Objekt": "Objekt",
    "Obměna": "Obměna",
    "obnova-hesla": "obnova-hesla",
    "Obnovit tabulku": "Obnovit tabulku",
    "Obrázek byl smazán": "Obrázek byl smazán",
    "Obrázky": "Obrázky",
    "Obsah": "Obsah",
    "Ochrana osobních údajů": "Ochrana osobních údajů",
    "Od": "Od",
    "Odběratel/klient": "Odběratel/klient",
    "Odběratel/Klient": "Odběratel/Klient",
    "Odbornost": "Odbornost",
    "Odcvičeno a přejít na další cvik": "Odcvičeno a přejít na další cvik",
    "Odebrat": "Odebrat",
    "Odebrat náhradníka": "Odebrat náhradníka",
    "Odebrat pacienta": "Odebrat klienta",
    "Odebrat položku": "Odebrat položku",
    "Odebrat výkon": "Odebrat výkon",
    "Odebrat z čekajících": "Odebrat z čekajících",
    "Odebrat zastávku na cestě": "Odebrat zastávku na cestě",
    "Odemknout": "Odemknout",
    "Odemknout výkon": "Odemknout výkon",
    "Odesílat email": "Odesílat email",
    "Odesílat email připomínku před návštěvou": "Odesílat email připomínku před návštěvou",
    "Odesílat připomínku e-mailem": "Odesílat připomínku e-mailem",
    "Odesílat SMS": "Odesílat SMS",
    "Odesílat SMS předem": "Odesílat SMS předem",
    "Odesílat SMS připomínku před návštěvou": "Odesílat SMS připomínku před návštěvou",
    "Odesílat stvrzenky klientům": "Odesílat stvrzenky klientům",
    "Odesílat upozornění e-mailem o vytvoření, změně, zrušení návštěvy": "Odesílat upozornění e-mailem o vytvoření, změně, zrušení návštěvy",
    "Odesílat žádost o recenzi": "Odesílat žádost o recenzi",
    "Odeslali jsme vám e-mail s instrukcemi k resetování hesla.": "Odeslali jsme vám e-mail s instrukcemi k resetování hesla.",
    "Odeslané zprávy": "Odeslané zprávy",
    "Odeslání dávek s přihlášením pomocí SMS kódu v tuto chvíli není podporované.": "Odeslání dávek s přihlášením pomocí SMS kódu v tuto chvíli není podporované.",
    "Odeslání dávky pojišťovně selhalo": "Odeslání dávky pojišťovně selhalo",
    "Odeslání emailu": "Odeslání emailu",
    "Odeslání emailu 1 pacientovi": "Odeslání emailu 1 klientovi",
    "Odeslání emailu pacientovi": "Odeslání emailu klientovi",
    "Odeslání SMS": "Odeslání SMS",
    "Odeslání SMS 1 pacientovi": "Odeslání SMS 1 klientovi",
    "Odeslání SMS pacientovi": "Odeslání SMS klientovi",
    "Odeslání zůstalo nedokončené": "Odeslání zůstalo nedokončené",
    "Odesláno": "Odesláno",
    "Odesláno na ": "Odesláno na ",
    "Odeslat": "Odeslat",
    "Odeslat %{count} dávku pojišťovně?": [
      "Odeslat %{count} dávku pojišťovně?",
      "Odeslat %{count} dávky pojišťovně?",
      "Odeslat %{count} dávek pojišťovně?"
    ],
    "Odeslat 1 stvrzenku": "Odeslat 1 stvrzenku",
    "Odeslat email": "Odeslat email",
    "Odeslat GDPR mailem": "Odeslat GDPR mailem",
    "Odeslat klientovi": "Odeslat klientovi",
    "Odeslat pacientovi": "Odeslat klientovi",
    "Odeslat potvrzení o platbě": "Odeslat potvrzení o platbě",
    "Odeslat pouze zvoleným klientům.": "Odeslat pouze zvoleným klientům.",
    "Odeslat připomínku platby (před návštěvou)": "Odeslat připomínku platby (před návštěvou)",
    "Odeslat SMS": "Odeslat SMS",
    "Odeslat SMS pomocí telefonu": "Odeslat SMS pomocí telefonu",
    "Odeslat soubory": "Odeslat soubory",
    "Odeslat znovu emailem": "Odeslat emailem",
    "odešlete": "odešlete",
    "Odhlásit": "Odhlásit",
    "Odkaz na formulář pro rezervaci čekajících pacientů": "Odkaz na formulář pro rezervaci čekajících klientů",
    "Odkaz na kalendář s přehledem vámi nabízených skupinových lekcí": "Odkaz na kalendář s přehledem vámi nabízených skupinových lekcí",
    "Odkaz na přístup do klientské sekce": "Odkaz na přístup do klientské sekce",
    "Odkaz na rezervaci byl zkopírován do schránky": "Odkaz na rezervaci byl zkopírován do schránky",
    "Odkaz na váš online rezervační systém": "Odkaz na váš online rezervační systém",
    "Odkaz na vaší stránku ordinace obsahující rozcestník služeb, recenze, ordinační dobu i kontaktní údaje": "Odkaz na vaší stránku ordinace obsahující rozcestník služeb, recenze, ordinační dobu i kontaktní údaje",
    "Odkud jste se o nás dozvěděli?": "Odkud jste se o nás dozvěděli?",
    "Odpovědi posílat na email": "Odpovědi posílat na email",
    "Odstranit časový interval": "Odstranit časový interval",
    "Ohodnoťte kvalitu naší služby": "Ohodnoťte kvalitu naší služby",
    "Omezuje počet rezervací této služby na jeden den. Vhodné pro časově nebo fyzicky náročné služby.": "Omezuje počet rezervací této služby na jeden den. Vhodné pro časově nebo fyzicky náročné služby.",
    "Omlouváme se, ale v aplikaci Fyzion došlo k nečekané chybě. Někdy i ty nejlepší svaly potřebují chvilku na odpočinek.": "Omlouváme se, ale v aplikaci Fyzion došlo k nečekané chybě. Někdy i ty nejlepší svaly potřebují chvilku na odpočinek.",
    "Online platba": "Online platba",
    "Online rezervace": "Online rezervace",
    "Opakování": "Opakování",
    "Opakovat heslo": "Opakovat heslo",
    "Opakovat jednou za": "Opakovat jednou za",
    "Opravdu si přejete archivovat pacienta?": "Opravdu si přejete archivovat klienta?",
    "Opravdu si přejete dokument smazat?": "Opravdu si přejete dokument smazat?",
    "Opravdu si přejete formulář smazat?": "Opravdu si přejete formulář smazat?",
    "Opravdu si přejete fotografii smazat?": "Opravdu si přejete fotografii smazat?",
    "Opravdu si přejete FT poukaz smazat?": "Opravdu si přejete FT poukaz smazat?",
    "Opravdu si přejete místnost smazat?": "Opravdu si přejete místnost smazat?",
    "Opravdu si přejete náhradníka odebrat?": "Opravdu si přejete náhradníka odebrat?",
    "Opravdu si přejete obrázek smazat?": "Opravdu si přejete obrázek smazat?",
    "Opravdu si přejete pacienta odebrat?": "Opravdu si přejete klienta odebrat?",
    "Opravdu si přejete permanentku smazat?": "Opravdu si přejete balíček smazat?",
    "Opravdu si přejete platbu zrušit?": "Opravdu si přejete platbu zrušit?",
    "Opravdu si přejete pobočku smazat?": "Opravdu si přejete pobočku smazat?",
    "Opravdu si přejete pojišťovnu smazat?": "Opravdu si přejete pojišťovnu smazat?",
    "Opravdu si přejete poukaz smazat?": "Opravdu si přejete poukaz smazat?",
    "Opravdu si přejete pracoviště smazat?": "Opravdu si přejete pracoviště smazat?",
    "Opravdu si přejete recenzi smazat?": "Opravdu si přejete recenzi smazat?",
    "Opravdu si přejete rezervaci zrušit?": "Opravdu si přejete rezervaci zrušit?",
    "Opravdu si přejete šablonu smazat?": "Opravdu si přejete šablonu smazat?",
    "Opravdu si přejete smazat cvik": "Opravdu si přejete smazat cvik",
    "Opravdu si přejete smazat kategorii cviků?": "Opravdu si přejete smazat kategorii cvičení?",
    "Opravdu si přejete smazat kategorii služeb": "Opravdu si přejete smazat kategorii služeb",
    "Opravdu si přejete smazat platbu č.": "Opravdu si přejete smazat platbu č.",
    "Opravdu si přejete smazat předplatné": "Opravdu si přejete smazat předplatné",
    "Opravdu si přejete smazat službu": "Opravdu si přejete smazat službu",
    "Opravdu si přejete stornovat stvrzenku?": "Opravdu si přejete stornovat stvrzenku?",
    "Opravdu si přejete synchronizaci odebrat?": "Opravdu si přejete synchronizaci odebrat?",
    "Opravdu si přejete terapeuta deaktivovat?": "Opravdu si přejete terapeuta deaktivovat?",
    "Opravdu si přejete video smazat?": "Opravdu si přejete video smazat?",
    "Opravdu si přejete volno smazat?": "Opravdu si přejete volno smazat?",
    "Opravdu si přejete zboží smazat?": "Opravdu si přejete zboží smazat?",
    "Opravná": "Opravná",
    "Opravná dávka": "Opravná dávka",
    "Opustit průvodce": "Opustit průvodce",
    "Ordinace": "Ordinace",
    "ordinační hodiny": "pracovní doba",
    "Ordinační hodiny": "Ordinační hodiny",
    "Origin:": "Origin:",
    "Osobní údaje": "Osobní údaje",
    "Osobní údaje, přihlašovací údaje, propojení s GC.": "Osobní údaje, přihlašovací údaje, propojení s GC.",
    "Ostatní diagnózy": "Ostatní diagnózy",
    "Ostatní služby": "Ostatní služby",
    "Otevírací doba": "Otevírací doba",
    "Otevřeno": "Otevřeno",
    "Otevřít": "Otevřít",
    "Otevřít nápovědu": "Otevřít nápovědu",
    "Otevřít návštěvu": "Otevřít návštěvu",
    "Otevřít v novém okně": "Otevřít v novém okně",
    "Ověření": "Ověření",
    "Označeno:": "Označeno:",
    "Označit jako zaplacené": "Označit jako zaplacené",
    "Pacient": "Klient",
    "Pacient byl archivován. Jestliže chcete jeho kartu obnovit, kontaktujte podporu": "Klient byl archivován. Jestliže chcete jeho kartu obnovit, kontaktujte podporu",
    "Pacient byl úspěšně přidán": "Klient byl úspěšně přidán",
    "Pacient ještě nepotvrdil GDPR": "Klient ještě nepotvrdil GDPR",
    "Pacient již GDPR potvrdil": "Klient již GDPR potvrdil",
    "Pacient má platný FT poukaz do %{date}.": "Klient má platný FT poukaz do %{date}.",
    "Pacient nemá nastavenou příští návštěvu": "Klient nemá nastavenou příští návštěvu",
    "Pacient odebrán": "Klient odebrán",
    "Pacient odhlášen z odběru novinek": "Klient odhlášen z odběru novinek",
    "Pacient přídán": "Klient přídán",
    "Pacient přihlášen k odběru novinek": "Klient přihlášen k odběru novinek",
    "Pacient úspěšně archivován": "Klient úspěšně archivován",
    "Pacient úspěšně odebrán z čekajících pacientů": "Klient úspěšně odebrán z čekajících klientů",
    "Pacient úspěšně přidán do čekajících pacientů": "Klient úspěšně přidán do čekajících klientů",
    "Pacient úspěšně upraven": "Klient úspěšně upraven",
    "Pacient zde zatím nemá žádnou návštěvu a k ní vytvořené popisy.": "Klient zde zatím nemá žádnou návštěvu a k ní vytvořené popisy.",
    "Pacienta se nepodařilo archivovat": "Klient se nepodařilo archivovat",
    "Pacienta se nepodařilo odebrat": "Klient se nepodařilo odebrat",
    "Pacienta se nepodařilo přidat do čekajících pacientů. Zkuste prosím znovu.": "Klienta se nepodařilo přidat do čekajících klientů. Zkuste prosím znovu.",
    "Pacienta se nepodařilo přihlásit k odběru novinek. Zkuste to prosím znovu.": "Klienta se nepodařilo přihlásit k odběru novinek. Zkuste to prosím znovu.",
    "Pacienti": "Klienti",
    "Pacienti úspěšně odebráni z čekajících pacientů": "Klienti úspěšně odebráni z čekajících klientů",
    "Pacienti, kteří přišli poprvé": "Klienti, kteří přišli poprvé",
    "Pacientovi pošleme potvrzení o platbě na jeho email": "Klientovi pošleme potvrzení o platbě na jeho email",
    "Pacientů na stránku": "Klientů na stránku",
    "pacientům": "klientům",
    "Paragon": "Paragon",
    "paragon č.": "paragon č.",
    "Paragony": "Paragony",
    "Parametry příští návštěvy upraveny": "Parametry příští návštěvy upraveny",
    "Pátek": "Pátek",
    "Patička faktury": "Patička faktury",
    "Paušální": "Paušální",
    "PDF": "PDF",
    "PDF se nepodařilo vygenerovat. Zkuste to prosím znovu.": "PDF se nepodařilo vygenerovat. Zkuste to prosím znovu.",
    "Permanentka aktualizována": "Balíček aktualizován",
    "Permanentka byla označena jako zaplacená": "Balíček byl označen jako zaplacený",
    "Permanentka umožňuje nastavit předplacené návštěvy na vybrané služby. Klientovi ji lze přiřadit v jeho kartě a při platbě využít. V kartě klienta uvidíte i počet zbývajících předplacených návštěv.": "Balíček umožňuje nastavit předplacené návštěvy na vybrané služby. Klientovi ji lze přiřadit v jeho kartě a při platbě využít. V kartě klienta uvidíte i počet zbývajících předplacených návštěv.",
    "Permanentka úspěšně odebrána pacientovi.": "Balíček úspěšně odebrán klientovi.",
    "Permanentka úspěšně přidána pacientovi.": "Balíček úspěšně přidán klientovi.",
    "Permanentka úspěšně vytvořena": "Balíček úspěšně vytvořen",
    "Permanentkou": "Balíčkem",
    "Permanentku se nepodařilo pacientovi odebrat. Zkuste prosím znovu.": "Balíček se nepodařilo klientovi odebrat. Zkuste prosím znovu.",
    "Permanentku se nepodařilo pacientovi přidat. Zkuste prosím znovu.": "Balíček se nepodařilo klientovi přidat. Zkuste prosím znovu.",
    "Permanentku se nepodařilo upravit.": "Balíček se nepodařilo upravit.",
    "Permanentku se nepodařilo vytvořit": "Balíček se nepodařilo vytvořit",
    "Permanentky": "Balíčky",
    "PL": "PL",
    "planovani": "planovani",
    "Plánování": "Plánování",
    "planovani-mistnosti": "planovani-mistnosti",
    "Platba": "Platba",
    "Platba byla smazána": "Platba byla smazána",
    "Platba byla zrušena": "Platba byla zrušena",
    "Platba pouze na místě při terapii": "Platba pouze na místě při terapii",
    "Platba předem": "Platba předem",
    "Platba předplatným": "Platba předplatným",
    "Platba za návštěvu byla úspěšně zrušena": "Platba za návštěvu byla úspěšně zrušena",
    "platby": "platby",
    "Platby": "Platby",
    "Platby za předplatné": "Platby za předplatné",
    "Platby za pronájem aplikace": "Platby za pronájem aplikace",
    "Plátce DPH": "Plátce DPH",
    "Plateb na stránku": "Plateb na stránku",
    "Platební brána": "Platební brána",
    "Platební brána byla úspěšně nastavena": "Platební brána byla úspěšně nastavena",
    "Platební brána Comgate": "Platební brána Comgate",
    "Platební brána Fyzion": "Platební brána Fyzion",
    "Platební brána se používá jen v případě, že jsou u služby zapnuté platby předem.": "Platební brána se používá jen v případě, že jsou u služby zapnuté platby předem.",
    "Platební informace": "Platební informace",
    "Platná do:": "Platná do:",
    "Platnost (v měsících)": "Platnost (v měsících)",
    "Platnost do": "Platnost do",
    "Platnost musí být větší nebo rovna 1.": "Platnost musí být větší nebo rovna 1.",
    "Platnost nové ceny od": "Platnost nové ceny od",
    "Platnost vašeho odkazu vypršela. Zažádejte si o nastavení nového hesla": "Platnost vašeho odkazu vypršela. Zažádejte si o nastavení nového hesla",
    "Po": "Po",
    "Po rezervaci budete přesměrování na platební bránu pro uhrazení ceny terapie.": "Po rezervaci budete přesměrování na platební bránu pro uhrazení ceny terapie.",
    "Po skončení návštěvy se klientovi automaticky odešle žádost o zpětnou vazbu.": "Po skončení návštěvy se klientovi automaticky odešle žádost o zpětnou vazbu.",
    "Po sloučení se všechny minulé i budoucí": "Po sloučení se všechny minulé i budoucí",
    "Po třech dnech": "Po třech dnech",
    "Po vložení kódu na váš web se zobrazí okno s rezervací": "Po vložení kódu na váš web se zobrazí okno s rezervací",
    "Po vložení kódu na váš web se zobrazí tlačítko s rezervací": "Po vložení kódu na váš web se zobrazí tlačítko s rezervací",
    "pobočka": "pobočka",
    "Pobočka": "Pobočka",
    "Pobočka byla úspěšně smazána": "Pobočka byla úspěšně smazána",
    "Pobočka byla úspěšně upravena": "Pobočka byla úspěšně upravena",
    "Pobočka byla úspěšně vytvořena": "Pobočka byla úspěšně vytvořena",
    "pobocky": "pobocky",
    "Pobočky": "Pobočky",
    "Počet": "Počet",
    "Počet dní do konce:": "Počet dní do konce:",
    "Počet dní před návštěvou se odešle připomínka při nezaplacené rezervaci.": "Počet dní před návštěvou se odešle připomínka při nezaplacené rezervaci.",
    "Počet návštěv": "Počet návštěv",
    "Počet návštěv musí být větší nebo rovno 1.": "Počet návštěv musí být větší nebo rovno 1.",
    "Počet povolených rezervací je naplněn.": "Počet povolených rezervací je naplněn.",
    "Počet výkonů": "Počet výkonů",
    "Počet zbývajících vstupů:": "Počet zbývajících vstupů:",
    "Počty návštěv": "Počty návštěv",
    "Podání nebylo pojišťovně odesláno. Po smazání můžete dávku upravit a odeslat znovu.": "Podání nebylo pojišťovně odesláno. Po smazání můžete dávku upravit a odeslat znovu.",
    "Podepisování tohoto podání zůstalo nedokončené. Dávku podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Podepisování tohoto podání zůstalo nedokončené. Dávku podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.",
    "Podepsat a odeslat": "Podepsat a odeslat",
    "Podívám se později": "Podívám se později",
    "Podkategorie": "Podkategorie",
    "Podmínky užití": "Podmínky užití",
    "Podpis": "Podpis",
    "Podpis/razítko firmy": "Podpis/razítko firmy",
    "Podpora": "Podpora",
    "podpora@fyzion.cz": "podpora@fyzion.cz",
    "Podrobnosti": "Podrobnosti",
    "Podrobný popis služby, který se zobrazí klientům při výběru služby v online rezervacích.": "Podrobný popis služby, který se zobrazí klientům při výběru služby v online rezervacích.",
    "Pohlaví": "Pohlaví",
    "Pohlaví:": "Pohlaví:",
    "Pohyb zboží": "Pohyb zboží",
    "Pojištění EU a mezinárodní smlouvy": "Pojištění EU a mezinárodní smlouvy",
    "Pojišťovna": "Pojišťovna",
    "Pojišťovna byla smazána": "Pojišťovna byla smazána",
    "Pojišťovna přidána": "Pojišťovna přidána",
    "Pojišťovna upravena": "Pojišťovna upravena",
    "Pojišťovna:": "Pojišťovna:",
    "Pojišťovnou": "Pojišťovnou",
    "Pojišťovny": "Pojišťovny",
    "Pokladna": "Pokladna",
    "Pokračovat": "Pokračovat",
    "Pokročilá funkce": "Pokročilá funkce",
    "pokročilý tarif.": "pokročilý tarif.",
    "Pokud": "Pokud",
    "Pokud budete chtít nastavit jinou šablonu pro tuto zprávu, tak nás kontaktujte na": "Pokud budete chtít nastavit jinou šablonu pro tuto zprávu, tak nás kontaktujte na",
    "Pokud je lekce plně obsazena, klienti se mohou zapsat jako náhradníci.": "Pokud je lekce plně obsazena, klienti se mohou zapsat jako náhradníci.",
    "Pokud je zapnuto, klient musí poznámku vyplnit, aby mohl rezervaci dokončit.": "Pokud je zapnuto, klient musí poznámku vyplnit, aby mohl rezervaci dokončit.",
    "Pokud má klient aktivní permanentku, platba za návštěvu se automaticky odečte z ní.": "Pokud má klient aktivní balíček, platba za návštěvu se automaticky odečte z něho.",
    "Pokud má pacient trvalé bydliště v ČR, zadejte jeho rodné číslo bez lomítka.": "Pokud má klient trvalé bydliště v ČR, zadejte jeho rodné číslo bez lomítka.",
    "Pokud máte jakékoliv dotazy, neváhejte nás kontaktovat na": "Pokud máte jakékoliv dotazy, neváhejte nás kontaktovat na",
    "Pokud pracujete jako FO, ve zdravotnické dokumentaci budeme uvádět Vaše identifikační údaje. Pokud ne, ve zdravotnické dokumentaci budou údaje firmy.": "Pokud pracujete jako FO, ve zdravotnické dokumentaci budeme uvádět Vaše identifikační údaje. Pokud ne, ve zdravotnické dokumentaci budou údaje firmy.",
    "Pokud problém přetrvává, napište nám na": "Pokud problém přetrvává, napište nám na",
    "Pokud si kdykoliv v budoucnu nebudete vědět rady, můžete se k průvodci aplikací vrátit.": "Pokud si kdykoliv v budoucnu nebudete vědět rady, můžete se k průvodci aplikací vrátit.",
    "Pokud účet ještě nemáte, zvolte možnost registrace.": "Pokud účet ještě nemáte, zvolte možnost registrace.",
    "Pole je povinné": "Pole je povinné",
    "Položka byla úspěšně smazána": "Položka byla úspěšně smazána",
    "Položka byla úspěšně upravena": "Položka byla úspěšně upravena",
    "Položka byla úspěšně vytvořena": "Položka byla úspěšně vytvořena",
    "Položku se nepodařilo smazat": "Položku se nepodařilo smazat",
    "polozky": "polozky",
    "Položky": "Položky",
    "Pondělí": "Pondělí",
    "Popis": "Popis",
    "Popis cviku": "Popis cviku",
    "Popis služby": "Popis služby",
    "Popisy návštěv": "Popisy návštěv",
    "Porovnat fotky": "Porovnat fotky",
    "Porovnat fotografie": "Porovnat fotografie",
    "Porovnat můžete maximálně 2 fotografie.": "Porovnat můžete maximálně 2 fotografie.",
    "Porovnat vybrané fotografie": "Porovnat vybrané fotografie",
    "porovnavac": "porovnavac",
    "Porovnávač": "Porovnávač",
    "Poslat firmě email": "Poslat firmě email",
    "Poslat firmě SMS": "Poslat firmě SMS",
    "Poslat terapeutovi email": "Poslat terapeutovi email",
    "Poslat terapeutovi SMS": "Poslat terapeutovi SMS",
    "Poslední fakturace": "Poslední fakturace",
    "Poslední návštěva": "Poslední návštěva",
    "Poslední návštěva:": "Poslední návštěva:",
    "Potvrdit": "Potvrdit",
    "Potvrdit nové heslo": "Potvrdit nové heslo",
    "Potvrďte nové heslo": "Potvrďte nové heslo",
    "Potvrzení GDPR před návštěvou fyzioterapie": "Potvrzení GDPR před návštěvou terapie",
    "Potvrzení zrušení platby": "Potvrzení zrušení platby",
    "Potvrzeno": "Potvrzeno",
    "potvrzuji": "potvrzuji",
    "Potvrzuji": "Potvrzuji",
    "Poukaz byl úspěšně vytvořen": "Poukaz byl úspěšně vytvořen",
    "Poukaz na lázně": "Poukaz na lázně",
    "Poukaz úspěšně smazán": "Poukaz úspěšně smazán",
    "poukazy": "poukazy",
    "Použít": "Použít",
    "Použito pro všechny": "Použito pro všechny",
    "Používáte": "Používáte",
    "Povinná platba online při rezervaci": "Povinná platba online při rezervaci",
    "povolení online rezervací": "povolení online rezervací",
    "Povolí přístup do klientské sekce pouze klientům, jejichž email máte v kartotéce": "Povolí přístup do klientské sekce pouze klientům, jejichž email máte v kartotéce",
    "Povolit odpovědi na SMS": "Povolit odpovědi na SMS",
    "Povolit online rezervace": "Povolit online rezervace",
    "Povolit registraci pacientů pouze s emailem z kartotéky": "Povolit registraci klientů pouze s emailem z kartotéky",
    "Povolit rezervace": "Povolit rezervace",
    "Povolit rezervace na státní svátky": "Povolit rezervace na státní svátky",
    "Povolit rezervace pro nepřihlášené uživatele v klientském portále": "Povolit rezervace pro nepřihlášené uživatele v klientském portále",
    "Povolit skupinovou službu": "Povolit skupinovou službu",
    "Povolit zobrazení detailu cizí návštěvy": "Povolit zobrazení Karty Klientů ostatních uživatelů",
    "Povolit zrušení rezervace": "Povolit zrušení rezervace",
    "Poznámka": "Poznámka",
    "Poznámka k návštěvě": "Poznámka k návštěvě",
    "Poznámka úspěšně smazána": "Poznámka úspěšně smazána",
    "Poznámka úspěšně uložena": "Poznámka úspěšně uložena",
    "Poznámka:": "Poznámka:",
    "Poznámku se nepodařilo uložit": "Poznámku se nepodařilo uložit",
    "Poznámku se nepodařilo uložit. Zkuste to prosím znovu.": "Poznámku se nepodařilo uložit. Zkuste to prosím znovu.",
    "Pozor, blížíte se k maximálnímu počtu pacientů.": "Pozor, blížíte se k maximálnímu počtu klientů.",
    "Pozor, blížíte se maximálnímu počtu pacientů.": "Pozor, blížíte se maximálnímu počtu klientů.",
    "Pozor, chystáte se zaplatit za návštěvu, která ještě neproběhla.": "Pozor, chystáte se zaplatit za návštěvu, která ještě neproběhla.",
    "Pozor! Snažíte se vytvořit návštěvu, která porušuje nastavení u Fyzioterapeuta, Služby nebo Místnosti nebo dochází ke konfliktu v kalendáři.": "Pozor! Snažíte se vytvořit návštěvu, která porušuje nastavení u Terapeuta, Služby nebo Místnosti nebo dochází ke konfliktu v kalendáři.",
    "Pozor! Upravujete globální cvik vytvořený aplikací Fyzion. Po uložení této úpravy vznikne duplicitní cvik v databázi. Původní cvik bude zachován v nezměněné podobě.": "Pozor! Upravujete globální cvik vytvořený aplikací Fyzion. Po uložení této úpravy vznikne duplicitní cvik v databázi. Původní cvik bude zachován v nezměněné podobě.",
    "pracoviste": "pracoviste",
    "Pracoviště": "Pracoviště",
    "Pracoviště bylo smazáno": "Pracoviště bylo smazáno",
    "Pracoviště pro pojišťovny": "Pracoviště pro pojišťovny",
    "Pracoviště upraveno": "Pracoviště upraveno",
    "Pracoviště vytvořeno": "Pracoviště vytvořeno",
    "Pracoviště žadatele bylo úspěšně uloženo": "Pracoviště žadatele bylo úspěšně uloženo",
    "Pracoviště žadatele bylo úspěšně vytvořeno": "Pracoviště žadatele bylo úspěšně vytvořeno",
    "Pracovní dny": "Pracovní dny",
    "Pracovní doba": "Pracovní doba",
    "Pracovníci": "Pracovníci",
    "Pracuji jako fyzická osoba": "Pracuji jako fyzická osoba",
    "Pravidelné terapie": "Pravidelné terapie",
    "Pravidla rušení rezervací": "Pravidla rušení rezervací",
    "Před návštěvou ordinace se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": "Před návštěvou ordinace se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte",
    "Před pokračováním vyplňte formulář": "Před pokračováním vyplňte formulář",
    "Před pokračováním zadejte rodné číslo": "Před pokračováním zadejte rodné číslo",
    "Před registrací musíte potvrdit souhlas se Všeobecnými obchodními podmínkami": "Před registrací musíte potvrdit souhlas se Všeobecnými obchodními podmínkami",
    "před termínem": "před termínem",
    "Předem děkuji a budu se těšit na Vaši návštěvu.": "Předem děkuji a budu se těšit na Vaši návštěvu.",
    "Předmět": "Předmět",
    "Předmět emailu": "Předmět emailu",
    "předplacené (permice)": "předplacené (permice)",
    "predplatne": "predplatne",
    "Předplatné": "Předplatné",
    "Předplatné Fyzion": "Předplatné Fyzion Mind",
    "Předplatné smazáno": "Předplatné smazáno",
    "Předplatné úspěšně přidáno": "Předplatné úspěšně přidáno",
    "Předplatné úspěšně upraveno": "Předplatné úspěšně upraveno",
    "Předplatných na stránku": "Předplatných na stránku",
    "Předplatným": "Předplatným",
    "Předvolba": "Předvolba",
    "Předvolba země chybí. Zkuste to prosím znovu.": "Předvolba země chybí. Zkuste to prosím znovu.",
    "Předvyplněn kód zadaný v %{time}. Platí obvykle 30 minut.": "Předvyplněn kód zadaný v %{time}. Platí obvykle 30 minut.",
    "Preferovaná místnost": "Preferovaná místnost",
    "Preferovaná pobočka": "Preferovaná pobočka",
    "Preferovaná služba": "Preferovaná služba",
    "Přehled cviků": "Přehled cvičení",
    "Přehled dávek": "Přehled dávek",
    "Přehled položek": "Přehled položek",
    "Přehled pracovišť": "Přehled pracovišť",
    "Přehled transakcí": "Přehled transakcí",
    "Přehled výkonů": "Přehled výkonů",
    "prehled-vykonu": "prehled-vykonu",
    "Přejete si vystavit doklad?": "Přejete si vystavit doklad?",
    "Přejete si vystavit fakturu na storno poplatek?": "Přejete si vystavit fakturu na storno poplatek?",
    "Přejete si vystavit storno doklad?": "Přejete si vystavit storno doklad?",
    "Přejít do aplikace": "Přejít do aplikace",
    "Přejít do profilu": "Přejít do profilu",
    "Přejít na tarif": "Přejít na tarif",
    "Překlady": "Překlady",
    "Překlady názvu kategorie": "Překlady názvu kategorie",
    "Překlady názvu služby": "Překlady názvu služby",
    "Premium registrace": "Premium registrace",
    "Přeskočit": "Přeskočit",
    "Přesun rezervace": "Přesun rezervace",
    "Přesun rezervací se řídí obecným nastavením firmy.": "Přesun rezervací se řídí obecným nastavením firmy.",
    "Přesunout rezervaci": "Přesunout rezervaci",
    "Přesuňte některé pacienty do archivu a pak objednejte tarif znovu.": "Přesuňte některé klienty do archivu a pak objednejte tarif znovu.",
    "Převodem": "Převodem",
    "Převodem (QR kód)": "Převodem (QR kód)",
    "při roční platbě": "při roční platbě",
    "Při vytvoření online rezervace:": "Při vytvoření online rezervace:",
    "Při zrušení online rezervace:": "Při zrušení online rezervace:",
    "Přidá po skončení rezervace časový blok, během kterého nebude možné vytvářet další rezervace (např. čas na úklid nebo pauzu).": "Přidá po skončení rezervace časový blok, během kterého nebude možné vytvářet další rezervace (např. čas na úklid nebo pauzu).",
    "Přidán na seznam": "Přidán na seznam",
    "Přidáno": "Přidáno",
    "Přidat": "Přidat",
    "Přidat 3 pacienty": "Přidat 3 klienty",
    "Přidat časový interval": "Přidat časový interval",
    "Přidat čekajícího": "Přidat čekajícího",
    "Přidat cvik": "Přidat cvik",
    "Přidat dodavatele": "Přidat dodavatele",
    "Přidat dokument": "Přidat dokument",
    "Přidat doplňkový text do e-mailů klientům": "Přidat doplňkový text do e-mailů klientům",
    "Přidat fotku": "Přidat fotku",
    "Přidat FT poukaz": "Přidat FT poukaz",
    "Přidat fyzioterapeuta": "Přidat uživatele",
    "Přidat k návštěvě": "Přidat k návštěvě",
    "Přidat kategorii": "Přidat kategorii",
    "Přidat místnost": "Přidat místnost",
    "Přidat náhradníka": "Přidat náhradníka",
    "Přidat náhradníka jako účastníka návštěvy": "Přidat náhradníka jako účastníka návštěvy",
    "Přidat náhradníka jako účastníka návštěvy?": "Přidat náhradníka jako účastníka návštěvy?",
    "Přidat návštěvu": "Přidat návštěvu",
    "Přidat nového čekajícího": "Přidat nového čekajícího klienta",
    "Přidat nového pacienta": "Přidat nového klienta",
    "Přidat pacientovi permanentku": "Přidat klientovi balíček",
    "Přidat peníze": "Přidat peníze",
    "Přidat permanentku": "Přidat balíček",
    "Přidat platbu": "Přidat platbu",
    "Přidat pobočku": "Přidat pobočku",
    "Přidat podkategorii": "Přidat podkategorii",
    "Přidat pojišťovnu": "Přidat pojišťovnu",
    "Přidat položku": "Přidat položku",
    "Přidat poznámku": "Přidat poznámku",
    "Přidat pracoviště": "Přidat pracoviště",
    "Přidat předplatné": "Přidat předplatné",
    "Přidat skupinovou návštěvu": "Přidat skupinovou návštěvu",
    "Přidat službu": "Přidat službu",
    "Přidat soubor": "Přidat soubor",
    "Přidat štítek...": "Přidat štítek...",
    "Přidat údaj": "Přidat údaj",
    "Přidat výkon": "Přidat výkon",
    "Přidat zboží": "Přidat zboží",
    "pridat-permanentku": "pridat-permanentku",
    "pridat-volno": "pridat-volno",
    "Přidejte vlastní informace, které klienti potřebují vědět před návštěvou – například kde najdou vchod, co si mají vzít s sebou nebo jaké jsou storno podmínky. Informace se zobrazí pod detailem rezervace v e-mailu s potvrzením návštěvy a v její připomínce.": "Přidejte vlastní informace, které klienti potřebují vědět před návštěvou – například kde najdou vchod, co si mají vzít s sebou nebo jaké jsou storno podmínky. Informace se zobrazí pod detailem rezervace v e-mailu s potvrzením návštěvy a v její připomínce.",
    "Přihlášení jako nesprávný typ uživatele": "Přihlášení jako nesprávný typ uživatele",
    "Přihlásit": "Přihlásit",
    "Přihlásit se": "Přihlásit se",
    "Přihlašovací jméno": "Přihlašovací jméno",
    "Přihlašovací údaje": "Přihlašovací údaje",
    "Přihlašovací údaje k portálům pojišťoven se nepodařilo načíst": "Přihlašovací údaje k portálům pojišťoven se nepodařilo načíst",
    "Přihlašovací údaje se nepodařilo smazat": "Přihlašovací údaje se nepodařilo smazat",
    "Přihlašovací údaje se nepodařilo uložit": "Přihlašovací údaje se nepodařilo uložit",
    "Přijat": "Přijat",
    "Příjemce": "Příjemce",
    "Příjemce:": "Příjemce:",
    "Přijmení": "Přijmení",
    "Příjmení": "Příjmení",
    "Přijmout do péče": "Přijmout do péče",
    "Přijmout FT poukaz": "Přijmout FT poukaz",
    "Příjmy": "Příjmy",
    "Příjmy (budoucí)": "Příjmy (budoucí)",
    "Příjmy fyzioterapeutů": "Příjmy terapeutů",
    "Příjmy z nabízených služeb": "Příjmy z nabízených služeb",
    "Přiložený soubor se nepodařilo nahrát": "Přiložený soubor se nepodařilo nahrát",
    "Primární barva události": "Primární barva události",
    "Primární barva události v rozvrhu místnosti": "Primární barva události v rozvrhu místnosti",
    "Případně kontaktujte naši podporu na ": "Případně kontaktujte naši podporu na ",
    "Připojištění": "Připojištění",
    "Připomínka platby": "Připomínka platby",
    "Připravujeme": "Na vyžádání",
    "Přiřazené služby": "Přiřazené služby",
    "Přišel/Přijde": "Přišel/Přijde",
    "Příští návštěva": "Příští návštěva",
    "Příští objednání": "Příští objednání",
    "Příští služba": "Příští služba",
    "Přítomen": "Přítomen",
    "Pro dokončení rezervace je nutné souhlasit se zásadami zpracování osobních údajů.": "Pro dokončení rezervace je nutné souhlasit se zásadami zpracování osobních údajů.",
    "Pro export kartotéky kontaktujte naší podporu na": "Pro export kartotéky kontaktujte naší podporu na",
    "Pro individuální nastavení textace emailů vašim klientům kontaktujte naši technickou podporu na": "Pro individuální nastavení textace emailů vašim klientům kontaktujte naši technickou podporu na",
    "Pro individuální nastavení textace emailů vašim pacientům kontaktujte naši technickou podporu na": "Pro individuální nastavení textace emailů vašim klientům kontaktujte naši technickou podporu na",
    "Pro nastavení časového úseku, kdy je možné tuto službu rezervovat online, kontaktujte naší podporu na": "Pro nastavení časového úseku, kdy je možné tuto službu rezervovat online, kontaktujte naší podporu na",
    "Pro nastavení otevírací doby místnosti kontaktujte naší podporu na": "Pro nastavení otevírací doby místnosti kontaktujte naší podporu na",
    "Pro odeslání potvrzení o platbě zadejte email pacienta": "Pro odeslání potvrzení o platbě zadejte email klienta",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu %{portal}.": "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu %{portal}.",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu pojišťovny.": "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu pojišťovny.",
    "Pro platby převodem systém automaticky vystaví fakturu namísto stvrzenky.": "Pro platby převodem systém automaticky vystaví fakturu namísto stvrzenky.",
    "Pro přihlášení je potřeba přejít na správné URL klientského portálu. Kontaktujte svého poskytovatele služeb.": "Pro přihlášení je potřeba přejít na správné URL klientského portálu. Kontaktujte svého poskytovatele služeb.",
    "Pro správné fungování aplikace je potřeba základní nastavení. Nebojte, základní nastavení aplikace a projití funkcí vám zabere jen pár minut!": "Pro správné fungování aplikace je potřeba základní nastavení. Nebojte, základní nastavení aplikace a projití funkcí vám zabere jen pár minut!",
    "Pro tohoto pacienta jste zatím nevytvořili žádný FT poukaz": "Pro tohoto klienta jste zatím nevytvořili žádný FT poukaz",
    "Pro tohoto pacienta jste zatím nevytvořili žádný poukaz": "Pro tohoto klienta jste zatím nevytvořili žádný poukaz",
    "Pro zobrazení platebního QR kódu vyplňte v": "Pro zobrazení platebního QR kódu vyplňte v",
    "Proběhlé návštěvy": "Proběhlé návštěvy",
    "Probíhá synchronizace Vašeho kalendáře": "Probíhá synchronizace Vašeho kalendáře",
    "Procentuální": "Procentuální",
    "Prodané permanentky": "Prodané balíčky",
    "Prodej zboží": "Prodej zboží",
    "Prodejní cena (s DPH)": "Prodejní cena (s DPH)",
    "Prodejní cena s DPH": "Prodejní cena s DPH",
    "Prodejní cena zboží za ks (s DPH)": "Prodejní cena zboží za ks (s DPH)",
    "Prodejní hodnota (s DPH)": "Prodejní hodnota (s DPH)",
    "Profil": "Profil",
    "Profilová fotografie": "Profilová fotografie",
    "Profilový obrázek byl úspěšně nahrán": "Profilový obrázek byl úspěšně nahrán",
    "Profily": "Profily",
    "Proklik na skupinovou návštěvu": "Proklik na skupinovou návštěvu",
    "Propojené aplikace": "Propojené aplikace",
    "Propojení": "Propojení",
    "Propojeno": "Propojeno",
    "Propojit": "Propojit",
    "Prosím": "Prosím",
    "Prosíme o její úhradu co nejdříve.": "Prosíme o její úhradu co nejdříve.",
    "Provedeme vás, nastavíme základní parametry, přidáme první klienty.": "Provedeme vás, nastavíme základní parametry, přidáme první klienty.",
    "Provedené akce": "Provedené akce",
    "Průměrná nákupní cena zboží na skladě za ks (s DPH)": "Průměrná nákupní cena zboží na skladě za ks (s DPH)",
    "Průvodce": "Průvodce",
    "Průvodce a nápovědu případně navštivte prostřednictvím odkazu v horním menu. Zde naleznete vše co vás zajímá přehledně na jednom místě.": "Průvodce a nápovědu případně navštivte prostřednictvím odkazu v horním menu. Zde naleznete vše co vás zajímá přehledně na jednom místě.",
    "PSČ": "PSČ",
    "Purobot API klíč": "Purobot API klíč",
    "Původní": "Původní",
    "Původní dávka": "Původní dávka",
    "qr": "qr",
    "RČ / Datum narození": "RČ / Datum narození",
    "Recenze": "Recenze",
    "Recenze byla smazána": "Recenze byla smazána",
    "Recenze návštěv": "Recenze od klientů",
    "recenzí": "recenzí",
    "Recepční": "Recepční",
    "Recepční vidí kalendáře uživatelů a statistiky, ale nemá přístup ke kartám klientů": "Recepční vidí kalendáře uživatelů a statistiky, ale nemá přístup ke kartám klientů",
    "Registrace": "Registrace",
    "Registrace náhradníka byla úspěšně vytvořena.": "Registrace náhradníka byla úspěšně vytvořena.",
    "Registrace proběhla úspěšně": "Registrace proběhla úspěšně",
    "Registrace proběhla úspěšně. Prosím potvrďte ještě svojí emailovou adresu kliknutím na odkaz ve vašem emailu!": "Registrace proběhla úspěšně. Prosím potvrďte ještě svojí emailovou adresu kliknutím na odkaz ve vašem emailu!",
    "Registrace se nepovedla": "Registrace se nepovedla",
    "registrace-zdarma": "registrace-zdarma",
    "Registrace/Přihlášení": "Registrace/Přihlášení",
    "Registrovat jako náhradník": "Registrovat jako náhradník",
    "Registrovat se": "Registrovat se",
    "Resetování hesla": "Resetování hesla",
    "Resetovat": "Resetovat",
    "Resetovat fyzioterapeuty dle diagnózy": "Resetovat terapeuty dle diagnózy",
    "Resetovat heslo": "Resetovat heslo",
    "resetpassword/:uid/:token": "resetpassword/:uid/:token",
    "Řešíte jiný problém?": "Řešíte jiný problém?",
    "Rezarvace byla úspěšně změněna na": "Rezarvace byla úspěšně změněna na",
    "rezervace": "rezervace",
    "Rezervace": "Rezervace",
    "Rezervace byla úspěšně vytvořena.": "Rezervace byla úspěšně vytvořena.",
    "Rezervace byla zrušena": "Rezervace byla zrušena",
    "Rezervace čekajících": "Rezervace čekajících",
    "Rezervace je potvrzena až po úspěšné online platbě.": "Rezervace je potvrzena až po úspěšné online platbě.",
    "Rezervace nejdříve": "Rezervace nejdříve",
    "Rezervace nejpozději": "Rezervace nejpozději",
    "Rezervace nemohla být vytvořena": "Rezervace nemohla být vytvořena",
    "Rezervace pacienta jsou povoleny": "Rezervace klienta jsou povoleny",
    "Rezervace pacienta jsou zablokovány": "Rezervace klienta jsou zablokovány",
    "Rezervace úspěšně vytvořena": "Rezervace úspěšně vytvořena",
    "rezervací": "rezervací",
    "Rezervaci již nelze zrušit online": "Rezervaci již nelze zrušit online",
    "Rezervaci můžete zrušit do": "Rezervaci můžete zrušit do",
    "Rezervaci nebylo možné dokončit": "Rezervaci nebylo možné dokončit",
    "Rezervaci nelze zrušit online": "Rezervaci nelze zrušit online",
    "Rezervaci se nepodařilo zrušit": "Rezervaci se nepodařilo zrušit",
    "Rezervační formulář": "Rezervační formulář",
    "Rezervační systém": "Rezervační systém",
    "Rezervační tlačítko": "Rezervační tlačítko",
    "Rezervovat": "Rezervovat",
    "Rezervovat jako náhradník": "Rezervovat jako náhradník",
    "Rezervujte si termín": "Rezervujte si termín",
    "Rezervujte si termín online": "Rezervujte si termín online",
    "Rezervujte si termín u": "Rezervujte si termín u",
    "Režim zobrazení": "Režim zobrazení",
    "Roční": "Roční",
    "Rodné číslo": "Rodné číslo",
    "Rodné číslo pacienta": "Rodné číslo klienta",
    "Rodné číslo:": "Rodné číslo:",
    "Rok": "Rok",
    "Roky": "Roky",
    "Role": "Role",
    "Rozpis termínů fyzioterapie": "Rozpis termínů terapie",
    "Rozpracovaná návštěva uložena": "Rozpracovaná návštěva uložena",
    "Rozpracované podání bylo smazáno": "Rozpracované podání bylo smazáno",
    "Rozpracované podání se nepodařilo smazat": "Rozpracované podání se nepodařilo smazat",
    "Rozvrh místností": "Rozvrh místností",
    "Rozvrh skupinových lekcí": "Rozvrh skupinových lekcí",
    "s GDPR, klikněte níže na tlačítko": "s GDPR, klikněte níže na tlačítko",
    "S jakým problémem k nám přicházíte?": "S jakým problémem k nám přicházíte?",
    "S nezaplacenými návštěvami": "S nezaplacenými návštěvami",
    "Šablon na stránku": "Šablon na stránku",
    "Šablona": "Šablona",
    "Šablona byla úspěšně aktualizována": "Šablona byla úspěšně aktualizována",
    "Šablona byla úspěšně smazána": "Šablona byla úspěšně smazána",
    "Šablona byla úspěšně upravena": "Šablona byla úspěšně upravena",
    "Šablona byla úspěšně vytvořena": "Šablona byla úspěšně vytvořena",
    "Šablona FT výkonů": "Šablona FT výkonů",
    "Šablona neobsahuje žádné výkony": "Šablona neobsahuje žádné výkony",
    "Šablona výkonů": "Šablona výkonů",
    "Šablona výkonů FT": "Šablona výkonů FT",
    "Šablona výkonů pro návštěvy": "Šablona výkonů pro návštěvy",
    "sablony": "sablony",
    "Šablony": "Šablony",
    "Šablony výkonů FT": "Šablony výkonů FT",
    "Šablony výkonů pro návštěvy": "Šablony výkonů pro návštěvy",
    "Sada cviků byla odeslána klientovi": "Sada cvičení byla odeslána klientovi",
    "Sazba DPH": "Sazba DPH",
    "Sdílejte": "Sdílejte",
    "SDÍLEJTE NÁS": "SDÍLEJTE NÁS",
    "Sdílení": "Sdílení",
    "sdílet": "sdílet",
    "sdílet aplikaci": "sdílet aplikaci",
    "Sekundární barva události": "Sekundární barva události",
    "Shrnutí historie návštěv": "Shrnutí historie návštěv",
    "Shrnutí návštěv": "Shrnutí návštěv",
    "SK": "SK",
    "Sklad": "Sklad",
    "Skrýt": "Skrýt",
    "Skupina služeb": "Skupina služeb",
    "Skupinová návštěva": "Skupinová návštěva",
    "Skupinová návštěva smazána": "Skupinová návštěva smazána",
    "Skupinové lekce se nepodařilo načíst": "Skupinové lekce se nepodařilo načíst",
    "Skupinovka": "Skupinovka",
    "Skutečně si přejete změnit tarif?": "Skutečně si přejete změnit tarif?",
    "Sloučení karet": "Sloučení karet",
    "Sloučit karty": "Sloučit karty",
    "Služba": "Služba",
    "Služba nenalezena": "Služba nenalezena",
    "Služba:": "Služba:",
    "sluzby": "sluzby",
    "Služby": "Služby",
    "Služby dle kategorií celkem za rok": "Služby dle kategorií celkem za rok",
    "Služby nebudou smazány, kategorie jim bude pouze odebrána.": "Služby nebudou smazány, kategorie jim bude pouze odebrána.",
    "Služby:": "Služby:",
    "Smazání": "Smazání",
    "Smazání obrázku se nezdařilo": "Smazání obrázku se nezdařilo",
    "Smazáno": "Smazáno",
    "Smazat": "Smazat",
    "Smazat cvik": "Smazat cvik",
    "Smazat dodavatele": "Smazat dodavatele",
    "Smazat dokument": "Smazat dokument",
    "Smazat formulář": "Smazat formulář",
    "Smazat fotku": "Smazat fotku",
    "Smazat fotografii": "Smazat fotografii",
    "Smazat kategorii cviků": "Smazat kategorii cvičení",
    "Smazat kategorii služeb": "Smazat kategorii služeb",
    "Smazat místnost": "Smazat místnost",
    "Smazat návštěvu": "Smazat návštěvu",
    "Smazat nezaplacenou návštěvu před termínem": "Smazat nezaplacenou návštěvu před termínem",
    "Smazat obrázek": "Smazat obrázek",
    "Smazat permanentku": "Smazat balíček",
    "Smazat pobočku": "Smazat pobočku",
    "Smazat podání": "Smazat podání",
    "Smazat podpis": "Smazat podpis",
    "Smazat pojišťovnu": "Smazat pojišťovnu",
    "Smazat položku": "Smazat položku",
    "Smazat pouze toto volno": "Smazat pouze toto volno",
    "Smazat pouze tuto návštěvu": "Smazat pouze tuto návštěvu",
    "Smazat pouze tuto skupinovou návštěvu": "Smazat pouze tuto skupinovou návštěvu",
    "Smazat pracoviště": "Smazat pracoviště",
    "Smazat předplatné": "Smazat předplatné",
    "Smazat přihlašovací údaje k portálu %{portal}?": "Smazat přihlašovací údaje k portálu %{portal}?",
    "Smazat recenzi": "Smazat recenzi",
    "Smazat rozpracované podání": "Smazat rozpracované podání",
    "Smazat rozpracované podání?": "Smazat rozpracované podání?",
    "Smazat šablonu": "Smazat šablonu",
    "Smazat službu": "Smazat službu",
    "Smazat soubor": "Smazat soubor",
    "Smazat stávající zápis": "Smazat stávající zápis",
    "Smazat toto a všechna budoucí volna": "Smazat toto a všechna budoucí volna",
    "Smazat tuto a všechny budoucí návštěvy": "Smazat tuto a všechny budoucí návštěvy",
    "Smazat tuto a všechny budoucí skupinové návštěvy": "Smazat tuto a všechny budoucí skupinové návštěvy",
    "Smazat video": "Smazat video",
    "Smazat volno": "Smazat volno",
    "Smazat zboží": "Smazat zboží",
    "Smaže rozpracované podání, např. abyste mohli dávku upravit a odeslat znovu": "Smaže rozpracované podání, např. abyste mohli dávku upravit a odeslat znovu",
    "Smluvní pojištění": "Smluvní pojištění",
    "SMS": "SMS",
    "SMS byla úspěšně odeslána": "SMS byla úspěšně odeslána",
    "SMS byly úspěšně odeslána": "SMS byly úspěšně odeslána",
    "SMS čekajícímu": "SMS čekajícímu",
    "SMS klientům": "SMS klientům",
    "SMS kód": "SMS kód",
    "SMS kód se nepodařilo vyžádat": "SMS kód se nepodařilo vyžádat",
    "SMS odpovědi od klientů budou přeposílány na zvolený email": "SMS odpovědi od klientů budou přeposílány na zvolený email",
    "SMS se nepodařilo odeslat": "SMS se nepodařilo odeslat",
    "SMS tento měsíc": "SMS tento měsíc",
    "Sobota": "Sobota",
    "Soubor se nepodařilo stáhnout": "Soubor se nepodařilo stáhnout",
    "Soubor se zobrazí zákazníkům v posledním kroku online rezervace.": "Soubor se zobrazí zákazníkům v posledním kroku online rezervace.",
    "Soubory úspěšně nahrány": "Soubory úspěšně nahrány",
    "Současné heslo": "Současné heslo",
    "Souhlas GDPR": "Souhlas GDPR",
    "Souhlas s GDPR": "Souhlas s GDPR",
    "Souhlas s GDPR odesílat automaticky": "Souhlas s GDPR odesílat automaticky",
    "Souhlas s novinkami:": "Souhlas s novinkami:",
    "Souhlas se zpracováním osobních údajů": "Souhlas se zpracováním osobních údajů",
    "Souhlas udělen": "Souhlas udělen",
    "Souhlasil s novinkami": "Souhlasil s novinkami",
    "Souhlasili": "Souhlasili",
    "Souhlasím s vytvořením karty pacienta v souladu s": "Souhlasím s vytvořením karty klienta v souladu s",
    "Souhlasím se": "Souhlasím se",
    "Souhlasím se zasíláním novinek a zajímavých nabídek": "Souhlasím se zasíláním novinek a zajímavých nabídek",
    "souhlasíte": "souhlasíte",
    "Spis byl načten": "Spis byl načten",
    "Spis se nepodařilo načíst": "Spis se nepodařilo načíst",
    "Spis se nepodařilo vytvořit": "Spis se nepodařilo vytvořit",
    "Spisy": "Spisy",
    "Spisy byly synchronizovány": "Spisy byly synchronizovány",
    "Spisy se nepodařilo načíst": "Spisy se nepodařilo načíst",
    "Splatnost": "Splatnost",
    "Splatnost faktury": "Splatnost faktury",
    "Spočítat": "Spočítat",
    "Stačí": "Stačí",
    "Stáhnout": "Stáhnout",
    "Stáhnout fakturu": "Stáhnout fakturu",
    "Stáhnout soubory": "Stáhnout soubory",
    "Stáhnout zálohovou fakturu": "Stáhnout zálohovou fakturu",
    "Start": "Start",
    "STATISTICS": "STATISTICS",
    "Statistiky": "Statistiky",
    "Status": "Status",
    "Stav": "Stav",
    "Stav bude změněn v obou případech. Volbou „Ano“ se doklad vystaví společně se změnou stavu.": "Stav bude změněn v obou případech. Volbou „Ano“ se doklad vystaví společně se změnou stavu.",
    "Stav bude změněn v obou případech. Volbou „Ano“ se faktura vystaví společně se změnou stavu.": "Stav bude změněn v obou případech. Volbou „Ano“ se faktura vystaví společně se změnou stavu.",
    "Stav návštěvy byl změněn": "Stav návštěvy byl změněn",
    "Stav platby": "Stav platby",
    "Stejné jako fakturační": "Stejné jako fakturační",
    "Štítek byl úspěšně odebrán": "Štítek byl úspěšně odebrán",
    "Štítek byl úspěšně smazán": "Štítek byl úspěšně smazán",
    "Štítek byl úspěšně vytvořen": "Štítek byl úspěšně vytvořen",
    "Štítky": "Štítky",
    "Štítky návštěv": "Štítky návštěv",
    "Štítky pacientů": "Štítky klientů",
    "Storno": "Storno",
    "Storno poplatek": "Storno poplatek",
    "Stornovaná faktura": "Stornovaná faktura",
    "stornovanou fakturu č.": "stornovanou fakturu č.",
    "Stornovaný paragon": "Stornovaný paragon",
    "stornovaný paragon č.": "stornovaný paragon č.",
    "Stornovat": "Stornovat",
    "stránka někam utekla...": "stránka někam utekla...",
    "Stránka ordinace": "Stránka ordinace",
    "Středa": "Středa",
    "Stvrzenek na stránku": "Stvrzenek na stránku",
    "svůj prohlížeč nebo si nainstalujte jiný.": "svůj prohlížeč nebo si nainstalujte jiný.",
    "Synchronizace kalendáře byla zrušena": "Synchronizace kalendáře byla zrušena",
    "Synchronizace s Google kalendářem": "Synchronizace s Google kalendářem",
    "Synchronizace se nezdařila": "Synchronizace se nezdařila",
    "synchronizace-kalendare": "synchronizace-kalendare",
    "Synchronizovat události z Google kalendáře do Fyzionu": "Synchronizovat události z Google kalendáře do Fyzionu",
    "Synchronizujte svůj Fyzion kalendář s kalendářem Google": "Synchronizujte svůj Fyzion kalendář s kalendářem Google",
    "Systém bude při automatickém vystavování dokladů používat výhradně fakturu místo stvrzenky.": "Systém bude při automatickém vystavování dokladů používat výhradně fakturu místo stvrzenky.",
    "Tarif": "Tarif",
    "Tarify": "Tarify",
    "Tato akce může ovlivnit rezervační systém.": "Tato akce může ovlivnit rezervační systém.",
    "Tato funkce je dostupná pouze v placeném tarifu.": "Tato funkce je dostupná pouze vo vyššom tarife.",
    "Tato funkce je dostupná pouze v placeném tarifu. Placené tarify ukrývají spoustu pokročilých funkcí, které Vám ulehčí práci.": "Tato funkce je dostupná pouze v placeném tarifu. Placené tarify ukrývají spoustu pokročilých funkcí, které Vám ulehčí práci.",
    "Tato karta se smaže.": "Tato karta se smaže.",
    "Tato přihlašovací stránka je určena pouze terapeutům.": "Tato přihlašovací stránka je určena pouze terapeutům.",
    "Tato služba bude automaticky předvyplněna při vytváření nové návštěvy.": "Tato služba bude automaticky předvyplněna při vytváření nové návštěvy.",
    "Tato zpráva bude účtována jako 2 SMS": "Tato zpráva bude účtována jako 2 SMS",
    "Tato zpráva bude účtována jako 3 SMS": "Tato zpráva bude účtována jako 3 SMS",
    "Tel.:": "Tel.:",
    "Telefon": "Telefon",
    "Telefonní číslo": "Telefonní číslo",
    "Telefonní číslo:": "Telefonní číslo:",
    "Tento měsíc": "Tento měsíc",
    "Tento pacient má nezaplacenou návštěvu, která nebyla omluvená.": "Tento klient má nezaplacenou návštěvu, která nebyla omluvená.",
    "Tento profil zatím nemá žádné permanentky.": "Tento profil zatím nemá žádné balíčky.",
    "Tento rok": "Tento rok",
    "Tento týden": "Tento týden",
    "Terapeut": "Terapeut",
    "Terapeut nemá přiřazené pracoviště pro pojišťovny. Přiřaďte pracoviště v profilu terapeuta a zkontrolujte nastavení pracoviště": "Terapeut nemá přiřazené pracoviště pro pojišťovny. Přiřaďte pracoviště v profilu terapeuta a zkontrolujte nastavení pracoviště",
    "Termín můžete přesunout do": "Termín můžete přesunout do",
    "Termín přidán. Nyní je možné pokračovat k potvrzení rezervací.": "Termín přidán. Nyní je možné pokračovat k potvrzení rezervací.",
    "Termín pro zaplacení": "Termín pro zaplacení",
    "termínů": "termínů",
    "Text": "Text",
    "Text s instrukcemi pro klienta, co má do poznámky uvést (např. Uveďte své zdravotní potíže nebo omezení).": "Text s instrukcemi pro klienta, co má do poznámky uvést (např. Uveďte své zdravotní potíže nebo omezení).",
    "Text SMS překročil maximální povolený limit znaků.": "Text SMS překročil maximální povolený limit znaků.",
    "Těžší varianta": "Těžší varianta",
    "theme_company": "Fyzion",
    "Tisk": "Tisk",
    "Tisk GDPR": "Tisk GDPR",
    "Tisk karty pacienta": "Tisk karty klienta",
    "Tisk návštěv": "Tisk návštěv",
    "Tisk návštěvy": "Tisk návštěvy",
    "Tisk rozpisu termínů návštěv": "Tisk rozpisu termínů návštěv",
    "Toto okno můžete zavřít.": "Toto okno můžete zavřít.",
    "Toto podání už na autorizaci nečeká, mezitím se dokončilo.": "Toto podání už na autorizaci nečeká, mezitím se dokončilo.",
    "Toto pole je povinné": "Toto pole je povinné",
    "Trvání služby v minutách": "Trvání služby v minutách",
    "týden": "týden",
    "Týdně": "Týdně",
    "týdnů": "týdnů",
    "týdny": "týdny",
    "Týdny": "Týdny",
    "Typ akce": "Typ akce",
    "Typ dávky": "Typ dávky",
    "Typ dokladu": "Typ dokladu",
    "Typ permanentky": "Typ balíčku",
    "Typ platby": "Typ platby",
    "Typ platební brány": "Typ platební brány",
    "Typ poukazu": "Typ poukazu",
    "Typ připojištění": "Typ připojištění",
    "Typ připojištění:": "Typ připojištění:",
    "Typ šablony": "Typ šablony",
    "Typ spisu": "Typ spisu",
    "Typ subjektu": "Typ subjektu",
    "Typ transakce": "Typ transakce",
    "Typ výkonu": "Typ výkonu",
    "Typ vyšetření": "Služba",
    "Typ vyšetření a délka": "Typ vyšetření a délka",
    "Typ záznamu": "Typ záznamu",
    "Tyto informace jsou vaše soukromé kontaktní údaje. Změnu veřejných kontaktních údajů, které vidí pacienti, uděláte v ": "Tyto informace jsou vaše soukromé kontaktní údaje. Změnu veřejných kontaktních údajů, které vidí klienti, uděláte v ",
    "Účast pacienta": "Účast klienta",
    "Údaje": "Údaje",
    "Údaje instituce": "Fakturační údaje",
    "Údaje o pojištění": "Údaje o pojištění",
    "Údaje pro platbu převodem": "Údaje pro platbu převodem",
    "Údaje úspěšně změněny": "Údaje úspěšně změněny",
    "Úhloměr": "Úhloměr",
    "Uhradit": "Uhradit",
    "Uhrazeno": "Uhrazeno",
    "Ukázat cvik": "Ukázat cvik",
    "Ulice": "Ulice",
    "Ulice a č. p.": "Ulice a č. p.",
    "Ulice a č.p.": "Ulice a č.p.",
    "Uložené heslo vám nikdy nezobrazíme. Ponechte pole prázdné, pokud ho nechcete měnit.": "Uložené heslo vám nikdy nezobrazíme. Ponechte pole prázdné, pokud ho nechcete měnit.",
    "Uložené šablony": "Uložené šablony",
    "Uloženo": "Uloženo",
    "uložit": "uložit",
    "Uložit": "Uložit",
    "Uložit a zamknout": "Uložit a zamknout",
    "Uložit jako PDF do karty pacienta": "Uložit jako PDF do karty klienta",
    "Uložit rozpracované": "Uložit rozpracované",
    "Uložit změny": "Uložit změny",
    "Umožní rezervaci více klientů na jeden termín.": "Umožní rezervaci více klientů na jeden termín.",
    "Umožnit rezervaci náhradníkům": "Umožnit rezervaci náhradníkům",
    "Upozornit klienta při vytvoření, změně a zrušení návštěvy": "Upozornit klienta při vytvoření, změně a zrušení návštěvy",
    "Upozornit terapeuta na akce provedené jinym terapeutem": "Upozornit terapeuta na akce provedené jinym terapeutem",
    "Úprava": "Úprava",
    "Úprava příští návštěvy": "Úprava příští návštěvy",
    "upravit": "upravit",
    "Upravit": "Upravit",
    "Upravit cvik": "Upravit cvik",
    "Upravit dodavatele": "Upravit dodavatele",
    "Upravit dostupnost": "Upravit dostupnost",
    "Upravit fakturaci": "Upravit fakturaci",
    "Upravit FT poukaz": "Upravit FT poukaz",
    "Upravit fyzioterapeuta": "Upravit terapeuta",
    "Upravit kategorii": "Upravit kategorii",
    "Upravit kategorii cviků": "Upravit kategorii cvičení",
    "Upravit kategorii služeb": "Upravit kategorii služeb",
    "Upravit místnost": "Upravit místnost",
    "Upravit ordinační hodiny": "Upravit ordinační hodiny",
    "Upravit pacientovu permanentku": "Upravit klientův balíček",
    "Upravit permanentku": "Upravit balíček",
    "Upravit platbu č.": "Upravit platbu č.",
    "Upravit pobočku": "Upravit pobočku",
    "Upravit podkategorii": "Upravit podkategorii",
    "Upravit pojišťovnu": "Upravit pojišťovnu",
    "Upravit položku": "Upravit položku",
    "Upravit pracoviště": "Upravit pracoviště",
    "Upravit pracoviště žadatele": "Upravit pracoviště žadatele",
    "Upravit šablonu": "Upravit šablonu",
    "Upravit šablonu výkonů": "Upravit šablonu výkonů",
    "Upravit službu": "Upravit službu",
    "Upravit štítky": "Upravit štítky",
    "Upravit uživatele": "Upravit uživatele",
    "Upravit žadatele": "Upravit žadatele",
    "Upravit zboží": "Upravit zboží",
    "upravit-ft-poukaz/:ticketId": "upravit-ft-poukaz/:ticketId",
    "upravit-permanentku/:ticketId": "upravit-permanentku/:ticketId",
    "upravit-volno": "upravit-volno",
    "Určuje maximální počet pacientů na skupinovou návštěvu. Hodnota 0 se rovná neomezenému počtu pacientů.": "Určuje maximální počet klientů na skupinovou návštěvu. Hodnota 0 se rovná neomezenému počtu klientů.",
    "Určuje základní stav odesílání stvrzenek. Toto nastavení můžete ještě individuálně upravovat před samotnou platbou za návštěvu.": "Určuje základní stav odesílání stvrzenek. Toto nastavení můžete ještě individuálně upravovat před samotnou platbou za návštěvu.",
    "Určuje, kolik dní před návštěvou musí být provedena platba. Pokud není zaplaceno včas, návštěva se automaticky smaže. (0 dní = nikdy nedojde ke smazání)": "Určuje, kolik dní před návštěvou musí být provedena platba. Pokud není zaplaceno včas, návštěva se automaticky smaže. (0 dní = nikdy nedojde ke smazání)",
    "Určuje, v jakém časovém rozmezí (počet dní) musí být všechny rezervace v rámci jedné objednávky.": "Určuje, v jakém časovém rozmezí (počet dní) musí být všechny rezervace v rámci jedné objednávky.",
    "Určuje, zda musí být během služby přítomen terapeut. Vypíná se např. u služeb bez přímé obsluhy (vana, infrasauna apod.).": "Určuje, zda musí být během služby přítomen terapeut. Vypíná se např. u služeb bez přímé obsluhy (vana, infrasauna apod.).",
    "user.form.role.worker.tooltip": "Zaměstnanec nemá přístup do záložek Statistiky, Pojišťovny a Nastavení. Dále nemůže měnit zvolený tarif spolupráce.",
    "Úspěšně jste byli zaregistrováni jako náhradník": "Úspěšně jste byli zaregistrováni jako náhradník",
    "Úspěšně nahrána dávka do Purobota": "Úspěšně nahrána dávka do Purobota",
    "Úterý": "Úterý",
    "Už mám odcvičeno:": "Už mám odcvičeno:",
    "Územní pracoviště VZP": "Územní pracoviště VZP",
    "Uživatel": "Uživatel",
    "Uživatel byl deaktivován": "Uživatel byl deaktivován",
    "Uživatel byl úspěšně přidán": "Uživatel byl úspěšně přidán",
    "Uživatelé": "Uživatelé",
    "v angličtině": "v angličtině",
    "v češtině": "v češtině",
    "V historii cvičení nejsou žádné záznamy.": "V historii cvičení nejsou žádné záznamy.",
    "V historii rezervací zatím není žádná absolvovaná návštěva.": "V historii rezervací zatím není žádná absolvovaná návštěva.",
    "V měsících, ode dne zakoupení": "V měsících, ode dne zakoupení",
    "v nejnovější verzi Google Chrome, kterou můžete zdarma stáhnout na": "v nejnovější verzi Google Chrome, kterou můžete zdarma stáhnout na",
    "V ordinaci hotově/kartou": "V ordinaci hotově/kartou",
    "v polštině": "v polštině",
    "V případě neuhrazení může dojít k dočasnému zablokování Vašeho účtu.": "V případě neuhrazení může dojít k dočasnému zablokování Vašeho účtu.",
    "V případě, že je tato volba zapnuta, pacientům automaticky odchází i stvrzenky za zakoupené permanentky.": "V případě, že je tato volba zapnuta, klientům automaticky odchází i stvrzenky za zakoupené balíčky.",
    "V případě, že přejdete na některý z pokročilých tarifů spolupráce, automaticky se ruší limit na počet pacientů v aplikaci.": "V případě, že přejdete na některý z pokročilých tarifů spolupráce, automaticky se ruší limit na počet klientů v aplikaci.",
    "V případě, že se nemůžete dostavit, volejte na": "V případě, že se nemůžete dostavit, volejte na",
    "V této sekci definujete obecnou nabídku permanentek. Chcete-li permanentku přiřadit konkrétnímu klientovi, přejděte do jeho Karty klienta a ve spodní části stránky klikněte na „Přidat permanentku\"": "V této sekci definujete obecnou nabídku balíčků. Chcete-li balíček přiřadit konkrétnímu klientovi, přejděte do jeho Karty klienta a ve spodní části stránky klikněte na „Přidat balíček\"",
    "V tomto období se počet návštěv u každého z fyzioterapeutů rovná nule": "V tomto období se počet návštěv u každého z terapeutů rovná nule",
    "V tuto chvíli není možné GDPR potvrdit. Zkuste to znovu později.": "V tuto chvíli není možné GDPR potvrdit. Zkuste to znovu později.",
    "Vám navýšíme limit kartotéky pacientů v balíčku Freemium.": "Vám navýšíme limit kartotéky klientů v balíčku Freemium.",
    "Variabilní symbol": "Variabilní symbol",
    "Variabilní symbol:": "Variabilní symbol:",
    "Váš prohlížeč nepodporuje datový formát tohoto videa.": "Váš prohlížeč nepodporuje datový formát tohoto videa.",
    "vaše číslo účtu nebo IBAN.": "vaše číslo účtu nebo IBAN.",
    "Vaše heslo bylo úspěšně změněno.": "Vaše heslo bylo úspěšně změněno.",
    "Vaše heslo bylo úspěšně změněno. Nyní se můžete přihlásit.": "Vaše heslo bylo úspěšně změněno. Nyní se můžete přihlásit.",
    "Vaše kategorie služeb byla smazána": "Vaše kategorie služeb byla smazána",
    "Vaše platba proběhla v pořádku. Mockrát děkujeme, že využíváte aplikaci Fyzion.": "Vaše platba proběhla v pořádku. Mockrát děkujeme, že využíváte aplikaci Fyzion.",
    "Vaše platba se bohužel nezdařila. Zkuste platbu opakovat. Jestliže platba opět neproběhne v pořádku, můžete zkusit zaplatit převodem.": "Vaše platba se bohužel nezdařila. Zkuste platbu opakovat. Jestliže platba opět neproběhne v pořádku, můžete zkusit zaplatit převodem.",
    "Vaše rodné číslo potřebujeme k vytvoření vaší karty pacienta, nebo abychom ověřili, že u nás už kartu máte. S rodným číslem nakládáme v souladu s vyhláškou o zdravotnické dokumentaci.": "Vaše rodné číslo potřebujeme k vytvoření vaší karty klienta, nebo abychom ověřili, že u nás už kartu máte. S rodným číslem nakládáme v souladu s vyhláškou o zdravotnické dokumentaci.",
    "Vaše služba byla smazána": "Vaše služba byla smazána",
    "Vaše zpráva": "Vaše zpráva",
    "Vaši rezervaci už nelze zrušit online!": "Vaši rezervaci už nelze zrušit online!",
    "Včera": "Včera",
    "včetně prodeje zboží": "včetně prodeje zboží",
    "ve slovenštině": "ve slovenštině",
    "Veřejné zdravotní pojištění": "Veřejné zdravotní pojištění",
    "Video": "Video",
    "Video a obrázky cviku": "Video a obrázky cviku",
    "Visa ikona": "Visa ikona",
    "Vítáme vás v aplikaci Fyzion": "Vítáme vás v aplikaci Fyzion",
    "Vítejte na přihlašovací stránce klientského portálu CortexApp.": "Vítejte na přihlašovací stránce klientského portálu FyzionApp.",
    "Vítejte v CortexApp": "Vítejte v FyzionApp",
    "Vlastní": "Vlastní",
    "Vložit konečnou (zkopírovat první) zastávku": "Vložit konečnou (zkopírovat první) zastávku",
    "Vložit pod stávající zápis": "Vložit pod stávající zápis",
    "Vložit zastávku cesty": "Vložit zastávku cesty",
    "Vložit zpáteční (zkopírovat předchozí) zastávku": "Vložit zpáteční (zkopírovat předchozí) zastávku",
    "Volno (Dovolená)": "Volno (Dovolená)",
    "Volno odstraněno": "Volno odstraněno",
    "VOP úspěšně nahrány": "VOP úspěšně nahrány",
    "VOP úspěšně odebrány": "VOP úspěšně odebrány",
    "Vrátit do průvodce?": "Vrátit do průvodce?",
    "Vše": "Vše",
    "Všechny": "Všechny",
    "Všechny doklady": "Všechny doklady",
    "Všechny jeho návštěvy zůstanou nadále ve Vašem kalendáři, ale nebude již možné vytvářet nové návštěvy pacientovi ani se Vám nebude pacient nabízet v seznamu pacientů.": "Všechny jeho návštěvy zůstanou nadále ve Vašem kalendáři, ale nebude již možné vytvářet nové návštěvy klientovi ani se Vám nebude klient nabízet v seznamu klientů.",
    "Všechny místnosti": "Všechny místnosti",
    "Všechny naplánované návštěvy na této pobočce zůstanou zachovány.": "Všechny naplánované návštěvy na této pobočce zůstanou zachovány.",
    "Všechny naplánované návštěvy v této místnosti zůstanou zachovány.": "Všechny naplánované návštěvy v této místnosti zůstanou zachovány.",
    "Všechny pobočky": "Všechny pobočky",
    "Všechny poukazy": "Všechny poukazy",
    "Všechny pracoviště": "Všechny pracoviště",
    "Všechny služby": "Všechny služby",
    "Všechny typy služeb": "Všechny typy služeb",
    "Všeobecné obchodní podmínky": "Všeobecné obchodní podmínky",
    "všeobecnými obchodními podmínkami": "všeobecnými obchodními podmínkami",
    "Všeobecnými obchodními podmínkami": "Všeobecnými obchodními podmínkami",
    "Všichni": "Všichni",
    "Všichni klienti": "Všichni klienti",
    "Všichni pacienti": "Všichni klienti",
    "Vyberte": "Vyberte",
    "Vyberte alespoň jednu službu": "Vyberte alespoň jednu službu",
    "Vyberte dokumenty": "Vyberte dokumenty",
    "Vyberte FT poukaz": "Vyberte FT poukaz",
    "Vyberte kategorii služby podle jejího typu (např. masáže, skupinové cvičení). Kategorie ovlivňuje přehlednost a zobrazení služeb v online rezervacích.": "Vyberte kategorii služby podle jejího typu (např. masáže, skupinové cvičení). Kategorie ovlivňuje přehlednost a zobrazení služeb v online rezervacích.",
    "Vyberte klienta jako náhradníka": "Vyberte klienta jako náhradníka",
    "Vyberte obrázky": "Vyberte obrázky",
    "Vyberte pacienta": "Vyberte klienta",
    "Vyberte předplatné": "Vyberte předplatné",
    "Vyberte prosím alespoň 1 fotografii.": "Vyberte prosím alespoň 1 fotografii.",
    "Vyberte šablonu": "Vyberte šablonu",
    "Vyberte soubor": "Vyberte soubor",
    "Vyberte soubory k nahrání do systému": "Vyberte soubory k nahrání do systému",
    "Vyberte termín": "Vyberte termín",
    "Vyberte typ poukazu": "Vyberte typ poukazu",
    "Vyberte typ spisu": "Vyberte typ spisu",
    "Vyberte typ výkonu z číselníku ÚZIS. Povinné pole sloužící pro statistiky a vykazování.": "Vyberte typ výkonu z číselníku ÚZIS. Povinné pole sloužící pro statistiky a vykazování.",
    "Vyberte video": "Vyberte video",
    "Vyberte zboží...": "Vyberte zboží...",
    "Vybraná šablona nebyla nalezena": "Vybraná šablona nebyla nalezena",
    "Vybraná šablona neobsahuje žádné výkony": "Vybraná šablona neobsahuje žádné výkony",
    "Vybrané dávky elektronicky podepíšete v aplikaci Fyzion Signer — jedním podpisem, v němž dávky nejprve projdete. Fyzion je poté odešle zdravotní pojišťovně a o výsledku vás bude informovat e-mailem.": "Vybrané dávky elektronicky podepíšete v aplikaci Fyzion Signer — jedním podpisem, v němž dávky nejprve projdete. Fyzion je poté odešle zdravotní pojišťovně a o výsledku vás bude informovat e-mailem.",
    "Vybrané dávky odešlete s ověřením jedním SMS kódem. Hromadně lze odeslat jen dávky pojišťoven jednoho portálu. O výsledku vás budeme informovat e-mailem.": "Vybrané dávky odešlete s ověřením jedním SMS kódem. Hromadně lze odeslat jen dávky pojišťoven jednoho portálu. O výsledku vás budeme informovat e-mailem.",
    "Vybrané termíny": "Vybrané termíny",
    "Vybráni všichni klienti seznamu, celkem": "Vybráni všichni klienti seznamu, celkem",
    "Vybráno cviků": "Vybráno cvičení",
    "Vybraný terapeut neprovádí zvolenou službu. Prosím vyberte jinou službu nebo terapeuta.": "Vybraný terapeut neprovádí zvolenou službu. Prosím vyberte jinou službu nebo terapeuta.",
    "Vybrat": "Vybrat",
    "Vybrat barvu": "Vybrat barvu",
    "Vybrat barvu štítku": "Vybrat barvu štítku",
    "Vybrat diagnózu": "Vybrat diagnózu",
    "Vybrat dodavatele": "Vybrat dodavatele",
    "Vybrat druh péče": "Vybrat druh péče",
    "Vybrat druh úhrady": "Vybrat druh úhrady",
    "Vybrat IČP": "Vybrat IČP",
    "Vybrat kategorii": "Vybrat kategorii",
    "Vybrat kód": "Vybrat kód",
    "Vybrat období": "Vybrat období",
    "Vybrat odbornost": "Vybrat odbornost",
    "Vybrat ostatní diagnózy": "Vybrat ostatní diagnózy",
    "Vybrat pacienta": "Vybrat klienta",
    "Vybrat podkategorii": "Vybrat podkategorii",
    "Vybrat pracoviště": "Vybrat pracoviště",
    "Vybrat pracovníky": "Vybrat pracovníky",
    "Vybrat šablonu": "Vybrat šablonu",
    "Vybrat správnou kartu": "Vybrat správnou kartu",
    "Vybrat vše": "Vybrat vše",
    "Vybrat všechny klienty seznamu, celkem": "Vybrat všechny klienty seznamu, celkem",
    "Vybrat výkon": "Vybrat výkon",
    "Výchozí": "Výchozí",
    "Výchozí šablona": "Výchozí šablona",
    "Vyčistit filtr": "Vyčistit filtr",
    "Vygenerovat fakturu": "Vygenerovat fakturu",
    "Vyhledat": "Vyhledat",
    "Vyhledat diagnózu": "Vyhledat diagnózu",
    "Vykázat výkon bez FT poukazu": "Vykázat výkon bez FT poukazu",
    "Výkon": "Výkon",
    "Výkon je odemknutý": "Výkon je odemknutý",
    "Výkon je zamknutý": "Výkon je zamknutý",
    "Výkon nelze upravit, protože je již přiřazen k návštěvě.": "Výkon nelze upravit, protože je již přiřazen k návštěvě.",
    "Výkonová": "Výkonová",
    "výkonů": "výkonů",
    "Výkonů na stránku": "Výkonů na stránku",
    "vykony": "vykony",
    "Výkony": "Výkony",
    "Výkony nezapsané na návštěvě budou smazány.": "Výkony nezapsané na návštěvě budou smazány.",
    "Vylepšení textu se nezdařilo.": "Vylepšení textu se nezdařilo.",
    "Vylepšený text": "Vylepšený text",
    "Vylepšit s AI": "Vylepšit s AI",
    "Vylepšit zprávu": "Vylepšit zprávu",
    "Vyplňte ve formátu +420 123 456 789": "Vyplňte ve formátu +420 123 456 789",
    "Vyplňte ve formátu DD.MM.RRRR": "Vyplňte ve formátu DD.MM.RRRR",
    "Vyplňte ve formátu HH:mm": "Vyplňte ve formátu HH:mm",
    "Vyplňte, pokud pacient změnil pojišťovnu, abychom mohli správně vytvořit dávku.": "Vyplňte, pokud klient změnil pojišťovnu, abychom mohli správně vytvořit dávku.",
    "Výše kreditu:": "Výše kreditu:",
    "Výše max. úhrady": "Výše max. úhrady",
    "Výše max. úhrady:": "Výše max. úhrady:",
    "Výše paušálu:": "Výše paušálu:",
    "Výše storno poplatku účtovaného při zrušení rezervace.": "Výše storno poplatku účtovaného při zrušení rezervace.",
    "výskytech": "výskytech",
    "výskytu": "výskytu",
    "Vystavovat fakturu pro platby převodem": "Vystavovat fakturu pro platby převodem",
    "Vystavovat faktury místo stvrzenek": "Vystavovat faktury místo stvrzenek",
    "vytisknout": "vytisknout",
    "Vytisknout": "Vytisknout",
    "Vytváření rezervace": "Vytváření rezervace",
    "Vytvoření": "Vytvoření",
    "Vytvořeno": "Vytvořeno",
    "Vytvořit": "Vytvořit",
    "Vytvořit 3 návštěvy": "Vytvořit 3 návštěvy",
    "Vytvořit a tisknout": "Vytvořit a tisknout",
    "Vytvořit dávku": "Vytvořit dávku",
    "Vytvořit dávky": "Vytvořit dávky",
    "Vytvořit faktury": "Vytvořit faktury",
    "Vytvořit FT poukaz": "Vytvořit FT poukaz",
    "Vytvořit novou kategorii": "Vytvořit novou kategorii",
    "Vytvořit novou podkategorii": "Vytvořit novou podkategorii",
    "Vytvořit novou rezervaci": "Vytvořit novou rezervaci",
    "Vytvořit novou službu": "Vytvořit novou službu",
    "Vytvořit nový cvik": "Vytvořit nový cvik",
    "Vytvořit opravnou dávku": "Vytvořit opravnou dávku",
    "Vytvořit platbu": "Vytvořit platbu",
    "Vytvořit pobočku": "Vytvořit pobočku",
    "Vytvořit poukaz": "Vytvořit poukaz",
    "Vytvořit rezervaci": "Vytvořit rezervaci",
    "Vytvořit šablonu výkonů": "Vytvořit šablonu výkonů",
    "Vytvořit zprávu": "Vytvořit zprávu",
    "Využívat klientský portál": "Využívat klientský portál",
    "Vyžádat SMS kód": "Vyžádat SMS kód",
    "Vyžadovat poznámku": "Vyžadovat poznámku",
    "Vyžaduje přítomnost terapeuta": "Vyžaduje přítomnost terapeuta",
    "Vyzkoušejte Fyzion Zdarma!": "Vyzkoušejte Fyzion Zdarma!",
    "Vyzkoušejte si Fyzion zdarma a přesvědčte se sami proč ho používá více jak 1000 fyzioterapetů v ČR. Stačí vyplnit několik údajů ve formuláři níže a můžete začít. Později můžete snadno upgradovat na vyšší tarif.": "Vyzkoušejte si Fyzion zdarma a přesvědčte se sami proč ho používá více jak 3000 terapeutů v ČR. Stačí vyplnit několik údajů ve formuláři níže a můžete začít. Později můžete snadno upgradovat na vyšší tarif.",
    "Vzdálenost (km)": "Vzdálenost (km)",
    "Vzdálenost od předchozí zastávky v km": "Vzdálenost od předchozí zastávky v km",
    "Vždy uvádějte jméno pacienta (i v případě dítěte)": "Vždy uvádějte jméno klienta (i v případě dítěte)",
    "Webinář": "Webinář",
    "white-mark": "white-mark",
    "x": "x",
    "z": "z",
    "z ceny aplikace": "z ceny aplikace",
    "z toho v hotovosti": "z toho v hotovosti",
    "Z-Poukaz": "Z-Poukaz",
    "Začínáme": "Začínáme",
    "Zadané telefonní číslo je neplatné.": "Zadané telefonní číslo je neplatné.",
    "zadatele": "zadatele",
    "Žadatelé": "Žadatelé",
    "Žadatelé na stránku": "Žadatelé na stránku",
    "Zadejte název služby, kterou nabízíte (např. individuální fyzioterapie, elektroléčba, dětská fyzioterapie, zdravotní cvičení). Název se zobrazuje v kalendáři i v online rezervačním systému.": "Zadejte název služby, kterou nabízíte (např. individuální terapie, elektroléčba, dětská terapie, zdravotní cvičení). Název se zobrazuje v kalendáři i v online rezervačním systému.",
    "Zadejte nové heslo": "Zadejte nové heslo",
    "Zadejte platnou e-mailovou adresu": "Zadejte platnou e-mailovou adresu",
    "Zadejte prosím e-mail, na který Vám zašleme informace k obnovení hesla.": "Zadejte prosím e-mail, na který Vám zašleme informace k obnovení hesla.",
    "Zadejte SMS kód z portálu pojišťovny. Platný kód, který už máte, můžete použít znovu, nový si vyžádejte jen tehdy, když žádný nemáte.": "Zadejte SMS kód z portálu pojišťovny. Platný kód, který už máte, můžete použít znovu, nový si vyžádejte jen tehdy, když žádný nemáte.",
    "Zadejte validní tel. číslo": "Zadejte validní tel. číslo",
    "Žádná pobočka není k dispozici": "Žádná pobočka není k dispozici",
    "Žádná služba není k dispozici": "Žádná služba není k dispozici",
    "Žádné akce k zobrazení": "Žádné akce k zobrazení",
    "Žádné dávky k zobrazení": "Žádné dávky k zobrazení",
    "Žádné doklady k zobrazení": "Žádné doklady k zobrazení",
    "Žádné možnosti nebyly nalezeny": "Žádné možnosti nebyly nalezeny",
    "Žádné návštěvy k zobrazení": "Žádné návštěvy k zobrazení",
    "Žádné stvrzenky k zobrazení": "Žádné stvrzenky k zobrazení",
    "Žádné výkony k zobrazení": "Žádné výkony k zobrazení",
    "Žádné výsledky": "Žádné výsledky",
    "Žádné zpráva k zobrazení": "Žádné zpráva k zobrazení",
    "Žádný fyzioterapeut není dostupný": "Žádný terapeut není dostupný",
    "Žádný typ služby není k dispozici": "Žádný typ služby není k dispozici",
    "Zahrnuté služby": "Zahrnuté služby",
    "Základní diagnóza": "Základní diagnóza",
    "Zákonný zástupce": "Zákonný zástupce",
    "Zákonný zástupce:": "Zákonný zástupce:",
    "Zákres": "Zákres",
    "Zaměstnanci": "Zaměstnanci",
    "Zaměstnanec": "Uživatel",
    "Zamezit online rezervace:": "Zamezit online rezervace:",
    "Zamknutou návštěvu nelze měnit.": "Zamknutou návštěvu nelze měnit.",
    "Zaplaceno": "Zaplaceno",
    "Zaplaceno:": "Zaplaceno:",
    "zaplatit": "zaplatit",
    "Zaplatit": "Zaplatit",
    "Zaplatit permanentkou": "Zaplatit balíčkem",
    "Zaplatit pomocí QR kódu": "Zaplatit pomocí QR kódu",
    "Zaplatit QR kódem": "Zaplatit QR kódem",
    "Zaplaťte pomocí QR kódu": "Zaplaťte pomocí QR kódu",
    "Zaplaťte předplatným, jestliže ho některá instituce poskytuje": "Zaplaťte předplatným, jestliže ho některá instituce poskytuje",
    "Zapnutím povolíte klientům rušení rezervací této služby.": "Zapnutím povolíte klientům rušení rezervací této služby.",
    "Zapnutím povolíte zobrazování služby v online rezervačním systému. Bez zapnutí nebude možné službu rezervovat online.": "Zapnutím povolíte zobrazování služby v online rezervačním systému. Bez zapnutí nebude možné službu rezervovat online.",
    "Zapnutím této funkce aktivujete integraci s McKenzie formuláři. Toto nastavení nelze po aktivaci vypnout.": "Zapnutím této funkce aktivujete integraci s McKenzie formuláři. Toto nastavení nelze po aktivaci vypnout.",
    "Zapomněli jste heslo?": "Zapomněli jste heslo?",
    "Zapsáno": "Zapsáno",
    "Zapsat cestu": "Zapsat cestu",
    "Zapsat výkon": "Zapsat výkon",
    "zásadami zpracování osobních údajů": "zásadami zpracování osobních údajů",
    "Zásob na stránku": "Zásob na stránku",
    "zasoby": "zasoby",
    "Zásoby": "Zásoby",
    "Zásoby na skladě": "Zásoby na skladě",
    "Zastávka": "Zastávka",
    "Zatím nebyl nahrán žádný dokument.": "Zatím nebyl nahrán žádný dokument.",
    "Zatím nebyla nahrána žádná videa.": "Zatím nebyla nahrána žádná videa.",
    "Zatím nebyly nahrány žádné obrázky.": "Zatím nebyly nahrány žádné obrázky.",
    "Zatím nebyly vytvořeny žádné permanentky": "Zatím nebyly vytvořeny žádné balíčky",
    "Zatím nejsou nahrána žádná videa.": "Zatím nejsou nahrána žádná videa.",
    "Zatím nejsou naplánovány žádné cviky.": "Zatím nejsou naplánovány žádná cvičení.",
    "Zatím nejsou žádné recenze.": "Zatím nejsou žádné recenze.",
    "Zatím nemáte naplánované žádné pacienty": "Zatím nemáte naplánované žádné klienty",
    "Zatím zde nejsou žádné cviky": "Zatím zde nejsou žádná cvičení",
    "Zatím zde nejsou žádné položky": "Zatím zde nejsou žádné položky",
    "Zatím zde nejsou žádné předplatné": "Zatím zde nejsou žádné předplatné",
    "Zatím zde nejsou žádné proběhlé návštěvy": "Zatím zde nejsou žádné proběhlé návštěvy",
    "Zatím zde nejsou žádné šablony": "Zatím zde nejsou žádné šablony",
    "Zatím zde nejsou žádné služby": "Zatím zde nejsou žádné služby",
    "Zatím zde nejsou žádné spisy": "Zatím zde nejsou žádné spisy",
    "Zatím zde nejsou žádné zásoby": "Zatím zde nejsou žádné zásoby",
    "Zatím zde nejsou žádné záznamy": "Zatím zde nejsou žádné záznamy",
    "Zatím zde nejsou žádní dodavatelé": "Zatím zde nejsou žádní dodavatelé",
    "Zatím zde nejsou žádní pacienti": "Zatím zde nejsou žádní klienti",
    "Zavolat do ordinace": "Zavolat do ordinace",
    "Zavolat na číslo": "Zavolat na číslo",
    "Zavolejte nám na telefon:": "Zavolejte nám na telefon:",
    "Zavřeno": "Zavřeno",
    "Zavřít": "Zavřít",
    "Zavřít menu": "Zavřít menu",
    "Zavřít platbu": "Zavřít platbu",
    "Zavřít zboží": "Zavřít zboží",
    "Záznamů na stránku": "Záznamů na stránku",
    "zaznamy": "zaznamy",
    "Zboží": "Zboží",
    "Zboží bylo úspěšně naskladněno": "Zboží bylo úspěšně naskladněno",
    "Zboží se nepodařilo naskladnit": "Zboží se nepodařilo naskladnit",
    "Zbývající počet znaků": "Zbývající počet znaků",
    "Zbývajících vstupů": "Zbývajících vstupů",
    "Zdá se, že nám hledaná": "Zdá se, že nám hledaná",
    "Zdarma": "Zdarma",
    "ZDARMA": "ZDARMA",
    "ZDE": "ZDE",
    "Zde můžete nahrát dokumenty, které se týkají vybraného profilu.": "Zde můžete nahrát dokumenty, které se týkají vybraného profilu.",
    "Zde prosím nahrajte svá data, která chcete nahrát do systému.": "Zde prosím nahrajte svá data, která chcete nahrát do systému.",
    "Zde se zobrazují všechny dokumenty, které jste v rámci návštěv daného pacienta nahráli": "Zde se zobrazují všechny dokumenty, které jste v rámci návštěv daného klienta nahráli",
    "Zdravotní pojišťovna": "Zdravotní pojišťovna",
    "Zdravotní pojišťovna podání odmítla, protože certifikát, kterým byla dávka podepsána, není zaveden u vašeho účtu na jejím portále. Podepište podání certifikátem, který máte na portále zdravotní pojišťovny zavedený, a dávku odešlete znovu.": "Zdravotní pojišťovna podání odmítla, protože certifikát, kterým byla dávka podepsána, není zaveden u vašeho účtu na jejím portále. Podepište podání certifikátem, který máte na portále zdravotní pojišťovny zavedený, a dávku odešlete znovu.",
    "Zdravotní pojišťovna podání odmítla, protože SMS kód byl neplatný nebo mu vypršela platnost. Vyžádejte si nový kód a dávku odešlete znovu.": "Zdravotní pojišťovna podání odmítla, protože SMS kód byl neplatný nebo mu vypršela platnost. Vyžádejte si nový kód a dávku odešlete znovu.",
    "Zelená": "Zelená",
    "Země": "Země",
    "Žena": "Žena",
    "Ženy": "Ženy",
    "Ženy (budoucí)": "Ženy (objednané)",
    "Zjistit více": "Zjistit více",
    "Zkontrolujte prosím zadanou adresu v prohlížeči.": "Zkontrolujte prosím zadanou adresu v prohlížeči.",
    "Zkopírováno": "Zkopírováno",
    "Zkopírovat": "Zkopírovat",
    "Zkopírovat kód": "Zkopírovat kód",
    "Zkopírovat odkaz do schránky": "Zkopírovat odkaz do schránky",
    "Zkopírovat odkaz na rezervaci této služby": "Zkopírovat odkaz na rezervaci této služby",
    "Zkuste to znovu": "Zkuste to znovu",
    "Žlutá": "Žlutá",
    "Změna hesla": "Změna hesla",
    "Změna se nezdařila. Prosím zkontrolujte údaje ve formuláři": "Změna se nezdařila. Prosím zkontrolujte údaje ve formuláři",
    "Změna tarifu není možná": "Změna tarifu není možná",
    "Změnit": "Změnit",
    "Změnit heslo": "Změnit heslo",
    "Změnit konfiguraci": "Změnit konfiguraci",
    "Změnit stav": "Změnit stav",
    "Změnit stav na „%{status}“?": "Změnit stav na „%{status}“?",
    "Změnit typ platby nebo částku můžete v editaci plateb.": "Změnit typ platby nebo částku můžete v editaci plateb.",
    "Zobrazit": "Zobrazit",
    "Zobrazit méně": "Zobrazit méně",
    "Zobrazit starší": "Zobrazit starší",
    "Zobrazit všechny recenze": "Zobrazit všechny recenze",
    "Zobrazit všechny zaměstnance": "Zobrazit všechny zaměstnance",
    "Zobrazovat bloky v kalendáři po 15 minutách": "Zobrazovat bloky v kalendáři po 15 minutách",
    "Zobrazovat jednotlivé terapeuty v online rezervačním systému": "Zobrazovat jednotlivé terapeuty v online rezervačním systému",
    "Zobrazovat jména ve formátu PŘÍJMENÍ JMÉNO v kartotéce": "Zobrazovat jména ve formátu PŘÍJMENÍ JMÉNO v kartotéce",
    "zpět": "zpět",
    "Zpět": "Zpět",
    "Zpět do aplikace": "Zpět do aplikace",
    "Zpět na cviky": "Zpět na cvičení",
    "Zpět na přihlášení": "Zpět na přihlášení",
    "Zpět na seznam dávek": "Zpět na seznam dávek",
    "Zpráva od terapeuta": "Zpráva od terapeuta",
    "zpravy": "zpravy",
    "Způsob platby": "Způsob platby",
    "Způsob platby při rezervaci online": "Způsob platby při rezervaci online",
    "Zrušená fakturace": "Zrušená fakturace",
    "Zrušená návštěva klienta": "Zrušená návštěva klienta",
    "Zrušení rezervace": "Zrušení rezervace",
    "Zrušení rezervací se bude řídit obecným nastavením firmy.": "Zrušení rezervací se bude řídit obecným nastavením firmy.",
    "Zrušení se storno poplatkem": "Zrušení se storno poplatkem",
    "Zrušení se storno poplatkem (před návštěvou)": "Zrušení se storno poplatkem (před návštěvou)",
    "Zrušením platby stornujete vytvořenou stvrzenku, vrátíte vstup na permanentku nebo vrátíte kredity na předplatné. Záleží na předchozím typu platby.": "Zrušením platby stornujete vytvořenou stvrzenku, vrátíte vstup na balíček nebo vrátíte kredity na předplatné. Záleží na předchozím typu platby.",
    "Zrušeno": "Zrušeno",
    "Zrušeno terapeutem": "Zrušeno terapeutem",
    "Zrušit": "Zrušit",
    "Zrušit dle storno podmínek": "Zrušit dle storno podmínek",
    "ZRUŠIT FILTR": "ZRUŠIT FILTR",
    "Zrušit návštěvu": "Zrušit návštěvu",
    "Zrušit platbu": "Zrušit platbu",
    "Zrušit přijetí": "Zrušit přijetí",
    "Zrušit rezervaci": "Zrušit rezervaci",
    "Zůstat na stránce": "Zůstat na stránce",
    "Zvolit": "Zvolit",
    "Zvolit fyzioterapeuta": "Zvolit terapeuta",
    "Zvolit pobočku": "Zvolit pobočku",
    "Zvolit službu": "Zvolit službu",
    "Zvolit typ služby": "Zvolit typ služby",
    "Zvolte alespoň jeden výkon": "Zvolte alespoň jeden výkon",
    "Zvolte alespoň jednu pojišťovnu": "Zvolte alespoň jednu pojišťovnu",
    "Zvolte ANO, pokud spolupracujete s pojišťovnami. Umožníme vám zapisování výkonů a tvorbu dávek a faktur.": "Zvolte ANO, pokud spolupracujete s pojišťovnami. Umožníme vám zapisování výkonů a tvorbu dávek a faktur.",
    "Zvolte barvu, kterou bude služba označena v kalendáři a rezervačním systému.": "Zvolte barvu, kterou bude služba označena v kalendáři a rezervačním systému.",
    "Zvolte čas": "Zvolte čas",
    "Zvolte datum": "Zvolte datum",
    "Zobrazovat jméno vyšetřujícího v dokumentech": "Zobrazovat jméno vyšetřujícího v dokumentech",
    "Platí pro dokument návštěvy a kartu klienta. Pokud je zapnuto, zobrazí se u každé návštěvy, kdo ji vyšetřil.": "Platí pro dokument návštěvy a kartu klienta. Pokud je zapnuto, zobrazí se u každé návštěvy, kdo ji vyšetřil.",
    "Hrazeno pojišťovnou": "Hrazeno pojišťovnou"
  },
  "sk": {
    " Identifikátor propojení obchodu ": " Identifikátor prepojenia obchodu ",
    " pacientů. Přidáním tohoto pacienta tuto kapacitu překročíte.": " klientov. Pridaním tohto klienta túto kapacitu prekročíte.",
    ":companyWorkspaceId/pridat-pojistovnu": ":companyWorkspaceId/pridat-poistovnu",
    ":companyWorkspaceId/upravit": ":companyWorkspaceId/upravit",
    ":companyWorkspaceId/upravit-pojistovnu/:insuranceContractId": ":companyWorkspaceId/upravit-poistovnu/:insuranceContractId",
    ":insuranceApplicantId/upravit": ":insuranceApplicantId/upravit",
    ":patientId/popisy-navstev": ":patientId/popisy-navstev",
    ":serviceGroupId/upravit": ":serviceGroupId/upravit",
    ":serviceId/upravit": ":serviceId/upravit",
    ":stockItemId/upravit": ":stockItemId/upravit",
    ":supplierId/upravit": ":supplierId/upravit",
    ":userId/ordinacni-hodiny": ":userId/ordinacne-hodiny",
    ":userId/upravit": ":userId/upravit",
    ". Před návštěvou se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": ". Pred návštevou si prečítajte zásady GDPR. Pre zobrazenie textu GDPR a potvrdenie kliknite",
    "(obsazeno)": "(obsadené)",
    "(Přišli poprvé)": "(Prišli prvýkrát)",
    "@": "@",
    "/akce": "/akcia",
    "/cekajici-pacienti": "/cakajuci-klienti",
    "/cviky": "/cviky",
    "/domu": "/domov",
    "/historie-akci": "/historia-akcii",
    "/historie-zprav": "/historia-sprav",
    "/kalendar": "/kalendar",
    "/moje-navstevy": "/moje-navstevy",
    "/moje-profily": "/moje-profily",
    "/moje-udaje": "/moje-udaje",
    "/nastaveni": "/nastavenie",
    "/novinky": "/novinky",
    "/ordinace": "/ordinacia",
    "/pacienti": "/klienti",
    "/pacienti/novy": "/klienti/novy",
    "/platba": "/platba",
    "/platby": "/platby",
    "/pojistovny": "/poistovne",
    "/predplatne": "/predplatne",
    "/profil": "/profil",
    "/provedene-akce": "/vykonane-akcie",
    "/pruvodce/": "/sprievodca/",
    "/recenze": "/recenzie",
    "/rozcestnik-pruvodce/": "/rozcestník-sprievodca/",
    "/rozsireni-kartoteky-zdarma": "/rozsirenie-kartoteky-zdarma",
    "/sablony": "/sablony",
    "/sklad": "/sklad",
    "/skupinove-navstevy/": "/skupinove-navstevy/",
    "/soubory": "/subory",
    "/statistiky": "/statistiky",
    "%": "%",
    "• E-mail: ": "• E-mail: ",
    "• IČO": "• IČO",
    "+420 315 315 817": "+420 315 315 817",
    "<div>Dobrý den,</div><br/>v příloze zasíláme rozpis termínů fyzioterapie.": "<div>Dobrý deň,</div><br/>v prílohe zasielame rozpis termínov terapie.",
    "<div>Dobrý den,</div><br/>v příloze zasíláme zprávu z provedené terapie.": "<div>Dobrý deň,</div><br/>v prílohe zasielame lekársku správu z vykonanej terapie.",
    "1. čvrtletí": "1. štvrťrok",
    "2. čtvrtletí": "2. štvrťrok",
    "3 - Úraz způsobený jinou osobou": "3 - Úraz spôsobený inou osobou",
    "3. čtvrtletí": "3. štvrťročie",
    "4 - Alkohol a omamné látky": "4 - Alkohol a omamné látky",
    "4. čvrtletí": "4. štvrťrok",
    "5 - Pracovní úraz": "5 - Pracovný úraz",
    "6 - Sociální důvody hospitalizace": "6 - Sociálne dôvody hospitalizácie",
    "60 pacientů": "60 klientov",
    "7 - Porušení léčebného režimu": "7 - Porušenie liečebneho režimu",
    "8 - Výměna komponent systému ASR_TM": "8 - Výmena komponentov systému ASR_TM",
    "9 - Nemoc z povolání": "9 - Nemoc z povolania",
    "A ROZŠIŘTE SI KARTOTÉKU": "A ROZŠÍRTE SI KARTOTÉKU",
    "a zaplatit": "Zaplatiť",
    "Absolutní": "Absolútny",
    "Absolutní storno poplatek": "Absolútny storno poplatok",
    "Admin": "Admin",
    "Admin má neomezený přístup ke všem funkcím v rámci zvoleného tarifu": "Admin má neobmedzený prístup ku všetkým funkciám v rámci zvoleného tarifu",
    "Adresa": "Adresa",
    "Adresa sídla": "Adresa sídla",
    "Adresa:": "Adresa:",
    "Adresát": "Adresát",
    "Adresu ukládejte ve formátu: Ulice č.p, Město, PSČ": "Adresu ukladajte vo formáte: Ulica č.p, Mesto, PSČ",
    "Akce": "Akcia",
    "Aktivace a dostupnost": "Aktivácia a dostupnosť",
    "Aktivací zpřístupníte klientský portál. Po naplánování návštěvy nového klienta nebo rezervace klient automaticky obdrží pozvánku do klientského portálu.": "Aktiváciou sprístupníte klientský portál. Po naplánovaní návštevy nového klienta alebo rezervácie klient automaticky dostane pozvánku do klientského portálu.",
    "Aktivní profil byl změněn": "Aktívny profil bol zmenený",
    "Aktivní tarif": "Aktívny tarif",
    "Aktivovat cesty za pacienty": "Aktivovať cesty za klientov",
    "aktualizujte": "aktualizujte",
    "Aktuální prostředí:": "Aktuálne prostredie:",
    "anamneza": "anamneza",
    "Anamnéza": "Anamnéza",
    "Anamnéza zatím nebyla vyplněna.": "Anamnéza zatiaľ nebola vyplnená.",
    "Anamnézu se nepodařilo načíst": "Anamnézu sa nepodarilo načítať.",
    "Anamnézu se nepodařilo uložit": "Anamnézu sa nepodarilo uložiť",
    "Anamnézy": "Anamnézy",
    "Ano": "Ano",
    "API URL:": "API URL:",
    "aplikaci Fyzion na sociálních sítích nebo kdekoliv na webu.": "aplikaciu Fyzion na sociálnych sieťach alebo kdekoľvek na webe.",
    "Aplikovat na všechny termíny": "Aplikovať na všetky termíny",
    "Aplikovat změny na toto a všechna budoucí volna": "Aplikovať zmeny na túto a všetky budúce návštevy",
    "Aplikovat změny na tuto a všechny budoucí návštěvy": "Aplikovať zmeny na túto a všetky budúce návštevy",
    "Aplikovat změny na tuto a všechny budoucí skupinové návštěvy": "Aplikovať zmeny na túto a všetky budúce skupinové návštevy",
    "Aplikovat změny pouze na toto volno": "Aplikovať zmeny len na túto návštevu",
    "Aplikovat změny pouze na tuto návštěvu": "Aplikovať zmeny len na túto návštevu",
    "Aplikovat změny pouze na tuto skupinovou návštěvu": "Aplikovať zmeny len na túto skupinovú návštevu",
    "Archivace": "Archivacia",
    "Archivovat": "Archivovať",
    "Automaticky kontaktovat náhradníky při smazání rezervace (pouze pro skupinové návštěvy)": "Automaticky kontaktovať náhradníkov pri zmazaní rezervácie (len pre skupinové návštevy)",
    "Automaticky odešle klientovi informaci o vytvoření, změně či zrušení návštěvy.": "Automaticky odošle klientovi informáciu o vytvorení, zmene alebo zrušení návštevy.",
    "Automaticky odešle klientovi připomínkovou SMS se zvolenými údaji v Nastavení. Zpráva se odesílá v časovém předstihu podle nastavení, vždy v 9 hodin ráno.": "Automaticky odošle klientovi pripomienkovú SMS so zvolenými údajmi v Nastaveniach. Správa sa odosiela v časovom predstihu podľa nastavenia, vždy o 9. hodine ráno.",
    "Automaticky odešle klientovi připomínku e-mailem s datem a časem návštěvy. Zpráva se odesílá v časovém předstihu podle nastavení, vždy v 9 hodin ráno.": "Automaticky odošle klientovi pripomienku e-mailom s dátumom a časom návštevy. Správa sa odosiela v časovom predstihu podľa nastavenia, vždy o 9. hodine ráno.",
    "Automaticky použít permanentku k úhradě návštěvy": "Automaticky použiť permanentku na úhradu návštevy",
    "Balíček zdarma je v základním nastavení limitován počtem pacientů, které je možné mít v kartotéce, na 20. V případě, že jste dosáhli limitu, máte možnost tento limit navýšit až na": "Balík zdarma je v základnom nastavení limitovaný počtom klientov, ktoré je možné mať v kartotéke, na 20. V prípade, že ste dosiahli limit, máte možnosť tento limit navýšiť až na",
    "Bankovní údaje": "Bankovné údaje",
    "Barva": "Farba",
    "Barva místnosti": "Farba miestnosti",
    "Barva místnosti v kalendáři": "Farba miestnosti v kalendári",
    "Barva služby": "Farba služby",
    "Barva terapeuta": "Farba terapeuta",
    "Barva v kalendáři": "Farba v kalendári",
    "barvy-kalendare": "farby-kalendara",
    "Bederní": "Bedrový",
    "Beru na vědomí": "Beriem na vedomie",
    "bezchybně a rychle": "bezchybne a rýchlo",
    "bezhotovostně": "bezhotovostne",
    "Bezplatná registrace": "Bezplatná registracia",
    "Bezplatné přesunutí (před návštěvou)": "Bezplatné presunutie (pred návštevou)",
    "Bezplatné zrušení (před návštěvou)": "Bezplatné zrušenie (pred návštevou)",
    "Bezplatné zrušení nejpozději": "Bezplatné zrušenie najneskôr",
    "Blok do kalendáře": "Blok do kalendára",
    "Blok do kalendáře zamezující rezervaci": "Blok do kalendára zamedzujúci rezerváciu",
    "Bodů": "Bodov",
    "Bodů celkem": "Bodov celkom",
    "Body": "Body",
    "Body:": "Body:",
    "Bude použito i pro variabilní symbol": "Bude použité aj pre variabilný symbol",
    "Budeme vás kontaktovat e-mailem nebo telefonicky, pokud se uvolní místo": "Budeme vás kontaktovať e-mailom alebo telefonicky, ak sa uvoľní miesto",
    "Budoucí návštěvy": "Budúce návštevy",
    "Čas": "Čas",
    "Čas byl úspěšně vybrán. Vyberte ještě": "Čas bol úspešne vybraný. Vyberte ešte",
    "Čas do je povinný": "Čas do je povinný",
    "Čas od je povinný": "Čas od je povinný",
    "Čas:": "Čas:",
    "Časové okno pro rezervace": "Časové okno pre rezervácie",
    "Časové okno pro rezervaci hromadných termínů": "Časové okno pre rezerváciu hromadných termínov",
    "Časový interval před návštěvou, během kterého může klient rezervaci bezplatně přesunout.": "Časový interval pred návštevou, počas ktorého môže klient rezerváciu bezplatne presunúť.",
    "Časový interval před návštěvou, během kterého může klient rezervaci zrušit bez poplatku.": "Časový interval pred návštevou, počas ktorého môže klient rezerváciu zrušiť bez poplatku.",
    "Časový interval před návštěvou, kdy je možné rezervaci zrušit, ale se storno poplatkem.": "Časový interval pred návštevou, kedy je možné rezerváciu zrušiť, ale so storno poplatkom.",
    "Částka": "Čiastka",
    "Částka bude vypočítána jako celková cena všech položek.": "Čiastka bude vypočítaná ako celková cena všetkých položiek.",
    "Částka k úhradě": "Čiastka k úhrade",
    "Částka nesmí být vyšší než cena návštěvy": "Suma nesmie byť vyššia ako cena návštevy",
    "Čeká na autorizaci": "Čaká na autorizáciu",
    "Čeká na platbu": "Čaká na platbu",
    "Čeká na zaplacení": "Čaká na zaplatenie",
    "Čekající": "Čakajúci",
    "Čekající pacienti": "Čakajúci klienti",
    "Čekající:": "Čakajúci:",
    "Celkem": "Celkom",
    "Celkem k úhradě": "Celkom k úhrade",
    "Celkem náhradníků:": "Celkom náhradníkov:",
    "Celkem návštěv:": "Celkom návštev:",
    "Celkový čas návštěvy klienta. Tato doba se zobrazuje klientovi v potvrzení rezervace a v pozvánce.": "Celkový čas návštevy klienta. Táto doba sa zobrazuje klientovi v potvrdení rezervácie a v pozvánke.",
    "Celkový časový blok rezervovaný v kalendáři pro tuto službu. Zahrnuje čas pro pacienta i navazující činnosti (administrativa, úklid, hygienická pauza apod.).": "Celkový časový blok rezervovaný v kalendári pre túto službu. Zahŕňa čas pre klienta aj nadväzujúce činnosti (administratíva, upratovanie, hygienická pauza a pod.).",
    "Celkový počet odeslaných SMS": "Celkový počet odoslaných SMS",
    "Celý den": "Celý deň",
    "Cena": "Cena",
    "Cena celkem": "Cena celkom",
    "Cena nemůže být nižší než 0": "Cena nemôže byť nižšia než 0",
    "Cena nesmí být záporná": "Cena nesmie byť záporná",
    "Cena permanentky": "Cena permanentky",
    "Cena s DPH": "Cena s DPH",
    "Cena služby.": "Cena služby.",
    "Cena za MJ": "Cena za MJ",
    "Cena:": "Cena:",
    "Certifikát": "Certifikát",
    "Červená": "Červená",
    "Cestovní zdravotní pojištění": "Cestovné zdravotné poistenie",
    "Četl/a jsem a souhlasím se": "Prečítal som si a súhlasím so",
    "Chápeme, že nyní není vhodný čas, k průvodci se můžete kdykoliv vrátit, případně využít tipy a nápovědu.": "Chápeme, že teraz nie je vhodný čas, k sprievodcovi sa môžete kedykoľvek vrátiť, prípadne využiť tipy a nápovedu.",
    "Charakter": "Charakter",
    "Charakter dávky": "Charakter dávky",
    "Chcete pokračovat v zadání návštěvy:": "Chcete pokračovať v zadaní návštevy:",
    "Chcete-li vytvořit rezervaci nebo spravovat své termíny, přihlaste se ke svému účtu.": "Ak chcete vytvoriť rezerváciu alebo spravovať svoje termíny, prihláste sa do svojho účtu.",
    "Chci naplánovat": "Chcem naplánovať",
    "chyba": "chyba",
    "Chyba při přesměrování na registraci náhradníka": "Chyba pri presmerovaní na registráciu náhradníka",
    "Cíl": "Cieľ",
    "Čísla dokladů v dávce od": "Čísla dokladov v dávke od",
    "Čísla faktur": "Čísla faktúr",
    "Číslo": "Číslo",
    "Číslo bez lomítka": "Číslo bez lomítka",
    "Číslo dávky": "Číslo dávky",
    "Číslo dokladu": "Číslo dokladu",
    "Číslo pojištěnce": "Číslo poistenca",
    "Číslo pojištěnce nemusí být správné": "Číslo poistenca nemusí byť správne",
    "Číslo pojištěnce:": "Číslo poistenca:",
    "Číslo pojišťenec": "Číslo poistenca",
    "Číslo účtu": "Číslo účtu",
    "Číslování dokladů": "Číslovanie dokladov",
    "Číslovat dávky od": "Číslovať dávky od",
    "Číslovat faktury od": "Číslovať faktúry od",
    "Číslovat paragony od": "Číslovať paragóny od",
    "Číst více": "Čítať viac",
    "client photo": "fotografia klienta",
    "Co je nového?": "Čo je nové?",
    "CS": "CS",
    "Čtvrtek": "Štvrtok",
    "Čtvrtletí": "Štvrťroky",
    "Čtvrtletní": "Štvrťroční",
    "cvik": "cvik",
    "Cvik": "Cvik",
    "cviků": "cvikov",
    "cviky": "cviky",
    "Cviky": "Cviky",
    "Cviky na vybraný den": "Cviky na vybraný deň",
    "Další akce": "Dalšia akcia",
    "Další krok postupu": "Ďalší krok postupu",
    "Další položka": "Další položka",
    "Další propojení dostupné pouze při": "Ďalšie prepojenie dostupné len pri",
    "Další štítky": "Ďalšie štítky",
    "Další výkon": "Další výkon",
    "Data se načítají...": "Údaje sa načítavajú...",
    "Datum": "Dátum",
    "Datum a čas": "Dátum a čas",
    "Datum expirace": "Dátum expirácie",
    "Datum inventury": "Dátum inventúry",
    "Datum je povinné": "Dátum je povinné",
    "Datum narození": "Dátum narodenia",
    "Datum narození:": "Dátum narodenia:",
    "Datum naskladnění": "Dátum naskladnenia",
    "Datum návštěvy": "Dátum návštevy",
    "Datum platnosti budoucí ceny nemůže být v minulosti.": "Dátum platnosti budúcej ceny nemôže byť v minulosti.",
    "Datum splatnosti:": "Dátum splatnosti:",
    "Datum transakce": "Dátum transakcie",
    "Datum vystavení": "Dátum vystavenia",
    "Datum začátku cvičení": "Dátum začiatku cvičenia",
    "Datum zaplacení": "Dátum zaplatenia",
    "Datum zdanitelného plnění": "Dátum zdaniteľného plnenia",
    "Datum změny pojištění:": "Dátum zmeny poistenia:",
    "Datum změny pojišťovny": "Dátum zmeny poisťovne",
    "Datum:": "Dátum:",
    "Dávek na stránku": "Dávok na stránku",
    "DÁVKA POUKAZŮ NA VYŠETŘENÍ/OŠETŘENÍ SMÍŠENÁ": "DÁVKA POUKAZOV NA VYŠETRENIE/OŠETRENIE ZMIEŠANÁ",
    "DÁVKA VYÚČTOVÁNÍ CEST V NÁVŠTĚVNÍ SLUŽBĚ": "DÁVKA VYÚČTOVANIA CIEST V NÁVŠTEVNEJ SLUŽBE",
    "DÁVKA VYÚČTOVÁNÍ VÝKONŮ V AMBULANTNÍ PÉČI": "DÁVKA VYÚČTOVANIA VÝKONOV V AMBULANTNEJ STAROSTLIVOSTI",
    "Dávku elektronicky podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Dávku elektronicky podpíšete v aplikácii Fyzion Signer a Fyzion ju odošle zdravotnej poisťovni.",
    "Dávku lze elektronicky odeslat přímo zdravotní pojišťovně, s podpisem certifikátem nebo s ověřením SMS kódem.": "Dávku možno elektronicky odoslať priamo zdravotnej poisťovni, s podpisom certifikátom alebo s overením SMS kódom.",
    "Dávku se nepodařilo vytvořit": "Dávku sa nepodarilo vytvoriť",
    "davky": "davky",
    "Dávky": "Dávky",
    "Dávky jsme zařadili k odeslání pojišťovně. O výsledku vás budeme informovat e-mailem.": "Dávky sme zaradili na odoslanie poisťovni. O výsledku vás budeme informovať e-mailom.",
    "Dávky nemůžeme vytvořit, protože jsme nenašli žádné výkony. Změňte výběr období, pojišťoven nebo pracoviště.": "Dávky nemôžeme vytvoriť, pretože sme nenašli žiadne výkony. Zmeňte výber obdobia, poisťovní alebo pracoviska.",
    "Dávky vytvořeny": "Dávky vytvorené",
    "DD.MM.RRRR": "DD.MM.RRRR",
    "Deaktivovat": "Deaktivovať",
    "Deaktivovat terapeuta": "Deaktivovať terapeuta",
    "dekujeme": "dakujeme",
    "Děkujeme za vaší recenzi!": "Ďakujeme vám za vašu recenziu!",
    "Děkujeme!": "Ďakujeme!",
    "Děkujeme! Souhlas s GDPR byl úspěšně potvrzen.": "Ďakujeme! Súhlas s GDPR bol úspešne potvrdený.",
    "Délka (min.)": "Dĺžka (min.)",
    "den": "den",
    "Den": "Den",
    "Denně": "Denne",
    "detail": "detail",
    "Detail následující návštěvy": "Detail nasledujúcej návštevy",
    "Detail návštěvy": "Detail návštevy",
    "Detail poslední návštěvy": "Detail poslednej návštevy",
    "Detail registrace náhradníka": "Detail registrácie náhradníka",
    "Detail rezervace": "Detail rezervácie",
    "Detail vybraného profilu": "Detail vybraného profilu",
    "Diagnóza": "Diagnóza",
    "Diagnózy": "Diagnózy",
    "DIČ": "DIČ",
    "dne": "dňa",
    "Dne": "Dňa",
    "Dnes": "Dnes",
    "dní": "dní",
    "dnů": "dní",
    "dny": "dni",
    "Dny": "Dni",
    "do": "do",
    "Do": "Do",
    "Do karty pacienta nebyly zatím nahrány žádné formuláře.": "Do karty klienta zatiaľ neboli nahrané žiadne formuláre.",
    "Do karty pacienta nebyly zatím nahrány žádné fotografie.": "Do karty klienta zatiaľ neboli nahrané žiadne fotografie.",
    "Do průvodce": "Do sprievodcu",
    "Doba splatnosti": "Doba splatnosti",
    "Doba trvání": "Doba trvania",
    "Doba trvání pro pacienty": "Doba trvania pre klientov",
    "Doba trvání:": "Doba trvania:",
    "Dobrý den": "Dobrý deň",
    "Dodavatel": "Dodavateľ",
    "Dodavatel byl úspěšně smazán": "Dodávateľ bol úspešne zmazaný",
    "Dodavatel byl úspěšně upraven": "Dodávateľ bol úspešne upravený",
    "Dodavatel byl úspěšně vytvořen": "Dodávateľ bol úspešne vytvorený",
    "dodavatele": "dodavatele",
    "Dodavatelé": "Dodávatelia",
    "Dodavatele se nepodařilo smazat": "Dodávateľa sa nepodarilo zmazať",
    "Dodavatele se nepodařilo upravit": "Dodávateľa sa nepodarilo upraviť",
    "Dojde k odstranění následujících místností navázaných na tuto pobočku:": "Dôjde k odstráneniu nasledujúcich miestností naviazaných na túto pobočku:",
    "Doklady": "Doklady",
    "Dokončeno": "Dokončené",
    "Dokončit odeslání": "Dokončiť odoslanie",
    "Dokončit odeslání dávky": "Dokončiť odoslanie dávky",
    "Dokončit odeslání dávky č. %{number} pro pojišťovnu %{insurance}?": "Dokončiť odoslanie dávky č. %{number} pre poisťovňu %{insurance}?",
    "Dokument byl úspěšně nahrán a odeslán": "Dokument bol úspešne nahraný a odoslaný",
    "Dokumenty": "Dokumenty",
    "Doplňková služba": "Doplnková služba",
    "dopředu": "vopred",
    "Dosáhli jste maximálního počtu pacientů v kartotéce. ": "Dosiahli ste maximálny počet klientov v kartotéke. ",
    "Dosažen limit SMS": "Dosiahnutý limit SMS",
    "Dosažení maximálního počtu pacientů": "Dosiahnutie maximálneho počtu klientov",
    "Dotazník": "Dotazník",
    "Dotazník pro klienta": "Dotazník pre klienta",
    "Dotazník pro klienta (dotazník uvidí klient v klientské sekci, kde ho může vyplnit)": "Dotazník pre klienta (dotazník uvidí klient v klientskej sekcii, kde ho môže vyplniť)",
    "Dotazník pro pacienta": "Dotazník pre klienta",
    "Dotazník uvidí klient v klientské sekci, kde ho může vyplnit": "Dotazník uvidí klient v klientskej sekcii, kde ho môže vyplniť",
    "Dotazovat se klientů na souhlas se zasíláním novinek v rezervačním systému": "Pýtať sa klientov na súhlas so zasielaním noviniek v rezervačnom systéme",
    "DPH": "DPH",
    "DPH%": "DPH%",
    "Druh péče": "Druh starostlivosti",
    "Druh péče:": "Druh starostlivosti:",
    "Druh úhrady": "Druh úhrady",
    "Druh úhrady:": "Druh úhrady:",
    "Duplikovat": "Duplikovať",
    "E-mail": "E-mail",
    "E-mail se nepodařilo odeslat.": "E-mail sa nepodarilo odoslať.",
    "E-mail úspěšně odeslán": "E-mail úspešne odoslaný",
    "E-mailová adresa": "E-mailová adresa",
    "E-mailová adresa:": "E-mailová adresa:",
    "Editace údajů pacienta": "Editácia údajov klienta",
    "Email": "Email",
    "Email byl úspěšně poslán": "E-mail úspešne odoslaný",
    "Email klientům": "E-mail klientom",
    "Email odeslán": "Email odoslaný",
    "Email pro faktury": "E-mail pre faktúry",
    "Emailová adresa": "E-mailová adresa",
    "EN": "EN",
    "Export bude vygenerován a zaslán na e-mail": "Export bude vygenerovaný a zaslaný na e-mail",
    "Export transakcí": "Export transakcií",
    "Exportovat": "Exportovať",
    "Exportovat data": "Exportovať data",
    "Exportovat ISDOC": "Exportovať ISDOC",
    "Exportovat PDF": "Exportovať PDF",
    "Exportovat platby": "Exportovať platby",
    "Exportovat výkony": "Exportovať",
    "Faktura": "Faktura",
    "Faktura bude vygenerována a zaslána na e-mail": "Faktúra bude vygenerovaná a zaslaná na e-mail",
    "Faktura byla označena jako zaplacená": "Faktúra bola označená ako zaplatená",
    "Fakturace": "Fakturacia",
    "Fakturace byla označena jako zaplacená": "Fakturácia bola označená ako zaplatená",
    "Fakturace úspěšně přidána": "Fakturácia úspešne pridaná",
    "Fakturace úspěšně upravena": "Fakturacia úspešne upravená",
    "Fakturace za období": "Fakturácia za obdobie",
    "Fakturace za období:": "Fakturácia za obdobie:",
    "Fakturační údaje": "Fakturačné údaje",
    "fakturacni-udaje": "fakturacne-udaje",
    "Fakturováno": "Fakturované",
    "fakturu č.": "faktúru č.",
    "faktury": "faktury",
    "Faktury": "Faktúry",
    "Filtrovat": "Filtrovať",
    "Filtrovat pacienty": "Filtrovať klientov",
    "Filtrujte cviky podle jména": "Filtrovať cviky podľa mena",
    "finance": "financie",
    "Finance": "Financie",
    "firemni-udaje": "firemne-udaje",
    "flag": "vlajka",
    "Formulář úspěšně nahrán": "Formulár úspešne nahraný",
    "Formuláře se nepodařilo načíst": "Formuláre sa nepodarilo načítať",
    "Fotka FT poukazu": "Fotka FT poukaz",
    "Fotka FT poukazu byla úspěšně nahrána": "Fotka FT poukazu bola úspešne nahraná",
    "Fotku obrazovky s Vaším sdílením": "Fotku obrazovky s Vašim zdieľaním",
    "Fotky": "Fotky",
    "Fotogalerie": "Fotogaléria",
    "fotografie": "fotografia",
    "Fotografie se nepodařilo načíst.": "Fotografia sa nepodarilo načítať.",
    "Fotografie se zobrazí na veřejné stránce v sekci zaměstnanci": "Fotografia sa zobrazí na verejnej stránke v sekcii zamestnanci",
    "Fotografie smazána": "Fotografia zmazaná",
    "Fotografie úspěšně nahrána": "Fotografia úspešne nahraná",
    "Fotografie ze dne": "Fotografia z dna",
    "FT poukaz": "FT poukaz",
    "FT Poukaz": "FT Poukaz",
    "FT poukaz byl úspěšně vytvořen": "FT poukaz bol úspešne vytvorený",
    "FT poukaz není možné vytvořit. Zkontrolujte, jestli je vše správně vyplněno na kartě pacienta.": "FT poukaz nie je možné vytvoriť. Skontrolujte, či je všetko správne vyplnené na karte klienta.",
    "FT poukaz úspěšně smazán": "FT poukaz úspešne zmazaný",
    "FT poukaz úspěšně upraven": "FT poukaz úspešne upravený",
    "FT poukazy": "FT poukazy",
    "Funkce pro větší instituce, se kterými spolupracujete. Mohou u vás mít „kredit“ a čerpat ho za vaše služby.": "Funkcia určená pre väčšie inštitúcie, s ktorými spolupracujete. Môžu mať u vás „kredit“ a čerpať ho za vaše služby.",
    "Fyzion – moderní software pro fyzioterapii": "Fyzion – moderný softvér pre terapiu",
    "Fyzion funguje": "Fyzion funguje",
    "Fyzion premium function": "Fyzion premium function",
    "Fyzion running away": "Fyzion beží preč",
    "fyzion-faktura.pdf": "fyzion-faktura.pdf",
    "fyzion-zalohova-faktura.pdf": "fyzion-zalohova-faktura.pdf",
    "Fyzioterapeut": "Terapeut",
    "Fyzioterapeut a místnost": "Terapeut a miestnosť",
    "Fyzioterapeut je povinný": "Terapeut je povinný",
    "Fyzioterapeut nemá vyplněné ordinační hodiny": "Terapeut nemá vyplnenú pracovnú dobu",
    "Fyzioterapeut:": "Terapeut:",
    "fyzioterapeuti": "terapeuti",
    "Fyzioterapeuti": "Terapeuti",
    "Fyzioterapeuti úspěšně resetováni podle diagnózy": "Terapeuti úspešne resetovaní podľa diagnózy",
    "GDPR": "GDPR",
    "GDPR souhlas": "GDPR súhlas",
    "GDPR úspěšně potvrzeno.": "GDPR úspešne potvrdené.",
    "GDPR:": "GDPR:",
    "Generováno": "Generované",
    "Generuji PDF pro tisk…": "Generujem PDF na tlač…",
    "Google kalendář": "Google kalendár",
    "Hesla se neshodují": "Heslá sa nezhodujú",
    "Heslo": "Heslo",
    "Heslo bylo úspěšně nastaveno": "Heslo bolo úspešne nastavené",
    "Heslo bylo úspěšně změněno": "Heslo bolo úspešne zmenené",
    "Heslo bylo úspěšně změněno. Přihlaste se prosím znovu novým heslem.": "Heslo bolo úspešne zmenené. Prihláste sa, prosím, znova novým heslom.",
    "Heslo musí obsahovat minimálně 8 znaků a alespoň 1 číslici.": "Heslo musí obsahovať minimálne 8 znakov a aspoň 1 číslicu.",
    "Historie akcí": "Záznam aktivit",
    "Historie akcí, odeslané zprávy.": "História akcií, odoslané správy.",
    "Historie cvičení": "História cvičení",
    "Historie emailů a SMS": "História emailov a SMS",
    "Historie návštěv": "História návštev",
    "Historie rezervací": "História rezervácií",
    "historie-akci": "historia-akcii",
    "Hledanému výrazu neodpovídá žádná diagnóza": "Hľadanému výrazu nezodpovedá žiadna diagnóza",
    "Hledanému výrazu neodpovídá žádné pracoviště": "Hľadanému výrazu nezodpovedá žiadne pracovisko",
    "Hledanému výrazu neodpovídá žádný pacient": "Hľadanému výrazu nezodpovedá žiadny klient",
    "Hledanému výrazu neodpovídá žádný poukaz": "Hľadanému výrazu nezodpovedá žiadny poukaz",
    "Hledanému výrazu neodpovídá žádný výkon": "Hľadanému výrazu nezodpovedá žiadny výkon",
    "Hledat klienta": "Hľadať klienta",
    "Hledat...": "Hľadať...",
    "hod": "hod",
    "hodin": "hodín",
    "hodinu": "hodinu",
    "hodiny": "hodiny",
    "Hodnota bodu": "Hodnota bodu",
    "Hodnota bodu:": "Hodnota bodu:",
    "Hotově": "V hotovosti",
    "Hotovo": "Hotovo",
    "Hromadné odeslání dávek pojišťovně selhalo": "Hromadné odoslanie dávok poisťovni zlyhalo",
    "Hrudní": "Hrudný",
    "HTML kód na web": "HTML kód na web",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Podminky_ochrany_osobnich_udaju.pdf": "https://fyzion.sk/ochrana-osobnich-udaju/",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Vseobbecne_obchodni_podminky_edit_2025_v2.pdf": "https://fyzion.sk/vop/",
    "https://fyzion.cz/cs/sdilejte-nas-a-rozsirte-si-kartoteku-zdarma/": "https://fyzion.sk/sk/sdilejte-nas-a-rozsirte-si-kartoteku-zdarma/",
    "https://fyzion.cz/cs/webinar/": "https://fyzion.sk/sk/webinar/",
    "https://fyzion.cz/navod-pojistovny": "https://fyzion.cz/navod-pojistovny",
    "https://fyzion.cz/navod-purobot": "https://fyzion.cz/navod-purobot",
    "https://kb.fyzion.cz/cs/": "https://kb.fyzion.cz/cs/",
    "https://kb.fyzion.cz/cs/article/databaze-cviku-a-jak-je-poslat-pacientovi-ue0fjk/": "https://kb.fyzion.cz/cs/article/databaze-cviku-a-jak-je-poslat-pacientovi-ue0fjk/",
    "https://kb.fyzion.cz/cs/article/fakturacni-udaje-1phelsb/": "https://kb.fyzion.cz/cs/article/fakturacni-udaje-1phelsb/",
    "https://kb.fyzion.cz/cs/article/jak-vyuzit-predplatne-ve-fyzionu-darkove-poukazy-benefity-a-firemni-fakturace-1xlifqz/": "https://kb.fyzion.cz/sk/article/jak-vyuzit-predplatne-ve-fyzionu-darkove-poukazy-benefity-a-firemni-fakturace-1xlifqz/",
    "https://kb.fyzion.cz/cs/article/kartoteka-pacientu-1bjloyh/": "https://kb.fyzion.cz/cs/article/kartoteka-pacientu-1bjloyh/",
    "https://kb.fyzion.cz/cs/article/nastaveni-terapeutu-sauigy/": "https://kb.fyzion.cz/cs/article/nastaveni-terapeutu-sauigy/",
    "https://kb.fyzion.cz/cs/article/permanentky-17qqddn/": "https://kb.fyzion.cz/cs/article/permanentky-17qqddn/",
    "https://kb.fyzion.cz/cs/article/platby-z33ojo/": "https://kb.fyzion.cz/cs/article/platby-z33ojo/",
    "https://kb.fyzion.cz/cs/article/platebni-brana-comgate-149e3gy/": "https://kb.fyzion.cz/cs/article/platebni-brana-comgate-149e3gy/",
    "https://kb.fyzion.cz/cs/article/platebni-brana-fyzion-1i889t1/": "https://kb.fyzion.cz/cs/article/platebni-brana-fyzion-1i889t1/",
    "https://kb.fyzion.cz/cs/article/pobocky-ve-fyzionu-vetsi-svoboda-pro-terapeuty-prehlednost-pro-klienty-1vwg90a/": "https://kb.fyzion.cz/cs/article/pobocky-ve-fyzionu-vetsi-svoboda-pro-terapeuty-prehlednost-pro-klienty-1vwg90a/",
    "https://kb.fyzion.cz/cs/article/pojistovny-16i7uc6/": "https://kb.fyzion.cz/cs/article/pojistovny-16i7uc6/",
    "https://kb.fyzion.cz/cs/article/propojeni-kalendare-s-googlem-h9fpzi/": "https://kb.fyzion.cz/cs/article/propojeni-kalendare-s-googlem-h9fpzi/",
    "https://kb.fyzion.cz/cs/article/recenze-1okedp6/": "https://kb.fyzion.cz/cs/article/recenze-1okedp6/",
    "https://kb.fyzion.cz/cs/article/sablony-jcwt6d/": "https://kb.fyzion.cz/cs/article/sablony-jcwt6d/",
    "https://kb.fyzion.cz/cs/article/sluzby-jak-nastavit-vase-sluzby-13wrswq/": "https://kb.fyzion.cz/cs/article/sluzby-jak-nastavit-vase-sluzby-13wrswq/",
    "https://kb.fyzion.cz/cs/article/sprava-skladu-a-fakturace-1dfkoro/": "https://kb.fyzion.cz/cs/article/sprava-skladu-a-fakturace-1dfkoro/",
    "https://www.fyzion.cz/cs/navod-fyzion": "https://kb.fyzion.cz/sk/",
    "https://www.google.com/chrome/": "https://www.google.com/chrome/",
    "IBAN": "IBAN",
    "IČ": "IČ",
    "IČO": "IČO",
    "IČP": "IČP",
    "IČP žadatele": "IČP žiadateľa",
    "IČZ": "IČZ",
    "id": "id",
    "iframe na web": "iframe na web",
    "Ignorovat automatické přepsání": "Ignorovať automatické prepísanie",
    "info@fyzion.cz": "podpora@fyzion.cz",
    "Informace o návštěvách": "Informacie o návštevách",
    "Informace o Vaší registraci jsme Vám poslali na e-mail": "Informácie o Vašej registrácii sme Vám poslali na e-mail",
    "Informace o Vaší rezervaci jsme Vám poslali na e-mail": "Informacie o Vašej rezervácii sme Vám poslali na e-mail",
    "inventura": "inventura",
    "Inventura": "Inventúra",
    "Inventura zboží": "Inventúra tovaru",
    "Inventura zboží úspěšně provedena": "Inventúra tovaru úspešne prevedená",
    "Inventuru zboží se nepodařilo uložit": "Inventúru tovaru sa nepodarilo uložiť",
    "Jak chcete pokračovat?": "Jak chcete pokračovať?",
    "Jak chcete provedené změny aplikovat?": "Ako chcete vykonané zmeny aplikovať?",
    "Jak funguje platební brána?": "Ako funguje platobná brána?",
    "Jak fungují permanentky?": "Ako fungujú permanentky?",
    "Jak fungují recenze?": "Ako fungujú recenzie?",
    "Jak na propojení s PURObotem?": "Ako na prepojenie s PUROrobotom?",
    "Jak na to": "Ako na to",
    "Jak nastavit fakturační údaje?": "Ako nastaviť fakturačné údaje?",
    "Jak nastavit online rezervace?": "Ako nastaviť online rezervácie?",
    "Jak nastavit pobočky?": "Ako nastaviť pobočky?",
    "Jak nastavit služby?": "Ako nastaviť služby?",
    "Jak nastavit terapeuta?": "Ako nastaviť terapeuta?",
    "Jak navýšit limit kartotéky pacientů?": "Ako navýšiť limit kartotéky klientov?",
    "Jak používat šablony?": "Ako používať šablóny?",
    "Jak pracovat s kartotekou?": "Ako pracovať s kartotékou?",
    "Jak pracovat s platbami?": "Ako pracovať s platbami?",
    "Jak pracovat se cviky?": "Ako pracovať s cvikmi?",
    "Jak propojit kalendář s Googlem?": "Ako prepojiť kalendár s Googlom?",
    "Jak si přejete aplikovat tuto šablonu?": "Naozaj si prepísať text šablónou?",
    "Jak spravovat sklad?": "Ako spravovať sklad?",
    "Jak vykazovat na pojišťovny?": "Ako vykazovať na poisťovne?",
    "Jak využít předplatné?": "Ako využiť predplatné?",
    "Jaké služby poskytuje?": "Aké služby poskytuje?",
    "Jakýkoliv": "Akýkoľvek",
    "Jde o duplicitní kartu?": "Jde o duplicitnú kartu?",
    "Jdeme na to teď!": "Ideme na to teraz!",
    "Je-li funkce zapnuta a pacient ještě nemá potvrzené GDPR, systém mu ho automaticky odesílá k potvrzení den před budoucí návštěvou.": "Je-li funkcia zapnutá a klient ešte nemá potvrdené GDPR, systém mu ho automaticky odosiela k potvrdeniu deň pred budúcou návštevou.",
    "Je-li tato funkce vypnuta, fyzioterapeut vidí návštěvy ostatních fyzioterapeutů, ale nemůže se prokliknout do jejich detailu": "Je-li táto funkcia vypnutá, terapeut vidí návštevy ostatných terapeutov, ale nemôže sa prekliknúť do ich detailu",
    "Jestliže splníte tyto tři úkoly dříve, než vyprší čas, jako odměnu od nás dostanete tarif Standard na tři měsíce": "Ak splníte tieto tri úlohy skôr, než uplynie čas, ako odmenu od nás dostanete tarif Standard na tri mesiace",
    "Jméno": "Meno",
    "Jméno pojištěnce": "Meno poistencov",
    "Jméno/název": "Meno/názov",
    "Jméno/Název": "Meno/Názov",
    "Jsou předepsané výkony": "Nasľúbené výkony",
    "K návštěvě existuje více než jedna platba": "K návšteve existuje viac ako jedna platba",
    "K platbě": "K platbe",
    "K poukazu zatím není zapsaný žádný výkon": "K poukazu zatiaľ nie je zapísaný žiadny výkon",
    "K přihlášení použijte váš e-mail, na který Vám zasíláme potvrzení o rezervacích.": "Na prihlásenie použite váš e-mail, na ktorý Vám zasielame potvrdenia o rezerváciách.",
    "K této cvičební položce nejsou k dispozici žádné obrázky ani videa.": "K tejto cvičebnej položke nie sú k dispozícii žiadne obrázky ani videá.",
    "K této cvičební poloze nejsou k dispozici žádné další informace.": "K tejto cvičebnej polohe nie sú k dispozícii žiadne ďalšie informácie.",
    "K této návštěvě nebyl zatím přidán žádný popis.": "K tejto návšteve nebol zatiaľ pridaný žiaden popis.",
    "K této recenzi nebyl přidán žádný text.": "K tejto recenzii nebol pridaný žiadny text.",
    "K vytvoření stvrzenky je potřeba návštěva": "K vytvorenie potvrdenky je potrebná návšteva",
    "K vytvoření stvrzenky je potřeba pacient a návštěva": "K vytvorenie potvrdenky je potrebný klient a návšteva",
    "k_batches.confirm_delete_k_batch_modal.confirm_text": "Zmazať",
    "k_batches.confirm_delete_k_batch_modal.heading_with_invoice": "Zmazať dávku a faktúru?",
    "k_batches.confirm_delete_k_batch_modal.heading_without_invoice": "Zmazať dávku?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_with_invoice": "Naozaj si prajete zmazať dávku č. %{batchNumber} a faktúru č. %{invoiceNumber}?",
    "k_batches.confirm_delete_k_batch_modal.informative_text_without_invoice": "Naozaj si prajete zmazať dávku č. %{batchNumber}?",
    "k_batches.corrective_k_batch.get_ft_tickets_for_corrective_k_batch_failed.notification": "k_batches.corrective_k_batch.get_ft_tickets_for_corrective_k_batch_failed.notification",
    "k_batches.k_batch_document.get_k_batch_document_list_failed.notification": "Dávku sa nepodarilo zmazať",
    "k_batches.k_batch.create_corrective_batch_successful.notification": "Opravná dávka vytvorená",
    "k_batches.k_batch.create_corrective_k_batch_btn.label": "Vytvoriť opravnú dávku",
    "k_batches.k_batch.delete_failed.notification": "Dávku sa nepodarilo zmazať",
    "k_batches.k_batch.delete_k_batch_btn.label": "Zmazať dávku",
    "k_batches.k_batch.delete_successful.notification": "Dávka zmazaná",
    "k_batches.k_batch.new_receipt_btn.label": "Vytvoriť fakturu z dávky",
    "K-Poukaz": "K-Poukaz",
    "Kalendář": "Kalendár",
    "Kalendář byl úspěšně synchronizován": "Kalendár bol úspešne synchronizovaný",
    "Kalendář je již synchronizovaný": "Kalendár je už synchronizovaný",
    "Kalendář místností": "Kalendár miestností",
    "Kalendář skupinových": "Kalendár skupinových",
    "Kalendář terapeutů": "Kalendár terapeutov",
    "Kapacita": "Kapacita",
    "Kapacita:": "Kapacita:",
    "Karta klienta": "Karta klienta",
    "Karta pacienta": "Karta klienta",
    "karta-pacienta": "karta-klienta",
    "Kartou": "Kartou",
    "Kartou online": "Kartou online",
    "Karty byly sloučeny": "Karty boli zlúčené",
    "Karty se nepodařilo sloučit": "Karty sa nepodarilo zlúčiť",
    "kategorie": "kategórie",
    "Kategorie": "Kategórie",
    "Kč": "€",
    "Kdokoliv dostupný": "Ktokolvek dostupný",
    "Klient": "Klient",
    "Klient platí za službu osobně během návštěvy.": "Klient platí za službu osobne počas návštevy.",
    "Klient si může vybrat, zda zaplatí online předem, nebo až při návštěvě.": "Klient si môže vybrať, či zaplatí online vopred, alebo až pri návšteve.",
    "Klienti a klientská sekce": "Klienti a klientská sekcia",
    "Klienti dostanou odkaz na přihlašovací stránku do klientského portálu od svého terapeuta.": "Klienti dostanú odkaz na prihlasovaciu stránku klientskeho portálu od svojho terapeuta.",
    "Klientská sekce": "Klientská sekcia",
    "Klientská sekce je vypnutá. Zapnout ji můžete v": "Klientská sekcia je vypnutá. Zapnúť ju môžete vo",
    "Klientský portál": "Klientský portál",
    "klientů": "klientov",
    "km)": "km)",
    "Kód": "Kód",
    "Kód ": "Kód ",
    "Kód a název pojišťovny": "Kód a názov poisťovne",
    "Kód a název zboží": "Kód a názov tovaru",
    "Kód a název zboží, počet": "Kód a názov tovaru, počet",
    "kód banky": "kód banky",
    "Kód banky": "Kód banky",
    "Kód náhrady": "Kód náhrady",
    "Kód pojišťovny": "Kód poisťovne",
    "Kód zboží": "Kód tovaru",
    "Končetiny dolní": "Dolné končatiny",
    "Končetiny horní": "Horné končatiny",
    "Konec": "Konec",
    "Kontakt na pacienta": "Kontakt na klienta",
    "Kontaktní osoba": "Kontaktná osoba",
    "Kontaktní údaje": "Kontaktné údaje",
    "kontaktni-udaje": "kontaktne-udaje",
    "Kontaktovat": "Kontaktovať",
    "Kontaktovat náhradníky s nabídkou termínu?": "Kontaktovať náhradníkov s ponukou termínu?",
    "Kontaktujte nás": "Kontaktujte nás",
    "Kontaktujte nás a rádi vám Fyzion představíme <br>během 15 minutového online hovoru.": "Kontaktujte nás a radi vám Fyzion predstavíme <br>počas 15 minútového online hovoru.",
    "Kontaktujte naši podporu": "Kontaktujte našu podporu",
    "Kontrola": "Kontrola",
    "Kontrolní spis se nepodařilo vytvořit": "Kontrolný spis sa nepodarilo vytvoriť",
    "Kopírovat": "Kopírovať",
    "Krční": "Krčný",
    "Kredit": "Kredit",
    "krok cviku": "krok cviku",
    "ks": "ks",
    "ks x": "ks x",
    "label": "label",
    "lekcí": "lekcií",
    "Limit": "Limit",
    "Limit dluhu předplatného bude překročen.": "Limit dlhu predplatného bude prekročený.",
    "Limit dlužné částky": "Limit dlžnej sumy",
    "Limit dlužné částky:": "Limit dlžnej sumy:",
    "Limit pacientů můžete zvýšit, když nám pomůžete sdílet aplikaci mezi Vaše kolegy, ": "Limit klientov môžete zvýšiť, keď nám pomôžete zdieľať aplikáciu medzi Vašich kolegov, ",
    "Logo": "Logo",
    "Logo aplikace Fyzion": "Logo aplikácie Fyzion",
    "Logo firmy": "Logo spoločnosti",
    "Luboš Truhlář": "Luboš Truhlář",
    "mailto:info@fyzion.cz": "mailto:podpora@fyzion.cz",
    "Mají tel.": "Majú tel.",
    "Mastercard ikona": "Mastercard ikona",
    "Máte již vlastní IČO?": "Máte už vlastné IČO?",
    "máte naplánovanou návštěvu v ordinaci fyzioterapie": "máte naplánované stretnutie v pracovisku terapie",
    "Máte neuhrazenou objednávku za pronájem aplikace!": "Máte neuhradenú objednávku za prenájom aplikácie!",
    "Máte objednány tyto návštěvy": "Máte objednané tieto návštevy",
    "Máte zde neuložené změny, chcete je před odchodem uložit?": "Máte tu neuložené zmeny, chcete ich pred odchodom uložiť?",
    "Max. 9 výkonů": "výkonov",
    "Maximální kapacita": "Maximálna kapacita",
    "Maximální kapacita návštěvy je ": "Maximálna kapacita návštevy je ",
    "Maximální počet klientů": "Maximálny počet klientov",
    "Maximální počet objednaných rezervací": "Maximálny počet objednaných rezervácií",
    "Maximální počet rezervací": "Maximálny počet rezervácií",
    "Maximální počet rezervací za den": "Maximálny počet rezervácií za deň",
    "Maximální počet termínů, které si může klient rezervovat v jedné objednávce. Pokud není vyplněno, počet rezervací není omezen.": "Maximálny počet termínov, ktoré si môže klient rezervovať v jednej objednávke. Ak nie je vyplnené, počet rezervácií nie je obmedzený.",
    "Maximální počet účastníků skupinové služby.": "Maximálny počet účastníkov skupinovej služby.",
    "Maximální úhrada": "Maximálna úhrada",
    "McKenzie formuláře byly úspěšně aktivovány": "McKenzie formuláre boli úspešne aktivované",
    "McKenzie spisy": "McKenzie spisy",
    "měsíc": "mesiac",
    "Měsíc": "Mesiac",
    "měsíce": "mesiace",
    "Měsíce": "Mesiace",
    "Měsíčně": "Mesacne",
    "Měsíční": "Mesačný",
    "měsíců": "mesiacov",
    "Město": "Mesto",
    "mezi vaše kolegy nebo přechodem na ": "medzi vašimi kolegami alebo prechodom na ",
    "mezi Vaše kolegy, nebo přechodem na ": "medzi vašimi kolegami alebo prechodom na",
    "min": "min",
    "min.": "min.",
    "Min. 1 výkon": "Min. 1 výkon",
    "min/terapie": "min/terapia",
    "Minimální počet objednaných rezervací": "Minimálny počet objednaných rezervácií",
    "Minimální počet rezervací": "Minimálny počet rezervácií",
    "Minimální počet termínů, které musí klient při jedné online rezervaci vybrat. Běžně je nastaveno na 1.": "Minimálny počet termínov, ktoré musí klient pri jednej online rezervácii vybrať. Bežne je nastavené na 1.",
    "Minulý měsíc": "Minulý mesiac",
    "Minulý rok": "Minulý rok",
    "Minulý týden": "Minulý týždeň",
    "minut": "minút",
    "Místnost": "Miestnosť",
    "Místnost bude odstraněna z pracovní doby.": "Miestnosť bude odstránená z pracovnej doby.",
    "Místnost byla úspěšně smazána": "Miestnosť bola úspešne zmazaná",
    "Místnost byla úspěšně upravena": "Miestnosť bola úspešne upravená",
    "Místnost byla úspěšně vytvořena": "Miestnosť bola úspešne vytvorená",
    "mistnosti": "miestnosti",
    "Místnosti": "Miestnosti",
    "MJ": "MJ",
    "Množství": "Množstvo",
    "Modrá": "Modrá",
    "Moduly": "Moduly",
    "Moje profily": "Moje profily",
    "Moje údaje": "Moje údaje",
    "Momentálně využívá": "Momentálne využíva",
    "Možnost dluhu": "Možnosť dlhu",
    "Možnost platit online předem nebo na místě": "Možnosť platiť online vopred alebo na mieste",
    "Mřížka": "Mrížka",
    "Můj tarif": "Môj tarif",
    "Můj tarif, platby za předplatné.": "Môj tarif, platby za predplatné.",
    "Musí být alespoň 1": "Musí byť aspoň 1",
    "Musí být menší než 1000.": "Musí byť väčší než 0.",
    "Musí být větší než 0.": "Musí byť väčší než 0.",
    "Muž": "Muž",
    "Můžete vložit obrázek s vaším razítkem nebo podpisem, který se následně vloží na generované doklady pro pacienty.": "Môžete vložiť obrázok s vašou pečiatkou alebo podpisom, ktorý sa následne vloží na generované doklady pre klientov.",
    "Muži": "Muži",
    "Muži (budoucí)": "Muži (objednaní)",
    "na info@fyzion.cz.": "na  podpora@fyzion.cz.",
    "Nabízené permanentky": "Ponúkané permanentky",
    "Nabízené služby": "Ponúkané služby",
    "Načíst další": "Načítať ďalší",
    "Načíst údaje z ARES": "Načítať údaje z ORSR",
    "Načíst výkony": "Načítať výkony",
    "Nadcházející návštěva": "Nadchádzajúca návšteva",
    "Nadpis bloku": "Nadpis bloku",
    "Náhradník": "Náhradník",
    "Náhradník odebrán": "Náhradník odobratý",
    "Náhradník přidán": "Náhradník pridaný",
    "Náhradníka se nepodařilo odebrat": "Náhradníka sa nepodarilo odobrať",
    "Náhradníka se nepodařilo přidat": "Náhradníka sa nepodarilo pridať",
    "Nahrané dokumenty zde není možné vidět.": "Nahrané dokumenty tu nie je možné vidieť.",
    "Nahrání dat do systému": "Nahranie dát do systému",
    "Nahrání obrázku se nezdařilo": "Nahratie obrázka zlyhalo",
    "Nahrát dávku do Purobota": "Odoslanie dávky do aplikácie Purobot",
    "Nahrát fotku": "Nahrať fotku",
    "Nahrát soubor": "Nahrať súbor",
    "Nahrát soubor typu jpeg nebo png": "Nahrať súbor typu jpeg alebo png",
    "Nahrávání souborů, prosím nezavírejte stránku...": "Nahrávanie súborov, prosím, nezatvárajte stránku...",
    "Nákupní (s DPH)": "Nákupný (s DPH)",
    "Nákupní cena a počet": "Nákupná cena a počet",
    "Nákupní cena s DPH": "Nákupná cena s DPH",
    "Nákupní hodnota (s DPH)": "Nákupná hodnota (s DPH)",
    "Napište nám na email:": "Napíšte nám na email:",
    "Napište poznámku…": "Napíšte poznámku…",
    "Naplánovat změnu ceny od zvoleného data": "Naplánovať zmenu ceny od zvoleného dátumu",
    "Nápověda": "Nápoveda",
    "např. číslo dávky, dokladu, pojištěnce": "napr. číslo dávky, dokladu, poistencov",
    "Např. kód, název zboží": "Napr. kód, názov tovaru",
    "např. název, IČP, telefonní číslo": "napr. názov, IČP, telefónne číslo",
    "např. název, instituce, IČO": "napr. názov, inštitúcia, IČO",
    "např. RČ pacienta, e-mail": "napr. meno, e-mail",
    "Např. RČ pacienta, e-mailová adresa": "Napr. RČ klienta, e-mailová adresa",
    "naší aplikaci či facebookovou skupinu Fyzion na internetu. Za každé takové sdílení Vám zdarma rozšíříme kartotéku o dalších pět pacientů. Jako potvrzení, že jste sdílení provedli, nám prosím zašlete screenshot (fotku obrazovky) sdíleného příspěvku na info@fyzion.cz a uveďte, o jakého fyzioterapeuta se jedná.": "našu aplikáciu alebo facebookovú skupinu Fyzion na internete. Za každé takéto zdieľanie vám bezplatne rozšírime kartotéku o ďalších päť klientov. Ako potvrdenie, že ste zdieľanie vykonali, nám prosím pošlite screenshot (fotku obrazovky) zdieľaného príspevku na podpora@fyzion.cz a uveďte, o akého terapeuta ide.",
    "naskladneni": "naskladnenie",
    "Naskladnění": "Naskladnenie",
    "Naskladnění zboží": "Naskladnenie tovaru",
    "Následující návštěva:": "Nasledujúca návšteva:",
    "Nasmlouvané výkony": "Nasľúbené výkony",
    "nastaveni": "nastavenie",
    "Nastavení": "Nastavenie",
    "Nastavení - Fakturační údaje": "Nastavenie - Fakturačné údaje",
    "NASTAVENÍ - KONTAKTNÍ ÚDAJE.": "NASTAVENIE - KONTAKTNÉ ÚDAJE.",
    "Nastavení hesla": "Nastavenie hesla",
    "Nastavení IČPE": "Nastavenia IČPE",
    "Nastavení nového hesla": "Nastavenie nového hesla",
    "Nastavení platby": "Nastavenie platby",
    "Nastavení předplatného": "Nastavenie predplatného",
    "Nastavení uloženo": "Nastavenie uložené",
    "Nastavit": "Nastaviť",
    "Nastavit heslo": "Nastaviť heslo",
    "Nastavit jako výchozí službu": "Nastaviť ako predvolenú službu",
    "Nastavit přesun podle": "Nastaviť presun podľa",
    "Nastavit text emailu": "Nastaviť text e-mailu",
    "Nastavit text SMS": "Nastaviť text SMS",
    "Nastavit zrušení podle": "Nastaviť zrušenie podľa",
    "Nastavuje počáteční číslo pro faktury": "Nastavuje počiatočné číslo pre faktúry",
    "Nastavuje počáteční číslo pro paragony": "Nastavuje počiatočné číslo pre paragóny",
    "Návod": "Návod",
    "Návrat do aplikace": "Návrat do aplikácie",
    "Návštěv na stránku": "Návštev na stránku",
    "návštěva": "návšteva",
    "Návštěva": "Návšteva",
    "Návštěva byla označena jako zaplacená": "Návšteva bola označená ako zaplatená",
    "Návštěva byla úspěšně zaplacena": "Návšteva bola úspešne zaplatená",
    "Návštěva je zamknuta": "Návšteva je zamknutá",
    "Návštěva nemůže mít datum po konci platnosti FT poukazu": "Návšteva nemôže mať dátum po konci platnosti FT poukazu",
    "Návštěva nenalezena": "Návšteva klienta",
    "Návštěva obsahuje nahrané formuláře": "Návšteva obsahuje nahrané formuláre",
    "Návštěva obsahuje nahrané fotografie": "Návšteva obsahuje nahrané fotografie",
    "Návštěva odemknuta": "Návšteva odemknutá",
    "Návštěva pacienta": "Návšteva klienta",
    "Návštěva smazána": "Návšteva zmazaná",
    "Návštěva úspěšně přidána": "Návšteva úspešne pridaná",
    "Návštěva zamknuta": "Návšteva zamknutá",
    "Návštěvu se nepodařilo uložit": "Návštevu sa nepodarilo uložiť",
    "Návštěvu se nepodařilo uložit! Zkuste to prosím znovu.": "Poznámku sa nepodarilo uložiť. Skúste to prosím znovu.",
    "navstevy": "navstevy",
    "Návštěvy": "Návštevy",
    "návštěvy pacientů": "návštevy klientov",
    "Návštěvy pacientů": "Návštevy klientov",
    "Návštěvy podle fyzioterapeutů": "Návštevy podľa terapeutov",
    "návštěvy vloží do správné karty.": "návštevy vloží do správnej karty.",
    "navstevy-pacienta": "navstevy-klienta",
    "Název": "Názov",
    "Název cviku": "Názov cviku",
    "Název firmy": "Názov spoločnosti",
    "Název instituce": "Názov inštitúcie",
    "Název kategorie": "Názov kategórie",
    "Název kliniky": "Názov kliniky",
    "Název místnosti": "Názov miestnosti",
    "Název permanentky": "Názov permanentky",
    "Název pobočky": "Názov pobočky",
    "Název podkategorie": "Názov podkategórie",
    "Název pojišťovny": "Názov poisťovne",
    "Název pracoviště": "Názov pracoviska",
    "Název předplatného": "Názov predplatného",
    "Název šablony": "Názov šablóny",
    "Název služby": "Názov služby",
    "Název v angličtině": "Názov v angličtine",
    "Název v češtině": "Názov v češtine",
    "Název v polštině": "Názov v poľštine",
    "Název ve slovenštině": "Názov v slovenčine",
    "Název zboží": "Názov tovaru",
    "Ne": "Nie",
    "nebo": "alebo",
    "nebo přechodem na pokročilý tarif. ": "alebo prechodom na pokročilý tarif. ",
    "Nebyly nalezeny žádné recenze.": "Neboli nájdené žiadne recenzie.",
    "Něco se pokazilo": "Niečo sa pokazilo",
    "Neděle": "Nedeľa",
    "Nedorazil:": "Nedorazil:",
    "Nejčastější sady výkonů můžete definovat v sekci POJIŠŤOVNY → ŠABLONY.": "Najčastejšie sady výkonov môžete definovať v sekcii POISŤOVNE → ŠABLÓNY.",
    "Nejméně 8 znaků a alespoň 1 malé písmeno": "Najmenej 8 znakov a aspoň 1 malé písmeno",
    "Nejprve vyberte návštěvy k zaplacení": "Najskôr vyberte návštevy na zaplatenie",
    "Nejprve vyberte šablonu výkonů": "Najskôr vyberte šablónu výkonov",
    "Nejsou dostupné žádné místnosti": "Nie sú dostupné žiadne miestnosti",
    "Nejsou dostupné žádné pobočky": "Nie sú dostupné žiadne pobočky",
    "Nejsou dostupné žádné předplatné": "Nie sú dostupné žiadne predplatné",
    "Nejsou dostupné žádné transakce": "Nie sú dostupné žiadne transakcie",
    "Nejsou dostupní žádní uživatelé": "Nie sú dostupní žiadni používatelia",
    "Nejsou dostupní žádní žadatelé": "Nie sú dostupní žiadni žiadatelia",
    "Nejsou k dispozici žádná data": "Nie sú k dispozícii žiadne údaje",
    "Nejsou k dispozici žádné fotografie": "Nie sú k dispozícii žiadne fotografie",
    "Některé funkce aplikace Fyzion vám": "Nektoré funkcie aplikacie Fyzion vám",
    "Některé z povinných údajů chybí": "Niektoré z povinných údajov chýbajú",
    "Nelze odebrat zamčený výkon": "Nenájdený žiaden doklad",
    "Nelze přesunout volno k jinému fyzioterapeutovi.": "Nemožno presunúť voľno k inému terapeutovi.",
    "Nelze smazat - zboží je na skladě.": "Nemožno zmazať - tovar je na sklade.",
    "Nelze vytvořit kontrolní spis: Chybí ID pacienta v M-Spisech": "Nie je možné vytvoriť kontrolný spis: Chýba ID klienta v M-Spisoch",
    "Nelze vytvořit kontrolní spis: doplňte rodné číslo k pacientovi": "Nie je možné vytvoriť kontrolný spis: doplňte rodné číslo ku klientovi",
    "Nelze vytvořit nový spis: Chybí ID pacienta v M-Spisech": "Nie je možné vytvoriť nový spis: Chýba ID klienta v M-Spisoch",
    "Nelze vytvořit nový spis: doplňte rodné číslo k pacientovi": "Nie je možné vytvoriť nový spis: doplňte rodné číslo ku klientovi",
    "Nemají tel.": "Nemajú tel.",
    "Nemáte dostatečné oprávnění pro tuto akci.": "Nemáte dostatočné oprávnenie pre túto akciu.",
    "Nemáte oprávnění na smazání cizí návštěvy": "Nemáte oprávnenie na zmazanie cudzej návštevy",
    "Nemáte oprávnění na smazání návštěvy": "Nemáte oprávnenie na zmazanie návštevy",
    "Nemáte oprávnění na úpravu jiného fyzioterapeuta": "Nemáte oprávnenie na úpravu iného terapeuta",
    "Nemáte oprávnění na úpravu jiných ordinačních hodin": "Nemáte oprávnenie na úpravu iné pracovné doby",
    "Nemáte oprávnění na úpravu permanentky": "Nemáte oprávnenie na úpravu permanentky",
    "Nemáte oprávnění na úpravu služby": "Nemáte oprávnenie na úpravu služby",
    "Nemáte oprávnění na zaplacení cizí návštěvy": "Nemáte oprávnenie na zaplatenie cudzej návštevy",
    "Nemáte oprávnění na zrušení cizí návštěvy": "Nemáte oprávnenie na zrušenie cudzej návštevy",
    "Nemáte oprávnění pro odemknutí výkonu": "Nemáte oprávnenie pre odomknutie výkonu",
    "Nemáte oprávnění prohlížet anamnézu pacienta": "Nemáte oprávnenie prezerať anamnézu klienta.",
    "Nemáte vytvořenou smlouvu s touto pojišťovnou. Pro tuto pojišťovnu se dávka nevytvoří.": "Nemáte vytvorenú zmluvu s touto poisťovňou. Pre túto poisťovňu sa dávka nevytvorí.",
    "Nemáte žádné objednané návštěvy.": "Nemáte žiadne objednané návštevy.",
    "nemusí správně fungovat.": "nemusí správne fungovať.",
    "Nemůže být záporné": "Nemôže byť záporné",
    "Nenalezen žádný dodavatel": "Nenájdený žiaden dodávateľ",
    "Nenalezen žádný doklad": "Nenájdený žiaden doklad",
    "Nenalezen žádný FT poukaz pro načtení výkonů": "Nenájdený žiadny FT poukaz pre načítanie výkonov",
    "Nenalezen žádný klient": "Nenájdený žiadny klient",
    "Nenalezen žádný pacient": "Nenájdený žiaden klient",
    "Nenalezen žádný výkon": "Nenájdený žiaden doklad",
    "Nenalezen žádný záznam": "Nenájdený žiadny záznam",
    "Nenalezena shoda se jménem žádného cviku.": "Nenašla sa zhoda s menom žiadneho cviku.",
    "Nenalezena žádná akce": "Nenájdená žiadna akcia",
    "Nenalezena žádná dávka": "Nenájdená žiadna dávka",
    "Nenalezena žádná návštěva": "Nenájdená žiadna návšteva",
    "Nenalezena žádná pracoviště": "Nenájdená žiadna pracoviská",
    "Nenalezena žádná šablona": "Nenájdená žiadna šablóna",
    "Nenalezena žádná stvrzenka": "Nenájdená žiadna potvrdenka",
    "Nenalezena žádná zpráva": "Nenájdená žiadna správa",
    "Nenalezeno žádné další zboží": "Nenájdené žiadne ďalšie tovar",
    "Nenalezeny žádná výkony": "Nenájdené žiadne výkony",
    "Nenalezeny žádné další služby": "Nenájdené žiadne ďalšie služby",
    "Nenalezeny žádné položky": "Nenájdené žiadne položky",
    "Nenalezeny žádné zásoby": "Nenájdené žiadne zásoby",
    "Není dostupná žádná šablona výkonů": "Nie je dostupná žiadna šablóna výkonov",
    "Není dostupný žádný platný FT poukaz": "Nie sú dostupné žiadne predplatné",
    "Není dostupný žádný výkon": "Není dostupný výkon",
    "Není možné změnit tarif, protože máte v kartotéce více pacientů,": "Není možné zmeniť tarif, pretože máte v kartotéke viac klientov,",
    "Není nahrána žádná fotka": "Nie je nahraná žiadna fotka",
    "Není naplánována další návštěva": "Nie je naplánovaná ďalšia návšteva",
    "Neočekávaná chyba": "Neočakávaná chyba",
    "Neomezený počet pacientů": "Neobmedzený počet klientov",
    "Neopakuje se": "Neopakuje sa",
    "Neplátce DPH": "Neplatiteľ DPH",
    "Nepodařilo se aktualizovat cviky v návštěvě": "Nepodarilo sa aktualizovať cviky v návšteve",
    "Nepodařilo se aktualizovat den se cvičením": "Nepodarilo sa aktualizovať deň so cvičením",
    "Nepodařilo se aktualizovat šablonu": "Nepodarilo sa aktualizovať šablónu.",
    "Nepodařilo se načíst AI shrnutí": "Nepodarilo sa načítať AI zhrnutie",
    "Nepodařilo se načíst AI shrnutí.": "Nepodarilo sa načítať AI zhrnutie.",
    "Nepodařilo se načíst budoucí návštěvy.": "Nepodarilo sa načítať budúce návštevy.",
    "Nepodařilo se načíst celkové hodnoty naskladněných položek": "Nepodarilo sa načítať celkové hodnoty naskladnených položiek",
    "Nepodařilo se načíst cesty za pacientem": "Nepodarilo sa načítať cesty za klientom",
    "Nepodařilo se načíst cviky": "Nepodarilo sa načítať cviky",
    "Nepodařilo se načíst data": "Nepodarilo sa načítať dáta",
    "Nepodařilo se načíst data ze systému": "Nepodarilo sa načítať dáta zo systému",
    "Nepodařilo se načíst dávku": "Nepodarilo sa načítať dávku",
    "Nepodařilo se načíst dávky": "Nepodarilo sa načítať dávky",
    "Nepodařilo se načíst detail poukazu": "Nepodarilo sa načítať detail poukazu",
    "Nepodařilo se načíst diagnózy": "Nepodarilo sa načítať diagnózy",
    "Nepodařilo se načíst dodavatele": "Nepodarilo sa načítať dodávateľa",
    "Nepodařilo se načíst dostupné fyzioterapeuty": "Nepodarilo sa načítať dostupných terapeutov",
    "Nepodařilo se načíst druhy péče": "Nepodarilo sa načítať druhy starostlivosti",
    "Nepodařilo se načíst FT poukazy": "Nepodarilo sa načítať FT poukazy",
    "Nepodařilo se načíst hromadnou návštěvu": "Nepodarilo sa načítať hromadnú návštevu",
    "Nepodařilo se načíst kategorie cviků": "Nepodarilo sa načítať kategórie cvikov",
    "Nepodařilo se načíst kategorii cviků": "Nepodarilo sa načítať kategóriu cvikov",
    "Nepodařilo se načíst místnost": "Nepodarilo sa načítať miestnosť",
    "Nepodařilo se načíst místnosti": "Nepodarilo sa načítať miestnosti",
    "Nepodařilo se načíst návrh platby": "Nepodarilo sa načítať návrh platby",
    "Nepodařilo se načíst návštěvu pacienta": "Nepodarilo sa načítať návštevu klienta",
    "Nepodařilo se načíst návštěvy pacienta": "Nepodarilo sa načítať návštevy klienta",
    "Nepodařilo se načíst novinku": "Nepodarilo sa načítať novinku",
    "Nepodařilo se načíst novinky": "Nepodarilo sa načítať novinky",
    "Nepodařilo se načíst odbornosti": "Nepodarilo sa načítať odbornosti",
    "Nepodařilo se načíst ordinaci na této adrese": "Nepodarilo sa načítať pracovisko na tejto adrese",
    "Nepodařilo se načíst pacienty": "Nepodarilo sa načítať klientov",
    "Nepodařilo se načíst permanentku": "Nepodarilo sa načítať permanentku",
    "Nepodařilo se načíst permanentky pacienta": "Nepodarilo sa načítať permanentky klienta",
    "Nepodařilo se načíst platbu": "Nepodarilo sa načítať platbu",
    "Nepodařilo se načíst platby": "Nepodarilo sa načítať platby",
    "Nepodařilo se načíst platební údaje": "Nepodarilo sa načítať platobné údaje",
    "Nepodařilo se načíst pojišťovnu": "Nepodarilo sa načítať poisťovňu",
    "Nepodařilo se načíst pojišťovny": "Nepodarilo sa načítať poisťovne",
    "Nepodařilo se načíst položku": "Nepodarilo sa načítať položku",
    "Nepodařilo se načíst poukazy": "Nepodarilo sa načítať poukazy",
    "Nepodařilo se načíst pracoviště": "Nepodarilo sa načítať pracovisko",
    "Nepodařilo se načíst předplatné": "Nepodarilo sa načítať predplatné",
    "Nepodařilo se načíst recenze": "Nepodarilo sa načítať recenzie",
    "Nepodařilo se načíst šablonu": "Nepodarilo sa načítať šablónu",
    "Nepodařilo se načíst šablony": "Nepodarilo sa načítať šablóny",
    "Nepodařilo se načíst šablony FT poukazů": "Nepodarilo sa načítať šablóny FT poukazov",
    "Nepodařilo se načíst seznam diagnóz": "Nepodarilo sa načítať diagnózy",
    "Nepodařilo se načíst seznam návštěv.": "Nepodarilo sa načítať zoznam návštev.",
    "Nepodařilo se načíst seznam uživatelů": "Nepodarilo sa načítať zoznam užívateľov",
    "Nepodařilo se načíst skupiny služeb": "Nepodarilo sa načítať skupiny služieb",
    "Nepodařilo se načíst služby": "Nepodarilo sa načítať služby",
    "Nepodařilo se načíst transakce": "Nepodarilo sa načítať transakcie",
    "Nepodařilo se načíst transakci": "Nepodarilo sa načítať transakciu",
    "Nepodařilo se načíst volné termíny": "Nepodarilo sa načítať voľné termíny",
    "Nepodařilo se načíst výkony": "Nepodarilo sa načítať výkony",
    "Nepodařilo se načíst žadatele": "Nepodarilo sa načítať žiadateľa",
    "Nepodařilo se načíst zaměstnance": "Nepodarilo sa načítať zamestnancov",
    "Nepodařilo se načíst zásoby": "Nepodarilo sa načítať zásoby",
    "Nepodařilo se načíst země": "Nepodarilo sa načítať krajiny",
    "Nepodařilo se načíst zemi": "Nepodarilo sa načítať krajinu.",
    "Nepodařilo se nahrát dávku do Purobota": "Nepodarilo sa nahrať dávku do aplikácie Purobot",
    "Nepodařilo se nahrát fotku FT poukazu": "Nepodarilo sa nahrávať fotku FT poukazu",
    "Nepodařilo se nahrát soubor": "Nepodarilo sa nahrať súbor",
    "Nepodařilo se odebrat štítek": "Nepodarilo sa odobrať štítok",
    "Nepodařilo se odemknout výkon": "Nepodarilo sa odomknúť výkon.",
    "Nepodařilo se odeslat recenzi. Zkuste to prosím znovu.": "Nepodarilo sa odoslať recenziu. Skúste to prosím znova.",
    "Nepodařilo se označit fakturu jako zaplacenou": "Nepodarilo sa označiť faktúru ako zaplatenú",
    "Nepodařilo se přidat fakturaci": "Nepodarilo sa pridať fakturáciu",
    "Nepodařilo se přidat předplatné": "Nepodarilo sa pridať predplatné",
    "Nepodařilo se smazat cvik": "Nepodarilo sa zmazať cvik",
    "Nepodařilo se smazat místnost": "Nepodarilo sa zmazať miestnosť",
    "Nepodařilo se smazat platbu": "Nepodarilo sa zmazať platbu",
    "Nepodařilo se smazat pojišťovnu": "Nepodarilo sa zmazať poisťovňu",
    "Nepodařilo se smazat pracoviště": "Nepodarilo sa zmazať pracovisko",
    "Nepodařilo se smazat předplatné": "Nepodarilo sa zmazať predplatné",
    "Nepodařilo se smazat recenzi": "Nepodarilo sa zmazať recenziu",
    "Nepodařilo se smazat šablonu": "Nepodarilo sa vymazať šablónu.",
    "Nepodařilo se smazat štítek": "Nepodarilo sa zmazať štítok",
    "Nepodařilo se spustit platbu. Zkuste to prosím znovu.": "Nepodarilo sa spustiť platbu. Skúste to prosím znova.",
    "Nepodařilo se uložit pracoviště žadatele": "Nepodarilo sa uložiť pracovisko žiadateľa",
    "Nepodařilo se upravit cvik.": "Nepodarilo sa upraviť cvik.",
    "Nepodařilo se upravit dostupnost": "Nepodarilo sa upraviť dostupnosť.",
    "Nepodařilo se upravit fakturaci": "Nepodarilo sa upraviť fakturáciu",
    "Nepodařilo se upravit místnost": "Nepodarilo sa upraviť miestnosť.",
    "Nepodařilo se upravit platbu": "Nepodarilo sa upraviť platbu",
    "Nepodařilo se upravit pobočku": "Nepodarilo sa upraviť pobočku",
    "Nepodařilo se upravit předplatné": "Nepodarilo sa upraviť predplatné",
    "Nepodařilo se vygenerovat export": "Nepodarilo sa vygenerovať export",
    "Nepodařilo se vygenerovat fakturu": "Nepodarilo sa vygenerovať faktúru",
    "Nepodařilo se vygenerovat platební odkaz": "Nepodarilo sa vygenerovať platobný odkaz",
    "Nepodařilo se vygenerovat zprávu": "Nepodarilo sa vygenerovať správu",
    "Nepodařilo se vylepšit popis návštěvy": "Nepodarilo sa vylepšiť popis návštevy",
    "Nepodařilo se vytvořit cvik.": "Nepodarilo sa vytvoriť cvik.",
    "Nepodařilo se vytvořit dodavatele": "Nepodarilo sa vytvoriť dodávateľa",
    "Nepodařilo se vytvořit hromadnou návštěvu": "Nepodarilo sa vytvoriť hromadnú návštevu",
    "Nepodařilo se vytvořit kategorii.": "Nepodarilo sa vytvoriť kategóriu.",
    "Nepodařilo se vytvořit místnost": "Nepodarilo sa vytvoriť miestnosť",
    "Nepodařilo se vytvořit platbu": "Nepodarilo sa vytvoriť platbu",
    "Nepodařilo se vytvořit pracoviště žadatele": "Nepodarilo sa vytvoriť pracovisko žiadateľa",
    "Nepodařilo se vytvořit registraci jako náhradník": "Nepodarilo sa vytvoriť registráciu ako náhradník",
    "Nepodařilo se vytvořit šablonu": "Nepodarilo sa vytvoriť šablónu.",
    "Nepodařilo se vytvořit štítek": "Nepodarilo sa vytvoriť štítok",
    "Nepodařilo se vytvořit uživatele": "Nepodarilo sa vytvoriť užívateľa",
    "Nepodařilo se zaplatit návštěvu": "Nepodarilo sa zaplatiť návštevu",
    "Nepodařilo se získat cviky pacienta": "Nepodarilo sa získať cviky klienta.",
    "Nepodařilo se změnit nastavení rezervací pacienta": "Nepodarilo sa zmeniť nastavenie rezervácií klienta.",
    "Nepodařilo se zrušit platbu": "Nepodarilo sa zrušiť platbu",
    "Nepodařilo se zrušit platbu za návštěvu": "Nepodarilo sa zrušiť platbu za návštevu",
    "Nepodporovaný typ prohlížeče": "Nepodporovaný typ prehliadača",
    "nepodporovaný typ prohlížeče.": "nepodporovaný typ prehliadača.",
    "Nepovinné": "Nepovinné",
    "Nepravidelné ordinační hodiny": "Nepravidelná pracovná doba",
    "Nepřišel": "Neprišiel",
    "Nesouhlasili": "Nesúhlasili",
    "Neuhrazená objednávka": "Neuhradená objednávka",
    "Neuhrazeno": "Nezaplatené",
    "Neukládat": "Neukladať",
    "Nevíte jak na to? Podívejte se na náš návod, přihlašte se na webinář nebo kontaktujte podporu.": "Neviete ako na to? Pozrite sa na náš návod, prihláste sa na webinár alebo kontaktujte podporu.",
    "Nevystaveno": "Nevystavené",
    "Nezaplaceno": "Nezaplatene",
    "notifikace": "notifikácie",
    "Notifikace": "Notifikácie",
    "Notifikace ordinaci": "Notifikácie ordinácie",
    "nova": "nova",
    "Nová cena": "Nová cena",
    "Nová cena s DPH": "Nová cena s DPH",
    "Nová cena se použije pro návštěvy od zvoleného data. Do té doby platí současná cena služby. Vypnutím naplánovanou změnu zrušíte.": "Nová cena sa použije pre návštevy od zvoleného dátumu. Dovtedy platí súčasná cena služby. Vypnutím naplánovanú zmenu zrušíte.",
    "Nová fakturace": "Nová fakturácia",
    "Nová místnost": "Nová miestnosť",
    "Nová návštěva": "Nová návšteva",
    "Nová operace": "Nová operácia",
    "Nová šablona": "Nová šablóna",
    "Nová skupinová návštěva": "Nová skupinová návšteva",
    "Nová událost": "Nová udalosť",
    "nova-navsteva": "nova-navsteva",
    "nova-opravna": "nova-opravna",
    "nova-skupinova-navsteva": "nova-skupinova-navsteva",
    "nove": "nove",
    "Nové heslo": "Nové heslo",
    "Nové pracoviště žadatele": "Nové pracovisko žiadateľa",
    "Nové předplatné": "Nové predplatné",
    "Novinky": "Novinky",
    "novy": "novy",
    "Nový pacient": "Nový klient",
    "Nový spis": "Nový spis",
    "Nový žadatel": "Nový žiadateľ",
    "novy-ft-poukaz": "novy-ft-poukaz",
    "O nás": "O nás",
    "Období": "Obdobie",
    "obecne": "obecne",
    "Obecné": "Všeobecné",
    "obecného nastavení firmy": "všeobecného nastavenia firmy",
    "obecném nastavení": "všeobecnom nastavení",
    "Objednat návštěvu": "Objednať návštevu",
    "Objednat se na": "Objednať sa na",
    "Objekt": "Objekt",
    "Obměna": "Obmena",
    "obnova-hesla": "obnova-hesla",
    "Obnovit tabulku": "Obnoviť tabuľku",
    "Obrázek byl smazán": "Obrázok bol odstránený",
    "Obrázky": "Obrázky",
    "Obsah": "Obsah",
    "Ochrana osobních údajů": "Ochrana osobných údajov",
    "Od": "Od",
    "Odběratel/klient": "Odberateľ/klient",
    "Odběratel/Klient": "Odberateľ/Klient",
    "Odbornost": "Odbornost",
    "Odcvičeno a přejít na další cvik": "Odcvičené a prejsť na ďalší cvik",
    "Odebrat": "Odebrat",
    "Odebrat náhradníka": "Odobrať náhradníka",
    "Odebrat pacienta": "Odobrať klienta",
    "Odebrat položku": "Odebrat položku",
    "Odebrat výkon": "Odebrat výkon",
    "Odebrat z čekajících": "Odobrať z čakajúcich",
    "Odebrat zastávku na cestě": "Odobrať zastávku na ceste",
    "Odemknout": "Odomknúť",
    "Odemknout výkon": "Odomknúť výkon",
    "Odesílat email": "Odosielať email",
    "Odesílat email připomínku před návštěvou": "Odosielať e-mail s pripomienkou pred návštevou",
    "Odesílat připomínku e-mailem": "Odosielať pripomienku e-mailom",
    "Odesílat SMS": "Odosielať SMS",
    "Odesílat SMS předem": "Odosielať SMS vopred",
    "Odesílat SMS připomínku před návštěvou": "Odosielať SMS pripomienku pred návštevou",
    "Odesílat stvrzenky klientům": "Odosielať potvrdenia klientom",
    "Odesílat upozornění e-mailem o vytvoření, změně, zrušení návštěvy": "Odosielať upozornenie e-mailom o vytvorení, zmene, zrušení návštevy",
    "Odesílat žádost o recenzi": "Odosielať žiadosť o recenziu",
    "Odeslali jsme vám e-mail s instrukcemi k resetování hesla.": "Odoslali sme vám e-mail s instrukciami k resetnutiu hesla.",
    "Odeslané zprávy": "Odoslané správy",
    "Odeslání dávek s přihlášením pomocí SMS kódu v tuto chvíli není podporované.": "Odoslanie dávok s prihlásením pomocou SMS kódu v súčasnosti nie je podporované.",
    "Odeslání dávky pojišťovně selhalo": "Odoslanie dávky poisťovni zlyhalo",
    "Odeslání emailu": "Odoslanie emailu",
    "Odeslání emailu 1 pacientovi": "Odoslanie emailu 1 klientovi",
    "Odeslání emailu pacientovi": "Odoslanie emailu klientovi",
    "Odeslání SMS": "Odoslanie SMS",
    "Odeslání SMS 1 pacientovi": "Odoslanie SMS 1 klientovi",
    "Odeslání SMS pacientovi": "Odoslanie SMS klientovi",
    "Odeslání zůstalo nedokončené": "Odoslanie zostalo nedokončené",
    "Odesláno": "Odoslano",
    "Odesláno na ": "Odoslano na",
    "Odeslat": "Odoslať",
    "Odeslat 1 stvrzenku": "Odoslať 1 potvrdenku",
    "Odeslat email": "Odoslať email",
    "Odeslat GDPR mailem": "Odoslať GDPR mailom",
    "Odeslat klientovi": "Odoslať klientovi",
    "Odeslat pacientovi": "Odoslať klientovi",
    "Odeslat potvrzení o platbě": "Odoslať potvrdenie o platbe",
    "Odeslat pouze zvoleným klientům.": "Odoslať len zvoleným klientom.",
    "Odeslat připomínku platby (před návštěvou)": "Odoslať pripomienku platby (pred návštevou)",
    "Odeslat SMS": "Odoslať SMS",
    "Odeslat SMS pomocí telefonu": "Odoslať SMS pomocou telefónu",
    "Odeslat soubory": "Odoslať súbory",
    "Odeslat znovu emailem": "Odoslať emailom",
    "odešlete": "odešlite",
    "Odhlásit": "Odhlásiť",
    "Odkaz na formulář pro rezervaci čekajících pacientů": "Odkaz na formulár pre rezerváciu čakajúcich klientov",
    "Odkaz na kalendář s přehledem vámi nabízených skupinových lekcí": "Odkaz na kalendár s prehľadom vami ponúkaných skupinových lekcií",
    "Odkaz na přístup do klientské sekce": "Odkaz na prístup do klientskej sekcie",
    "Odkaz na rezervaci byl zkopírován do schránky": "Odkaz na rezerváciu bol skopírovaný do schránky.",
    "Odkaz na váš online rezervační systém": "Odkaz na váš online rezervačný systém",
    "Odkaz na vaší stránku ordinace obsahující rozcestník služeb, recenze, ordinační dobu i kontaktní údaje": "Odkaz na vašu stránku ordinácie obsahujúcu rozcestník služieb, recenzie, ordinačné hodiny aj kontaktné údaje",
    "Odkud jste se o nás dozvěděli?": "Odkiaľ ste sa o nás dozvedeli?",
    "Odpovědi posílat na email": "Odpovede posielať na e-mail",
    "Odstranit časový interval": "Odstrániť časový interval",
    "Ohodnoťte kvalitu naší služby": "Ohodnoťte kvalitu našej služby",
    "Omezuje počet rezervací této služby na jeden den. Vhodné pro časově nebo fyzicky náročné služby.": "Obmedzuje počet rezervácií tejto služby na jeden deň. Vhodné pre časovo alebo fyzicky náročné služby.",
    "Omlouváme se, ale v aplikaci Fyzion došlo k nečekané chybě. Někdy i ty nejlepší svaly potřebují chvilku na odpočinek.": "Ospravedlňujeme sa, ale v aplikácii Fyzion došlo k neočakávanej chybe. Niekedy aj tie najlepšie svaly potrebujú chvíľku na oddych.",
    "Online platba": "Fyzion platby",
    "Online rezervace": "Online rezervácie",
    "Opakování": "Opakovanie",
    "Opakovat heslo": "Opakovať heslo",
    "Opakovat jednou za": "Opakovať jednou za",
    "Opravdu si přejete archivovat pacienta?": "Naozaj si prajete archivovať klienta?",
    "Opravdu si přejete dokument smazat?": "Naozaj si prajete dokument zmazať?",
    "Opravdu si přejete formulář smazat?": "Naozaj si prajete formulár zmazať?",
    "Opravdu si přejete fotografii smazat?": "Naozaj si prajete fotografiu zmazať?",
    "Opravdu si přejete FT poukaz smazat?": "Naozaj si prajete FT poukaz zmazať?",
    "Opravdu si přejete místnost smazat?": "Naozaj si prajete miestnosť zmazať?",
    "Opravdu si přejete náhradníka odebrat?": "Naozaj si prajete náhradníka odobrať?",
    "Opravdu si přejete obrázek smazat?": "Naozaj si prajete obrázok vymazať?",
    "Opravdu si přejete pacienta odebrat?": "Naozaj si prajete klienta odobrať?",
    "Opravdu si přejete permanentku smazat?": "Naozaj si prajete permanentku zmazať?",
    "Opravdu si přejete platbu zrušit?": "Naozaj si prajete platbu zrušiť?",
    "Opravdu si přejete pobočku smazat?": "Naozaj si prajete pobočku zmazať?",
    "Opravdu si přejete pojišťovnu smazat?": "Naozaj si prajete poisťovňu zmazať?",
    "Opravdu si přejete poukaz smazat?": "Naozaj si prajete poukaz zmazať?",
    "Opravdu si přejete pracoviště smazat?": "Naozaj si prajete pracovisko zmazať?",
    "Opravdu si přejete recenzi smazat?": "Naozaj si prajete recenziu zmazať?",
    "Opravdu si přejete rezervaci zrušit?": "Naozaj si prajete rezerváciu zrušiť?",
    "Opravdu si přejete šablonu smazat?": "Naozaj si prajete šablónu zmazať?",
    "Opravdu si přejete smazat cvik": "Naozaj si prajete odstrániť cvik",
    "Opravdu si přejete smazat kategorii cviků?": "Naozaj si prajete zmazať kategóriu cvikov?",
    "Opravdu si přejete smazat kategorii služeb": "Naozaj si prajete zmazať kategóriu služieb",
    "Opravdu si přejete smazat platbu č.": "Naozaj si prajete zmazať platbu č.",
    "Opravdu si přejete smazat předplatné": "Naozaj si prajete odstrániť predplatné",
    "Opravdu si přejete smazat službu": "Naozaj si prajete zmazať službu",
    "Opravdu si přejete stornovat stvrzenku?": "Naozaj si prajete stornovať potvrdenku?",
    "Opravdu si přejete synchronizaci odebrat?": "Naozaj si prajete synchronizáciu odstrániť?",
    "Opravdu si přejete terapeuta deaktivovat?": "Naozaj si prajete terapeuta deaktivovať?",
    "Opravdu si přejete video smazat?": "Naozaj si prajete video vymazať?",
    "Opravdu si přejete volno smazat?": "Naozaj si prajete voľno vymazať?",
    "Opravdu si přejete zboží smazat?": "Naozaj si prajete tovar vymazať?",
    "Opravná": "Opravná",
    "Opravná dávka": "Opravná dávka",
    "Opustit průvodce": "Opustiť sprievodcu",
    "Ordinace": "Pracovisko",
    "ordinační hodiny": "pracovná doba",
    "Ordinační hodiny": "Ordinačné hodiny",
    "Origin:": "Pôvod:",
    "Osobní údaje": "Osobné údaje",
    "Osobní údaje, přihlašovací údaje, propojení s GC.": "Osobné údaje, prihlasovacie údaje, prepojenie s GC.",
    "Ostatní diagnózy": "Ostatné diagnózy",
    "Ostatní služby": "Ostatné služby",
    "Otevírací doba": "Otváracie hodiny",
    "Otevřeno": "Otvorené",
    "Otevřít": "Otvoriť",
    "Otevřít nápovědu": "Otvoriť nápovedu",
    "Otevřít návštěvu": "Otvoriť návštevu",
    "Otevřít v novém okně": "Otvoriť v novom okne",
    "Ověření": "Overenie",
    "Označeno:": "Označené:",
    "Označit jako zaplacené": "Označiť ako zaplatené",
    "Pacient": "Klient",
    "Pacient byl archivován. Jestliže chcete jeho kartu obnovit, kontaktujte podporu": "Klient bol archivovaný. Ak chcete jeho kartu obnoviť, kontaktujte podporu",
    "Pacient byl úspěšně přidán": "Klient bol úspešne pridaný",
    "Pacient ještě nepotvrdil GDPR": "Klient ešte nepotvrdil GDPR",
    "Pacient již GDPR potvrdil": "Klient už GDPR potvrdil",
    "Pacient má platný FT poukaz do %{date}.": "Klient má platný FT poukaz do %{date}.",
    "Pacient nemá nastavenou příští návštěvu": "Klient nemá nastavenú nasledujúcu návštevu",
    "Pacient odebrán": "Klient odobraný",
    "Pacient odhlášen z odběru novinek": "Klient odhlásený z odberu noviniek",
    "Pacient přídán": "Klient pridaný",
    "Pacient přihlášen k odběru novinek": "Klient prihlásený k odberu noviniek",
    "Pacient úspěšně archivován": "Klient úspešne archivovaný",
    "Pacient úspěšně odebrán z čekajících pacientů": "Klient úspešne odobraný z čakajúcich klientov",
    "Pacient úspěšně přidán do čekajících pacientů": "Klient úspešne pridaný do čakajúcich klientov",
    "Pacient úspěšně upraven": "Klient úspešne upravený",
    "Pacient zde zatím nemá žádnou návštěvu a k ní vytvořené popisy.": "Klient tu zatiaľ nemá žiadnu návštevu a k nej vytvorené popisy.",
    "Pacienta se nepodařilo archivovat": "Klienta sa nepodarilo archivovať",
    "Pacienta se nepodařilo odebrat": "Klienta sa nepodarilo odobrať",
    "Pacienta se nepodařilo přidat do čekajících pacientů. Zkuste prosím znovu.": "Klienta sa nepodarilo pridať do čakajúcich klientov. Skúste prosím znovu.",
    "Pacienta se nepodařilo přihlásit k odběru novinek. Zkuste to prosím znovu.": "Klienta sa nepodarilo prihlásiť k odberu noviniek. Skúste to prosím znovu.",
    "Pacienti": "Klienti",
    "Pacienti úspěšně odebráni z čekajících pacientů": "Klienti úspešne odobratí z čakajúcich klientov",
    "Pacienti, kteří přišli poprvé": "Klienti, ktorí prišli po prvýkrát",
    "Pacientovi pošleme potvrzení o platbě na jeho email": "Klientovi pošleme potvrdenie o platbe na jeho email",
    "Pacientů na stránku": "Klientov na stránku",
    "pacientům": "klientom",
    "Paragon": "Paragon",
    "paragon č.": "paragon č.",
    "Paragony": "Paragony",
    "Parametry příští návštěvy upraveny": "Parametre nasledujúcej návštevy upravené",
    "Pátek": "Piatok",
    "Patička faktury": "Pätička faktúry",
    "Paušální": "Paušálny",
    "PDF": "PDF",
    "PDF se nepodařilo vygenerovat. Zkuste to prosím znovu.": "PDF sa nepodarilo vygenerovať. Skúste to prosím znova.",
    "Permanentka aktualizována": "Permanentka aktualizovaná",
    "Permanentka byla označena jako zaplacená": "Permanentka bola označená ako zaplatená",
    "Permanentka umožňuje nastavit předplacené návštěvy na vybrané služby. Klientovi ji lze přiřadit v jeho kartě a při platbě využít. V kartě klienta uvidíte i počet zbývajících předplacených návštěv.": "Permanentky: Umožňujú nastaviť predplatené návštevy na vybrané služby. Permanentku môžete klientovi priradiť v jeho karte a použiť ju pri platbe. V karte klienta vidíte aj počet zostávajúcich predplatených návštev.",
    "Permanentka úspěšně odebrána pacientovi.": "Permanentka úspešne odobraná klientovi.",
    "Permanentka úspěšně přidána pacientovi.": "Permanentka úspešne pridaná klientovi.",
    "Permanentka úspěšně vytvořena": "Permanentka úspešne vytvorená",
    "Permanentkou": "Permanentkou",
    "Permanentku se nepodařilo pacientovi odebrat. Zkuste prosím znovu.": "Permanentku sa nepodarilo klientovi odobrať. Skúste prosím znovu.",
    "Permanentku se nepodařilo pacientovi přidat. Zkuste prosím znovu.": "Permanentku sa nepodarilo klientovi pridať. Skúste prosím znovu.",
    "Permanentku se nepodařilo upravit.": "Permanentku sa nepodarilo upraviť.",
    "Permanentku se nepodařilo vytvořit": "Nepodarilo sa vytvoriť permanentku",
    "Permanentky": "Permanentky",
    "PL": "PL",
    "planovani": "planovanie",
    "Plánování": "Plánovanie",
    "planovani-mistnosti": "planovanie-miestnosti",
    "Platba": "Platba",
    "Platba byla smazána": "Platba bola zmazaná",
    "Platba byla zrušena": "Platba bola zrušená",
    "Platba pouze na místě při terapii": "Platba iba na mieste pri terapii",
    "Platba předem": "Platba vopred",
    "Platba předplatným": "Platba predplatným",
    "Platba za návštěvu byla úspěšně zrušena": "Platba za návštevu bola úspešne zrušená",
    "platby": "platby",
    "Platby": "Platby",
    "Platby za předplatné": "Platby za predplatné",
    "Platby za pronájem aplikace": "Úhrady za prenájom aplikácie",
    "Plátce DPH": "Platiteľ DPH",
    "Plateb na stránku": "Úhrady na stránku",
    "Platební brána": "Platobná brána",
    "Platební brána byla úspěšně nastavena": "Platobná brána bola úspešne nastavená",
    "Platební brána Comgate": "Platobná brána Comgate",
    "Platební brána Fyzion": "Platobná brána Fyzion",
    "Platební brána se používá jen v případě, že jsou u služby zapnuté platby předem.": "Platobná brána sa používa len v prípade, že sú pri službe zapnuté platby vopred.",
    "Platební informace": "Platebné informácie",
    "Platná do:": "Platnosť do:",
    "Platnost (v měsících)": "Platnosť (v mesiacoch)",
    "Platnost do": "Platnosť do",
    "Platnost musí být větší nebo rovna 1.": "Platnosť musí byť väčšia alebo rovná 1.",
    "Platnost nové ceny od": "Platnosť novej ceny od",
    "Platnost vašeho odkazu vypršela. Zažádejte si o nastavení nového hesla": "Platnosť vášho odkazu vypršala. Požiadajte si o nastavenie nového hesla",
    "Po": "Po",
    "Po rezervaci budete přesměrování na platební bránu pro uhrazení ceny terapie.": "Po rezervácii budete presmerovaní na platobnú bránu na úhradu ceny terapie.",
    "Po skončení návštěvy se klientovi automaticky odešle žádost o zpětnou vazbu.": "Po skončení návštevy sa klientovi automaticky odošle žiadosť o spätnú väzbu.",
    "Po sloučení se všechny minulé i budoucí": "Po zlúčení sa všetky minulé i budúce",
    "Po třech dnech": "Po troch dňoch",
    "Po vložení kódu na váš web se zobrazí okno s rezervací": "Po vložení kódu na váš web sa zobrazí okno s rezerváciou",
    "Po vložení kódu na váš web se zobrazí tlačítko s rezervací": "Po vložení kódu na váš web sa zobrazí tlačidlo s rezerváciou",
    "pobočka": "pobočka",
    "Pobočka": "Pobočka",
    "Pobočka byla úspěšně smazána": "Pobočka bola úspešne zmazaná",
    "Pobočka byla úspěšně upravena": "Pobočka bola úspešne upravená",
    "Pobočka byla úspěšně vytvořena": "Pobočka bola úspešne vytvorená",
    "pobocky": "pobocky",
    "Pobočky": "Pobočky",
    "Počet": "Počet",
    "Počet dní do konce:": "Počet dní do konca:",
    "Počet dní před návštěvou se odešle připomínka při nezaplacené rezervaci.": "Počet dní pred návštevou sa odošle pripomienka pri nezaplatenej rezervácii.",
    "Počet návštěv": "Počet návštev",
    "Počet návštěv musí být větší nebo rovno 1.": "Počet návštev musí byť väčší alebo rovný 1.",
    "Počet povolených rezervací je naplněn.": "Počet povolených rezervácií je naplnený.",
    "Počet výkonů": "Počet výkonov",
    "Počet zbývajících vstupů:": "Zostávajúcich vstupov:",
    "Počty návštěv": "Počty návštev",
    "Podání nebylo pojišťovně odesláno. Po smazání můžete dávku upravit a odeslat znovu.": "Podanie nebolo odoslané poisťovni. Po zmazaní môžete dávku upraviť a odoslať znova.",
    "Podepisování tohoto podání zůstalo nedokončené. Dávku podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Podpisovanie tohto podania zostalo nedokončené. Dávku podpíšete v aplikácii Fyzion Signer a Fyzion ju odošle zdravotnej poisťovni.",
    "Podepsat a odeslat": "Podpísať a odoslať",
    "Podívám se později": "Pozriem sa neskôr",
    "Podkategorie": "Podkategórie",
    "Podmínky užití": "Podmienky používania",
    "Podpis": "Podpis",
    "Podpis/razítko firmy": "Podpis/pečiatka firmy",
    "Podpora": "Podpora",
    "podpora@fyzion.cz": "podpora@fyzion.cz.",
    "Podrobnosti": "Podrobnosti",
    "Podrobný popis služby, který se zobrazí klientům při výběru služby v online rezervacích.": "Podrobný popis služby, ktorý sa zobrazí klientom pri výbere služby v online rezerváciách.",
    "Pohlaví": "Pohlavie",
    "Pohlaví:": "Pohlavie:",
    "Pohyb zboží": "Pohyb tovaru",
    "Pojištění EU a mezinárodní smlouvy": "Poistenie EÚ a medzinárodné zmluvy",
    "Pojišťovna": "Poisťovňa",
    "Pojišťovna byla smazána": "Poisťovňa bola zmazaná",
    "Pojišťovna přidána": "Poisťovňa pridaná",
    "Pojišťovna upravena": "Poisťovňa upravená",
    "Pojišťovna:": "Poisťovňa:",
    "Pojišťovnou": "Poisťovňou",
    "Pojišťovny": "Poistovne",
    "Pokladna": "Pokladna",
    "Pokračovat": "Pokračovať",
    "Pokročilá funkce": "Pokročilá funkcia",
    "pokročilý tarif.": "pokročilý tarif.",
    "Pokud": "Ak",
    "Pokud budete chtít nastavit jinou šablonu pro tuto zprávu, tak nás kontaktujte na": "Ak si želáte nastaviť inú šablónu pre túto správu, kontaktujte nás na",
    "Pokud je lekce plně obsazena, klienti se mohou zapsat jako náhradníci.": "Ak je lekcia plne obsadená, klienti sa môžu zapísať ako náhradníci.",
    "Pokud je zapnuto, klient musí poznámku vyplnit, aby mohl rezervaci dokončit.": "Ak je zapnuté, klient musí poznámku vyplniť, aby mohol rezerváciu dokončiť.",
    "Pokud má klient aktivní permanentku, platba za návštěvu se automaticky odečte z ní.": "Ak má klient aktívnu permanentku, platba za návštevu sa z nej automaticky odpočíta.",
    "Pokud má pacient trvalé bydliště v ČR, zadejte jeho rodné číslo bez lomítka.": "Ak má klient trvalé bydlisko v ČR, zadajte jeho rodné číslo bez lomítka.",
    "Pokud máte jakékoliv dotazy, neváhejte nás kontaktovat na": "Ak máte akékoľvek otázky, neváhajte nás kontaktovať na",
    "Pokud pracujete jako FO, ve zdravotnické dokumentaci budeme uvádět Vaše identifikační údaje. Pokud ne, ve zdravotnické dokumentaci budou údaje firmy.": "Ak pracujete ako FO, v zdravotníckej dokumentácii budeme uvádzať Vaše identifikačné údaje. Ak nie, v zdravotníckej dokumentácii budú údaje spoločnosti.",
    "Pokud problém přetrvává, napište nám na": "Ak problém pretrváva, napíšte nám na",
    "Pokud si kdykoliv v budoucnu nebudete vědět rady, můžete se k průvodci aplikací vrátit.": "Ak si kedykoľvek v budúcnosti nebudete vedieť rady, môžete sa vrátiť k sprievodcovi aplikácie.",
    "Pokud účet ještě nemáte, zvolte možnost registrace.": "Ak ešte nemáte účet, zvoľte možnosť registrácie.",
    "Pole je povinné": "Pole je povinné",
    "Položka byla úspěšně smazána": "Položka bola úspešne zmazaná",
    "Položka byla úspěšně upravena": "Položka bola úspešne upravená",
    "Položka byla úspěšně vytvořena": "Položka bola úspešne vytvorená",
    "Položku se nepodařilo smazat": "Položku sa nepodarilo zmazať",
    "polozky": "polozky",
    "Položky": "Položky",
    "Pondělí": "Pondelok",
    "Popis": "Popis",
    "Popis cviku": "Popis cviku",
    "Popis služby": "Popis služby",
    "Popisy návštěv": "Popisy návštev",
    "Porovnat fotky": "Porovnat fotky",
    "Porovnat fotografie": "Porovnat fotografie",
    "Porovnat můžete maximálně 2 fotografie.": "Porovnať môžete maximálne 2 fotografie.",
    "Porovnat vybrané fotografie": "Porovnať vybrané fotografie",
    "porovnavac": "porovnavac",
    "Porovnávač": "Porovnávač",
    "Poslat firmě email": "Poslať firme e-mail",
    "Poslat firmě SMS": "Poslať firme SMS",
    "Poslat terapeutovi email": "Poslať terapeutovi e-mail",
    "Poslat terapeutovi SMS": "Poslať terapeutovi SMS",
    "Poslední fakturace": "Posledná fakturácia",
    "Poslední návštěva": "Posledná návšteva",
    "Poslední návštěva:": "Posledná návšteva:",
    "Potvrdit": "Potvrdiť",
    "Potvrdit nové heslo": "Potvrdiť nové heslo",
    "Potvrďte nové heslo": "Potvrďte nové heslo",
    "Potvrzení GDPR před návštěvou fyzioterapie": "Potvrdenie GDPR pred návštevou terapie",
    "Potvrzení zrušení platby": "Potvrdenie zrušenia platby",
    "Potvrzeno": "Potvrdené",
    "potvrzuji": "potvrdzujem",
    "Potvrzuji": "Potvrdzujem",
    "Poukaz byl úspěšně vytvořen": "Poukaz bol úspešne vytvorený",
    "Poukaz na lázně": "Poukaz na kúpele",
    "Poukaz úspěšně smazán": "Poukaz úspešne zmazaný",
    "poukazy": "poukazy",
    "Použít": "Použiť",
    "Použito pro všechny": "Použité pre všetkých",
    "Používáte": "Používate",
    "Povinná platba online při rezervaci": "Povinná platba online pri rezervácii",
    "povolení online rezervací": "povolenie online rezervácií",
    "Povolí přístup do klientské sekce pouze klientům, jejichž email máte v kartotéce": "Povolí prístup do klientskej sekcie len klientom, ktorých e-mail máte v kartotéke",
    "Povolit odpovědi na SMS": "Povoliť odpovede na SMS",
    "Povolit online rezervace": "Povoliť online rezervácie",
    "Povolit registraci pacientů pouze s emailem z kartotéky": "Povoliť registráciu klientov len s e-mailom z kartotéky",
    "Povolit rezervace": "Povoliť rezervácie",
    "Povolit rezervace na státní svátky": "Povoliť rezervácie na štátne sviatky",
    "Povolit rezervace pro nepřihlášené uživatele v klientském portále": "Povoliť rezervácie pre neprihlásených používateľov v klientskom portáli",
    "Povolit skupinovou službu": "Povoliť skupinovú službu",
    "Povolit zobrazení detailu cizí návštěvy": "Povoliť zobrazenie detailu cudzej návštevy",
    "Povolit zrušení rezervace": "Povoliť zrušenie rezervácie",
    "Poznámka": "Poznámka",
    "Poznámka k návštěvě": "Poznámka k návšteve",
    "Poznámka úspěšně smazána": "Poznámka úspešne zmazaná",
    "Poznámka úspěšně uložena": "Poznámka úspešne uložená",
    "Poznámka:": "Poznámka:",
    "Poznámku se nepodařilo uložit": "Poznámku sa nepodarilo uložiť",
    "Poznámku se nepodařilo uložit. Zkuste to prosím znovu.": "Poznámku sa nepodarilo uložiť. Skúste to prosím znovu.",
    "Pozor, blížíte se k maximálnímu počtu pacientů.": "Pozor, blížite sa k maximálnemu počtu klientov.",
    "Pozor, blížíte se maximálnímu počtu pacientů.": "Pozor, blížite sa maximálnemu počtu klientov.",
    "Pozor, chystáte se zaplatit za návštěvu, která ještě neproběhla.": "Pozor, chystáte sa zaplatiť za návštevu, ktorá ešte neprebehla.",
    "Pozor! Snažíte se vytvořit návštěvu, která porušuje nastavení u Fyzioterapeuta, Služby nebo Místnosti nebo dochází ke konfliktu v kalendáři.": "Pozor! Snažíte sa vytvoriť návštevu, ktorá porušuje nastavenie u Terapeuta, Služby alebo Miestnosti alebo dochádza k konfliktu v kalendári.",
    "Pozor! Upravujete globální cvik vytvořený aplikací Fyzion. Po uložení této úpravy vznikne duplicitní cvik v databázi. Původní cvik bude zachován v nezměněné podobě.": "Pozor! Upravujete globálne cvičenie vytvorené aplikáciou Fyzion. Po uložení tejto úpravy vznikne duplicitné cvičenie v databáze. Pôvodné cvičenie zostane zachované v nezmenenej podobe.",
    "pracoviste": "pracovisko",
    "Pracoviště": "Pracovisko",
    "Pracoviště bylo smazáno": "Pracovisko bolo zmazané",
    "Pracoviště pro pojišťovny": "Pracovisko pre poisťovne",
    "Pracoviště upraveno": "Pracovisko upravené",
    "Pracoviště vytvořeno": "Pracovisko vytvorené",
    "Pracoviště žadatele bylo úspěšně uloženo": "Pracovisko žiadateľa bolo úspešne uložené",
    "Pracoviště žadatele bylo úspěšně vytvořeno": "Pracovisko žiadateľa bolo úspešne vytvorené",
    "Pracovní dny": "Pracovné dni",
    "Pracovní doba": "Pracovná doba",
    "Pracovníci": "Pracovníci",
    "Pracuji jako fyzická osoba": "Pracujem ako fyzická osoba",
    "Pravidelné terapie": "Pravidelné terapie",
    "Pravidla rušení rezervací": "Pravidlá rušenia rezervácií",
    "Před návštěvou ordinace se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": "Pred návštevou pracoviska sa, prosím, oboznámte so zásadami GDPR. Pre zobrazenie textu GDPR a potvrdenie kliknite",
    "Před pokračováním vyplňte formulář": "Pred pokračovaním vyplňte formulár",
    "Před pokračováním zadejte rodné číslo": "Pred pokračovaním zadajte rodné číslo.",
    "Před registrací musíte potvrdit souhlas se Všeobecnými obchodními podmínkami": "Pred registraciou musíte potvrdiť súhlas so Všeobecnými obchodnými podmienkami",
    "před termínem": "pred termínom",
    "Předem děkuji a budu se těšit na Vaši návštěvu.": "Vopred vám ďakujem a teším sa na vašu návštevu.",
    "Předmět": "Predmet",
    "Předmět emailu": "Predmet emailu",
    "předplacené (permice)": "predplatené (permanentka)",
    "predplatne": "predplatne",
    "Předplatné": "Predplatné",
    "Předplatné Fyzion": "Predplatné Fyzion Mind",
    "Předplatné smazáno": "Predplatné odstránené",
    "Předplatné úspěšně přidáno": "Predplatné úspešne pridané",
    "Předplatné úspěšně upraveno": "Predplatné úspešne upravené",
    "Předplatných na stránku": "Predplatných na stránku",
    "Předplatným": "Predplatným",
    "Předvolba": "Predvoľba",
    "Předvolba země chybí. Zkuste to prosím znovu.": "Predvoľba krajiny chýba. Skúste to prosím znova.",
    "Předvyplněn kód zadaný v %{time}. Platí obvykle 30 minut.": "Predvyplnený kód zadaný o %{time}. Platí zvyčajne 30 minút.",
    "Preferovaná místnost": "Preferovaná miestnosť",
    "Preferovaná pobočka": "Preferovaná pobočka",
    "Preferovaná služba": "Preferovaná služba",
    "Přehled cviků": "Prehľad cvikov",
    "Přehled dávek": "Prehľad dávok",
    "Přehled položek": "Prehľad položiek",
    "Přehled pracovišť": "Prehľad pracovísk",
    "Přehled transakcí": "Prehľad transakcií",
    "Přehled výkonů": "Prehľad výkonov",
    "prehled-vykonu": "prehlad-vykonov",
    "Přejete si vystavit doklad?": "Prajete si vystaviť doklad?",
    "Přejete si vystavit fakturu na storno poplatek?": "Prajete si vystaviť faktúru na storno poplatok?",
    "Přejete si vystavit storno doklad?": "Prajete si vystaviť storno doklad?",
    "Přejít do aplikace": "Prejsť do aplikácie",
    "Přejít do profilu": "Prejsť do profilu",
    "Přejít na tarif": "Prejsť na tarif",
    "Překlady": "Preklady",
    "Překlady názvu kategorie": "Preklady názvu kategórie",
    "Překlady názvu služby": "Preklady názvu služby",
    "Premium registrace": "Premium registracia",
    "Přeskočit": "Preskočiť",
    "Přesun rezervace": "Presun rezervácie",
    "Přesun rezervací se řídí obecným nastavením firmy.": "Presun rezervácií sa riadi všeobecným nastavením firmy.",
    "Přesunout rezervaci": "Presunúť rezerváciu",
    "Přesuňte některé pacienty do archivu a pak objednejte tarif znovu.": "Presuňte niektorých klientov do archívu a potom objednajte tarif znovu.",
    "Převodem": "Prevodom",
    "Převodem (QR kód)": "Prevodom (QR kód)",
    "při roční platbě": "pri ročnej platbe",
    "Při vytvoření online rezervace:": "Pri vytvorení online rezervácie:",
    "Při zrušení online rezervace:": "Pri zrušení online rezervácie:",
    "Přidá po skončení rezervace časový blok, během kterého nebude možné vytvářet další rezervace (např. čas na úklid nebo pauzu).": "Pridá po skončení rezervácie časový blok, počas ktorého nebude možné vytvárať ďalšie rezervácie (napr. čas na upratovanie alebo prestávku).",
    "Přidán na seznam": "Pridaný na zoznam",
    "Přidáno": "Pridané",
    "Přidat": "Pridať",
    "Přidat 3 pacienty": "Pridať 3 klientov",
    "Přidat časový interval": "Pridať časový interval",
    "Přidat čekajícího": "Pridať čakajúceho",
    "Přidat cvik": "Pridať cvik",
    "Přidat dodavatele": "Pridať dodávateľa",
    "Přidat dokument": "Pridať dokument",
    "Přidat doplňkový text do e-mailů klientům": "Pridať doplnkový text do e-mailov klientom",
    "Přidat fotku": "Pridať fotku",
    "Přidat FT poukaz": "Pridať FT poukaz",
    "Přidat fyzioterapeuta": "Pridať používateľa",
    "Přidat k návštěvě": "Pridať k návšteve",
    "Přidat kategorii": "Pridať kategóriu",
    "Přidat místnost": "Pridať miestnosť",
    "Přidat náhradníka": "Pridať náhradníka",
    "Přidat náhradníka jako účastníka návštěvy": "Pridať náhradníka ako účastníka návštevy",
    "Přidat náhradníka jako účastníka návštěvy?": "Pridať náhradníka ako účastníka návštevy?",
    "Přidat návštěvu": "Pridať návštevu",
    "Přidat nového čekajícího": "Pridať nového čakajúceho",
    "Přidat nového pacienta": "Pridať nového klienta",
    "Přidat pacientovi permanentku": "Pridať klientovi permanentku",
    "Přidat peníze": "Pridať peniaze",
    "Přidat permanentku": "Pridať permanentku",
    "Přidat platbu": "Pridať platbu",
    "Přidat pobočku": "Pridať pobočku",
    "Přidat podkategorii": "Pridať podkategóriu",
    "Přidat pojišťovnu": "Pridať poisťovňu",
    "Přidat položku": "Pridať položku",
    "Přidat poznámku": "Pridať poznámku",
    "Přidat pracoviště": "Pridať pracovisko",
    "Přidat předplatné": "Pridať predplatné",
    "Přidat skupinovou návštěvu": "Pridať skupinovú návštevu",
    "Přidat službu": "Pridať službu",
    "Přidat soubor": "Pridať súbor",
    "Přidat štítek...": "Pridať štítok...",
    "Přidat údaj": "Pridať údaj",
    "Přidat výkon": "Pridať výkon",
    "Přidat zboží": "Pridať tovar",
    "pridat-permanentku": "pridat-permanentku",
    "pridat-volno": "pridat-volno",
    "Přidejte vlastní informace, které klienti potřebují vědět před návštěvou – například kde najdou vchod, co si mají vzít s sebou nebo jaké jsou storno podmínky. Informace se zobrazí pod detailem rezervace v e-mailu s potvrzením návštěvy a v její připomínce.": "Pridajte vlastné informácie, ktoré klienti potrebujú vedieť pred návštevou – napríklad kde nájdu vchod, čo si majú vziať so sebou alebo aké sú storno podmienky. Informácie sa zobrazia pod detailom rezervácie v e-maile s potvrdením návštevy a v jej pripomienke.",
    "Přihlášení jako nesprávný typ uživatele": "Prihlásenie ako nesprávny typ používateľa",
    "Přihlásit": "Prihlásiť",
    "Přihlásit se": "Prihlásiť sa",
    "Přihlašovací jméno": "Prihlasovacie meno",
    "Přihlašovací údaje": "Prihlasovacie údaje",
    "Přihlašovací údaje k portálům pojišťoven se nepodařilo načíst": "Prihlasovacie údaje k portálom poisťovní sa nepodarilo načítať",
    "Přihlašovací údaje se nepodařilo smazat": "Prihlasovacie údaje sa nepodarilo vymazať",
    "Přihlašovací údaje se nepodařilo uložit": "Prihlasovacie údaje sa nepodarilo uložiť",
    "Přijat": "Prijatý",
    "Příjemce": "Príjemca",
    "Příjemce:": "Príjemca:",
    "Přijmení": "Priezvisko",
    "Příjmení": "Priezvisko",
    "Přijmout do péče": "Prijať do starostlivosti",
    "Přijmout FT poukaz": "Prijať FT poukaz",
    "Příjmy": "Príjmy",
    "Příjmy (budoucí)": "Príjmy (budúce)",
    "Příjmy fyzioterapeutů": "Pridať terapeuta",
    "Příjmy z nabízených služeb": "Príjmy z ponúkaných služieb",
    "Přiložený soubor se nepodařilo nahrát": "Nepodarilo sa nahrať priložený súbor.",
    "Primární barva události": "Primárna farba udalosti",
    "Primární barva události v rozvrhu místnosti": "Primárna farba udalosti v rozvrhu miestnosti",
    "Případně kontaktujte naši podporu na ": "Prípadne kontaktujte našu podporu na ",
    "Připojištění": "Pripoistenie",
    "Připomínka platby": "Pripomienka platby",
    "Připravujeme": "Pripravujeme",
    "Přiřazené služby": "Pridelené služby",
    "Přišel/Přijde": "Prišiel/Príde",
    "Příští návštěva": "Nasledujúca návšteva",
    "Příští objednání": "Nasledujúce objednanie",
    "Příští služba": "Nasledujúca služba",
    "Přítomen": "Prítomný",
    "Pro dokončení rezervace je nutné souhlasit se zásadami zpracování osobních údajů.": "Na dokončenie rezervácie je potrebné súhlasiť so zásadami spracovania osobných údajov.",
    "Pro export kartotéky kontaktujte naší podporu na": "Pre export kartotéky kontaktujte našu podporu na",
    "Pro individuální nastavení textace emailů vašim klientům kontaktujte naši technickou podporu na": "Pre individuálne nastavenie textácie e-mailov vašim klientom kontaktujte našu technickú podporu na",
    "Pro individuální nastavení textace emailů vašim pacientům kontaktujte naši technickou podporu na": "Pre individuálne nastavenie textácie emailov vašim klientom kontaktujte našu technickú podporu na",
    "Pro nastavení časového úseku, kdy je možné tuto službu rezervovat online, kontaktujte naší podporu na": "Pro nastavenie časového úseku, kedy je možné túto službu rezervovať online, kontaktujte našu podporu na",
    "Pro nastavení otevírací doby místnosti kontaktujte naší podporu na": "Pro nastavenie otváracej doby miestnosti kontaktujte našu podporu na",
    "Pro odeslání potvrzení o platbě zadejte email pacienta": "Pro odoslanie potvrdenia o platbe zadajte email klienta",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu %{portal}.": "Na overenie SMS kódom si najprv v profile uložte prihlasovacie údaje k portálu %{portal}.",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu pojišťovny.": "Na overenie SMS kódom si najprv v profile uložte prihlasovacie údaje k portálu poisťovne.",
    "Pro platby převodem systém automaticky vystaví fakturu namísto stvrzenky.": "Pre platby prevodom systém automaticky vystaví faktúru namiesto potvrdenia.",
    "Pro přihlášení je potřeba přejít na správné URL klientského portálu. Kontaktujte svého poskytovatele služeb.": "Na prihlásenie je potrebné prejsť na správné URL klientského portálu. Kontaktujte svojho poskytovateľa služieb.",
    "Pro správné fungování aplikace je potřeba základní nastavení. Nebojte, základní nastavení aplikace a projití funkcí vám zabere jen pár minut!": "Pre správne fungovanie aplikácie je potrebné základné nastavenie. Nebojte sa, základné nastavenie aplikácie a prehliadnutie funkcií vám zaberie len pár minút!",
    "Pro tohoto pacienta jste zatím nevytvořili žádný FT poukaz": "Pre tohto klienta ste zatiaľ nevytvorili žiaden FT poukaz",
    "Pro tohoto pacienta jste zatím nevytvořili žádný poukaz": "Pre tohto klienta ste zatiaľ nevytvorili žiadny poukaz",
    "Pro zobrazení platebního QR kódu vyplňte v": "Pro zobrazenie platobného QR kódu vyplňte v",
    "Proběhlé návštěvy": "Prebehnuté návštevy",
    "Probíhá synchronizace Vašeho kalendáře": "Prebieha synchronizácia Vášho kalendára",
    "Procentuální": "Percentuálny",
    "Prodané permanentky": "Prodané permanentky",
    "Prodej zboží": "Predaj tovaru",
    "Prodejní cena (s DPH)": "Prodejná cena (s DPH)",
    "Prodejní cena s DPH": "Prodejná cena s DPH",
    "Prodejní cena zboží za ks (s DPH)": "Predajná cena tovaru za ks (s DPH)",
    "Prodejní hodnota (s DPH)": "Prodejná hodnota (s DPH)",
    "Profil": "Profil",
    "Profilová fotografie": "Profilová fotografia",
    "Profilový obrázek byl úspěšně nahrán": "Profilový obrázok bol úspešne nahraný",
    "Profily": "Profily",
    "Proklik na skupinovou návštěvu": "Preklik na skupinovú návštevu",
    "Propojené aplikace": "Propojené aplikácie",
    "Propojení": "Prepojenie",
    "Propojeno": "Propojené",
    "Propojit": "Propojit",
    "Prosím": "Prosím",
    "Prosíme o její úhradu co nejdříve.": "Prosíme o jej úhradu čo najskôr.",
    "Provedeme vás, nastavíme základní parametry, přidáme první klienty.": "Povedieme vás, nastavíme základné parametre, pridáme prvých klientov.",
    "Provedené akce": "Vykonané akcie",
    "Průměrná nákupní cena zboží na skladě za ks (s DPH)": "Priemerná nákupná cena tovaru na sklade za ks (s DPH)",
    "Průvodce": "Sprievodca",
    "Průvodce a nápovědu případně navštivte prostřednictvím odkazu v horním menu. Zde naleznete vše co vás zajímá přehledně na jednom místě.": "Sprievodcu a nápovedu prípadne navštívte prostredníctvom odkazu v hornom menu. Tu nájdete všetko, čo vás zaujíma prehľadne na jednom mieste.",
    "PSČ": "PSČ",
    "Purobot API klíč": "Kľúč API Purobot",
    "Původní": "Pôvodný",
    "Původní dávka": "Pôvodná dávka",
    "qr": "qr",
    "RČ / Datum narození": "RČ / Dátum narodenia",
    "Recenze": "Recenzie",
    "Recenze byla smazána": "Recenzie bola zmazaná",
    "Recenze návštěv": "Recenzie návštev",
    "recenzí": "recenzií",
    "Recepční": "Recepčná",
    "Recepční vidí kalendáře uživatelů a statistiky, ale nemá přístup ke kartám klientů": "Recepčná vidí kalendáre používateľov a štatistiky, ale nemá prístup ku kartám klientov",
    "Registrace": "Registrácia",
    "Registrace náhradníka byla úspěšně vytvořena.": "Registrácia náhradníka bola úspešne vytvorená.",
    "Registrace proběhla úspěšně": "Registracia prebehla úspešne",
    "Registrace proběhla úspěšně. Prosím potvrďte ještě svojí emailovou adresu kliknutím na odkaz ve vašem emailu!": "Registrácia prebehla úspešne. Prosím, potvrďte ešte svoju emailovú adresu kliknutím na odkaz vo vašom emaile!",
    "Registrace se nepovedla": "Registrácia sa nepodarila",
    "registrace-zdarma": "registracia-zdarma",
    "Registrace/Přihlášení": "Registrácia/Prihlásenie",
    "Registrovat jako náhradník": "Registrovať ako náhradník",
    "Registrovat se": "Registrovať sa",
    "Resetování hesla": "Resetovanie hesla",
    "Resetovat": "Resetovať",
    "Resetovat fyzioterapeuty dle diagnózy": "Resetovať terapeutov podľa diagnózy",
    "Resetovat heslo": "Resetovať heslo",
    "resetpassword/:uid/:token": "resetpassword/:uid/:token",
    "Řešíte jiný problém?": "Riešite iný problém?",
    "Rezarvace byla úspěšně změněna na": "Rezervácia bola úspešne zmenená na",
    "rezervace": "rezervácia",
    "Rezervace": "Rezervácia",
    "Rezervace byla úspěšně vytvořena.": "Rezervácia bola úspešne vytvorená.",
    "Rezervace byla zrušena": "Rezervácia bola zrušená",
    "Rezervace čekajících": "Rezervácia čakajúcich",
    "Rezervace je potvrzena až po úspěšné online platbě.": "Rezervácia je potvrdená až po úspešnej online platbe.",
    "Rezervace nejdříve": "Rezervácia najskôr",
    "Rezervace nejpozději": "Rezervácia najneskôr",
    "Rezervace nemohla být vytvořena": "Rezervácia nemohla byť vytvorená",
    "Rezervace pacienta jsou povoleny": "Rezervácie klienta sú povolené.",
    "Rezervace pacienta jsou zablokovány": "Rezervácie klienta sú zablokované.",
    "Rezervace úspěšně vytvořena": "Rezervácia úspešne vytvorená",
    "rezervací": "rezervácií",
    "Rezervaci již nelze zrušit online": "Rezerváciu už nie je možné zrušiť online",
    "Rezervaci můžete zrušit do": "Rezerváciu môžete zrušiť do",
    "Rezervaci nebylo možné dokončit": "Rezerváciu nebolo možné dokončiť",
    "Rezervaci nelze zrušit online": "Rezerváciu nie je možné zrušiť online",
    "Rezervaci se nepodařilo zrušit": "Rezerváciu sa nepodarilo zrušiť",
    "Rezervační formulář": "Rezervačný formulár",
    "Rezervační systém": "Rezervačný systém",
    "Rezervační tlačítko": "Rezervačné tlačidlo",
    "Rezervovat": "Rezervovať",
    "Rezervovat jako náhradník": "Rezervovať ako náhradník",
    "Rezervujte si termín": "Rezervujte si termín",
    "Rezervujte si termín online": "Rezervujte si termín online",
    "Rezervujte si termín u": "Rezervujte si termín u",
    "Režim zobrazení": "Režim zobrazenia",
    "Roční": "Ročná",
    "Rodné číslo": "Rodné číslo",
    "Rodné číslo pacienta": "Rodné číslo klienta",
    "Rodné číslo:": "Rodné číslo:",
    "Rok": "Rok",
    "Roky": "Roky",
    "Role": "Rola",
    "Rozpis termínů fyzioterapie": "Rozpis termínov terapie",
    "Rozpracovaná návštěva uložena": "Rozpracovaná návšteva uložená",
    "Rozpracované podání bylo smazáno": "Rozpracované podanie bolo zmazané",
    "Rozpracované podání se nepodařilo smazat": "Rozpracované podanie sa nepodarilo zmazať",
    "Rozvrh místností": "Rozvrh miestností",
    "Rozvrh skupinových lekcí": "Rozvrh skupinových lekcií",
    "s GDPR, klikněte níže na tlačítko": "s GDPR, kliknite nižšie na tlačidlo",
    "S jakým problémem k nám přicházíte?": "S akým problémom k nám prichádzate?",
    "S nezaplacenými návštěvami": "S nezaplatenými návštevami",
    "Šablon na stránku": "Šablóna na stránku",
    "Šablona": "Šablóna",
    "Šablona byla úspěšně aktualizována": "Šablóna bola úspešne aktualizovaná",
    "Šablona byla úspěšně smazána": "Šablóna bola úspešne zmazaná",
    "Šablona byla úspěšně upravena": "Šablóna bola úspešne upravená",
    "Šablona byla úspěšně vytvořena": "Šablóna bola úspešne vytvorená",
    "Šablona FT výkonů": "Šablóna FT výkonov",
    "Šablona neobsahuje žádné výkony": "Šablóna neobsahuje žiadne výkony",
    "Šablona výkonů": "Šablóna výkonov",
    "Šablona výkonů FT": "Šablóna výkonov FT",
    "Šablona výkonů pro návštěvy": "Šablóna výkonov pre návštevy",
    "sablony": "sablony",
    "Šablony": "Šablóny",
    "Šablony výkonů FT": "Šablóny výkonov FT",
    "Šablony výkonů pro návštěvy": "Šablóny výkonov pre návštevy",
    "Sada cviků byla odeslána klientovi": "Sada cvikov bola odoslaná klientovi",
    "Sazba DPH": "Sazba DPH",
    "Sdílejte": "Sdíľajte",
    "SDÍLEJTE NÁS": "SDIEĽAJTE NÁS",
    "Sdílení": "Zdieľanie",
    "sdílet": "sdíľať",
    "sdílet aplikaci": "sdíľať aplikáciu",
    "Sekundární barva události": "Sekundárna farba udalosti",
    "Shrnutí historie návštěv": "Zhrnutie histórie návštev",
    "Shrnutí návštěv": "Zhrnutie návštev",
    "SK": "SK",
    "Sklad": "Sklad",
    "Skrýt": "Skryť",
    "Skupina služeb": "Skupina služieb",
    "Skupinová návštěva": "Skupinová návšteva",
    "Skupinová návštěva smazána": "Skupinová návšteva zmazaná",
    "Skupinové lekce se nepodařilo načíst": "Skupinové lekcie sa nepodarilo načítať",
    "Skupinovka": "Skupinovka",
    "Skutečně si přejete změnit tarif?": "Skutočne si prajete zmeniť tarif?",
    "Sloučení karet": "Slúčenie kariet",
    "Sloučit karty": "Spoločniť karty",
    "Služba": "Služba",
    "Služba nenalezena": "Služba nenájdená",
    "Služba:": "Služba:",
    "sluzby": "sluzby",
    "Služby": "Služby",
    "Služby dle kategorií celkem za rok": "Služby podľa kategórií celkovo za rok",
    "Služby nebudou smazány, kategorie jim bude pouze odebrána.": "Služby nebudú zmazané, kategórie im bude len odobraná.",
    "Služby:": "Služby:",
    "Smazání": "Vymazanie",
    "Smazání obrázku se nezdařilo": "Vymazanie obrázka sa nezadarilo",
    "Smazáno": "Vymazané",
    "Smazat": "Odstrániť",
    "Smazat cvik": "Odstrániť cvik",
    "Smazat dodavatele": "Odstrániť dodavateľa",
    "Smazat dokument": "Zmazať dokument",
    "Smazat formulář": "Odstrániť formulár",
    "Smazat fotku": "Odstrániť fotku",
    "Smazat fotografii": "Odstrániť fotografiu",
    "Smazat kategorii cviků": "Odstrániť kategóriu cvikov",
    "Smazat kategorii služeb": "Odstrániť kategóriu služieb",
    "Smazat místnost": "Zmazať miestnosť",
    "Smazat návštěvu": "Odstrániť návštevu",
    "Smazat nezaplacenou návštěvu před termínem": "Zmazať nezaplatenú návštevu pred termínom",
    "Smazat obrázek": "Vymazať obrázok",
    "Smazat permanentku": "Odstrániť permanentku",
    "Smazat pobočku": "Zmazať pobočku",
    "Smazat podání": "Zmazať podanie",
    "Smazat podpis": "Zmazať podpis",
    "Smazat pojišťovnu": "Odstrániť poisťovňu",
    "Smazat položku": "Odstrániť položku",
    "Smazat pouze toto volno": "Odstrániť len túto návštevu",
    "Smazat pouze tuto návštěvu": "Odstrániť len túto návštevu",
    "Smazat pouze tuto skupinovou návštěvu": "Zmazať len túto skupinovú návštevu",
    "Smazat pracoviště": "Odstrániť pracovisko",
    "Smazat předplatné": "Odstrániť predplatné",
    "Smazat přihlašovací údaje k portálu %{portal}?": "Vymazať prihlasovacie údaje k portálu %{portal}?",
    "Smazat recenzi": "Odstrániť recenziu",
    "Smazat rozpracované podání": "Zmazať rozpracované podanie",
    "Smazat rozpracované podání?": "Zmazať rozpracované podanie?",
    "Smazat šablonu": "Odstrániť šablónu",
    "Smazat službu": "Odstrániť službu",
    "Smazat soubor": "Odstrániť súbor",
    "Smazat stávající zápis": "Odstrániť existujúci zápis",
    "Smazat toto a všechna budoucí volna": "Odstrániť túto a všetky budúce návštevy",
    "Smazat tuto a všechny budoucí návštěvy": "Odstrániť túto a všetky budúce návštevy",
    "Smazat tuto a všechny budoucí skupinové návštěvy": "Zmazať túto a všetky budúce skupinové návštevy",
    "Smazat video": "Odstrániť video",
    "Smazat volno": "Zmazať voľno",
    "Smazat zboží": "Vymazať tovar",
    "Smaže rozpracované podání, např. abyste mohli dávku upravit a odeslat znovu": "Zmaže rozpracované podanie, napr. aby ste mohli dávku upraviť a odoslať znova",
    "Smluvní pojištění": "Smluvné poistenie",
    "SMS": "SMS",
    "SMS byla úspěšně odeslána": "SMS bola úspešne odoslaná",
    "SMS byly úspěšně odeslána": "SMS boli úspešne odoslané",
    "SMS čekajícímu": "SMS čakajúcemu",
    "SMS klientům": "SMS klientom",
    "SMS kód": "SMS kód",
    "SMS kód se nepodařilo vyžádat": "SMS kód sa nepodarilo vyžiadať",
    "SMS odpovědi od klientů budou přeposílány na zvolený email": "SMS odpovede od klientov budú preposielané na zvolený e-mail",
    "SMS se nepodařilo odeslat": "SMS sa nepodarilo odoslať",
    "SMS tento měsíc": "SMS tento mesiac",
    "Sobota": "Sobota",
    "Soubor se nepodařilo stáhnout": "Súbor sa nepodarilo stiahnuť",
    "Soubor se zobrazí zákazníkům v posledním kroku online rezervace.": "Súbor sa zobrazí zákazníkom v poslednom kroku online rezervácie.",
    "Soubory úspěšně nahrány": "Súbory úspešne nahrané",
    "Současné heslo": "Súčasné heslo",
    "Souhlas GDPR": "Súhlas GDPR",
    "Souhlas s GDPR": "Súhlas s GDPR",
    "Souhlas s GDPR odesílat automaticky": "Súhlas s GDPR odosielať automaticky",
    "Souhlas s novinkami:": "Súhlas s novinkami:",
    "Souhlas se zpracováním osobních údajů": "Súhlas so spracovaním osobných údajov",
    "Souhlas udělen": "Súhlas udelený",
    "Souhlasil s novinkami": "Súhlasil s novinkami",
    "Souhlasili": "Súhlasili",
    "Souhlasím s vytvořením karty pacienta v souladu s": "Súhlasím s vytvorením karty klienta v súlade s",
    "Souhlasím se": "Súhlasím so",
    "Souhlasím se zasíláním novinek a zajímavých nabídek": "Súhlasím so zasielaním noviniek a zaujímavých ponúk",
    "souhlasíte": "súhlasíte",
    "Spis byl načten": "Spis bol načítaný",
    "Spis se nepodařilo načíst": "Spis sa nepodarilo načítať",
    "Spis se nepodařilo vytvořit": "Spis sa nepodarilo vytvoriť",
    "Spisy": "Spisy",
    "Spisy byly synchronizovány": "Spisy boli synchronizované",
    "Spisy se nepodařilo načíst": "Spisy sa nepodarilo načítať",
    "Splatnost": "Splatnost",
    "Splatnost faktury": "Splatnost faktúry",
    "Spočítat": "Spočítať",
    "Stačí": "Stačí",
    "Stáhnout": "Stiahnuť",
    "Stáhnout fakturu": "Stiahnuť faktúru",
    "Stáhnout soubory": "Stiahnuť súbory",
    "Stáhnout zálohovou fakturu": "Stiahnuť zálohovú faktúru",
    "Start": "Štart",
    "STATISTICS": "ŠTATISTIKY",
    "Statistiky": "Štatistiky",
    "Status": "Status",
    "Stav": "Stav",
    "Stav bude změněn v obou případech. Volbou „Ano“ se doklad vystaví společně se změnou stavu.": "Stav bude zmenený v oboch prípadoch. Voľbou „Áno“ sa doklad vystaví spoločne so zmenou stavu.",
    "Stav bude změněn v obou případech. Volbou „Ano“ se faktura vystaví společně se změnou stavu.": "Stav bude zmenený v oboch prípadoch. Voľbou „Áno“ sa faktúra vystaví spoločne so zmenou stavu.",
    "Stav návštěvy byl změněn": "Stav návštevy bol zmenený",
    "Stav platby": "Stav platby",
    "Stejné jako fakturační": "Rovnaké ako fakturačné",
    "Štítek byl úspěšně odebrán": "Štítok bol úspešne odobratý",
    "Štítek byl úspěšně smazán": "Štítok bol úspešne zmazaný",
    "Štítek byl úspěšně vytvořen": "Štítok bol úspešne vytvorený",
    "Štítky": "Štítky",
    "Štítky návštěv": "Štítky návštev",
    "Štítky pacientů": "Štítky klientov",
    "Storno": "Storno",
    "Storno poplatek": "Storno poplatok",
    "Stornovaná faktura": "Stornovaná faktúra",
    "stornovanou fakturu č.": "faktúru č.",
    "Stornovaný paragon": "Stornovaný paragón",
    "stornovaný paragon č.": "paragon č.",
    "Stornovat": "Stornovať",
    "stránka někam utekla...": "stránka niekam utiekla...",
    "Stránka ordinace": "Stránka ordinácie",
    "Středa": "Streda",
    "Stvrzenek na stránku": "Zobrazenie na stránku",
    "svůj prohlížeč nebo si nainstalujte jiný.": "svoj prehliadač alebo si nainštalujte iný.",
    "Synchronizace kalendáře byla zrušena": "Synchronizacia kalendara bola zrusena",
    "Synchronizace s Google kalendářem": "Synchronizacia s Google kalendárom",
    "Synchronizace se nezdařila": "Synchronizacia sa nezdarila",
    "synchronizace-kalendare": "synchronizacia-kalendara",
    "Synchronizovat události z Google kalendáře do Fyzionu": "Synchronizovať udalosti z Google kalendára do Fyzionu",
    "Synchronizujte svůj Fyzion kalendář s kalendářem Google": "Synchronizujte svoj Fyzion kalendár s kalendárom Google",
    "Systém bude při automatickém vystavování dokladů používat výhradně fakturu místo stvrzenky.": "Systém bude pri automatickom vystavovaní dokladov používať výhradne faktúru namiesto potvrdenia.",
    "Tarif": "Tarify",
    "Tarify": "Tarify",
    "Tato akce může ovlivnit rezervační systém.": "Táto akcia môže ovplyvniť rezervačný systém.",
    "Tato funkce je dostupná pouze v placeném tarifu.": "Tato funkce je dostupná pouze vo vyššom tarife.",
    "Tato funkce je dostupná pouze v placeném tarifu. Placené tarify ukrývají spoustu pokročilých funkcí, které Vám ulehčí práci.": "Táto funkcia je dostupná iba vo vyššom tarife. Tieto tarify ukrývajú veľa pokročilých funkcií, ktoré vám uľahčia prácu.",
    "Tato karta se smaže.": "Táto karta sa vymaže.",
    "Tato přihlašovací stránka je určena pouze terapeutům.": "Táto prihlasovacia stránka je určená len terapeutom.",
    "Tato služba bude automaticky předvyplněna při vytváření nové návštěvy.": "Táto služba bude automaticky predvyplnená pri vytváraní novej návštevy.",
    "Tato zpráva bude účtována jako 2 SMS": "Táto správa bude účtovaná ako 2 SMS",
    "Tato zpráva bude účtována jako 3 SMS": "Táto správa bude účtovaná ako 3 SMS",
    "Tel.:": "Tel.:",
    "Telefon": "Telefón",
    "Telefonní číslo": "Telefónne číslo",
    "Telefonní číslo:": "Telefónne číslo:",
    "Tento měsíc": "Tento mesiac",
    "Tento pacient má nezaplacenou návštěvu, která nebyla omluvená.": "Tento klient má nezaplatenú návštevu, ktorá nebola ospravedlnená.",
    "Tento profil zatím nemá žádné permanentky.": "Tento profil zatiaľ nemá žiadne permanentky.",
    "Tento rok": "Tento rok",
    "Tento týden": "Tento týždeň",
    "Terapeut": "Terapeut",
    "Terapeut nemá přiřazené pracoviště pro pojišťovny. Přiřaďte pracoviště v profilu terapeuta a zkontrolujte nastavení pracoviště": "Terapeut nemá priradené pracovisko pre poisťovne. Priraďte pracovisko v profile terapeuta a skontrolujte nastavenie pracoviska",
    "Termín můžete přesunout do": "Termín môžete presunúť do",
    "Termín přidán. Nyní je možné pokračovat k potvrzení rezervací.": "Termín pridaný. Teraz je možné pokračovať k potvrdeniu rezervácií.",
    "Termín pro zaplacení": "Termín na zaplatenie",
    "termínů": "termínov",
    "Text": "Text",
    "Text s instrukcemi pro klienta, co má do poznámky uvést (např. Uveďte své zdravotní potíže nebo omezení).": "Text s inštrukciami pre klienta, čo má do poznámky uviesť (napr. Uveďte svoje zdravotné ťažkosti alebo obmedzenia).",
    "Text SMS překročil maximální povolený limit znaků.": "Text SMS prekročil maximálny povolený limit znakov.",
    "Těžší varianta": "Ťažšia varianta",
    "theme_company": "Fyzion",
    "Tisk": "Tisk",
    "Tisk GDPR": "Tisk GDPR",
    "Tisk karty pacienta": "Tisk karty klienta",
    "Tisk návštěv": "Tlač návštev",
    "Tisk návštěvy": "Tlač návštevy",
    "Tisk rozpisu termínů návštěv": "Tlač rozpisu termínov návštev.",
    "Toto okno můžete zavřít.": "Toto okno môžete zavrieť.",
    "Toto podání už na autorizaci nečeká, mezitím se dokončilo.": "Toto podanie už na autorizáciu nečaká, medzitým sa dokončilo.",
    "Toto pole je povinné": "Toto pole je povinné",
    "Trvání služby v minutách": "Trvanie služby v minútach",
    "týden": "týždeň",
    "Týdně": "Týždenne",
    "týdnů": "týždňov",
    "týdny": "týždne",
    "Týdny": "Týždne",
    "Typ akce": "Typ akcie",
    "Typ dávky": "Typ dávky",
    "Typ dokladu": "Typ dokladu",
    "Typ permanentky": "Typ permanentky",
    "Typ platby": "Typ platby",
    "Typ platební brány": "Typ platobnej brány",
    "Typ poukazu": "Typ poukazu",
    "Typ připojištění": "Typ poistenia",
    "Typ připojištění:": "Typ poistenia:",
    "Typ šablony": "Typ šablón",
    "Typ spisu": "Typ spisu",
    "Typ subjektu": "Typ subjektu",
    "Typ transakce": "Typ transakcie",
    "Typ výkonu": "Typ výkonu",
    "Typ vyšetření": "Typ vyšetrenia",
    "Typ vyšetření a délka": "Typ vyšetrenia a dĺžka",
    "Typ záznamu": "Typ záznamu",
    "Tyto informace jsou vaše soukromé kontaktní údaje. Změnu veřejných kontaktních údajů, které vidí pacienti, uděláte v ": "Tieto informácie sú vaše súkromné kontaktné údaje. Zmenu verejných kontaktných údajov, ktoré vidia klienti, urobíte v ",
    "Účast pacienta": "Účasť klienta",
    "Údaje": "Údaje",
    "Údaje instituce": "Údaje o inštitúcii",
    "Údaje o pojištění": "Údaje o poistení",
    "Údaje pro platbu převodem": "Údaje pre platbu prevodom",
    "Údaje úspěšně změněny": "Údaje úspešne zmenené",
    "Úhloměr": "Úhlomer",
    "Uhradit": "Uhradiť",
    "Uhrazeno": "Zaplatené",
    "Ukázat cvik": "Ukázať cvik",
    "Ulice": "Ulica",
    "Ulice a č. p.": "Ulica a súpisné číslo",
    "Ulice a č.p.": "Ulica a súpisné číslo",
    "Uložené heslo vám nikdy nezobrazíme. Ponechte pole prázdné, pokud ho nechcete měnit.": "Uložené heslo vám nikdy nezobrazíme. Ponechajte pole prázdne, ak ho nechcete meniť.",
    "Uložené šablony": "Uložené šablóny",
    "Uloženo": "Uložené",
    "uložit": "uložiť",
    "Uložit": "Uložiť",
    "Uložit a zamknout": "Uložiť a zamknúť",
    "Uložit jako PDF do karty pacienta": "Uložiť ako PDF do karty klienta",
    "Uložit rozpracované": "Uložiť rozpracované",
    "Uložit změny": "Uložiť zmeny",
    "Umožní rezervaci více klientů na jeden termín.": "Umožní rezerváciu viacerých klientov na jeden termín.",
    "Umožnit rezervaci náhradníkům": "Umožniť rezerváciu náhradníkom",
    "Upozornit klienta při vytvoření, změně a zrušení návštěvy": "Upozorniť klienta pri vytvorení, zmene a zrušení návštevy",
    "Upozornit terapeuta na akce provedené jinym terapeutem": "Upozorniť terapeuta na kroky vykonané iným terapeutom",
    "Úprava": "Uprava",
    "Úprava příští návštěvy": "Úprava nasledujúcej návštevy",
    "upravit": "upraviť",
    "Upravit": "Upraviť",
    "Upravit cvik": "Upraviť cvik",
    "Upravit dodavatele": "Upraviť dodávateľa",
    "Upravit dostupnost": "Upraviť dostupnosť",
    "Upravit fakturaci": "Upraviť fakturaciu",
    "Upravit FT poukaz": "Upraviť FT poukaz",
    "Upravit fyzioterapeuta": "Upraviť terapeuta",
    "Upravit kategorii": "Upraviť kategóriu",
    "Upravit kategorii cviků": "Upraviť kategóriu cvikov",
    "Upravit kategorii služeb": "Upraviť kategóriu služieb",
    "Upravit místnost": "Upraviť miestnosť",
    "Upravit ordinační hodiny": "Upraviť pracovnú dobu",
    "Upravit pacientovu permanentku": "Upraviť klientovu permanentku",
    "Upravit permanentku": "Upraviť permanentku",
    "Upravit platbu č.": "Upraviť platbu č.",
    "Upravit pobočku": "Upraviť pobočku",
    "Upravit podkategorii": "Upraviť podkategóriu",
    "Upravit pojišťovnu": "Upraviť poisťovňu",
    "Upravit položku": "Upraviť položku",
    "Upravit pracoviště": "Upraviť pracovisko",
    "Upravit pracoviště žadatele": "Upraviť pracovisko žiadateľa",
    "Upravit šablonu": "Upraviť šablónu",
    "Upravit šablonu výkonů": "Upraviť šablónu výkonov",
    "Upravit službu": "Upraviť službu",
    "Upravit štítky": "Upraviť štítky",
    "Upravit uživatele": "Upraviť užívateľa",
    "Upravit žadatele": "Upraviť žiadateľa",
    "Upravit zboží": "Upraviť tovar",
    "upravit-ft-poukaz/:ticketId": "upravit-ft-poukaz/:ticketId",
    "upravit-permanentku/:ticketId": "upravit-permanentku/:ticketId",
    "upravit-volno": "upravit-volno",
    "Určuje maximální počet pacientů na skupinovou návštěvu. Hodnota 0 se rovná neomezenému počtu pacientů.": "Určuje maximálny počet klientov na skupinovú návštevu. Hodnota 0 sa rovná neobmedzenému počtu klientov.",
    "Určuje základní stav odesílání stvrzenek. Toto nastavení můžete ještě individuálně upravovat před samotnou platbou za návštěvu.": "Určuje základný stav odosielania stvrdeniek. Toto nastavenie môžete ešte individuálne upravovať pred samotnou platbou za návštevu.",
    "Určuje, kolik dní před návštěvou musí být provedena platba. Pokud není zaplaceno včas, návštěva se automaticky smaže. (0 dní = nikdy nedojde ke smazání)": "Určuje, koľko dní pred návštevou musí byť vykonaná platba. Ak nie je zaplatené včas, návšteva sa automaticky zmaže. (0 dní = nikdy nedôjde k zmazaniu)",
    "Určuje, v jakém časovém rozmezí (počet dní) musí být všechny rezervace v rámci jedné objednávky.": "Určuje, v akom časovom rozpätí (počet dní) musia byť všetky rezervácie v rámci jednej objednávky.",
    "Určuje, zda musí být během služby přítomen terapeut. Vypíná se např. u služeb bez přímé obsluhy (vana, infrasauna apod.).": "Určuje, či musí byť počas služby prítomný terapeut. Vypína sa napr. pri službách bez priamej obsluhy (vaňa, infrasauna a pod.).",
    "user.form.role.worker.tooltip": "Zamestnanec nemá prístup do záložiek Štatistiky, Poisťovne a Nastavenia. Ďalej nemôže meniť zvolenú tarifu spolupráce.",
    "Úspěšně jste byli zaregistrováni jako náhradník": "Úspešne ste boli zaregistrovaní ako náhradník",
    "Úspěšně nahrána dávka do Purobota": "Dávka úspešne nahraná do aplikácie Purobot",
    "Úterý": "Utorok",
    "Už mám odcvičeno:": "Už mám odcvičené:",
    "Územní pracoviště VZP": "Uzemné pracovisko VZP",
    "Uživatel": "Užívateľ",
    "Uživatel byl deaktivován": "Užívateľ bol deaktivovaný",
    "Uživatel byl úspěšně přidán": "Užívateľ bol úspešne pridaný",
    "Uživatelé": "Používatelia",
    "v angličtině": "v angličtine",
    "v češtině": "v češtine",
    "V historii cvičení nejsou žádné záznamy.": "V histórii cvičení nie sú žiadne záznamy.",
    "V historii rezervací zatím není žádná absolvovaná návštěva.": "V histórii rezervácií zatiaľ nie je žiadna absolvovaná návšteva.",
    "V měsících, ode dne zakoupení": "V mesiacoch, odo dňa zakúpenia",
    "v nejnovější verzi Google Chrome, kterou můžete zdarma stáhnout na": "v najnovšej verzii Google Chrome, ktorú môžete zadarmo stiahnuť na",
    "V ordinaci hotově/kartou": "V pracovisku v hotovosti/kartou",
    "v polštině": "v poľštine",
    "V případě neuhrazení může dojít k dočasnému zablokování Vašeho účtu.": "V prípade neuhradenia môže dôjsť k dočasnému zablokovaniu Vášho účtu.",
    "V případě, že je tato volba zapnuta, pacientům automaticky odchází i stvrzenky za zakoupené permanentky.": "V prípade, že je táto voľba zapnutá, klientom automaticky odchádzajú aj stvrdenky za zakúpené permanentky.",
    "V případě, že přejdete na některý z pokročilých tarifů spolupráce, automaticky se ruší limit na počet pacientů v aplikaci.": "V prípade, že prejdete na nejaký z pokročilých tarifov spolupráce, automaticky sa ruší limit na počet klientov v aplikácii.",
    "V případě, že se nemůžete dostavit, volejte na": "V prípade, že sa nemôžete dostaviť, volajte na",
    "V tomto období se počet návštěv u každého z fyzioterapeutů rovná nule": "Počas tohto obdobia je počet návštev u každého terapeuta nulový.",
    "V tuto chvíli není možné GDPR potvrdit. Zkuste to znovu později.": "V tomto okamihu nie je možné GDPR potvrdiť. Skúste to znovu neskôr.",
    "Vám navýšíme limit kartotéky pacientů v balíčku Freemium.": "Vám navýšime limit kartotéky klientov v balíčku Freemium.",
    "Variabilní symbol": "Variabilný symbol",
    "Variabilní symbol:": "Variabilný symbol:",
    "Váš prohlížeč nepodporuje datový formát tohoto videa.": "Váš prehliadač nepodporuje dátový formát tohto videa.",
    "vaše číslo účtu nebo IBAN.": "vaše číslo účtu alebo IBAN.",
    "Vaše heslo bylo úspěšně změněno.": "Vaše heslo bolo úspešne zmenené.",
    "Vaše heslo bylo úspěšně změněno. Nyní se můžete přihlásit.": "Vaše heslo bolo úspešne zmenené. Teraz sa môžete prihlásiť.",
    "Vaše kategorie služeb byla smazána": "Vaša kategória služieb bola zmazaná",
    "Vaše platba proběhla v pořádku. Mockrát děkujeme, že využíváte aplikaci Fyzion.": "Vaša platba prebehla v poriadku. Veľmi ďakujeme, že využívate aplikáciu Fyzion.",
    "Vaše platba se bohužel nezdařila. Zkuste platbu opakovat. Jestliže platba opět neproběhne v pořádku, můžete zkusit zaplatit převodem.": "Vaša platba sa bohužiaľ nezdarila. Skúste platbu opakovať. Ak platba opäť neprebehne v poriadku, môžete skúsiť zaplatiť prevodom.",
    "Vaše rodné číslo potřebujeme k vytvoření vaší karty pacienta, nebo abychom ověřili, že u nás už kartu máte. S rodným číslem nakládáme v souladu s vyhláškou o zdravotnické dokumentaci.": "Vaše rodné číslo potrebujeme na vytvorenie vašej karty klienta, alebo aby sme overili, že u nás už kartu máte. S rodným číslom nakladáme v súlade s vyhláškou o zdravotníckej dokumentácii.",
    "Vaše služba byla smazána": "Vaša služba bola zmazaná",
    "Vaše zpráva": "Vaša správa",
    "Vaši rezervaci už nelze zrušit online!": "Vašu rezerváciu už nie je možné zrušiť online!",
    "Včera": "Včera",
    "včetně prodeje zboží": "vrátane predaja tovaru",
    "ve slovenštině": "ve slovenčine",
    "Veřejné zdravotní pojištění": "Verejné zdravotné poistenie",
    "Video": "Video",
    "Video a obrázky cviku": "Video a obrázky cviku",
    "Visa ikona": "Visa ikona",
    "Vítáme vás v aplikaci Fyzion": "Vitáme vás v aplikácii Fyzion",
    "Vítejte na přihlašovací stránce klientského portálu CortexApp.": "Vitajte na prihlasovacej stránke klientského portálu Fyzion.",
    "Vítejte v CortexApp": "Vítejte vo Fyzionu",
    "Vlastní": "Vlastný",
    "Vložit konečnou (zkopírovat první) zastávku": "Vložiť konečnú (skopírovať prvú) zastávku",
    "Vložit pod stávající zápis": "Vložiť pod existujúci zápis",
    "Vložit zastávku cesty": "Vložiť zastávku cesty",
    "Vložit zpáteční (zkopírovat předchozí) zastávku": "Vložiť spätnú (skopírovať predchádzajúcu) zastávku",
    "Volno (Dovolená)": "Volno (Dovolenka)",
    "Volno odstraněno": "Volno odstránené",
    "VOP úspěšně nahrány": "VOP úspešne nahrané",
    "VOP úspěšně odebrány": "VOP úspešne odobraté",
    "Vrátit do průvodce?": "Vrátiť do sprievodcu?",
    "Vše": "Všetko",
    "Všechny": "Všetky",
    "Všechny doklady": "Všetky doklady",
    "Všechny jeho návštěvy zůstanou nadále ve Vašem kalendáři, ale nebude již možné vytvářet nové návštěvy pacientovi ani se Vám nebude pacient nabízet v seznamu pacientů.": "Všetky jeho návštevy zostanú naďalej vo Vašom kalendári, ale nebude už možné vytvárať nové návštevy klientovi ani sa Vám nebude klient ponúkať v zozname klientov.",
    "Všechny místnosti": "Všetky miestnosti",
    "Všechny naplánované návštěvy na této pobočce zůstanou zachovány.": "Všetky naplánované návštevy na tejto pobočke zostanú zachované.",
    "Všechny naplánované návštěvy v této místnosti zůstanou zachovány.": "Všetky naplánované návštevy v tejto miestnosti zostanú zachované.",
    "Všechny pobočky": "Všetky pobočky",
    "Všechny poukazy": "Všetky poukazy",
    "Všechny pracoviště": "Všetky pracoviská",
    "Všechny služby": "Všetky služby",
    "Všechny typy služeb": "Všetky typy služieb",
    "Všeobecné obchodní podmínky": "Všeobecné obchodné podmienky",
    "všeobecnými obchodními podmínkami": "všeobecnými obchodnými podmienkami",
    "Všeobecnými obchodními podmínkami": "Všeobecnými obchodnými podmienkami",
    "Všichni": "Všetci",
    "Všichni klienti": "Všetci klienti",
    "Všichni pacienti": "Všetci klienti",
    "Vyberte": "Vyberte",
    "Vyberte alespoň jednu službu": "Vyberte aspoň jednu službu",
    "Vyberte dokumenty": "Vyberte dokumenty",
    "Vyberte FT poukaz": "Vyberte FT poukaz",
    "Vyberte kategorii služby podle jejího typu (např. masáže, skupinové cvičení). Kategorie ovlivňuje přehlednost a zobrazení služeb v online rezervacích.": "Vyberte kategóriu služby podľa jej typu (napr. masáže, skupinové cvičenie). Kategória ovplyvňuje prehľadnosť a zobrazenie služieb v online rezerváciách.",
    "Vyberte klienta jako náhradníka": "Vyberte klienta ako náhradníka",
    "Vyberte obrázky": "Vyberte obrázky",
    "Vyberte pacienta": "Vyberte klienta",
    "Vyberte předplatné": "Vyberte predplatné",
    "Vyberte prosím alespoň 1 fotografii.": "Vyberte prosím aspoň 1 fotografiu.",
    "Vyberte šablonu": "Vyberte šablónu",
    "Vyberte soubor": "Vyberte súbor",
    "Vyberte soubory k nahrání do systému": "Vyberte súbory na nahranie do systému",
    "Vyberte termín": "Vyberte termín",
    "Vyberte typ poukazu": "Vyberte typ poukazu",
    "Vyberte typ spisu": "Vyberte typ spisu",
    "Vyberte typ výkonu z číselníku ÚZIS. Povinné pole sloužící pro statistiky a vykazování.": "Vyberte typ výkonu z číselníka ÚZIS. Povinné pole slúžiace na štatistiky a vykazovanie.",
    "Vyberte video": "Vyberte video",
    "Vyberte zboží...": "Vyberte tovar...",
    "Vybraná šablona nebyla nalezena": "Vybraná šablóna nebola nájdená",
    "Vybraná šablona neobsahuje žádné výkony": "Vybraná šablóna neobsahuje žiadne výkony",
    "Vybrané dávky elektronicky podepíšete v aplikaci Fyzion Signer — jedním podpisem, v němž dávky nejprve projdete. Fyzion je poté odešle zdravotní pojišťovně a o výsledku vás bude informovat e-mailem.": "Vybrané dávky elektronicky podpíšete v aplikácii Fyzion Signer — jedným podpisom, v ktorom dávky najprv prejdete. Fyzion ich potom odošle zdravotnej poisťovni a o výsledku vás bude informovať e-mailom.",
    "Vybrané dávky odešlete s ověřením jedním SMS kódem. Hromadně lze odeslat jen dávky pojišťoven jednoho portálu. O výsledku vás budeme informovat e-mailem.": "Vybrané dávky odošlite s overením jedným SMS kódom. Hromadne možno odoslať iba dávky poisťovní jedného portálu. O výsledku vás budeme informovať e-mailom.",
    "Vybrané termíny": "Vybrané termíny",
    "Vybráni všichni klienti seznamu, celkem": "Vybraní všetci klienti zoznamu, celkom",
    "Vybráno cviků": "Vybrané cviky",
    "Vybraný terapeut neprovádí zvolenou službu. Prosím vyberte jinou službu nebo terapeuta.": "Vybraný terapeut nevykonáva vybranú službu. Vyberte si inú službu alebo terapeuta.",
    "Vybrat": "Vybrať",
    "Vybrat barvu": "Vybrať farbu",
    "Vybrat barvu štítku": "Vybrať farbu štítku",
    "Vybrat diagnózu": "Vybrať diagnózu",
    "Vybrat dodavatele": "Vybrať dodávateľa",
    "Vybrat druh péče": "Vybrať druh starostlivosti",
    "Vybrat druh úhrady": "Vybrať druh úhrady",
    "Vybrat IČP": "Vybrať IČP",
    "Vybrat kategorii": "Vybrať kategóriu",
    "Vybrat kód": "Vybrať kód",
    "Vybrat období": "Vybrať obdobie",
    "Vybrat odbornost": "Vybrať odbornost",
    "Vybrat ostatní diagnózy": "Vybrať ostatné diagnózy",
    "Vybrat pacienta": "Vybrať klienta",
    "Vybrat podkategorii": "Vybrať podkategóriu",
    "Vybrat pracoviště": "Vybrať pracovisko",
    "Vybrat pracovníky": "Vybrať pracovníkov",
    "Vybrat šablonu": "Vybrať šablónu",
    "Vybrat správnou kartu": "Vybrať správnu kartu",
    "Vybrat vše": "Vybrať všetko",
    "Vybrat všechny klienty seznamu, celkem": "Vybrať všetkých klientov zoznamu, celkom",
    "Vybrat výkon": "Vybrať výkon",
    "Výchozí": "Východzie",
    "Výchozí šablona": "Východzia šablóna",
    "Vyčistit filtr": "Vyčistiť filter",
    "Vygenerovat fakturu": "Vygenerovať faktúru",
    "Vyhledat": "Vyhľadať",
    "Vyhledat diagnózu": "Vyhľadať diagnózu",
    "Vykázat výkon bez FT poukazu": "Vykázať výkon bez FT poukazu",
    "Výkon": "Výkon",
    "Výkon je odemknutý": "Výkon je odomknutý",
    "Výkon je zamknutý": "Výkon je zamknutý",
    "Výkon nelze upravit, protože je již přiřazen k návštěvě.": "Výkon nie je možné upraviť, pretože je už priradený k návšteve.",
    "Výkonová": "Výkonová",
    "výkonů": "výkonov",
    "Výkonů na stránku": "Výkonov na stránku",
    "vykony": "vykony",
    "Výkony": "Výkony",
    "Výkony nezapsané na návštěvě budou smazány.": "Výkony nezapísané na návšteve budú vymazané.",
    "Vylepšení textu se nezdařilo.": "Vylepšenie textu sa nepodarilo.",
    "Vylepšený text": "Vylepšený text",
    "Vylepšit s AI": "Vylepšiť s AI",
    "Vylepšit zprávu": "Vylepšiť správu",
    "Vyplňte ve formátu +420 123 456 789": "Vyplňte vo formáte +420 123 456 789",
    "Vyplňte ve formátu DD.MM.RRRR": "Vyplňte vo formáte DD.MM.RRRR",
    "Vyplňte ve formátu HH:mm": "Vyplnte v tvare HH:mm",
    "Vyplňte, pokud pacient změnil pojišťovnu, abychom mohli správně vytvořit dávku.": "Vyplňte, pokiaľ klient zmenil poisťovňu, aby sme mohli správne vytvoriť dávku.",
    "Výše kreditu:": "Výška kreditu:",
    "Výše max. úhrady": "Výška max. úhrady",
    "Výše max. úhrady:": "Výška max. úhrady:",
    "Výše paušálu:": "Výška paušálu:",
    "Výše storno poplatku účtovaného při zrušení rezervace.": "Výška storno poplatku účtovaného pri zrušení rezervácie.",
    "výskytech": "výskytoch",
    "výskytu": "výskytu",
    "Vystavovat fakturu pro platby převodem": "Vystavovať faktúru pre platby prevodom",
    "Vystavovat faktury místo stvrzenek": "Vystavovať faktúry namiesto potvrdení",
    "vytisknout": "vytlačiť",
    "Vytisknout": "Vytlačiť",
    "Vytváření rezervace": "Vytváranie rezervácie",
    "Vytvoření": "Vytvorenie",
    "Vytvořeno": "Vytvorene",
    "Vytvořit": "Vytvoriť",
    "Vytvořit 3 návštěvy": "Vytvoriť 3 návštevy",
    "Vytvořit a tisknout": "Vytvoriť a vytlačiť",
    "Vytvořit dávku": "Vytvoriť dávku",
    "Vytvořit dávky": "Vytvoriť dávky",
    "Vytvořit faktury": "Vytvoriť faktúry",
    "Vytvořit FT poukaz": "Vytvoriť FT poukaz",
    "Vytvořit novou kategorii": "Vytvoriť novú kategóriu",
    "Vytvořit novou podkategorii": "Vytvoriť novú podkategóriu",
    "Vytvořit novou rezervaci": "Vytvoriť novú rezerváciu",
    "Vytvořit novou službu": "Vytvoriť novú službu",
    "Vytvořit nový cvik": "Vytvoriť nový cvik",
    "Vytvořit opravnou dávku": "Vytvoriť opravnú dávku",
    "Vytvořit platbu": "Vytvoriť platbu",
    "Vytvořit pobočku": "Vytvoriť pobočku",
    "Vytvořit poukaz": "Vytvoriť poukaz",
    "Vytvořit rezervaci": "Vytvoriť rezerváciu",
    "Vytvořit šablonu výkonů": "Vytvoriť šablónu výkonov",
    "Vytvořit zprávu": "Vytvoriť správu",
    "Využívat klientský portál": "Využívať klientský portál",
    "Vyžádat SMS kód": "Vyžiadať SMS kód",
    "Vyžadovat poznámku": "Vyžadovať poznámku",
    "Vyžaduje přítomnost terapeuta": "Vyžaduje prítomnosť terapeuta",
    "Vyzkoušejte Fyzion Zdarma!": "Vyskúšajte Fyzion zadarmo!",
    "Vyzkoušejte si Fyzion zdarma a přesvědčte se sami proč ho používá více jak 1000 fyzioterapetů v ČR. Stačí vyplnit několik údajů ve formuláři níže a můžete začít. Později můžete snadno upgradovat na vyšší tarif.": "Vyskúšajte Fyzion zadarmo a presvedčte sa sami, prečo ho používa viac ako 3000 terapeutov v Českej republike a na Slovensku. Stačí vyplniť niekoľko údajov v nižšie uvedenom formulári a môžete začať. Neskôr môžete ľahko prejsť na vyšší tarif.",
    "Vzdálenost (km)": "Vzdialenosť (km)",
    "Vzdálenost od předchozí zastávky v km": "Vzdialenosť od predchádzajúcej zastávky v km",
    "Vždy uvádějte jméno pacienta (i v případě dítěte)": "Vždy uvádzajte meno klienta (i v prípade dieťaťa)",
    "Webinář": "Webinár",
    "white-mark": "white-mark",
    "x": "x",
    "z": "z",
    "z ceny aplikace": "z ceny aplikacie",
    "z toho v hotovosti": "z toho v hotovosti",
    "Z-Poukaz": "Z-Poukaz",
    "Začínáme": "Začíname",
    "Zadané telefonní číslo je neplatné.": "Zadané telefónne číslo je neplatné.",
    "zadatele": "zadatela",
    "Žadatelé": "Žiadatelia",
    "Žadatelé na stránku": "Žiadatelia na stránku",
    "Zadejte název služby, kterou nabízíte (např. individuální fyzioterapie, elektroléčba, dětská fyzioterapie, zdravotní cvičení). Název se zobrazuje v kalendáři i v online rezervačním systému.": "Zadajte názov služby, ktorú ponúkate (napr. individuálna terapia, elektroliečba, detská terapia, zdravotné cvičenie). Názov sa zobrazuje v kalendári aj v online rezervačnom systéme.",
    "Zadejte nové heslo": "Zadajte nové heslo",
    "Zadejte platnou e-mailovou adresu": "Zadajte platnú e-mailovú adresu",
    "Zadejte prosím e-mail, na který Vám zašleme informace k obnovení hesla.": "Zadajte prosím e-mail, na ktorý Vám zašleme informácie k obnoveniu hesla.",
    "Zadejte SMS kód z portálu pojišťovny. Platný kód, který už máte, můžete použít znovu, nový si vyžádejte jen tehdy, když žádný nemáte.": "Zadajte SMS kód z portálu poisťovne. Platný kód, ktorý už máte, môžete použiť znova, nový si vyžiadajte len vtedy, keď žiadny nemáte.",
    "Zadejte validní tel. číslo": "Zadajte validné tel. číslo",
    "Žádná pobočka není k dispozici": "Žiadna pobočka nie je k dispozícii",
    "Žádná služba není k dispozici": "Žiadna služba nie je k dispozícii",
    "Žádné akce k zobrazení": "Žiadne akcie k zobrazeniu",
    "Žádné dávky k zobrazení": "Žiadne dávky k zobrazeniu",
    "Žádné doklady k zobrazení": "Žiadne doklady k zobrazeniu",
    "Žádné možnosti nebyly nalezeny": "Žiadne možnosti neboli nájdené",
    "Žádné návštěvy k zobrazení": "Žiadne návštevy k zobrazeniu",
    "Žádné stvrzenky k zobrazení": "Žiadne potvrdenky k zobrazeniu",
    "Žádné výkony k zobrazení": "Žiadne dávky k zobrazeniu",
    "Žádné výsledky": "Žiadne výsledky",
    "Žádné zpráva k zobrazení": "Žiadna správa na zobrazenie",
    "Žádný fyzioterapeut není dostupný": "Žiaden terapeut nie je dostupný",
    "Žádný typ služby není k dispozici": "Žiadny typ služby nie je k dispozícii",
    "Zahrnuté služby": "Zahrnuté služby",
    "Základní diagnóza": "Základná diagnóza",
    "Zákonný zástupce": "Zákonný zástupca",
    "Zákonný zástupce:": "Zákonný zástupca:",
    "Zákres": "Zákres",
    "Zaměstnanci": "Zamestnanci",
    "Zaměstnanec": "Zamestnanec",
    "Zamezit online rezervace:": "Zabrániť online rezerváciám:",
    "Zamknutou návštěvu nelze měnit.": "Zamknutú návštevu nie je možné meniť.",
    "Zaplaceno": "Zaplatené",
    "Zaplaceno:": "Zaplatené:",
    "zaplatit": "Zaplatiť",
    "Zaplatit": "Zaplatiť",
    "Zaplatit permanentkou": "Zaplatiť permanentkou",
    "Zaplatit pomocí QR kódu": "Zaplatiť pomocou QR kódu",
    "Zaplatit QR kódem": "Zaplatiť QR kódom",
    "Zaplaťte pomocí QR kódu": "Zaplaťte pomocou QR kódu",
    "Zaplaťte předplatným, jestliže ho některá instituce poskytuje": "Zaplaťte predplatným, jestliže ho nejaká inštitúcia poskytuje",
    "Zapnutím povolíte klientům rušení rezervací této služby.": "Zapnutím povolíte klientom rušenie rezervácií tejto služby.",
    "Zapnutím povolíte zobrazování služby v online rezervačním systému. Bez zapnutí nebude možné službu rezervovat online.": "Zapnutím povolíte zobrazovanie služby v online rezervačnom systéme. Bez zapnutia nebude možné službu rezervovať online.",
    "Zapnutím této funkce aktivujete integraci s McKenzie formuláři. Toto nastavení nelze po aktivaci vypnout.": "Zapnutím tejto funkcie aktivujete integráciu s McKenzie formulármi. Toto nastavenie nie je možné po aktivácii vypnúť.",
    "Zapomněli jste heslo?": "Zabudli ste heslo?",
    "Zapsáno": "Zapsané",
    "Zapsat cestu": "Zapísať cestu",
    "Zapsat výkon": "Zapsať výkon",
    "zásadami zpracování osobních údajů": "zásadami spracovania osobných údajov",
    "Zásob na stránku": "Zásob na stránku",
    "zasoby": "zasoby",
    "Zásoby": "Zásoby",
    "Zásoby na skladě": "Zásoby na sklade",
    "Zastávka": "Zastávka",
    "Zatím nebyl nahrán žádný dokument.": "Zatiaľ nebol nahratý žiadny dokument.",
    "Zatím nebyla nahrána žádná videa.": "Zatiaľ niebolo nahrané žiadne video.",
    "Zatím nebyly nahrány žádné obrázky.": "Zatiaľ neboli nahrané žiadne obrázky.",
    "Zatím nebyly vytvořeny žádné permanentky": "Zatiaľ neboli vytvorené žiadne permanentky",
    "Zatím nejsou nahrána žádná videa.": "Zatiaľ nie sú nahrané žiadne videá.",
    "Zatím nejsou naplánovány žádné cviky.": "Zatiaľ nie sú naplánované žiadne cviky.",
    "Zatím nejsou žádné recenze.": "Zatiaľ nie sú žiadne recenzie.",
    "Zatím nemáte naplánované žádné pacienty": "Zatiaľ nemáte naplánovaných žiadnych klientov",
    "Zatím zde nejsou žádné cviky": "Zatiaľ tu nie sú žiadne cviky.",
    "Zatím zde nejsou žádné položky": "Zatiaľ tu nie sú žiadne položky",
    "Zatím zde nejsou žádné předplatné": "Zatiaľ tu nie sú žiadne predplatné",
    "Zatím zde nejsou žádné proběhlé návštěvy": "Zatiaľ tu nie sú žiadne prebehnuté návštevy",
    "Zatím zde nejsou žádné šablony": "Zatiaľ tu nie sú žiadne šablóny",
    "Zatím zde nejsou žádné služby": "Zatiaľ tu nie sú žiadne služby",
    "Zatím zde nejsou žádné spisy": "Zatiaľ tu nie sú žiadne spisy",
    "Zatím zde nejsou žádné zásoby": "Zatiaľ tu nie sú žiadne zásoby",
    "Zatím zde nejsou žádné záznamy": "Zatiaľ tu nie sú žiadne záznamy",
    "Zatím zde nejsou žádní dodavatelé": "Zatiaľ tu nie sú žiadny dodávatelia",
    "Zatím zde nejsou žádní pacienti": "Zatiaľ tu nie sú žiadni klienti",
    "Zavolat do ordinace": "Zavolat do ordinacie",
    "Zavolat na číslo": "Zavolať na číslo",
    "Zavolejte nám na telefon:": "Zavolajte nám na telefón:",
    "Zavřeno": "Zatvorené",
    "Zavřít": "Zavrieť",
    "Zavřít menu": "Zavrieť menu",
    "Zavřít platbu": "Zatvoriť platbu",
    "Zavřít zboží": "Zavrieť tovar",
    "Záznamů na stránku": "Záznamov na stránku",
    "zaznamy": "zaznamy",
    "Zboží": "Tovar",
    "Zboží bylo úspěšně naskladněno": "Tovar bol úspešne naskladnený",
    "Zboží se nepodařilo naskladnit": "Tovar sa nepodarilo naskladniť",
    "Zbývající počet znaků": "Zbývajúci počet znakov",
    "Zbývajících vstupů": "Zostávajúcich vstupov",
    "Zdá se, že nám hledaná": "Zdá sa, že nám hľadaná",
    "Zdarma": "Zdarma",
    "ZDARMA": "ZDARMA",
    "ZDE": "ZDE",
    "Zde můžete nahrát dokumenty, které se týkají vybraného profilu.": "Tu môžete nahrať dokumenty, ktoré sa týkajú vybraného profilu.",
    "Zde prosím nahrajte svá data, která chcete nahrát do systému.": "Tu prosím nahrajte svoje dáta, ktoré chcete nahrať do systému.",
    "Zde se zobrazují všechny dokumenty, které jste v rámci návštěv daného pacienta nahráli": "Tu sa zobrazujú všetky dokumenty, ktoré ste počas návštev daného klienta nahrali",
    "Zdravotní pojišťovna": "Zdravotná poisťovňa",
    "Zdravotní pojišťovna podání odmítla, protože certifikát, kterým byla dávka podepsána, není zaveden u vašeho účtu na jejím portále. Podepište podání certifikátem, který máte na portále zdravotní pojišťovny zavedený, a dávku odešlete znovu.": "Zdravotná poisťovňa podanie odmietla, pretože certifikát, ktorým bola dávka podpísaná, nie je zavedený u vášho účtu na jej portáli. Podpíšte podanie certifikátom, ktorý máte na portáli zdravotnej poisťovne zavedený, a dávku odošlite znova.",
    "Zdravotní pojišťovna podání odmítla, protože SMS kód byl neplatný nebo mu vypršela platnost. Vyžádejte si nový kód a dávku odešlete znovu.": "Zdravotná poisťovňa podanie odmietla, pretože SMS kód bol neplatný alebo mu vypršala platnosť. Vyžiadajte si nový kód a dávku odošlite znova.",
    "Zelená": "Zelená",
    "Země": "Krajina",
    "Žena": "Žena",
    "Ženy": "Ženy",
    "Ženy (budoucí)": "Ženy (objednané)",
    "Zjistit více": "Zistiť viac",
    "Zkontrolujte prosím zadanou adresu v prohlížeči.": "Skontrolujte prosím zadanú adresu v prehliadači.",
    "Zkopírováno": "Zkopírované",
    "Zkopírovat": "Skopírovať",
    "Zkopírovat kód": "Skopírovať kód",
    "Zkopírovat odkaz do schránky": "Zkopírovať odkaz do schránky",
    "Zkopírovat odkaz na rezervaci této služby": "Skopírovať odkaz na rezerváciu tejto služby.",
    "Zkuste to znovu": "Skúste to znova",
    "Žlutá": "Žltá",
    "Změna hesla": "Zmena hesla",
    "Změna se nezdařila. Prosím zkontrolujte údaje ve formuláři": "Zmena sa nepodarila. Prosím, skontrolujte údaje vo formulári.",
    "Změna tarifu není možná": "Zmena tarifu nie je možná",
    "Změnit": "Zmeniť",
    "Změnit heslo": "Zmena hesla",
    "Změnit konfiguraci": "Zmeniť konfiguráciu",
    "Změnit stav": "Zmeniť stav",
    "Změnit stav na „%{status}“?": "Zmeniť stav na „%{status}“?",
    "Změnit typ platby nebo částku můžete v editaci plateb.": "Zmeniť typ platby alebo čiastku môžete v editácii platieb.",
    "Zobrazit": "Zobrazit",
    "Zobrazit méně": "Zobrazit menej",
    "Zobrazit starší": "Zobraziť staršie",
    "Zobrazit všechny recenze": "Zobraziť všetky recenzie",
    "Zobrazit všechny zaměstnance": "Zobraziť všetkých zamestnancov",
    "Zobrazovat bloky v kalendáři po 15 minutách": "Zobrazovať bloky v kalendári po 15 minútach",
    "Zobrazovat jednotlivé terapeuty v online rezervačním systému": "Zobrazovať jednotlivých terapeutov v online rezervačnom systéme",
    "Zobrazovat jména ve formátu PŘÍJMENÍ JMÉNO v kartotéce": "Zobrazovať mená vo formáte PRIEZVISKO MENO v kartotéke",
    "zpět": "späť",
    "Zpět": "Späť",
    "Zpět do aplikace": "Návrat do aplikácie",
    "Zpět na cviky": "Späť na zoznam dávok",
    "Zpět na přihlášení": "Späť na prihlásenie",
    "Zpět na seznam dávek": "Späť na zoznam dávok",
    "Zpráva od terapeuta": "Správa od terapeuta",
    "zpravy": "spravy",
    "Způsob platby": "Spôsob platby",
    "Způsob platby při rezervaci online": "Spôsob platby pri rezervácii online",
    "Zrušená fakturace": "Zrušená fakturácia",
    "Zrušená návštěva klienta": "Zrušená návšteva klienta",
    "Zrušení rezervace": "Zrušenie rezervácie",
    "Zrušení rezervací se bude řídit obecným nastavením firmy.": "Zrušenie rezervácií sa riadi všeobecným nastavením firmy.",
    "Zrušení se storno poplatkem": "Zrušenie so storno poplatkom",
    "Zrušení se storno poplatkem (před návštěvou)": "Zrušenie so storno poplatkom (pred návštevou)",
    "Zrušením platby stornujete vytvořenou stvrzenku, vrátíte vstup na permanentku nebo vrátíte kredity na předplatné. Záleží na předchozím typu platby.": "Zrušením platby stornujete vytvorenú stvrdenku, vrátite vstup na permanentku alebo vrátite kredity na predplatné. Záleží na predchádzajúcom type platby.",
    "Zrušeno": "Zrušiť",
    "Zrušeno terapeutem": "Zrušené terapeutom",
    "Zrušit": "Zrušiť",
    "Zrušit dle storno podmínek": "Zrušiť podľa storno podmienok",
    "ZRUŠIT FILTR": "ZRUŠIŤ FILTR",
    "Zrušit návštěvu": "Zrušiť návštevu",
    "Zrušit platbu": "Zrušiť platbu",
    "Zrušit přijetí": "Zrušiť prijatie",
    "Zrušit rezervaci": "Zrušiť rezerváciu",
    "Zůstat na stránce": "Zostať na stránke",
    "Zvolit": "Zvolit",
    "Zvolit fyzioterapeuta": "Zvoliť terapeuta",
    "Zvolit pobočku": "Zvoliť pobočku",
    "Zvolit službu": "Zvoliť službu",
    "Zvolit typ služby": "Zvoliť typ služby",
    "Zvolte alespoň jeden výkon": "Zvoľte aspoň jeden výkon",
    "Zvolte alespoň jednu pojišťovnu": "Zvoľte aspoň jednu poisťovňu",
    "Zvolte ANO, pokud spolupracujete s pojišťovnami. Umožníme vám zapisování výkonů a tvorbu dávek a faktur.": "Zvoľte ÁNO, ak spolupracujete s poisťovňami. Umožníme vám zapisovanie výkonov a tvorbu dávok a faktúr.",
    "Zvolte barvu, kterou bude služba označena v kalendáři a rezervačním systému.": "Zvoľte farbu, ktorou bude služba označená v kalendári a rezervačnom systéme.",
    "Zvolte čas": "Zvoľte čas",
    "Zvolte datum": "Zvoľte dátum",
    "Zobrazovat jméno vyšetřujícího v dokumentech": "Zobrazovať meno vyšetrujúceho v dokumentoch",
    "Platí pro dokument návštěvy a kartu klienta. Pokud je zapnuto, zobrazí se u každé návštěvy, kdo ji vyšetřil.": "Platí pre dokument návštevy a kartu klienta. Ak je zapnuté, pri každej návšteve sa zobrazí, kto ju vyšetril.",
    "Hrazeno pojišťovnou": "Hradené poisťovňou"
  },
  "pl": {
    " Identifikátor propojení obchodu ": " Identyfikator powiązania sklepu ",
    " pacientů. Přidáním tohoto pacienta tuto kapacitu překročíte.": " klientów. Dodaniem tego klienta przekroczysz limit.",
    ":companyWorkspaceId/pridat-pojistovnu": ":companyWorkspaceId/dodaj-ubezpieczyciela",
    ":companyWorkspaceId/upravit": ":companyWorkspaceId/edytuj",
    ":companyWorkspaceId/upravit-pojistovnu/:insuranceContractId": ":companyWorkspaceId/edytuj-ubezpieczyciela/:insuranceContractId",
    ":insuranceApplicantId/upravit": ":insuranceApplicantId/edytuj",
    ":patientId/popisy-navstev": ":patientId/opisy-wizyt",
    ":serviceGroupId/upravit": ":serviceGroupId/edytuj",
    ":serviceId/upravit": ":serviceId/edytuj",
    ":stockItemId/upravit": ":stockItemId/edytuj",
    ":supplierId/upravit": ":supplierId/edytuj",
    ":userId/ordinacni-hodiny": ":userId/godziny-przyjęć",
    ":userId/upravit": ":userId/edytuj",
    ". Před návštěvou se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": "Przed wizytą prosimy o zapoznanie się z zasadami RODO. Aby wyświetlić treść RODO i potwierdzić, kliknij",
    "(obsazeno)": "(zajęte)",
    "(Přišli poprvé)": "(Przyszli po raz pierwszy)",
    "@": "mrudolf @ kdewebdev. org",
    "/akce": "/akcja",
    "/cekajici-pacienti": "/oczekujący-klienci",
    "/cviky": "/ćwiczenia",
    "/domu": "/do-domu",
    "/historie-akci": "/historia-akcji",
    "/historie-zprav": "/historia-wiadomości",
    "/kalendar": "/kalendarz",
    "/moje-navstevy": "/moje-wizyty",
    "/moje-profily": "/moje-profile",
    "/moje-udaje": "/moje-dane",
    "/nastaveni": "/ustawienia",
    "/novinky": "/nowości",
    "/ordinace": "/gabinet",
    "/pacienti": "/klienci",
    "/pacienti/novy": "/klienci/nowy",
    "/platba": "/płatność",
    "/platby": "/platnosci",
    "/pojistovny": "/ubezpieczyciele",
    "/predplatne": "/prenumerata",
    "/profil": "/profil",
    "/provedene-akce": "/ implemented",
    "/pruvodce/": "/przewodnik/",
    "/recenze": "/recenzje",
    "/rozcestnik-pruvodce/": "/menu-przewodnika/",
    "/rozsireni-kartoteky-zdarma": "/rozszerzenie-kartoteki-darmowe",
    "/sablony": "/szablony",
    "/sklad": "/magazyn",
    "/skupinove-navstevy/": "/wizyty-grupowe",
    "/soubory": "/pliki",
    "/statistiky": "/statystyki",
    "%": "%",
    "• E-mail: ": "• E-mail: ",
    "• IČO": "NIP",
    "+420 315 315 817": "+ 420 315 315 817",
    "<div>Dobrý den,</div><br/>v příloze zasíláme rozpis termínů fyzioterapie.": "<div>Dzień dobry,</div>w załączniku przesyłamy terminy fizjoterapii",
    "<div>Dobrý den,</div><br/>v příloze zasíláme zprávu z provedené terapie.": "<div>Dzień dobry,</div>w załączniku przesyłamy raport z przeprowadzonej terapii.",
    "1. čvrtletí": "1.kwartał",
    "2. čtvrtletí": "2.kwartał",
    "3 - Úraz způsobený jinou osobou": "3 - Uraz spowodowany przez inną osobę",
    "3. čtvrtletí": "3.kwartał",
    "4 - Alkohol a omamné látky": "4 - Alkohol i środki odurzające",
    "4. čvrtletí": "4.kwartał",
    "5 - Pracovní úraz": "5 - Wypadek przy pracy",
    "6 - Sociální důvody hospitalizace": "6 - Społeczne powody hospitalizacji",
    "60 pacientů": "60 klientów",
    "7 - Porušení léčebného režimu": "7- Naruszenie programu leczenia",
    "8 - Výměna komponent systému ASR_TM": "8 - Wymiana komponentu systemu ASR_TM",
    "9 - Nemoc z povolání": "9 - Choroba zawodowa",
    "A ROZŠIŘTE SI KARTOTÉKU": "Rozszerz swoją kartotekę",
    "a zaplatit": "i zapłacić",
    "Absolutní": "Stała kwota",
    "Absolutní storno poplatek": "Bezwzględna opłata za anulowanie",
    "Admin": "Admin",
    "Admin má neomezený přístup ke všem funkcím v rámci zvoleného tarifu": "Admin ma nieograniczony dostęp do wszystkich funkcji systemu w ramach wybranej taryfy",
    "Adresa": "Adres",
    "Adresa sídla": "Adres siedziby",
    "Adresa:": "Adres:",
    "Adresát": "Adresat",
    "Adresu ukládejte ve formátu: Ulice č.p, Město, PSČ": "Adres należy zapisywać w formacie: Ulica nr domu, Miasto, Kod pocztowy",
    "Akce": "Akcja",
    "Aktivace a dostupnost": "Aktywacja i dostępność",
    "Aktivací zpřístupníte klientský portál. Po naplánování návštěvy nového klienta nebo rezervace klient automaticky obdrží pozvánku do klientského portálu.": "Aktywacja udostępni portal klienta. Po zaplanowaniu wizyty nowego klienta lub rezerwacji klient automatycznie otrzyma zaproszenie do portalu klienta.",
    "Aktivní profil byl změněn": "Aktywny profil został zmieniony",
    "Aktivní tarif": "Aktywna taryfa",
    "Aktivovat cesty za pacienty": "Aktywować dojazdy do klientów",
    "aktualizujte": "aktualizuj",
    "Aktuální prostředí:": "Obecne środowisko:",
    "anamneza": "wywiad medyczny",
    "Anamnéza": "Wywiad medyczny",
    "Anamnéza zatím nebyla vyplněna.": "Wywiad lekarski nie został jeszcze wypełniony.",
    "Anamnézu se nepodařilo načíst": "Nie udało się wczytać wywiadu medycznego.",
    "Anamnézu se nepodařilo uložit": "Nie udało się zapisać wywiadu lekarskiego.",
    "Anamnézy": "Wywiady lekarskie",
    "Ano": "Tak",
    "API URL:": "URL API:",
    "aplikaci Fyzion na sociálních sítích nebo kdekoliv na webu.": "aplikację Fyzion w mediach społecznościowych lub gdziekolwiek w Internecie",
    "Aplikovat na všechny termíny": "Zastosuj do wszystkich terminów",
    "Aplikovat změny na toto a všechna budoucí volna": "Zastosuj zmiany do tego i wszystkich przyszłych przerw ( urlopów)",
    "Aplikovat změny na tuto a všechny budoucí návštěvy": "Zastosuj zmiany do tej i wszystkich przyszłych wizyt",
    "Aplikovat změny na tuto a všechny budoucí skupinové návštěvy": "Zastosuj zmiany do tej i wszystkich przyszłych wizyt grupowych",
    "Aplikovat změny pouze na toto volno": "Zastosuj zmiany tylko do tej przerwy ( urlopu)",
    "Aplikovat změny pouze na tuto návštěvu": "Zastosuj zmiany tylko tej wizyty",
    "Aplikovat změny pouze na tuto skupinovou návštěvu": "Zastosuj zmiany tylko tej wizyty grupowej",
    "Archivace": "Archiwizacja",
    "Archivovat": "Archiwizuj",
    "Automaticky kontaktovat náhradníky při smazání rezervace (pouze pro skupinové návštěvy)": "Automatycznie kontaktować osoby rezerwowe po usunięciu rezerwacji (tylko dla wizyt grupowych)",
    "Automaticky odešle klientovi informaci o vytvoření, změně či zrušení návštěvy.": "Automatycznie wysyła klientowi informację o utworzeniu, zmianie lub odwołaniu wizyty.",
    "Automaticky odešle klientovi připomínkovou SMS se zvolenými údaji v Nastavení. Zpráva se odesílá v časovém předstihu podle nastavení, vždy v 9 hodin ráno.": "Automatycznie wysyła do klienta SMS przypominający z wybranymi danymi z Ustawień. Wiadomość jest wysyłana z wyprzedzeniem zgodnie z ustawieniami, zawsze o godzinie 9:00 rano.",
    "Automaticky odešle klientovi připomínku e-mailem s datem a časem návštěvy. Zpráva se odesílá v časovém předstihu podle nastavení, vždy v 9 hodin ráno.": "Automatycznie wysyła klientowi e-mailowe przypomnienie z datą i godziną wizyty. Wiadomość jest wysyłana z wyprzedzeniem zgodnie z ustawieniami, zawsze o godzinie 9:00 rano.",
    "Automaticky použít permanentku k úhradě návštěvy": "Automatycznie użyj biletu, aby złożyć wizytę",
    "Balíček zdarma je v základním nastavení limitován počtem pacientů, které je možné mít v kartotéce, na 20. V případě, že jste dosáhli limitu, máte možnost tento limit navýšit až na": "Bezpłatny pakiet jest w ustawieniach podstawowych ograniczony liczbą klientów, których można mieć w kartotece, do 20. W przypadku osiągnięcia limitu masz możliwość zwiększenia tego limitu do nawet",
    "Bankovní údaje": "Dane bankowe",
    "Barva": "Kolor",
    "Barva místnosti": "Kolor pokoju",
    "Barva místnosti v kalendáři": "Kolor pokoju w kalendarzu",
    "Barva služby": "Kolor usługi",
    "Barva terapeuta": "Kolor terapeuty",
    "Barva v kalendáři": "Kolor w kalendarzu",
    "barvy-kalendare": "barwy-kalendarz",
    "Bederní": "lędźwiowy",
    "Beru na vědomí": "Przyjmuję do wiadomości",
    "bezchybně a rychle": "bezbłędnie i szybko",
    "bezhotovostně": "bezgotówkowo",
    "Bezplatná registrace": "Bezpłatna rejestracja",
    "Bezplatné přesunutí (před návštěvou)": "Bezplatne przeniesienie (przed wizytą)",
    "Bezplatné zrušení (před návštěvou)": "Bezplatné zrušení (przed wizytą)",
    "Bezplatné zrušení nejpozději": "Bezpłatne anulowanie najpóźniej",
    "Blok do kalendáře": "Blok do kalendarza",
    "Blok do kalendáře zamezující rezervaci": "Kalendarz, aby uniknąć rezerwacji",
    "Bodů": "Punktów",
    "Bodů celkem": "Punkty ogółem",
    "Body": "Punkty",
    "Body:": "Ciało:",
    "Bude použito i pro variabilní symbol": "Będzie użyte rownież w symbolu zmiennym",
    "Budeme vás kontaktovat e-mailem nebo telefonicky, pokud se uvolní místo": "Skontaktujemy się mailowo lub telefonicznie, jeśli zwolni się miejsce",
    "Budoucí návštěvy": "Przyszłe wizyty",
    "Čas": "Czas",
    "Čas byl úspěšně vybrán. Vyberte ještě": "Czas został pomyślnie wybrany. Wybierz jeszcze",
    "Čas do je povinný": "Czas jest obowiązkowy",
    "Čas od je povinný": "Czas od jest obowiązkowy",
    "Čas:": "Czas:",
    "Časové okno pro rezervace": "Okno czasowe dla rezerwacji",
    "Časové okno pro rezervaci hromadných termínů": "Okno czasowe dla rezerwacji wielu dat",
    "Časový interval před návštěvou, během kterého může klient rezervaci bezplatně přesunout.": "Przedział czasowy przed wizytą, podczas którego klient może przenieść rezerwację bezpłatnie.",
    "Časový interval před návštěvou, během kterého může klient rezervaci zrušit bez poplatku.": "Przedział czasowy przed wizytą, podczas którego klient może anulować rezerwację bez opłat.",
    "Časový interval před návštěvou, kdy je možné rezervaci zrušit, ale se storno poplatkem.": "Odstęp czasu przed wizytą, kiedy można anulować rezerwację, ale za opłatą za anulowanie rezerwacji.",
    "Částka": "Kwota",
    "Částka bude vypočítána jako celková cena všech položek.": "Kwota zostanie obliczona jako łączna cena wszystkich pozycji.",
    "Částka k úhradě": "Kwota do zapłaty",
    "Částka nesmí být vyšší než cena návštěvy": "Kwota nie może być wyższa niż cena wizyty",
    "Čeká na autorizaci": "Oczekuje na autoryzację",
    "Čeká na platbu": "Oczekuje na płatność",
    "Čeká na zaplacení": "Oczekuje na zapłatę",
    "Čekající": "Oczekujący",
    "Čekající pacienti": "Oczekujący klienci",
    "Čekající:": "Oczekujący:",
    "Celkem": "Łącznie",
    "Celkem k úhradě": "Łącznie do zapłaty",
    "Celkem náhradníků:": "Łączna liczba rezerwowych:",
    "Celkem návštěv:": "Łącznie wizyt:",
    "Celkový čas návštěvy klienta. Tato doba se zobrazuje klientovi v potvrzení rezervace a v pozvánce.": "Całkowity czas wizyty klienta. Tym razem jest pokazywany klientowi w potwierdzeniu rezerwacji i w zaproszeniu.",
    "Celkový časový blok rezervovaný v kalendáři pro tuto službu. Zahrnuje čas pro pacienta i navazující činnosti (administrativa, úklid, hygienická pauza apod.).": "Całkowity blok czasowy zastrzeżony w kalendarzu dla tej usługi. Obejmuje czas klienta i działania następcze (podawanie, czyszczenie, higiena itp.).",
    "Celkový počet odeslaných SMS": "Łączna liczba wysłanych wiadomości SMS",
    "Celý den": "Cały dzień",
    "Cena": "Cena",
    "Cena celkem": "Cena celkem",
    "Cena nemůže být nižší než 0": "Cena nie może być niższa niż 0",
    "Cena nesmí být záporná": "Cena nie może być ujemna",
    "Cena permanentky": "Cena karnetu",
    "Cena s DPH": "Cena z VAT",
    "Cena služby.": "Cena usługi.",
    "Cena za MJ": "Cena za jednostkę",
    "Cena:": "Cena:",
    "Certifikát": "Certyfikat",
    "Červená": "Czerwona",
    "Cestovní zdravotní pojištění": "Zdrowotne ubezpieczenie podróżne",
    "Četl/a jsem a souhlasím se": "Czytałem/łam i zgadzam się",
    "Chápeme, že nyní není vhodný čas, k průvodci se můžete kdykoliv vrátit, případně využít tipy a nápovědu.": "Rozumiemy, że teraz nie jest odpowiedni moment, do przewodnika możesz wrócić w każdej chwili, ewentualnie skorzystać z podpowiedzi i wskazówek.",
    "Charakter": "Charakter",
    "Charakter dávky": "Charakter paczki",
    "Chcete pokračovat v zadání návštěvy:": "Czy chcesz kontynuować wprowadzanie wizyty:",
    "Chcete-li vytvořit rezervaci nebo spravovat své termíny, přihlaste se ke svému účtu.": "Aby utworzyć rezerwację lub zarządzać swoimi terminami, zaloguj się na swoje konto.",
    "Chci naplánovat": "Chcę zaplanować",
    "chyba": "błąd",
    "Chyba při přesměrování na registraci náhradníka": "Błąd podczas przekierowania do rejestracji rezerwowego",
    "Cíl": "Cel",
    "Čísla dokladů v dávce od": "Numery dokumentów w partii od",
    "Čísla faktur": "Numery faktur",
    "Číslo": "Numer",
    "Číslo bez lomítka": "Numer bez ukośnika",
    "Číslo dávky": "Numer partii",
    "Číslo dokladu": "Numer dokumentu",
    "Číslo pojištěnce": "Numer ubezpieczonego",
    "Číslo pojištěnce nemusí být správné": "Numer ubezpieczonego może być nieprawidłowy",
    "Číslo pojištěnce:": "Numer ubezpieczonego:",
    "Číslo pojišťenec": "Numer ubezpieczonego",
    "Číslo účtu": "Numer rachunku",
    "Číslování dokladů": "Numeracja dokumentów",
    "Číslovat dávky od": "Numerować partie od",
    "Číslovat faktury od": "Numerować faktury od",
    "Číslovat paragony od": "Numerować paragony od",
    "Číst více": "Czytaj więcej",
    "client photo": "zdjęcie klienta",
    "Co je nového?": "Co nowego?",
    "CS": "PL",
    "Čtvrtek": "Czwartek",
    "Čtvrtletí": "Kwartał",
    "Čtvrtletní": "Kwartalny",
    "cvik": "ćwiczenie",
    "Cvik": "Ćwiczenie",
    "cviků": "ćwiczeń",
    "cviky": "ćwiczenia",
    "Cviky": "Ćwiczenia",
    "Cviky na vybraný den": "Ćwiczenia na dany dzień",
    "Další akce": "Kolejne akcje",
    "Další krok postupu": "Następny krok",
    "Další položka": "Kolejna pozycja",
    "Další propojení dostupné pouze při": "Dodatkowe połączenia dostępne tylko wtedy, gdy",
    "Další štítky": "- Dalsze etykiety",
    "Další výkon": "Kolejne świadczenie",
    "Data se načítají...": "Dane się wczytują...",
    "Datum": "Data",
    "Datum a čas": "Data i czas",
    "Datum expirace": "Datum expirace",
    "Datum inventury": "Data inwentaryzacji",
    "Datum je povinné": "Data jest obowiązkowa",
    "Datum narození": "Data urodzenia",
    "Datum narození:": "Data urodzenia:",
    "Datum naskladnění": "Data przyjęcia na stan",
    "Datum návštěvy": "Data wizyty",
    "Datum platnosti budoucí ceny nemůže být v minulosti.": "Data obowiązywania przyszłej ceny nie może być w przeszłości.",
    "Datum splatnosti:": "Termin płatności:",
    "Datum transakce": "Data transakcji",
    "Datum vystavení": "Data wystawienia",
    "Datum začátku cvičení": "Data początku ćwiczenia",
    "Datum zaplacení": "Data zapłaty",
    "Datum zdanitelného plnění": "Data powstania obowiązku podatkowego",
    "Datum změny pojištění:": "Data zmiany ubezpieczenia:",
    "Datum změny pojišťovny": "Data zmiany ubezpieczyciela",
    "Datum:": "Data:",
    "Dávek na stránku": "Ilość elementów na stronę",
    "DÁVKA POUKAZŮ NA VYŠETŘENÍ/OŠETŘENÍ SMÍŠENÁ": "DAWKI WYTYCZNYCH DOTYCZĄCYCH DOCHODZENIA / DOCHODZENIA",
    "DÁVKA VYÚČTOVÁNÍ CEST V NÁVŠTĚVNÍ SLUŽBĚ": "DOKUMENT REALIZACJI CEST W USŁUGACH WIZYTACJI",
    "DÁVKA VYÚČTOVÁNÍ VÝKONŮ V AMBULANTNÍ PÉČI": "DOKUMENT RACHUNKU WYKONAWCZEGO W AMBULANTACH",
    "Dávku elektronicky podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Paczkę podpiszesz elektronicznie w aplikacji Fyzion Signer, a Fyzion wyśle ją do zakładu ubezpieczeń zdrowotnych.",
    "Dávku lze elektronicky odeslat přímo zdravotní pojišťovně, s podpisem certifikátem nebo s ověřením SMS kódem.": "Paczkę można wysłać elektronicznie bezpośrednio do zakładu ubezpieczeń zdrowotnych, z podpisem certyfikatem lub z weryfikacją kodem SMS.",
    "Dávku se nepodařilo vytvořit": "Nie udało się utworzyć paczki danych",
    "davky": "paczki danych",
    "Dávky": "Paczki danych",
    "Dávky jsme zařadili k odeslání pojišťovně. O výsledku vás budeme informovat e-mailem.": "Paczki zostały zakolejkowane do wysłania do zakładu ubezpieczeń. O wyniku poinformujemy Cię e-mailem.",
    "Dávky nemůžeme vytvořit, protože jsme nenašli žádné výkony. Změňte výběr období, pojišťoven nebo pracoviště.": "Nie udało się utworzyć paczki danych, ponieważ nie znaleziono żadnych wykonanych świadczeń. Proszę zmienić zakres dat, wybrane ubezpieczalnie lub miejsce realizacji.",
    "Dávky vytvořeny": "Paczki danych utworzone",
    "DD.MM.RRRR": "DD.MM.RRRR",
    "Deaktivovat": "Dezaktywować",
    "Deaktivovat terapeuta": "Dezaktywować terapeutę",
    "dekujeme": "dziękujemy",
    "Děkujeme za vaší recenzi!": "Dziękujemy za Twoją opinię!",
    "Děkujeme!": "Dziękujemy!",
    "Děkujeme! Souhlas s GDPR byl úspěšně potvrzen.": "Dziękujemy! Akceptacja z RODO jest potwierdzona.",
    "Délka (min.)": "Długość ( min.)",
    "den": "dzień",
    "Den": "Dzień",
    "Denně": "Dziennie",
    "detail": "szczegół",
    "Detail následující návštěvy": "Szczegóły następnej wizyty",
    "Detail návštěvy": "Szczegóły wizyty",
    "Detail poslední návštěvy": "Szczegóły ostatniej wizyty",
    "Detail registrace náhradníka": "Szczegóły rejestracji rezerwowego",
    "Detail rezervace": "Szczegóły rezerwacji",
    "Detail vybraného profilu": "Szczegóły wybranego profilu",
    "Diagnóza": "Diagnoza",
    "Diagnózy": "Diagnozy",
    "DIČ": "NIP",
    "dne": "dnia",
    "Dne": "Dnia",
    "Dnes": "Dziś",
    "dní": "dni",
    "dnů": "dni",
    "dny": "dni",
    "Dny": "Dni",
    "do": "do",
    "Do": "Do",
    "Do karty pacienta nebyly zatím nahrány žádné formuláře.": "Do karty klienta nie dodano jeszcze żadnych formularzy.",
    "Do karty pacienta nebyly zatím nahrány žádné fotografie.": "Do karty klienta nie dodano jeszcze żadnych zdjęć.",
    "Do průvodce": "Do przewodnika",
    "Doba splatnosti": "Termin płatności",
    "Doba trvání": "Czas trwania",
    "Doba trvání pro pacienty": "Czas trwania dla klientów",
    "Doba trvání:": "Czas trwania:",
    "Dobrý den": "Dzień dobry",
    "Dodavatel": "Dostawca",
    "Dodavatel byl úspěšně smazán": "Dostawca został usunięty",
    "Dodavatel byl úspěšně upraven": "Dane dostawcy zostały pomyślnie zaktualizowane",
    "Dodavatel byl úspěšně vytvořen": "Dostawca został pomyślnie dodany",
    "dodavatele": "dostawcy",
    "Dodavatelé": "Dostawcy",
    "Dodavatele se nepodařilo smazat": "Dostawcy nie udało się usunąć",
    "Dodavatele se nepodařilo upravit": "Dostawcy nie udało się aktualizować",
    "Dojde k odstranění následujících místností navázaných na tuto pobočku:": "Następujące pokoje związane z tym oddziałem zostaną usunięte:",
    "Doklady": "Dokumenty",
    "Dokončeno": "Zakończono",
    "Dokončit odeslání": "Dokończ wysyłanie",
    "Dokončit odeslání dávky": "Dokończ wysyłanie paczki",
    "Dokončit odeslání dávky č. %{number} pro pojišťovnu %{insurance}?": "Dokończyć wysyłanie paczki nr %{number} dla zakładu ubezpieczeń %{insurance}?",
    "Dokument byl úspěšně nahrán a odeslán": "Dokument został pomyślnie załadowany i wysłany",
    "Dokumenty": "Dokumenty",
    "Doplňková služba": "Usługa dodatkowa",
    "dopředu": "naprzód",
    "Dosáhli jste maximálního počtu pacientů v kartotéce. ": "Osiągnąłeś maksymalną liczbę klientów w kartotece. ",
    "Dosažen limit SMS": "Osiągnięty limit SMS",
    "Dosažení maximálního počtu pacientů": "Osiągnięto maksymalną liczbę klientów",
    "Dotazník": "Ankieta",
    "Dotazník pro klienta": "Ankieta dla klienta",
    "Dotazník pro klienta (dotazník uvidí klient v klientské sekci, kde ho může vyplnit)": "Ankieta dla klienta (klient zobaczy ankietę w sekcji klienta, gdzie może ją wypełnić)",
    "Dotazník pro pacienta": "Ankieta dla klienta",
    "Dotazník uvidí klient v klientské sekci, kde ho může vyplnit": "klient zobaczy ankietę w sekcji klienta, gdzie może ją wypełnić",
    "Dotazovat se klientů na souhlas se zasíláním novinek v rezervačním systému": "Pytać klientów o zgodę na otrzymywanie aktualności w systemie rezerwacyjnym",
    "DPH": "VAT",
    "DPH%": "VAT%",
    "Druh péče": "Rodzaj opieki",
    "Druh péče:": "Rodzaj opieki:",
    "Druh úhrady": "Forma płatności",
    "Druh úhrady:": "Forma płatności:",
    "Duplikovat": "Duplikować",
    "E-mail": "E-mail",
    "E-mail se nepodařilo odeslat.": "Nie udało się wysłać e-maila.",
    "E-mail úspěšně odeslán": "E-mail wysłany",
    "E-mailová adresa": "Adres e-mail",
    "E-mailová adresa:": "Adres e-mail:",
    "Editace údajů pacienta": "Edycja danych klienta",
    "Email": "E-mail",
    "Email byl úspěšně poslán": "E-mail został wysłany",
    "Email klientům": "E-mail do klientów",
    "Email odeslán": "E-mail wysłany",
    "Email pro faktury": "Adres e-mail do faktur",
    "Emailová adresa": "Adres e-mail",
    "EN": "PL",
    "Export bude vygenerován a zaslán na e-mail": "Eksport zostanie przygotowany i przesłany na adres e-mail.",
    "Export transakcí": "Eksport transakcji",
    "Exportovat": "Eksportuj",
    "Exportovat data": "Eksportuj dane",
    "Exportovat ISDOC": "Eksport ISDOC",
    "Exportovat PDF": "Eksportuj PDF",
    "Exportovat platby": "Eksportuj płatności",
    "Exportovat výkony": "Eksportuj świadczenia",
    "Faktura": "Faktura",
    "Faktura bude vygenerována a zaslána na e-mail": "Faktura będzie wygenerowana i przesłana na e-mail",
    "Faktura byla označena jako zaplacená": "Faktura została oznaczona jako zapłacona",
    "Fakturace": "Fakturowanie",
    "Fakturace byla označena jako zaplacená": "Faktura została oznaczona jako opłacona",
    "Fakturace úspěšně přidána": "Faktura została pomyślnie dodana",
    "Fakturace úspěšně upravena": "Faktura została pomyślnie zaktualizowana",
    "Fakturace za období": "Faktura za okres",
    "Fakturace za období:": "Faktura za okres:",
    "Fakturační údaje": "Dane do faktury",
    "fakturacni-udaje": "dane-do-faktury",
    "Fakturováno": "Zafakturowano",
    "fakturu č.": "faktury nr",
    "faktury": "faktury",
    "Faktury": "Faktury",
    "Filtrovat": "Filtruj",
    "Filtrovat pacienty": "Filtruj klientów",
    "Filtrujte cviky podle jména": "Filtruj ćwiczenia według nazwy",
    "finance": "finanse",
    "Finance": "Finanse",
    "firemni-udaje": "dane-firmy",
    "flag": "znacznik",
    "Formulář úspěšně nahrán": "Formularz został pomyślnie przesłany",
    "Formuláře se nepodařilo načíst": "Nie udało się wczytać formularza",
    "Fotka FT poukazu": "Zdjęcie skierowania FT",
    "Fotka FT poukazu byla úspěšně nahrána": "Zdjecie skierowania FT zostało wczytane",
    "Fotku obrazovky s Vaším sdílením": "Zrzut ekranu z Twoim udostępnieniem",
    "Fotky": "Zdjęcia",
    "Fotogalerie": "Galeria zdjęć",
    "fotografie": "zdjęcia",
    "Fotografie se nepodařilo načíst.": "Nie udało się wczytać zdjęcia.",
    "Fotografie se zobrazí na veřejné stránce v sekci zaměstnanci": "Zdjęcie będzie widoczne na publicznej stronie w sekcji pracownicy",
    "Fotografie smazána": "Zdjęcie usunięte",
    "Fotografie úspěšně nahrána": "Zdjęcie zostało pomyślnie przesłane",
    "Fotografie ze dne": "Zdjęcie z dnia",
    "FT poukaz": "skierowanie FT",
    "FT Poukaz": "skierowanie na fizjoterapię",
    "FT poukaz byl úspěšně vytvořen": "Skierowanie FT zostało pomyślnie wystawione",
    "FT poukaz není možné vytvořit. Zkontrolujte, jestli je vše správně vyplněno na kartě pacienta.": "Nie można utworzyć skierowania FT. Sprawdź, czy wszystkie dane na karcie klienta zostały poprawnie wypełnione.",
    "FT poukaz úspěšně smazán": "Skierowanie FT zostało usunięte",
    "FT poukaz úspěšně upraven": "skierowanie FT zostało edytowane",
    "FT poukazy": "skierowanie FT",
    "Funkce pro větší instituce, se kterými spolupracujete. Mohou u vás mít „kredit“ a čerpat ho za vaše služby.": "Funkcja dla większych instytucji, z którymi współpracujecie. Mogą mieć u was „kredyt” i wykorzystywać go na wasze usługi.",
    "Fyzion – moderní software pro fyzioterapii": "Physion - Nowoczesne oprogramowanie do fizjoterapii",
    "Fyzion funguje": "Fyzion działa",
    "Fyzion premium function": "Fyzion funkcje premium",
    "Fyzion running away": "Fyzion zamyka się",
    "fyzion-faktura.pdf": "fyzion-faktura.pdf",
    "fyzion-zalohova-faktura.pdf": "fyzion-faktura-proforma.pdf",
    "Fyzioterapeut": "Fizjoterapeuta",
    "Fyzioterapeut a místnost": "Fizjoterapeuta i pokój",
    "Fyzioterapeut je povinný": "Fizjoterapeuta jest obowiązkowy",
    "Fyzioterapeut nemá vyplněné ordinační hodiny": "Fizjoterapeuta nie ma wypenionych godzin przyjęć",
    "Fyzioterapeut:": "Fizjoterapeuta:",
    "fyzioterapeuti": "fizjoterapeuci",
    "Fyzioterapeuti": "Fizjoterapeuci",
    "Fyzioterapeuti úspěšně resetováni podle diagnózy": "Fizjoterapeuci zostali pomyślnie zresetowani na podstawie diagnozy.",
    "GDPR": "RODO",
    "GDPR souhlas": "zgoda RODO",
    "GDPR úspěšně potvrzeno.": "RODO potwierdzone.",
    "GDPR:": "RODO:",
    "Generováno": "Wygenerowano",
    "Generuji PDF pro tisk…": "Generowanie PDF do druku…",
    "Google kalendář": "kalendarz Google",
    "Hesla se neshodují": "Hasła się nie zgadzają",
    "Heslo": "Hasło",
    "Heslo bylo úspěšně nastaveno": "Hasło zostało pomyślnie ustawione",
    "Heslo bylo úspěšně změněno": "Hasło zostało zmienione",
    "Heslo bylo úspěšně změněno. Přihlaste se prosím znovu novým heslem.": "Hasło zostało zmienione. Zaloguj się ponownie, używając nowego hasła.",
    "Heslo musí obsahovat minimálně 8 znaků a alespoň 1 číslici.": "Hasło musi zawierać minimalnie 8 znaków i co najmniej 1 cyfrę.",
    "Historie akcí": "Historia akcji",
    "Historie akcí, odeslané zprávy.": "Historia działań, wysłane wiadomości",
    "Historie cvičení": "Historia ćwiczenia",
    "Historie emailů a SMS": "Historia e-maili i SMS",
    "Historie návštěv": "Historia wizyt",
    "Historie rezervací": "Historia rezerwacji",
    "historie-akci": "historia-dzialan",
    "Hledanému výrazu neodpovídá žádná diagnóza": "Żadna diagnoza nie odpowiada wyszukiwanemu wyrażeniu",
    "Hledanému výrazu neodpovídá žádné pracoviště": "Brak pracowni pasującej do wyszukiwanego hasła",
    "Hledanému výrazu neodpovídá žádný pacient": "Nie znaleziono klienta pasującego do podanego wyrażenia",
    "Hledanému výrazu neodpovídá žádný poukaz": "Nie znaleziono żadnego dokumentu pasującego do podanego wyrażenia",
    "Hledanému výrazu neodpovídá žádný výkon": "Nie znaleziono żadnego świadczenia pasującego do podanego wyrażenia",
    "Hledat klienta": "Szukaj klienta",
    "Hledat...": "Szukaj...",
    "hod": "godziny",
    "hodin": "godziny",
    "hodinu": "godziny",
    "hodiny": "godziny",
    "Hodnota bodu": "Wartość punktu",
    "Hodnota bodu:": "Wartość punktu:",
    "Hotově": "Gotówką",
    "Hotovo": "Gotowe",
    "Hromadné odeslání dávek pojišťovně selhalo": "Zbiorcza wysyłka paczek do zakładu ubezpieczeń nie powiodła się",
    "Hrudní": "Piersiowy",
    "HTML kód na web": "Kod HTML do osadzenia na stronie",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Podminky_ochrany_osobnich_udaju.pdf": "https://fyzion.fra1.digitaloceanspaces.com/docs/Podminky_ochrany_osobnich_udaju-FS_2025_v2_PL.pdf",
    "https://fra1.digitaloceanspaces.com/endevel-web/media/documents/Vseobbecne_obchodni_podminky_edit_2025_v2.pdf": "https://fyzion.fra1.digitaloceanspaces.com/docs/Vseobbecne_obchodni_podminky_edit_2025_v2_PL.pdf",
    "https://fyzion.cz/cs/sdilejte-nas-a-rozsirte-si-kartoteku-zdarma/": "https://fyzion.pl/pl/udostępnij-nas-i-rozszerz-kartoteke-za-darmo/",
    "https://fyzion.cz/cs/webinar/": "https://fyzion.pl/pl//webinar/",
    "https://fyzion.cz/navod-pojistovny": "https://fyzion.pl/wytyczne-ubezpieczyciela/",
    "https://fyzion.cz/navod-purobot": "https://fyzion.cz/navod-purobot",
    "https://kb.fyzion.cz/cs/": "https://kb.fyzion.cz/pl/",
    "https://kb.fyzion.cz/cs/article/databaze-cviku-a-jak-je-poslat-pacientovi-ue0fjk/": "https://kb.fyzion.cz/pl/article/baza-cwiczen-i-jak-wyslac-je-klientowi-1h94btw/",
    "https://kb.fyzion.cz/cs/article/fakturacni-udaje-1phelsb/": "https://kb.fyzion.cz/pl/article/dane-do-faktury-1t1wwqs/",
    "https://kb.fyzion.cz/cs/article/jak-vyuzit-predplatne-ve-fyzionu-darkove-poukazy-benefity-a-firemni-fakturace-1xlifqz/": "https://kb.fyzion.cz/pl/article/jak-korzystac-z-abonamentu-w-serwisie-fyzion-bony-upominkowe-benefity-i-faktury-firmowe-1jcrdbw/",
    "https://kb.fyzion.cz/cs/article/kartoteka-pacientu-1bjloyh/": "https://kb.fyzion.cz/pl/article/kartoteki-pacjentow-cwcotk/",
    "https://kb.fyzion.cz/cs/article/nastaveni-terapeutu-sauigy/": "https://kb.fyzion.cz/pl/article/ustawienia-terapeutow-1sonsfe/",
    "https://kb.fyzion.cz/cs/article/permanentky-17qqddn/": "https://kb.fyzion.cz/cs/article/permanentky-17qqddn/",
    "https://kb.fyzion.cz/cs/article/platby-z33ojo/": "https://kb.fyzion.cz/cs/article/platby-z33ojo/",
    "https://kb.fyzion.cz/cs/article/platebni-brana-comgate-149e3gy/": "https://kb.fyzion.cz/cs/article/platebni-brana-comgate-149e3gy/",
    "https://kb.fyzion.cz/cs/article/platebni-brana-fyzion-1i889t1/": "https://kb.fyzion.cz/pl/article/bramka-platnicza-fyzion-1h7b3b0/",
    "https://kb.fyzion.cz/cs/article/pobocky-ve-fyzionu-vetsi-svoboda-pro-terapeuty-prehlednost-pro-klienty-1vwg90a/": "https://kb.fyzion.cz/pl/article/oddzialy-w-fyzionie-wieksza-swoboda-dla-terapeutow-przejrzystosc-dla-klientow-1q3qtsm/",
    "https://kb.fyzion.cz/cs/article/pojistovny-16i7uc6/": "https://kb.fyzion.cz/cs/article/pojistovny-16i7uc6/",
    "https://kb.fyzion.cz/cs/article/propojeni-kalendare-s-googlem-h9fpzi/": "https://kb.fyzion.cz/cs/article/propojeni-kalendare-s-googlem-h9fpzi/",
    "https://kb.fyzion.cz/cs/article/recenze-1okedp6/": "https://kb.fyzion.cz/pl/article/recenzje-14sddhr/",
    "https://kb.fyzion.cz/cs/article/sablony-jcwt6d/": "https://kb.fyzion.cz/pl/article/szablony-1j1ogab/",
    "https://kb.fyzion.cz/cs/article/sluzby-jak-nastavit-vase-sluzby-13wrswq/": "https://kb.fyzion.cz/cs/article/sluzby-jak-nastavit-vase-sluzby-13wrswq/",
    "https://kb.fyzion.cz/cs/article/sprava-skladu-a-fakturace-1dfkoro/": "https://kb.fyzion.cz/cs/article/sprava-skladu-a-fakturace-1dfkoro/",
    "https://www.fyzion.cz/cs/navod-fyzion": "https://kb.fyzion.cz/pl/",
    "https://www.google.com/chrome/": "https://www.google.com/chrome/",
    "IBAN": "IBAN",
    "IČ": "NIP",
    "IČO": "NIP",
    "IČP": "Identyfikacyjny numer placówki",
    "IČP žadatele": "Identyfikacyjny numer placówki wnioskującej",
    "IČZ": "Identyfikacyjny numer zakładu opieki zdrowotnej",
    "id": "id",
    "iframe na web": "iframe do osadzenia na stronie",
    "Ignorovat automatické přepsání": "Zignoruj automatyczne nadpisanie",
    "info@fyzion.cz": "info@fyzion.pl",
    "Informace o návštěvách": "Informacje o wizytach",
    "Informace o Vaší registraci jsme Vám poslali na e-mail": "Informacje o Twojej rezerwacji wysłaliśmy na e-mail",
    "Informace o Vaší rezervaci jsme Vám poslali na e-mail": "Informacje o Twojej rezerwacji wysłaliśmy na e-mail",
    "inventura": "inwentaryzacja",
    "Inventura": "Inwentaryzacja",
    "Inventura zboží": "Inwentaryzacja towaru",
    "Inventura zboží úspěšně provedena": "Inwentaryzacja towaru została pomyślnie przeprowadzona",
    "Inventuru zboží se nepodařilo uložit": "Inwentaryzacji towaru nie udało się zapisać",
    "Jak chcete pokračovat?": "Jak chcesz kontynuować?",
    "Jak chcete provedené změny aplikovat?": "W jaki sposób chcesz zatwierdzić wprowadzone zmiany?",
    "Jak funguje platební brána?": "Jak działa bramka płatnicza?",
    "Jak fungují permanentky?": "Jak działają karnety okresowe?",
    "Jak fungují recenze?": "Jak działają recenzje?",
    "Jak na propojení s PURObotem?": "Jak połączyć się z Purobotem?",
    "Jak na to": "Jak to zrobić",
    "Jak nastavit fakturační údaje?": "Jak skonfigurować informacje rozliczeniowe?",
    "Jak nastavit online rezervace?": "Jak skonfigurować rezerwacje online?",
    "Jak nastavit pobočky?": "Jak skonfigurować oddziały",
    "Jak nastavit služby?": "Jak skonfigurować usługi?",
    "Jak nastavit terapeuta?": "Jak założyć terapeutę?",
    "Jak navýšit limit kartotéky pacientů?": "Jak zwiększyć limit kartoteki klientów?",
    "Jak používat šablony?": "Jak korzystać z szablonów?",
    "Jak pracovat s kartotekou?": "Jak pracować z kartoteką?",
    "Jak pracovat s platbami?": "Jak obsługiwać płatności?",
    "Jak pracovat se cviky?": "Jak wykonywać ćwiczenia?",
    "Jak propojit kalendář s Googlem?": "Jak połączyć kalendarz z Google?",
    "Jak si přejete aplikovat tuto šablonu?": "Jak chcesz zastosować ten szablon?",
    "Jak spravovat sklad?": "Jak zarządzać magazynem?",
    "Jak vykazovat na pojišťovny?": "Jak rozliczać się z ubezpieczalniami?",
    "Jak využít předplatné?": "Jak korzystać z subskrypcji?",
    "Jaké služby poskytuje?": "Jakie usługi świadczy?",
    "Jakýkoliv": "Jakikolwiek",
    "Jde o duplicitní kartu?": "Chodzi o duplikat karty?",
    "Jdeme na to teď!": "Działamy teraz!",
    "Je-li funkce zapnuta a pacient ještě nemá potvrzené GDPR, systém mu ho automaticky odesílá k potvrzení den před budoucí návštěvou.": "Jeśli funkcja jest włączona, a klient nie potwierdził jeszcze zgody RODO, system automatycznie wysyła mu ją do potwierdzenia dzień przed przyszłą wizytą.",
    "Je-li tato funkce vypnuta, fyzioterapeut vidí návštěvy ostatních fyzioterapeutů, ale nemůže se prokliknout do jejich detailu": "Jeśli ta funkcja jest wyłączona, fizjoterapeuta widzi wizyty innych fizjoterapeutów, ale nie może przejść do ich szczegółów.",
    "Jestliže splníte tyto tři úkoly dříve, než vyprší čas, jako odměnu od nás dostanete tarif Standard na tři měsíce": "Jeżeli wykonasz te trzy zadania przed upływem czasu, w nagrodę od nas otrzymasz taryfę Standard na trzy miesiące.",
    "Jméno": "Imię",
    "Jméno pojištěnce": "Imię ubezpieczonego",
    "Jméno/název": "Imię/nazwa",
    "Jméno/Název": "Imię/Nazwa",
    "Jsou předepsané výkony": "Są przepisane świadczenia",
    "K návštěvě existuje více než jedna platba": "Do wizyty jest przepisana więcej niż jedna płatność",
    "K platbě": "Do płatności",
    "K poukazu zatím není zapsaný žádný výkon": "Do skierowania nie ma przypisanego żadnego świadczenia",
    "K přihlášení použijte váš e-mail, na který Vám zasíláme potvrzení o rezervacích.": "Do logowania użyj adresu e-mail, na który wysyłamy potwierdzenia rezerwacji.",
    "K této cvičební položce nejsou k dispozici žádné obrázky ani videa.": "Do tego ćwiczenia nie są dostępne żadne obrazki ani filmy.",
    "K této cvičební poloze nejsou k dispozici žádné další informace.": "Do tej pozycji ćwiczeniowej nie ma dostępnych żadnych dodatkowych informacji.",
    "K této návštěvě nebyl zatím přidán žádný popis.": "Do tej wizyty nie dodano jeszcze żadnego opisu.",
    "K této recenzi nebyl přidán žádný text.": "Do tej opinii nie dodano jeszcze tekstu.",
    "K vytvoření stvrzenky je potřeba návštěva": "Do wytworzenia potwierdzenia potrzebna jest wizyta",
    "K vytvoření stvrzenky je potřeba pacient a návštěva": "Do utworzenia potwierdzenia potrzebny jest klient i wizyta",
    "k_batches.confirm_delete_k_batch_modal.confirm_text": "k_batches.confirm_delete_k_batch_modal.confirm_text",
    "k_batches.confirm_delete_k_batch_modal.heading_with_invoice": "k _ nietoperze. potwierdź _ delete _ k _ batch _ modal. nagłówek _ z _ wejściem",
    "k_batches.confirm_delete_k_batch_modal.heading_without_invoice": "k _ nietoperze. potwierdź _ delete _ k _ batch _ modal. nagłówek _ bez _ innowacji",
    "k_batches.confirm_delete_k_batch_modal.informative_text_with_invoice": "k _ nietoperze. potwierdź _ delete _ k _ batch _ modal. information _ text _ with _ input",
    "k_batches.confirm_delete_k_batch_modal.informative_text_without_invoice": "k _ nietoperze. potwierdź _ delete _ k _ batch _ modal. information _ text _ without _ input",
    "k_batches.corrective_k_batch.get_ft_tickets_for_corrective_k_batch_failed.notification": "k _ nietoperze. correct _ k _ batch. get _ ft _ bilets _ for _ correct _ k _ batch _ failed. powiadomienie",
    "k_batches.k_batch_document.get_k_batch_document_list_failed.notification": "k _ nietoperze. k _ batch _ document. get _ k _ batch _ document _ list _ failed. powiadomienie",
    "k_batches.k_batch.create_corrective_batch_successful.notification": "k _ nietoperze. k _ batch. create _ correct _ batch _ successful.notification",
    "k_batches.k_batch.create_corrective_k_batch_btn.label": "k _ nietoperze. k _ batch.create _ correct _ k _ batch _ bt.label",
    "k_batches.k_batch.delete_failed.notification": "k _ nietoperze. k _ batch.delete _ failed. powiadomienie",
    "k_batches.k_batch.delete_k_batch_btn.label": "k _ nietoperze. k _ batch.delete _ k _ batch _ bt.label",
    "k_batches.k_batch.delete_successful.notification": "k _ nietoperze. k _ batch.delete _ successful.notification",
    "k_batches.k_batch.new_receipt_btn.label": "k _ nietoperze. k _ batch. new _ receipt _ btn.label",
    "K-Poukaz": "K- voucher",
    "Kalendář": "Kalendarz",
    "Kalendář byl úspěšně synchronizován": "Kalendarz został zsynchronizowany",
    "Kalendář je již synchronizovaný": "Kalendarz jest już zsynchronizowany",
    "Kalendář místností": "Kalendarz pomieszczeń",
    "Kalendář skupinových": "Kalendarz grupowych",
    "Kalendář terapeutů": "Kalendarz terapeutów",
    "Kapacita": "Pojemność",
    "Kapacita:": "Pojemność:",
    "Karta klienta": "Karta klienta",
    "Karta pacienta": "Karta klienta",
    "karta-pacienta": "karta-klienta",
    "Kartou": "Kartą",
    "Kartou online": "Kartą online",
    "Karty byly sloučeny": "Karty zostały połączone",
    "Karty se nepodařilo sloučit": "Połączenie kart nie powiodło się",
    "kategorie": "kategoria",
    "Kategorie": "Kategoria",
    "Kč": "zł",
    "Kdokoliv dostupný": "Ktokolwiek dostępny",
    "Klient": "Klient",
    "Klient platí za službu osobně během návštěvy.": "Klient płaci za usługę osobiście podczas wizyty.",
    "Klient si může vybrat, zda zaplatí online předem, nebo až při návštěvě.": "Klient może wybrać, czy zapłacić online z góry lub podczas wizyty.",
    "Klienti a klientská sekce": "Klienci i sekcja klienta",
    "Klienti dostanou odkaz na přihlašovací stránku do klientského portálu od svého terapeuta.": "Klienci otrzymają od swojego terapeuty link do strony logowania do portalu klienta.",
    "Klientská sekce": "Strefa klienta",
    "Klientská sekce je vypnutá. Zapnout ji můžete v": "Strefa klienta jest wyłączona. Możesz ją włączyć w",
    "Klientský portál": "Portal klienta",
    "klientů": "klientów",
    "km)": "km)",
    "Kód": "Kod",
    "Kód ": "Kod ",
    "Kód a název pojišťovny": "Kod i nazwa ubezpieczalni",
    "Kód a název zboží": "Kod i nazwa produktu",
    "Kód a název zboží, počet": "Kod i nazwa produktu, ilość",
    "kód banky": "kod banku",
    "Kód banky": "Kod banku",
    "Kód náhrady": "Kod zamiennika",
    "Kód pojišťovny": "Kod ubezpieczalni",
    "Kód zboží": "Kod produktu",
    "Končetiny dolní": "kończyny dolne",
    "Končetiny horní": "Kończyny górne",
    "Konec": "Koniec",
    "Kontakt na pacienta": "Kontakt do klienta",
    "Kontaktní osoba": "Osoba kontaktowa",
    "Kontaktní údaje": "Dane kontaktowe",
    "kontaktni-udaje": "dane-kontaktowe",
    "Kontaktovat": "Kontaktować",
    "Kontaktovat náhradníky s nabídkou termínu?": "Skontaktować się z surogatami z terminem?",
    "Kontaktujte nás": "Skontaktuj się z nami",
    "Kontaktujte nás a rádi vám Fyzion představíme <br>během 15 minutového online hovoru.": "Skontaktuj się z nami, a z przyjemnością zaprezentujemy Ci Fyzion podczas 15-minutowej rozmowy online.",
    "Kontaktujte naši podporu": "Skontaktuj się z naszym działem wsparcia",
    "Kontrola": "Kontrola",
    "Kontrolní spis se nepodařilo vytvořit": "Plik kontrolny nie został utworzony",
    "Kopírovat": "Skopiuj",
    "Krční": "Szyjny",
    "Kredit": "Kredyt",
    "krok cviku": "krok ćwiczenia",
    "ks": "szt.",
    "ks x": "szt. x",
    "label": "etykieta",
    "lekcí": "zajęć",
    "Limit": "Limit",
    "Limit dluhu předplatného bude překročen.": "Limit zadłużenia abonamentu zostanie przekroczony.",
    "Limit dlužné částky": "Limit zadłużenia",
    "Limit dlužné částky:": "Limit zadłużenia:",
    "Limit pacientů můžete zvýšit, když nám pomůžete sdílet aplikaci mezi Vaše kolegy, ": "Limit klientów możesz zwiększyć, pomagając nam udostępnić aplikację swoim kolegom. ",
    "Logo": "Logo",
    "Logo aplikace Fyzion": "Logo aplikacji Fyzion",
    "Logo firmy": "Logo firmy",
    "Luboš Truhlář": "Luboš Truhlář",
    "mailto:info@fyzion.cz": "mailto:info@fyzion.pl",
    "Mají tel.": "Mają tel.",
    "Mastercard ikona": "Ikona Mastercard",
    "Máte již vlastní IČO?": "Posiadasz NIP?",
    "máte naplánovanou návštěvu v ordinaci fyzioterapie": "masz niezaplanowaną wizytę w gabinecie fizjoterapii",
    "Máte neuhrazenou objednávku za pronájem aplikace!": "Masz zaległą płatność za korzystanie z  aplikacji",
    "Máte objednány tyto návštěvy": "Masz umówione następujące wizyty",
    "Máte zde neuložené změny, chcete je před odchodem uložit?": "Masz niezapisane zmiany, czy chcesz je zapisać przed opuszczeniem strony?",
    "Max. 9 výkonů": "Max. 9 świadczeń",
    "Maximální kapacita": "Maksymalna pojemność",
    "Maximální kapacita návštěvy je ": "Maksymalna liczba uczestników wizyty to ",
    "Maximální počet klientů": "Maksymalna liczba klientów",
    "Maximální počet objednaných rezervací": "Maksymalna liczba zarezerwowanych miejsc",
    "Maximální počet rezervací": "Maksymalna liczba rezerwacji",
    "Maximální počet rezervací za den": "Maksymalna liczba rezerwacji dziennie",
    "Maximální počet termínů, které si může klient rezervovat v jedné objednávce. Pokud není vyplněno, počet rezervací není omezen.": "Maksymalna liczba terminów, które klient może zarezerwować w jednym zamówieniu. Jeśli nie jest wypełniony, liczba rezerwacji nie jest ograniczona.",
    "Maximální počet účastníků skupinové služby.": "Maksymalna liczba uczestników usług grupowych.",
    "Maximální úhrada": "Maksymalna opłata",
    "McKenzie formuláře byly úspěšně aktivovány": "Formularze McKenzie zostały z powodzeniem aktywowane",
    "McKenzie spisy": "Pliki McKenzie",
    "měsíc": "miesiąc",
    "Měsíc": "Miesiąc",
    "měsíce": "miesiące",
    "Měsíce": "Miesiące",
    "Měsíčně": "Miesięcznie",
    "Měsíční": "Miesięczny",
    "měsíců": "miesięcy",
    "Město": "Miasto",
    "mezi vaše kolegy nebo přechodem na ": "wśród swoich kolegów albo przechodząc na ",
    "mezi Vaše kolegy, nebo přechodem na ": "wśród swoich kolegów albo przechodząc na ",
    "min": "min",
    "min.": "min.",
    "Min. 1 výkon": "Min. 1 świadczenie",
    "min/terapie": "min/terapia",
    "Minimální počet objednaných rezervací": "Minimalna liczba zamówionych rezerwacji",
    "Minimální počet rezervací": "Minimalna liczba rezerwacji",
    "Minimální počet termínů, které musí klient při jedné online rezervaci vybrat. Běžně je nastaveno na 1.": "Minimalna liczba warunków, jakie klient musi wybrać podczas rezerwacji online. Zazwyczaj jest ustawiony na 1.",
    "Minulý měsíc": "Poprzedni miesiąc",
    "Minulý rok": "Poprzedni rok",
    "Minulý týden": "Poprzedni tydzień",
    "minut": "minut",
    "Místnost": "Pokój",
    "Místnost bude odstraněna z pracovní doby.": "Pokój zostanie usunięty z czasu pracy.",
    "Místnost byla úspěšně smazána": "Pomieszczenie zostało pomyślnie usunięte",
    "Místnost byla úspěšně upravena": "Pokój był pomyślnie zaktualizowany",
    "Místnost byla úspěšně vytvořena": "Pokój został pomyślnie utworzony",
    "mistnosti": "pokoje",
    "Místnosti": "Pokoje",
    "MJ": "JM",
    "Množství": "Ilości",
    "Modrá": "Niebieska",
    "Moduly": "Moduły",
    "Moje profily": "Moje profile",
    "Moje údaje": "Moje dane",
    "Momentálně využívá": "Aktualnie używa",
    "Možnost dluhu": "Możliwość zadłużenia",
    "Možnost platit online předem nebo na místě": "Możliwość płatności online z góry lub na miejscu",
    "Mřížka": "Siatka",
    "Můj tarif": "Mój abonament",
    "Můj tarif, platby za předplatné.": "Mój abonament, płatności za subskrypcję.",
    "Musí být alespoň 1": "Musi być co najmniej 1",
    "Musí být menší než 1000.": "Musi być mniejszy niż 1000.",
    "Musí být větší než 0.": "Musi być większy od 0.",
    "Muž": "Mężczyzna",
    "Můžete vložit obrázek s vaším razítkem nebo podpisem, který se následně vloží na generované doklady pro pacienty.": "Możesz wstawić obraz ze swoim pieczęcią lub podpisem, który następnie zostanie umieszczony na generowanych dokumentach dla klientów.",
    "Muži": "Mężczyźni",
    "Muži (budoucí)": "Mężczyźni (przyszli)",
    "na info@fyzion.cz.": "na info@fyzion.pl",
    "Nabízené permanentky": "Oferujemy karnety",
    "Nabízené služby": "Oferowane usługi",
    "Načíst další": "Wczytać kolejne",
    "Načíst údaje z ARES": "Wczytaj dane z GUS",
    "Načíst výkony": "Wczytać wyniki",
    "Nadcházející návštěva": "Nadchodząca wizyta",
    "Nadpis bloku": "Nagłówek bloku",
    "Náhradník": "Zastępca",
    "Náhradník odebrán": "Rezerwowy usunięty",
    "Náhradník přidán": "Rezerwowy dodany",
    "Náhradníka se nepodařilo odebrat": "Usunięcie rezerwowego nie powiodło się",
    "Náhradníka se nepodařilo přidat": "Nie udało się dodać rezerwowego",
    "Nahrané dokumenty zde není možné vidět.": "Nie można tutaj zobaczyć przesłanych dokumentów.",
    "Nahrání dat do systému": "Wgranie danych do systemu",
    "Nahrání obrázku se nezdařilo": "Przesłanie zdjęcia nie powiodło się",
    "Nahrát dávku do Purobota": "Wyślij dawkę do Purobot",
    "Nahrát fotku": "Wgrać zdjęcie",
    "Nahrát soubor": "Wgrać plik",
    "Nahrát soubor typu jpeg nebo png": "Wgrać plik w formacie jpeg lub png",
    "Nahrávání souborů, prosím nezavírejte stránku...": "Wgrywanie pliku, nie zamykaj strony...",
    "Nákupní (s DPH)": "Zakupu (z VAT)",
    "Nákupní cena a počet": "Cena zakupu i ilość",
    "Nákupní cena s DPH": "Cena zakupu z VAT",
    "Nákupní hodnota (s DPH)": "Wartość zakupu (z VAT)",
    "Napište nám na email:": "Napisz do nas na e-mail:",
    "Napište poznámku…": "Napisz notatkę…",
    "Naplánovat změnu ceny od zvoleného data": "Zaplanuj zmianę ceny od wybranej daty",
    "Nápověda": "Wsparcie",
    "např. číslo dávky, dokladu, pojištěnce": "np. numer paczki, dokumentu, ubezpieczonego",
    "Např. kód, název zboží": "Np. kod, nazwa produktu",
    "např. název, IČP, telefonní číslo": "np. nazwa, identyfikator placówki, numer telefonu",
    "např. název, instituce, IČO": "np. nazwa, instytucja, nr NIP",
    "např. RČ pacienta, e-mail": "np. PESEL klienta, e-mail",
    "Např. RČ pacienta, e-mailová adresa": "Np. PESEL klienta, adres e-mail",
    "naší aplikaci či facebookovou skupinu Fyzion na internetu. Za každé takové sdílení Vám zdarma rozšíříme kartotéku o dalších pět pacientů. Jako potvrzení, že jste sdílení provedli, nám prosím zašlete screenshot (fotku obrazovky) sdíleného příspěvku na info@fyzion.cz a uveďte, o jakého fyzioterapeuta se jedná.": "naszą aplikację lub facebookową grupę Fyzion w internecie. Za każde takie udostępnienie bezpłatnie rozszerzymy Twoją kartotekę o kolejnych pięciu klientów. Jako potwierdzenie, że dokonałeś udostępnienia, prosimy o przesłanie zrzutu ekranu (zdjęcia ekranu) udostępnionego posta na adres info@fyzion.pl oraz podanie, którego fizjoterapeutę to dotyczy.",
    "naskladneni": "przyjęcie na stan",
    "Naskladnění": "Przyjęcie na stan",
    "Naskladnění zboží": "Przyjęcie na stan produktu",
    "Následující návštěva:": "Następna wizyta:",
    "Nasmlouvané výkony": "Umówione świadczenia",
    "nastaveni": "ustawienia",
    "Nastavení": "Ustawienia",
    "Nastavení - Fakturační údaje": "Ustawienia - Dane do faktury",
    "NASTAVENÍ - KONTAKTNÍ ÚDAJE.": "USTAWIENIA - DANE KONTAKTOWE.",
    "Nastavení hesla": "Ustawienia hasła",
    "Nastavení IČPE": "Ustawienia IČPE",
    "Nastavení nového hesla": "Ustawienie nowego hasła",
    "Nastavení platby": "Ustawienia płatności",
    "Nastavení předplatného": "Ustawienie subskrypcji",
    "Nastavení uloženo": "Zapisano ustawienia",
    "Nastavit": "Ustawić",
    "Nastavit heslo": "Ustaw hasło",
    "Nastavit jako výchozí službu": "Ustaw jako usługę domyślną",
    "Nastavit přesun podle": "Ustaw przeniesienie według",
    "Nastavit text emailu": "Ustawić treść e-maila",
    "Nastavit text SMS": "Ustawić treść SMS",
    "Nastavit zrušení podle": "Ustaw anulowanie według",
    "Nastavuje počáteční číslo pro faktury": "Ustawia numer początkowy faktur",
    "Nastavuje počáteční číslo pro paragony": "Ustawia numer początkowy parafonów",
    "Návod": "Instrukcja",
    "Návrat do aplikace": "Powrót do aplikacji",
    "Návštěv na stránku": "Wizyt na stronę",
    "návštěva": "wizyta",
    "Návštěva": "Wizyta",
    "Návštěva byla označena jako zaplacená": "Wizyta została oznaczona jako zapłacona",
    "Návštěva byla úspěšně zaplacena": "Wizyta została pomyślnie zapłacona",
    "Návštěva je zamknuta": "Wizyta jest zamknięta",
    "Návštěva nemůže mít datum po konci platnosti FT poukazu": "Data wizyty nie może przekraczać terminu ważności skierowania FT",
    "Návštěva nenalezena": "Wizyta nie została odnaleziona",
    "Návštěva obsahuje nahrané formuláře": "Wizyta zawiera wgrane formularze",
    "Návštěva obsahuje nahrané fotografie": "Wizyta zawiera wgrane zdjęcia",
    "Návštěva odemknuta": "Wizyta otwarta",
    "Návštěva pacienta": "Wizyta klienta",
    "Návštěva smazána": "Wizyta usunięta",
    "Návštěva úspěšně přidána": "Wizyta została pomyślnie dodana",
    "Návštěva zamknuta": "Wizyta zamknięta",
    "Návštěvu se nepodařilo uložit": "Wizyty nie udało się zapisać",
    "Návštěvu se nepodařilo uložit! Zkuste to prosím znovu.": "Wizyty nie udało się zapisać! Spróbuj ponownie.",
    "navstevy": "wizyty",
    "Návštěvy": "Wizyty",
    "návštěvy pacientů": "wizyty klientów",
    "Návštěvy pacientů": "Wizyty klientów",
    "Návštěvy podle fyzioterapeutů": "Wizyty według fizjoterapeutów",
    "návštěvy vloží do správné karty.": "wizyty zostaną przypisane do właściwej karty.",
    "navstevy-pacienta": "wizyty-klienta",
    "Název": "Nazwa",
    "Název cviku": "Nazwa ćwiczenia",
    "Název firmy": "Nawa firmy",
    "Název instituce": "Nazwa instytucji",
    "Název kategorie": "Nazwa kategorii",
    "Název kliniky": "Nazwa kliniki",
    "Název místnosti": "Nawa pokoju",
    "Název permanentky": "Nazwa karnetu",
    "Název pobočky": "Nazwa oddziału",
    "Název podkategorie": "Nazwa podkategorii",
    "Název pojišťovny": "Nazwa ubezpieczyciela",
    "Název pracoviště": "Nazwa placówki",
    "Název předplatného": "Nazwa subsktypcji",
    "Název šablony": "Nazwa szablonu",
    "Název služby": "Nazwa usługi",
    "Název v angličtině": "Nazwa po angielsku",
    "Název v češtině": "Nazwa po czesku",
    "Název v polštině": "Nazwa po polsku",
    "Název ve slovenštině": "Nazwa po słowacku",
    "Název zboží": "Nazwa produktu",
    "Ne": "Nie",
    "nebo": "lub",
    "nebo přechodem na pokročilý tarif. ": "lub przejściem do wyższej taryfy. ",
    "Nebyly nalezeny žádné recenze.": "Nie odnaleziono żadnych opinii.",
    "Něco se pokazilo": "Coś poszło nie tak",
    "Neděle": "Niedziela",
    "Nedorazil:": "Nie przyszedł:",
    "Nejčastější sady výkonů můžete definovat v sekci POJIŠŤOVNY → ŠABLONY.": "Najczęstsze zestawy występów można zdefiniować w sekcji UBEZPIECZENIA → SABLONS.",
    "Nejméně 8 znaků a alespoň 1 malé písmeno": "Minimalnie 8 znaków i co najmniej 1 mała litera",
    "Nejprve vyberte návštěvy k zaplacení": "Najpierw wybierz wizyty do opłacenia",
    "Nejprve vyberte šablonu výkonů": "Najpierw wybierz wzorzec osiągnięć",
    "Nejsou dostupné žádné místnosti": "Żadne pokoje nie są dostępne",
    "Nejsou dostupné žádné pobočky": "Żadne oddziały nie są dostępne",
    "Nejsou dostupné žádné předplatné": "Żadne subskrypcje nie są dostępne",
    "Nejsou dostupné žádné transakce": "Żadne transakcje nie są dostępne",
    "Nejsou dostupní žádní uživatelé": "Żaden użytkownik nie jest dostępny",
    "Nejsou dostupní žádní žadatelé": "Żadni wnioskodawcy nie są dostępni",
    "Nejsou k dispozici žádná data": "Żadne dane nie są dostępne",
    "Nejsou k dispozici žádné fotografie": "Żadne zdjęcia nie są dostępne",
    "Některé funkce aplikace Fyzion vám": "Niektóre funkcje aplikacji Fyzion są dla Ciebie",
    "Některé z povinných údajů chybí": "Brak niektórych obowiązkowych danych",
    "Nelze odebrat zamčený výkon": "Nie można usunąć zamkniętego świadczenia",
    "Nelze přesunout volno k jinému fyzioterapeutovi.": "Nie można przenieść przerwy/urlopu do innego fizjoterapeuty.",
    "Nelze smazat - zboží je na skladě.": "Nie można usunąć - produkt jest w magazynie.",
    "Nelze vytvořit kontrolní spis: Chybí ID pacienta v M-Spisech": "Nie można utworzyć pliku kontrolnego: brak ID klienta w plikach M-",
    "Nelze vytvořit kontrolní spis: doplňte rodné číslo k pacientovi": "Nie można utworzyć pliku kontrolnego: dodać numer urodzenia do klienta",
    "Nelze vytvořit nový spis: Chybí ID pacienta v M-Spisech": "Nie można utworzyć nowego pliku: brak ID klienta w plikach M-",
    "Nelze vytvořit nový spis: doplňte rodné číslo k pacientovi": "Nie można utworzyć nowego pliku: dodać numer urodzenia do klienta",
    "Nemají tel.": "Nie mają tel.",
    "Nemáte dostatečné oprávnění pro tuto akci.": "Nie masz właściwych uprawnień do tego działania.",
    "Nemáte oprávnění na smazání cizí návštěvy": "Nie masz uprawnień do usunięcia obcej wizyty",
    "Nemáte oprávnění na smazání návštěvy": "Nie masz uprawnień do usunięcia wizyty",
    "Nemáte oprávnění na úpravu jiného fyzioterapeuta": "Nie masz uprawnień do wprowadzania zmian u innego fizjoterapeuty",
    "Nemáte oprávnění na úpravu jiných ordinačních hodin": "Nie masz uprawnień do zmian w innych godzinach przyjęć",
    "Nemáte oprávnění na úpravu permanentky": "Nie masz uprawnień do zmian w karnecie",
    "Nemáte oprávnění na úpravu služby": "Nie masz uprawnień do zmian w usłudze",
    "Nemáte oprávnění na zaplacení cizí návštěvy": "Nie masz uprawnień do zapłaty za obcą wizytę",
    "Nemáte oprávnění na zrušení cizí návštěvy": "Nie masz uprawnień do anulowania obcej wizyty",
    "Nemáte oprávnění pro odemknutí výkonu": "Nie masz uprawnień do otwarcia świadczenia",
    "Nemáte oprávnění prohlížet anamnézu pacienta": "Nie masz uprawnień do przeglądania wywiadu lekarskiego klienta",
    "Nemáte vytvořenou smlouvu s touto pojišťovnou. Pro tuto pojišťovnu se dávka nevytvoří.": "Nie masz utworzonej umowy z tym ubezpieczycielem. Dla tego ubezpieczyciela pakiet się nie utworzy.",
    "Nemáte žádné objednané návštěvy.": "Nie masz żadnych umówionych wizyt.",
    "nemusí správně fungovat.": "nie musi działać poprawnie",
    "Nemůže být záporné": "Nie może być ujemne",
    "Nenalezen žádný dodavatel": "NIe odnaleziono żadnego dostawcy",
    "Nenalezen žádný doklad": "NIe odnaleziono żadnego dokumentu",
    "Nenalezen žádný FT poukaz pro načtení výkonů": "Nie znaleziono żadnego kuponu FT do pobrania usług",
    "Nenalezen žádný klient": "Nie znaleziono żadnego klienta",
    "Nenalezen žádný pacient": "Nie odnaleziono żadnego klienta",
    "Nenalezen žádný výkon": "Nie odnaleziono żadnego świadczenia",
    "Nenalezen žádný záznam": "Nie znaleziono żadnego rekordu",
    "Nenalezena shoda se jménem žádného cviku.": "Nie znaleziono zgodności z nazwą żadnego ćwiczenia.",
    "Nenalezena žádná akce": "Nie odnaleziono żadej akcji",
    "Nenalezena žádná dávka": "Zestawieni nie zostało odnalezione",
    "Nenalezena žádná návštěva": "Nie odnaleziono żadnej wizyty",
    "Nenalezena žádná pracoviště": "Nie odnaleziono żadnej placówki",
    "Nenalezena žádná šablona": "Nie odnaleziono żadnego szablonu",
    "Nenalezena žádná stvrzenka": "Nie odnaleziono żadnego potwierdzenia",
    "Nenalezena žádná zpráva": "NIe odnaleziono żadnej wiadomości",
    "Nenalezeno žádné další zboží": "Nie odnaleziono dalszych produktów",
    "Nenalezeny žádná výkony": "Nie znaleziono żadnych usług",
    "Nenalezeny žádné další služby": "Nie odnaleziono kolejnych usług",
    "Nenalezeny žádné položky": "Nie odnaleziono żadnych pozycji",
    "Nenalezeny žádné zásoby": "Nie znaleziono żadnych zasobów",
    "Není dostupná žádná šablona výkonů": "Nie ma dostępnych szablonów osiągnięć",
    "Není dostupný žádný platný FT poukaz": "Żadne ważne skierowanie FT nie jest dostępne",
    "Není dostupný žádný výkon": "Żadne świadczenie nie jest dostępne",
    "Není možné změnit tarif, protože máte v kartotéce více pacientů,": "Nie można zmienić taryfy, ponieważ masz w kartotece więcej klientów,",
    "Není nahrána žádná fotka": "Nie wgranych żadnych zdjęć",
    "Není naplánována další návštěva": "Nie ma zaplanowanej kolejnej wizyty",
    "Neočekávaná chyba": "Nieoczekiwany błąd",
    "Neomezený počet pacientů": "Nieograniczona liczba klientów",
    "Neopakuje se": "Nie powtarza się",
    "Neplátce DPH": "Nie jest płatnikiem VAT",
    "Nepodařilo se aktualizovat cviky v návštěvě": "Aktualizacja ćwiczeń dla wizyty nie powiodła się",
    "Nepodařilo se aktualizovat den se cvičením": "Aktualizacja dnia z ćwiczeniem nie powiodła się",
    "Nepodařilo se aktualizovat šablonu": "Aktualizacja szablonu nie powiodła się",
    "Nepodařilo se načíst AI shrnutí": "Nie udało się załadować podsumowania AI",
    "Nepodařilo se načíst AI shrnutí.": "Nie udało się załadować podsumowania AI.",
    "Nepodařilo se načíst budoucí návštěvy.": "Wczytanie przyszłych wizyt nie powiodło się.",
    "Nepodařilo se načíst celkové hodnoty naskladněných položek": "Nie powiodło się wczytanie całkowitej wartości pozycji magazynowych",
    "Nepodařilo se načíst cesty za pacientem": "- Nie można wczytać danych o wyjazdach do klientów",
    "Nepodařilo se načíst cviky": "Wczytanie ćwieczeń nie powiodło się",
    "Nepodařilo se načíst data": "Wczytanie danych nie powiodło się",
    "Nepodařilo se načíst data ze systému": "Wczytanie danych z systemu nie powiodło się",
    "Nepodařilo se načíst dávku": "Nie powiodło się zapisanie zestawienia",
    "Nepodařilo se načíst dávky": "Nie powiodło się zapisanie zestawień",
    "Nepodařilo se načíst detail poukazu": "Nie udało się załadować szczegółów kuponu",
    "Nepodařilo se načíst diagnózy": "Wczytanie diagnozy nie powiodło się",
    "Nepodařilo se načíst dodavatele": "Wczytanie dostawcy nie powiodło się",
    "Nepodařilo se načíst dostupné fyzioterapeuty": "Wczytanie dostępnych fizjoterapeutów nie powiodło się",
    "Nepodařilo se načíst druhy péče": "Nie udało się załadować typów opieki",
    "Nepodařilo se načíst FT poukazy": "Wczytanie skierowań FT nie powiodło się",
    "Nepodařilo se načíst hromadnou návštěvu": "Wczytanie wizyty grupowej nie powiodło się",
    "Nepodařilo se načíst kategorie cviků": "Wczytanie kategorii ćwiczeń nie powiodło się",
    "Nepodařilo se načíst kategorii cviků": "Nie powiodło się wczytanie kategorii ćwiczeń",
    "Nepodařilo se načíst místnost": "Wczytanie pokojo nie powiodło się",
    "Nepodařilo se načíst místnosti": "wczytanie pokojów nie powiodło się",
    "Nepodařilo se načíst návrh platby": "Nie udało się załadować propozycji płatności",
    "Nepodařilo se načíst návštěvu pacienta": "Wczytanie wizyty klienta nie powiodło się",
    "Nepodařilo se načíst návštěvy pacienta": "Nie powiodło się wczytanie wizyt klienta",
    "Nepodařilo se načíst novinku": "Wczytanie aktualności nie powiodło się",
    "Nepodařilo se načíst novinky": "Nie powiodło się wczytanie aktualności",
    "Nepodařilo se načíst odbornosti": "Nie udało się wczytać specjalizacji",
    "Nepodařilo se načíst ordinaci na této adrese": "Wczytanie gabinetu pod tym adresem nie powiodło się",
    "Nepodařilo se načíst pacienty": "Wczytanie klientów nie powiodło się",
    "Nepodařilo se načíst permanentku": "Wczytanie karnetu nie powiodło się",
    "Nepodařilo se načíst permanentky pacienta": "Wczytanie karnetu klienta nie powiodło się",
    "Nepodařilo se načíst platbu": "Wczytanie płatności nie powiodło się",
    "Nepodařilo se načíst platby": "NIe powiodło się wczytanie płatności",
    "Nepodařilo se načíst platební údaje": "Wczytanie danych do płatności nie powiodło się",
    "Nepodařilo se načíst pojišťovnu": "Wczytanie ubezpieczalni nie powiodło się",
    "Nepodařilo se načíst pojišťovny": "Nie powiodło się wczytanie ubezpieczalni",
    "Nepodařilo se načíst položku": "Wczytanie pozycji nie powiodło się",
    "Nepodařilo se načíst poukazy": "Nie udało się załadować kuponów",
    "Nepodařilo se načíst pracoviště": "Wczytanie placówki nie powiodło się",
    "Nepodařilo se načíst předplatné": "Wczytanie subskrypcji nie powiodło się",
    "Nepodařilo se načíst recenze": "Wczytanie opinii nie powiodło się",
    "Nepodařilo se načíst šablonu": "Wczytanie szablonu nie powiodło się",
    "Nepodařilo se načíst šablony": "Wczytanie szablonów nie powiodło się",
    "Nepodařilo se načíst šablony FT poukazů": "Nie udało się załadować szablonów kuponów FT",
    "Nepodařilo se načíst seznam diagnóz": "wczytanie listy diagnoz nie powiodło się",
    "Nepodařilo se načíst seznam návštěv.": "Wczytanie listy wizyt nie powiodło się.",
    "Nepodařilo se načíst seznam uživatelů": "Wczytanie listy użytkowników nie powiodło się",
    "Nepodařilo se načíst skupiny služeb": "Wczytanie grupy usług nie powiodło się",
    "Nepodařilo se načíst služby": "Wczytanie usługi nie powiodło się",
    "Nepodařilo se načíst transakce": "Wczytanie transakcji nie powiodło się",
    "Nepodařilo se načíst transakci": "Nie powiodło się wczytanie transakcji",
    "Nepodařilo se načíst volné termíny": "Wczytanie wolnych terminów nie powiodło się",
    "Nepodařilo se načíst výkony": "Wczytanie świadczeń nie powiodło się",
    "Nepodařilo se načíst žadatele": "Wczytanie kierującego nie powiodło się",
    "Nepodařilo se načíst zaměstnance": "Nie udało się załadować danych pracowników",
    "Nepodařilo se načíst zásoby": "Wczytanie zapasów nie powiodło się",
    "Nepodařilo se načíst země": "Wczytanie kraju nie powiodło się",
    "Nepodařilo se načíst zemi": "Wczytanie krajów nie powiodło się",
    "Nepodařilo se nahrát dávku do Purobota": "Nie można przesłać dawki do Purobot",
    "Nepodařilo se nahrát fotku FT poukazu": "NIe powiodło się wczytanie zdjęcia skierowania FT",
    "Nepodařilo se nahrát soubor": "Wzytanie pliku nie powiodło się",
    "Nepodařilo se odebrat štítek": "Nie udało się usunąć etykiet",
    "Nepodařilo se odemknout výkon": "Otwarcie świadczenia nie powiodło się",
    "Nepodařilo se odeslat recenzi. Zkuste to prosím znovu.": "Nie powiodło się wysłanie recenzji. Spróbuj ponownie.",
    "Nepodařilo se označit fakturu jako zaplacenou": "Oznaczenie faktury jako zapłaconej nie powiodło się",
    "Nepodařilo se přidat fakturaci": "Dodanie faktury nie powiodło się",
    "Nepodařilo se přidat předplatné": "Dodanie subskrypcji nie powiodło się",
    "Nepodařilo se smazat cvik": "Usunięcie ćwiczenia nie powiodło się",
    "Nepodařilo se smazat místnost": "Niepowodzenie usuwania pokoju",
    "Nepodařilo se smazat platbu": "Usunięcie płątności nie powiodło się",
    "Nepodařilo se smazat pojišťovnu": "Usunięcie ubezpieczalni nie powiodło się",
    "Nepodařilo se smazat pracoviště": "Usunięcie placówki nie powiodło się",
    "Nepodařilo se smazat předplatné": "Usunięcie subskrypcji nie powiodło się",
    "Nepodařilo se smazat recenzi": "Usunięcie opinii nie powiodło się",
    "Nepodařilo se smazat šablonu": "Ysunięcie szablonu nie powiodło się",
    "Nepodařilo se smazat štítek": "Nie udało się usunąć etykiety",
    "Nepodařilo se spustit platbu. Zkuste to prosím znovu.": "Nie udało się uruchomić płatności. Proszę spróbować ponownie.",
    "Nepodařilo se uložit pracoviště žadatele": "Zapisanie placówki kierującej nie powiodło się",
    "Nepodařilo se upravit cvik.": "Nie udało się edytować ćwiczenia.",
    "Nepodařilo se upravit dostupnost": "Nie udało się edtować dostępności",
    "Nepodařilo se upravit fakturaci": "Nie udało się edytować faktur",
    "Nepodařilo se upravit místnost": "Nie udało się edytować pokoju",
    "Nepodařilo se upravit platbu": "NIe udało się edytować płatności",
    "Nepodařilo se upravit pobočku": "NIe udało się edytować oddziału",
    "Nepodařilo se upravit předplatné": "Nie udało się edytować subskrypcji",
    "Nepodařilo se vygenerovat export": "Nie udało się wygenerować eksportu",
    "Nepodařilo se vygenerovat fakturu": "Nie udało się wygenerować faktury",
    "Nepodařilo se vygenerovat platební odkaz": "Nie udało się wygenerować linku do płatności",
    "Nepodařilo se vygenerovat zprávu": "Nie udało się wygenerować wiadomości",
    "Nepodařilo se vylepšit popis návštěvy": "Nie udało się ulepszyć opisu wizyty",
    "Nepodařilo se vytvořit cvik.": "Nie udało się utworzyć ćwiczenia.",
    "Nepodařilo se vytvořit dodavatele": "Nie udało się utworzyć dostawcy",
    "Nepodařilo se vytvořit hromadnou návštěvu": "Nie udało się utworzyć wizyty grupowej",
    "Nepodařilo se vytvořit kategorii.": "Nie udało się utworzyć kategorii.",
    "Nepodařilo se vytvořit místnost": "Nie udało się utworzyć pokoju",
    "Nepodařilo se vytvořit platbu": "Nie udało się utworzyć płatności",
    "Nepodařilo se vytvořit pracoviště žadatele": "Nie udało się utworzyć placówki kierującej",
    "Nepodařilo se vytvořit registraci jako náhradník": "Nie udało się utworzyć rejestracji jako rezerwowy",
    "Nepodařilo se vytvořit šablonu": "Nie udało się utworzyć szablonu",
    "Nepodařilo se vytvořit štítek": "Nie udało się utworzyć etykiety",
    "Nepodařilo se vytvořit uživatele": "Nie udało się utworzyć użytkownika",
    "Nepodařilo se zaplatit návštěvu": "Nie udało się zapłacić wizyty",
    "Nepodařilo se získat cviky pacienta": "Nie udało się pobrać ćwiczeń klienta",
    "Nepodařilo se změnit nastavení rezervací pacienta": "Nie udało się zmienić ustawień klienta",
    "Nepodařilo se zrušit platbu": "Nie udało się anulować płatności",
    "Nepodařilo se zrušit platbu za návštěvu": "Nie udało się anulować płatności za wizytę",
    "Nepodporovaný typ prohlížeče": "Nieobsługiwany typ przeglądarki",
    "nepodporovaný typ prohlížeče.": "nieobsługiwany typ przeglądarki.",
    "Nepovinné": "Nieobowiązkowe",
    "Nepravidelné ordinační hodiny": "Nieprawidłowe godziny przyjęć",
    "Nepřišel": "Nie przyszedł",
    "Nesouhlasili": "Nie zgodzili się",
    "Neuhrazená objednávka": "Nieopłacone zamówienie",
    "Neuhrazeno": "Nieopłacono",
    "Neukládat": "Nie zapisywać",
    "Nevíte jak na to? Podívejte se na náš návod, přihlašte se na webinář nebo kontaktujte podporu.": "Nie wiesz, od czego zacząć? Skorzystaj z naszej instrukcji, zapisz się na webinar lub skontaktuj się z naszym zespołem wsparcia.",
    "Nevystaveno": "Nie wystawiono",
    "Nezaplaceno": "Nieopłacono",
    "notifikace": "powiadomienia",
    "Notifikace": "Powiadomienia",
    "Notifikace ordinaci": "Powiadomienia dla placówki",
    "nova": "nowa",
    "Nová cena": "Nowa cena",
    "Nová cena s DPH": "Nowa cena z VAT",
    "Nová cena se použije pro návštěvy od zvoleného data. Do té doby platí současná cena služby. Vypnutím naplánovanou změnu zrušíte.": "Nowa cena będzie obowiązywać dla wizyt od wybranej daty. Do tego czasu obowiązuje obecna cena usługi. Wyłączenie anuluje zaplanowaną zmianę.",
    "Nová fakturace": "Nowa faktura",
    "Nová místnost": "Nowy pokój",
    "Nová návštěva": "Nowa wizyta",
    "Nová operace": "Nowa operacja",
    "Nová šablona": "Nowy szablon",
    "Nová skupinová návštěva": "Nowa wizyta grupowa",
    "Nová událost": "Nowe wydarzenie",
    "nova-navsteva": "nowa-wizyta",
    "nova-opravna": "nowa-korygująca",
    "nova-skupinova-navsteva": "nowa-wizyta-grupowa",
    "nove": "nowe",
    "Nové heslo": "Nowe hasło",
    "Nové pracoviště žadatele": "Nowa placówka kierującego",
    "Nové předplatné": "Nowa subskrypcja",
    "Novinky": "Nowości",
    "novy": "nowy",
    "Nový pacient": "Nowy klient",
    "Nový spis": "Nowy plik",
    "Nový žadatel": "Nowy kierujący",
    "novy-ft-poukaz": "nowe-skierowanie-ft",
    "O nás": "O nas",
    "Období": "Okres",
    "obecne": "obecnie",
    "Obecné": "Obecnie",
    "obecného nastavení firmy": "ogólnych ustawień firmy",
    "obecném nastavení": "ustawieniach ogólnych",
    "Objednat návštěvu": "Umówić wizytę",
    "Objednat se na": "Umówić się na",
    "Objekt": "Obiekt",
    "Obměna": "Wariant",
    "obnova-hesla": "odzyskiwanie hasła",
    "Obnovit tabulku": "Odświeżyć tabelę",
    "Obrázek byl smazán": "Obraz został usunięty",
    "Obrázky": "Obrazy",
    "Obsah": "Zawartość",
    "Ochrana osobních údajů": "Ochrona danych osobowych",
    "Od": "Od",
    "Odběratel/klient": "Odbiorca/klient",
    "Odběratel/Klient": "Odbiorca/Klient",
    "Odbornost": "Specjalizacja",
    "Odcvičeno a přejít na další cvik": "Ćwiczenie wykonane, przejdź do następnego ćwiczenia",
    "Odebrat": "Odebrać",
    "Odebrat náhradníka": "Usunąć rezerwowego",
    "Odebrat pacienta": "Przejąć klienta",
    "Odebrat položku": "Usunąć pozycję",
    "Odebrat výkon": "Usunąć świadczenie",
    "Odebrat z čekajících": "Usuń z oczekujących",
    "Odebrat zastávku na cestě": "Usuń przystanek na trasie",
    "Odemknout": "Otworzyć",
    "Odemknout výkon": "Otworzyć świadczenie",
    "Odesílat email": "Wysyłać e-mail",
    "Odesílat email připomínku před návštěvou": "Wysyłać przypomnienie e-mail przed wizytą",
    "Odesílat připomínku e-mailem": "Wysyłać przypomnienie e-mailem",
    "Odesílat SMS": "Wysyłać SMS",
    "Odesílat SMS předem": "Wysyłać SMS z wyprzedzeniem",
    "Odesílat SMS připomínku před návštěvou": "Wysyłać przypomnienie SMS przed wizytą",
    "Odesílat stvrzenky klientům": "Wysyłać potwierdzenia do klientów",
    "Odesílat upozornění e-mailem o vytvoření, změně, zrušení návštěvy": "Wysyłać powiadomienie e-mailem o utworzeniu, zmianie lub odwołaniu wizyty",
    "Odesílat žádost o recenzi": "Wyślij wniosek o recenzję",
    "Odeslali jsme vám e-mail s instrukcemi k resetování hesla.": "Wysłaliśmy do ciebie e-mail z instrukcjami do zmiany hasła.",
    "Odeslané zprávy": "Wysłane wiadomości",
    "Odeslání dávek s přihlášením pomocí SMS kódu v tuto chvíli není podporované.": "Wysyłanie paczek z logowaniem za pomocą kodu SMS nie jest obecnie obsługiwane.",
    "Odeslání dávky pojišťovně selhalo": "Nie udało się wysłać paczki do zakładu ubezpieczeń",
    "Odeslání emailu": "Wysłanie e-maila",
    "Odeslání emailu 1 pacientovi": "Wysłanie e-maila do 1 klienta",
    "Odeslání emailu pacientovi": "Wysłanie e-maila do klienta",
    "Odeslání SMS": "Wysłanie SMS",
    "Odeslání SMS 1 pacientovi": "Wysłanie SMS do 1 klienta",
    "Odeslání SMS pacientovi": "Wysłanie SMS do klienta",
    "Odeslání zůstalo nedokončené": "Wysyłanie zostało niedokończone",
    "Odesláno": "Wysłane",
    "Odesláno na ": "Wysłane na ",
    "Odeslat": "Wysłać",
    "Odeslat 1 stvrzenku": "Wysłać 1 paragon",
    "Odeslat email": "Wysłać e-mail",
    "Odeslat GDPR mailem": "Wysłać RODO e-mailem",
    "Odeslat klientovi": "Wysłać klientowi",
    "Odeslat pacientovi": "Wyślij do klienta",
    "Odeslat potvrzení o platbě": "Wysłać potwierdzenie płatności",
    "Odeslat pouze zvoleným klientům.": "Wysłać tylko wybranym klientom.",
    "Odeslat připomínku platby (před návštěvou)": "Wyślij uwagę dotyczącą płatności (przed wizytą)",
    "Odeslat SMS": "Wysłać SMS",
    "Odeslat SMS pomocí telefonu": "Wyślij wiadomość SMS z telefonu",
    "Odeslat soubory": "Wyślij pliki",
    "Odeslat znovu emailem": "Wysłać e-mailem",
    "odešlete": "wyślij",
    "Odhlásit": "Wylogować",
    "Odkaz na formulář pro rezervaci čekajících pacientů": "Link do formularza rezerwacji dla oczekujących pacjentów",
    "Odkaz na kalendář s přehledem vámi nabízených skupinových lekcí": "Link do kalendarza z przeglądem oferowanych przez Ciebie zajęć grupowych",
    "Odkaz na přístup do klientské sekce": "Link do dostępu do sekcji klienta",
    "Odkaz na rezervaci byl zkopírován do schránky": "Link do rezerwacji został skopiowany do schowka",
    "Odkaz na váš online rezervační systém": "Link do systemu rezerwacji online",
    "Odkaz na vaší stránku ordinace obsahující rozcestník služeb, recenze, ordinační dobu i kontaktní údaje": "Link do strony gabinetu zawierającej spis usług, opinie, godziny przyjęć oraz dane kontaktowe",
    "Odkud jste se o nás dozvěděli?": "Skąd o nas wiesz",
    "Odpovědi posílat na email": "Odpowiedzi wysyłać na e-mail",
    "Odstranit časový interval": "Usuń przedział czasowy",
    "Ohodnoťte kvalitu naší služby": "Oceń jakość naszej usługi",
    "Omezuje počet rezervací této služby na jeden den. Vhodné pro časově nebo fyzicky náročné služby.": "Ogranicza liczbę rezerwacji tej usługi w ciągu jednego dnia.",
    "Omlouváme se, ale v aplikaci Fyzion došlo k nečekané chybě. Někdy i ty nejlepší svaly potřebují chvilku na odpočinek.": "Przepraszamy, ale w aplikacji Fyzion wystąpił nieoczekiwany błąd. Nawet najlepsze mięśnie potrzebują czasem chwili odpoczynku.",
    "Online platba": "Płatność online",
    "Online rezervace": "Rezerwacja online",
    "Opakování": "Powtórzenie",
    "Opakovat heslo": "Powtórz hasło",
    "Opakovat jednou za": "Powtórzyć raz na",
    "Opravdu si přejete archivovat pacienta?": "Czy na pewno chcesz zarchiwizować klienta?",
    "Opravdu si přejete dokument smazat?": "Czy na pewno chcesz usunąć dokument?",
    "Opravdu si přejete formulář smazat?": "Czy na pewno chcesz usunąć formularz?",
    "Opravdu si přejete fotografii smazat?": "Czy na pewno chcesz usunąć zdjęcie?",
    "Opravdu si přejete FT poukaz smazat?": "Czy na pewno chcesz usunąć skierowanie FT",
    "Opravdu si přejete místnost smazat?": "Czy na pewno chcesz usunąć pokój?",
    "Opravdu si přejete náhradníka odebrat?": "Czy na pewno chcesz usunąć rezerwowego?",
    "Opravdu si přejete obrázek smazat?": "Czy na pewno chcesz usunąć obraz?",
    "Opravdu si přejete pacienta odebrat?": "Czy na pewno chcesz usunąć klienta?",
    "Opravdu si přejete permanentku smazat?": "Czy na pewno chcesz usunąć karnet?",
    "Opravdu si přejete platbu zrušit?": "Czy na pewno chcesz anulować płatność?",
    "Opravdu si přejete pobočku smazat?": "Czy na pewno chcesz usunąć tę gałąź?",
    "Opravdu si přejete pojišťovnu smazat?": "Czy na pewno chcesz usunąć ubezpieczalnię?",
    "Opravdu si přejete poukaz smazat?": "Czy na pewno chcesz usunąć ten voucher?",
    "Opravdu si přejete pracoviště smazat?": "Czy na pewno chcesz usunąć placówkę?",
    "Opravdu si přejete recenzi smazat?": "Czy na pewno chcesz usunąć opinię?",
    "Opravdu si přejete rezervaci zrušit?": "Czy na pewno chcesz anulować rezerwację?",
    "Opravdu si přejete šablonu smazat?": "Czy na pewno chcesz usunąć szablon?",
    "Opravdu si přejete smazat cvik": "Czy na pewno chcesz usunąć ćwiczenie",
    "Opravdu si přejete smazat kategorii cviků?": "Czy na pewno chcesz usunąć kategorię ćwiczeń?",
    "Opravdu si přejete smazat kategorii služeb": "Czy na pewno chcesz usunąć kategorię usług",
    "Opravdu si přejete smazat platbu č.": "Czy na pewno chcesz usunąć płątność nr",
    "Opravdu si přejete smazat předplatné": "Czy na pewno chcesz usunąć subskrypcję",
    "Opravdu si přejete smazat službu": "Czy na pewno chcesz usunąć usługę",
    "Opravdu si přejete stornovat stvrzenku?": "Czy na pewno chcesz stornować potwierdzenie?",
    "Opravdu si přejete synchronizaci odebrat?": "Czy na pewno chcesz usunąć synchronizację?",
    "Opravdu si přejete terapeuta deaktivovat?": "Czy na pewno chcesz deaktywować fizjoterapeutę?",
    "Opravdu si přejete video smazat?": "Czy na pewno chcesz usunąć film?",
    "Opravdu si přejete volno smazat?": "Czy na pewno chcesz usunąć przerwę/urlop?",
    "Opravdu si přejete zboží smazat?": "Czy na pewno chcesz usunąć ten produkt?",
    "Opravná": "Korygująca",
    "Opravná dávka": "Zestawienie korygujące",
    "Opustit průvodce": "Opuść przewodnika",
    "Ordinace": "Gabinet",
    "ordinační hodiny": "godziny przyjęć",
    "Ordinační hodiny": "Godziny przyjęć",
    "Origin:": "Pochodzenie:",
    "Osobní údaje": "Dane osobowe",
    "Osobní údaje, přihlašovací údaje, propojení s GC.": "Dane osobowe, dane logowania, połączenie z GC.",
    "Ostatní diagnózy": "Inne diagnozy",
    "Ostatní služby": "Inne usługi",
    "Otevírací doba": "Godziny pracy",
    "Otevřeno": "Otwarte",
    "Otevřít": "Otwórz",
    "Otevřít nápovědu": "Otwórz pomoc",
    "Otevřít návštěvu": "Otwórz wizytę",
    "Otevřít v novém okně": "Otwórz w nowym oknie",
    "Ověření": "Weryfikacja",
    "Označeno:": "Oznaczone:",
    "Označit jako zaplacené": "Oznaczyć jako zapłacone",
    "Pacient": "klient",
    "Pacient byl archivován. Jestliže chcete jeho kartu obnovit, kontaktujte podporu": "Klient został zarchiwizowany. Jeśli chcesz przywrócić jego kartę, skontaktuj się z pomocą techniczną.",
    "Pacient byl úspěšně přidán": "Klient został pomyślnie dodany",
    "Pacient ještě nepotvrdil GDPR": "Klient nie potwierdził RODO",
    "Pacient již GDPR potvrdil": "Klient potwierdził RODO",
    "Pacient má platný FT poukaz do %{date}.": "Klient ma skierowanie FT ważne do %{date}.",
    "Pacient nemá nastavenou příští návštěvu": "Klient ma ustawioną następną wizytę",
    "Pacient odebrán": "Klient usunięty",
    "Pacient odhlášen z odběru novinek": "Klient usunięty z listy mailingowej",
    "Pacient přídán": "Klient dodany",
    "Pacient přihlášen k odběru novinek": "Klient jest zapisany na odbiór newslettera",
    "Pacient úspěšně archivován": "Klient został pomyślnie zarchiwizowany",
    "Pacient úspěšně odebrán z čekajících pacientů": "Klient został pomyślnie usunięty z listy oczekujących",
    "Pacient úspěšně přidán do čekajících pacientů": "Klient został pomyślnie dodany do listy oczekujących",
    "Pacient úspěšně upraven": "Klient został pomyślnie zaktualizowany",
    "Pacient zde zatím nemá žádnou návštěvu a k ní vytvořené popisy.": "Klient nie ma jeszcze żadnej wizyty ani do niej utworzonych opisów.",
    "Pacienta se nepodařilo archivovat": "Archiwizacja klienta nie powiodła się",
    "Pacienta se nepodařilo odebrat": "Usunięcie klienta nie powiodło się",
    "Pacienta se nepodařilo přidat do čekajících pacientů. Zkuste prosím znovu.": "Nie udało się dodać klienta do listy oczekujących. Proszę spróbować ponownie.",
    "Pacienta se nepodařilo přihlásit k odběru novinek. Zkuste to prosím znovu.": "Nie udało się zapisać klienta do newslettera. Proszę spróbować ponownie.",
    "Pacienti": "Klienci",
    "Pacienti úspěšně odebráni z čekajících pacientů": "Pacjenci zostali pomyślnie usunięci z listy oczekujących",
    "Pacienti, kteří přišli poprvé": "Klienci, którzy przyszli po raz pierwszy.",
    "Pacientovi pošleme potvrzení o platbě na jeho email": "Wyślemy klientowi potwierdzenie płatności na jego e-mail",
    "Pacientů na stránku": "Klientów na stronę",
    "pacientům": "klientom",
    "Paragon": "Paragon",
    "paragon č.": "paragon nr",
    "Paragony": "Paragony",
    "Parametry příští návštěvy upraveny": "Parametry następnej wizyty zostały zmienione",
    "Pátek": "Piątek",
    "Patička faktury": "Stopka faktury",
    "Paušální": "Ryczałtowy",
    "PDF": "PDF",
    "PDF se nepodařilo vygenerovat. Zkuste to prosím znovu.": "Nie udało się wygenerować pliku PDF. Spróbuj ponownie.",
    "Permanentka aktualizována": "Karnet został zaktualizowany",
    "Permanentka byla označena jako zaplacená": "Karnet został oznaczony jako zaplacony",
    "Permanentka umožňuje nastavit předplacené návštěvy na vybrané služby. Klientovi ji lze přiřadit v jeho kartě a při platbě využít. V kartě klienta uvidíte i počet zbývajících předplacených návštěv.": "Karnet umożliwia ustawienie przedpłaconych wizyt na wybrane usługi. Można go przypisać klientowi w jego karcie i wykorzystać podczas płatności. W karcie klienta będzie również widoczna liczba pozostałych przedpłaconych wizyt.",
    "Permanentka úspěšně odebrána pacientovi.": "Karnet został skutecznie usunięty z konta klienta.",
    "Permanentka úspěšně přidána pacientovi.": "Karnet został pomyślnie przypisany klientowi.",
    "Permanentka úspěšně vytvořena": "Karnet został pomyślnie utworzony.",
    "Permanentkou": "Karnetem",
    "Permanentku se nepodařilo pacientovi odebrat. Zkuste prosím znovu.": "Nie udało się odebrać karnetu klientowi. Proszę spróbować ponownie.",
    "Permanentku se nepodařilo pacientovi přidat. Zkuste prosím znovu.": "Nie udało się dodać karnetu klientowi. Proszę spróbować ponownie.",
    "Permanentku se nepodařilo upravit.": "Aktualizaja karnetu nie powiodła się.",
    "Permanentku se nepodařilo vytvořit": "Utworzenie karnetu nie powiodło się",
    "Permanentky": "Karnety",
    "PL": "PL",
    "planovani": "planowanie",
    "Plánování": "Planowanie",
    "planovani-mistnosti": "planowanie-pokoje",
    "Platba": "Płatność",
    "Platba byla smazána": "Płatność została usunięta",
    "Platba byla zrušena": "Płatność została anulowana",
    "Platba pouze na místě při terapii": "Płatność wyłącznie na miejscu",
    "Platba předem": "Płatność z góry",
    "Platba předplatným": "Płatność przedpłatą",
    "Platba za návštěvu byla úspěšně zrušena": "Płatność za wizytę została anulowana",
    "platby": "płatności",
    "Platby": "Płatności",
    "Platby za předplatné": "Płatności za subskrypcję",
    "Platby za pronájem aplikace": "Opłaty za korzystanie z aplikacji",
    "Plátce DPH": "Płatnik VAT",
    "Plateb na stránku": "Płatności na stronę",
    "Platební brána": "Bramka płatnicza",
    "Platební brána byla úspěšně nastavena": "Bramka płatności została pomyślnie skonfigurowana",
    "Platební brána Comgate": "Bramka płatnicza Comgate",
    "Platební brána Fyzion": "Bramka płatnicza Fyzion",
    "Platební brána se používá jen v případě, že jsou u služby zapnuté platby předem.": "Bramka płatnicza jest używana tylko wtedy, gdy dla usługi włączone są płatności z góry.",
    "Platební informace": "Informacje płatnicze",
    "Platná do:": "Ważna do:",
    "Platnost (v měsících)": "Płatność ( w miesiącach)",
    "Platnost do": "Ważne do",
    "Platnost musí být větší nebo rovna 1.": "Ważność musi być większa lub równa 1.",
    "Platnost nové ceny od": "Nowa cena obowiązuje od",
    "Platnost vašeho odkazu vypršela. Zažádejte si o nastavení nového hesla": "Ważność Twojego linku wygasła. Ponów prośbę o ustawienie nowego hasła.",
    "Po": "Po",
    "Po rezervaci budete přesměrování na platební bránu pro uhrazení ceny terapie.": "Po rezerwacji zostaniesz przekierowany na bramkę płatności w celu zapłaty za terapię.",
    "Po skončení návštěvy se klientovi automaticky odešle žádost o zpětnou vazbu.": "Po zakończeniu wizyty klientowi automatycznie zostanie wysłana prośba o opinię.",
    "Po sloučení se všechny minulé i budoucí": "Po scaleniu wszystkie przeszłe i przyszłe",
    "Po třech dnech": "Po trzech dniach",
    "Po vložení kódu na váš web se zobrazí okno s rezervací": "Po wstawieniu kodu na Twoją stronę internetową pojawi się okno z rezerwacją.",
    "Po vložení kódu na váš web se zobrazí tlačítko s rezervací": "Po wstawieniu kodu na Twoją stronę internetową pojawi się przycisk z rezerwacją.",
    "pobočka": "oddział",
    "Pobočka": "Oddział",
    "Pobočka byla úspěšně smazána": "Oddział został pomyślnie usunięty",
    "Pobočka byla úspěšně upravena": "Oddział został pomyślnie zaktualizowany",
    "Pobočka byla úspěšně vytvořena": "Oddział został utworzony",
    "pobocky": "oddziały",
    "Pobočky": "Oddziały",
    "Počet": "Liczba",
    "Počet dní do konce:": "Ilość dni do końca:",
    "Počet dní před návštěvou se odešle připomínka při nezaplacené rezervaci.": "Liczba dni przed wizytą, kiedy wysyłane jest przypomnienie o nieopłaconej rezerwacji.",
    "Počet návštěv": "Ilość wizyt",
    "Počet návštěv musí být větší nebo rovno 1.": "Ilość wizyt musi być większa lub równa 1.",
    "Počet povolených rezervací je naplněn.": "Liczba dozwolonych rezerwacji została osiągnięta.",
    "Počet výkonů": "Liczba świadczeń",
    "Počet zbývajících vstupů:": "Liczba pozostałych wejść:",
    "Počty návštěv": "Liczba wizyt",
    "Podání nebylo pojišťovně odesláno. Po smazání můžete dávku upravit a odeslat znovu.": "Zgłoszenie nie zostało wysłane do zakładu ubezpieczeń. Po usunięciu możesz edytować paczkę i wysłać ją ponownie.",
    "Podepisování tohoto podání zůstalo nedokončené. Dávku podepíšete v aplikaci Fyzion Signer a Fyzion ji odešle zdravotní pojišťovně.": "Podpisywanie tego zgłoszenia zostało niedokończone. Paczkę podpiszesz w aplikacji Fyzion Signer, a Fyzion wyśle ją do zakładu ubezpieczeń zdrowotnych.",
    "Podepsat a odeslat": "Podpisz i wyślij",
    "Podívám se později": "Sprawdzę później",
    "Podkategorie": "Podkategoria",
    "Podmínky užití": "Warunki użytkowania",
    "Podpis": "Podpis",
    "Podpis/razítko firmy": "Podpis/pieczątka firmy",
    "Podpora": "Wsparcie",
    "podpora@fyzion.cz": "wsparcie@fyzion.pl",
    "Podrobnosti": "Szczegóły",
    "Podrobný popis služby, který se zobrazí klientům při výběru služby v online rezervacích.": "Szczegółowy opis usługi wyświetlany klientom podczas wyboru usługi w rezerwacjach online.",
    "Pohlaví": "Płeć",
    "Pohlaví:": "Płeć:",
    "Pohyb zboží": "Ruch produktów",
    "Pojištění EU a mezinárodní smlouvy": "Ubezpieczenie UE i umowy międzynarodowe",
    "Pojišťovna": "Ubezpieczalnia",
    "Pojišťovna byla smazána": "Ubezpieczalnia została usunięta",
    "Pojišťovna přidána": "Unezpieczalnia została dodana",
    "Pojišťovna upravena": "Ubezpieczalnia zaktualizowana",
    "Pojišťovna:": "Ubezpieczalnia:",
    "Pojišťovnou": "Przez ubezpieczyciela",
    "Pojišťovny": "Ubezpieczalnie",
    "Pokladna": "Kasa",
    "Pokračovat": "Kontynuuj",
    "Pokročilá funkce": "Funkcja zaawansowana",
    "pokročilý tarif.": "zaawansowany plan taryfowy.",
    "Pokud": "Jeśli",
    "Pokud budete chtít nastavit jinou šablonu pro tuto zprávu, tak nás kontaktujte na": "Jeżeli chcesz ustawić inny szablon dla tej wiadomości, skontaktuj się z nami przez",
    "Pokud je lekce plně obsazena, klienti se mohou zapsat jako náhradníci.": "Jeśli termin jest w pełni obsadzony, klienci mogą zapisać się na listę rezerwową.",
    "Pokud je zapnuto, klient musí poznámku vyplnit, aby mohl rezervaci dokončit.": "Jeśli włączone, klient musi uzupełnić notatkę, aby móc dokończyć rezerwację.",
    "Pokud má klient aktivní permanentku, platba za návštěvu se automaticky odečte z ní.": "Jeśli klient posiada aktywny karnet, płatność zostanie z niego automatycznie odliczona.",
    "Pokud má pacient trvalé bydliště v ČR, zadejte jeho rodné číslo bez lomítka.": "Jeżeli klient ma pobyt trwały w Polsce, podaj jego PESEL",
    "Pokud máte jakékoliv dotazy, neváhejte nás kontaktovat na": "Jeśli masz jakiekolwiek pytania, nie wahaj się z nami skontaktować na",
    "Pokud pracujete jako FO, ve zdravotnické dokumentaci budeme uvádět Vaše identifikační údaje. Pokud ne, ve zdravotnické dokumentaci budou údaje firmy.": "Jeśli pracujesz jako osoba fizyczna (FO), w dokumentacji medycznej będziemy podawać Państwa dane identyfikacyjne. Jeśli nie, w dokumentacji medycznej będą podane dane firmy.",
    "Pokud problém přetrvává, napište nám na": "Jeśli problem będzie się utrzymywał, napisz do nas na adres",
    "Pokud si kdykoliv v budoucnu nebudete vědět rady, můžete se k průvodci aplikací vrátit.": "Jeśli w przyszłości kiedykolwiek nie będziesz wiedział, jak postępować, możesz wrócić do przewodnika po aplikacji.",
    "Pokud účet ještě nemáte, zvolte možnost registrace.": "Jeśli nie masz jeszcze konta, wybierz opcję rejestracji.",
    "Pole je povinné": "Pole jest obowiązkowe",
    "Položka byla úspěšně smazána": "Pozycja została usunięta",
    "Položka byla úspěšně upravena": "Pozycja została zaktualizowana",
    "Položka byla úspěšně vytvořena": "Pozycja została utworzona",
    "Položku se nepodařilo smazat": "Usunięcie pozycji nie powiodło się",
    "polozky": "pozycje",
    "Položky": "Pozycje",
    "Pondělí": "Poniedziałek",
    "Popis": "Opis",
    "Popis cviku": "Opis ćwiczenia",
    "Popis služby": "Opis usługi",
    "Popisy návštěv": "Opisy wizyt",
    "Porovnat fotky": "Porównaj zdjęcia",
    "Porovnat fotografie": "Porównaj zdjęcia",
    "Porovnat můžete maximálně 2 fotografie.": "Możesz porównać maksymalnie 2 zdjęcia.",
    "Porovnat vybrané fotografie": "Porównaj wybrane zdjęcia",
    "porovnavac": "porównywarka",
    "Porovnávač": "Porównywarka",
    "Poslat firmě email": "Wysłać e-mail do firmy",
    "Poslat firmě SMS": "Wysłać SMS do firmy",
    "Poslat terapeutovi email": "Wysłać e-mail do terapeuty",
    "Poslat terapeutovi SMS": "Wysłać SMS do terapeuty",
    "Poslední fakturace": "Ostatnie faktury",
    "Poslední návštěva": "Ostatnia wizyta",
    "Poslední návštěva:": "Ostatnia wizyta:",
    "Potvrdit": "Potwierdź",
    "Potvrdit nové heslo": "Potwierdź nowe hasło",
    "Potvrďte nové heslo": "Potwierdź nowe hasło",
    "Potvrzení GDPR před návštěvou fyzioterapie": "Potwierdź RODO przed wizytą fizjoterapeutyczną",
    "Potvrzení zrušení platby": "Potwierdzenie anulowania płątności",
    "Potvrzeno": "Potwierdzone",
    "potvrzuji": "potwierdzam",
    "Potvrzuji": "Potwierdzam",
    "Poukaz byl úspěšně vytvořen": "Kupon został pomyślnie utworzony",
    "Poukaz na lázně": "Bony Spa",
    "Poukaz úspěšně smazán": "Kupon został pomyślnie usunięty",
    "poukazy": "kupony",
    "Použít": "Zastosuj",
    "Použito pro všechny": "Zastosowano dla wszystkich",
    "Používáte": "Używasz",
    "Povinná platba online při rezervaci": "Obowiązkowa płatność online przy rezerwacji",
    "povolení online rezervací": "pozwolenie na rezerwacje online",
    "Povolí přístup do klientské sekce pouze klientům, jejichž email máte v kartotéce": "Dostęp do sekcji klienta jest przyznawany wyłącznie tym klientom, których adres e-mail znajduje się w Twojej kartotece",
    "Povolit odpovědi na SMS": "Zezwolić na odpowiedzi na SMS",
    "Povolit online rezervace": "Zezwól na rezerwacje online",
    "Povolit registraci pacientů pouze s emailem z kartotéky": "Zezwalać na rejestrację klientów tylko z adresem e-mail z kartoteki",
    "Povolit rezervace": "Zezwól na rezerwację",
    "Povolit rezervace na státní svátky": "Zeswól na rezerwację w dni świąteczne",
    "Povolit rezervace pro nepřihlášené uživatele v klientském portále": "Zezwolić na rezerwacje dla niezalogowanych użytkowników w portalu klienta",
    "Povolit skupinovou službu": "Włącz usługę grupową",
    "Povolit zobrazení detailu cizí návštěvy": "Zezwól na wyświetlenie szczegółów obcej wizyty",
    "Povolit zrušení rezervace": "Zezwól na anulowanie wizyty",
    "Poznámka": "Uwaga",
    "Poznámka k návštěvě": "Uwaga do wizyty",
    "Poznámka úspěšně smazána": "Uwaga została usunięta",
    "Poznámka úspěšně uložena": "Uwaga została zapisana",
    "Poznámka:": "Uwaga:",
    "Poznámku se nepodařilo uložit": "Nie udało się zapisać notatki",
    "Poznámku se nepodařilo uložit. Zkuste to prosím znovu.": "Uwagi nie udało się zapisać. Spróbuj ponownie.",
    "Pozor, blížíte se k maximálnímu počtu pacientů.": "Uwaga, zbliżasz się do maksymalnej liczby klientów.",
    "Pozor, blížíte se maximálnímu počtu pacientů.": "Uwaga, zbliżasz się do maksymalnej liczy klientów.",
    "Pozor, chystáte se zaplatit za návštěvu, která ještě neproběhla.": "Uwaga, starasz się zapłacić z wizytę, która się jeszcze nie odbyła.",
    "Pozor! Snažíte se vytvořit návštěvu, která porušuje nastavení u Fyzioterapeuta, Služby nebo Místnosti nebo dochází ke konfliktu v kalendáři.": "Uwaga! Próbujesz utworzyć wizytę, która narusza ustawienia Fizjoterapeuty, Usługi lub Pokoju, albo dochodzi do konfliktu w kalendarzu.",
    "Pozor! Upravujete globální cvik vytvořený aplikací Fyzion. Po uložení této úpravy vznikne duplicitní cvik v databázi. Původní cvik bude zachován v nezměněné podobě.": "Uwaga! Edytujesz globalne ćwiczenie utworzone przez aplikację Fyzion. Po zapisaniu tej zmiany w bazie danych powstanie zduplikowane ćwiczenie. Oryginalne ćwiczenie pozostanie bez zmian.",
    "pracoviste": "placówka",
    "Pracoviště": "Placówka",
    "Pracoviště bylo smazáno": "Placówka została usunięta",
    "Pracoviště pro pojišťovny": "Placówka dla ubezpieczalni",
    "Pracoviště upraveno": "Placówka zaktualizowana",
    "Pracoviště vytvořeno": "Placówka utworzona",
    "Pracoviště žadatele bylo úspěšně uloženo": "Placówka wnioskodawcy zostało pomyślnie zapisana",
    "Pracoviště žadatele bylo úspěšně vytvořeno": "Placówka wnioskodawcy została utworzona",
    "Pracovní dny": "Dni robocze",
    "Pracovní doba": "Godziny pracy",
    "Pracovníci": "Pracownicy",
    "Pracuji jako fyzická osoba": "Pracuje jako osoba fizyczna",
    "Pravidelné terapie": "Regularne terapie",
    "Pravidla rušení rezervací": "Zasady anulowania rezerwacji",
    "Před návštěvou ordinace se prosím seznamte se zásadami GDPR. Pro náhled znění GDPR a možnost potvrzení klikněte": "Przed wizytą w gabinecie prosimy o zapoznanie się z zasadami RODO. Aby wyświetlić treść RODO i potwierdzić zapoznanie się, kliknij tutaj",
    "Před pokračováním vyplňte formulář": "Przed kontynuacją wypełnij formularz",
    "Před pokračováním zadejte rodné číslo": "Przed kontynuacją podaj PESEL",
    "Před registrací musíte potvrdit souhlas se Všeobecnými obchodními podmínkami": "Przed rejestracją musisz potwierdzić zapoznanie się z Regulaminem",
    "před termínem": "przed terminem",
    "Předem děkuji a budu se těšit na Vaši návštěvu.": "Z góry dziękuję i oczekuję na Twoją wizytę.",
    "Předmět": "Temat",
    "Předmět emailu": "Temat e-maila",
    "předplacené (permice)": "subskrypcje ( karnety)",
    "predplatne": "subskrypcje",
    "Předplatné": "Subskrypcje",
    "Předplatné Fyzion": "Subskrypcja Fyzion Mind",
    "Předplatné smazáno": "Subskrypcję usunięto",
    "Předplatné úspěšně přidáno": "Subskrypcja dodana",
    "Předplatné úspěšně upraveno": "Subskrypcja zaktualizowana",
    "Předplatných na stránku": "Subskrypcji na stronę",
    "Předplatným": "Subskrypcją",
    "Předvolba": "Prefiks",
    "Předvolba země chybí. Zkuste to prosím znovu.": "Brakuje numeru kierunkowego kraju. Proszę spróbować ponownie.",
    "Předvyplněn kód zadaný v %{time}. Platí obvykle 30 minut.": "Wstępnie wypełniono kod wpisany o %{time}. Zwykle jest ważny 30 minut.",
    "Preferovaná místnost": "Preferowany pokój",
    "Preferovaná pobočka": "Preferowany oddział",
    "Preferovaná služba": "Preferowana usługa",
    "Přehled cviků": "Przegląd ćwiczeń",
    "Přehled dávek": "Przegląd zestawień",
    "Přehled položek": "Przegląd pozycji",
    "Přehled pracovišť": "Przegląd placówek",
    "Přehled transakcí": "Przegląd transakcji",
    "Přehled výkonů": "Przegląd osiągnięć",
    "prehled-vykonu": "Podgląd",
    "Přejete si vystavit doklad?": "Czy chcesz wystawić dokument?",
    "Přejete si vystavit fakturu na storno poplatek?": "Czy chcesz wystawić fakturę za opłatę za anulowanie?",
    "Přejete si vystavit storno doklad?": "Czy chcesz wystawić dokument storno?",
    "Přejít do aplikace": "Przejdź do aplikacji",
    "Přejít do profilu": "Przejdź do profilu",
    "Přejít na tarif": "Przejdź do taryfy",
    "Překlady": "Tłumaczenia",
    "Překlady názvu kategorie": "Tłumaczenia nazwy kategorii",
    "Překlady názvu služby": "Tłumaczenie nazwy usługi",
    "Premium registrace": "Rejstracja premium",
    "Přeskočit": "Pomiń",
    "Přesun rezervace": "Zmiana terminu rezerwacji",
    "Přesun rezervací se řídí obecným nastavením firmy.": "Zmiana terminu rezerwacji odbywa się zgodnie z ogólnymi ustawieniami firmy.",
    "Přesunout rezervaci": "Zmienić termin rezerwacji",
    "Přesuňte některé pacienty do archivu a pak objednejte tarif znovu.": "Przenieś niektórych klientów do archiwum, a następnie zamów ponownie taryfę.",
    "Převodem": "Przelewem",
    "Převodem (QR kód)": "Przelewem ( QR kod)",
    "při roční platbě": "przy płatności rocznej",
    "Při vytvoření online rezervace:": "Przy utworzeniu rezerwacji online:",
    "Při zrušení online rezervace:": "Przy anulowaniu rezerwacji online:",
    "Přidá po skončení rezervace časový blok, během kterého nebude možné vytvářet další rezervace (např. čas na úklid nebo pauzu).": "Dodaje po zakończeniu wizyty blok czasowy, w którym nie można tworzyć kolejnych rezerwacji.",
    "Přidán na seznam": "Dodano do spisu",
    "Přidáno": "Dodano",
    "Přidat": "Dodaj",
    "Přidat 3 pacienty": "Dodaj 3 klientów",
    "Přidat časový interval": "Dodać przedział czasowy",
    "Přidat čekajícího": "Dodać oczekującego",
    "Přidat cvik": "Dodaj ćwiczenie",
    "Přidat dodavatele": "Dodaj dostawcę",
    "Přidat dokument": "Dodaj dokument",
    "Přidat doplňkový text do e-mailů klientům": "Dodaj dodatkowy tekst do e-maili dla klientów",
    "Přidat fotku": "Dodaj zdjęcie",
    "Přidat FT poukaz": "Dodaj skierowanie FT",
    "Přidat fyzioterapeuta": "Dodaj użytkownika",
    "Přidat k návštěvě": "Dodaj do wizyty",
    "Přidat kategorii": "Dodaj kategorię",
    "Přidat místnost": "Dodaj pokój",
    "Přidat náhradníka": "Dodaj rezerwowego",
    "Přidat náhradníka jako účastníka návštěvy": "Dodaj rezerwowego jako uczestnika wizyty",
    "Přidat náhradníka jako účastníka návštěvy?": "Dodać rezerwowego jako uczestnika wizyty?",
    "Přidat návštěvu": "Dodaj wizytę",
    "Přidat nového čekajícího": "Dodaj nowego oczekującego",
    "Přidat nového pacienta": "Dodaj nowego klienta",
    "Přidat pacientovi permanentku": "Dodaj karnet do klienta",
    "Přidat peníze": "Dodaj pieniądze",
    "Přidat permanentku": "Dodaj karnet",
    "Přidat platbu": "Dodaj płatność",
    "Přidat pobočku": "Dodaj oddział",
    "Přidat podkategorii": "Dodaj podkategorię",
    "Přidat pojišťovnu": "Dodaj ubezpieczyciela",
    "Přidat položku": "Dodaj pozycję",
    "Přidat poznámku": "Dodaj uwagę",
    "Přidat pracoviště": "Dodaj placówkę",
    "Přidat předplatné": "Dodaj subskrypcję",
    "Přidat skupinovou návštěvu": "Dodaj wizytę grupową",
    "Přidat službu": "Dodaj usługę",
    "Přidat soubor": "Dodaj plik",
    "Přidat štítek...": "Dodaj etykietę...",
    "Přidat údaj": "Dodać informację",
    "Přidat výkon": "Dodaj świadczenie",
    "Přidat zboží": "Dodać towar",
    "pridat-permanentku": "dodaj-karnet",
    "pridat-volno": "dodaj-wolne",
    "Přidejte vlastní informace, které klienti potřebují vědět před návštěvou – například kde najdou vchod, co si mají vzít s sebou nebo jaké jsou storno podmínky. Informace se zobrazí pod detailem rezervace v e-mailu s potvrzením návštěvy a v její připomínce.": "Dodaj własne informacje, które klienci powinni znać przed wizytą – na przykład gdzie znajdą wejście, co mają ze sobą zabrać lub jakie są warunki anulowania. Informacje pojawią się pod szczegółami rezerwacji w e-mailu z potwierdzeniem wizyty oraz w jej przypomnieniu.",
    "Přihlášení jako nesprávný typ uživatele": "Logowanie jako nieprawidłowy typ użytkownika",
    "Přihlásit": "Zaloguj się",
    "Přihlásit se": "Zaloguj się",
    "Přihlašovací jméno": "Login",
    "Přihlašovací údaje": "Dane do logowania",
    "Přihlašovací údaje k portálům pojišťoven se nepodařilo načíst": "Nie udało się wczytać danych logowania do portali zakładów ubezpieczeń",
    "Přihlašovací údaje se nepodařilo smazat": "Nie udało się usunąć danych logowania",
    "Přihlašovací údaje se nepodařilo uložit": "Nie udało się zapisać danych logowania",
    "Přijat": "Akceptowane",
    "Příjemce": "Odbiorca",
    "Příjemce:": "Odbiorca:",
    "Přijmení": "Nazwisko",
    "Příjmení": "Nazwisko",
    "Přijmout do péče": "Akceptuj opiekę",
    "Přijmout FT poukaz": "Przyjąć FT pokwitowanie",
    "Příjmy": "Przychody",
    "Příjmy (budoucí)": "Przychody ( przyszłe)",
    "Příjmy fyzioterapeutů": "Przychody fizjoterapeutów",
    "Příjmy z nabízených služeb": "Przychody z oferowanych usług",
    "Přiložený soubor se nepodařilo nahrát": "Przesłanie załączonego pliku nie powiodło się",
    "Primární barva události": "Główny kolor wydarzenia",
    "Primární barva události v rozvrhu místnosti": "Główny kolor wydarzenia w grafiku pomieszczenia",
    "Případně kontaktujte naši podporu na ": "W razie potrzeby skontaktuj się z naszym wsparciem przez ",
    "Připojištění": "Ubezpieczenie dodatkowe",
    "Připomínka platby": "Przypomnienie o płatności",
    "Připravujeme": "Przygotowujemy",
    "Přiřazené služby": "Przypisane usługi",
    "Přišel/Přijde": "Przyszedł/Przyjdzie",
    "Příští návštěva": "Przyszła wizyta",
    "Příští objednání": "Przyszłe zamówienie",
    "Příští služba": "Przyszła usługa",
    "Přítomen": "Obecny",
    "Pro dokončení rezervace je nutné souhlasit se zásadami zpracování osobních údajů.": "Aby dokończyć rezerwację, należy wyrazić zgodę na zasady przetwarzania danych osobowych.",
    "Pro export kartotéky kontaktujte naší podporu na": "Aby wyeksportować kartotekę, skontaktuj się z naszym działem wsparcia pod",
    "Pro individuální nastavení textace emailů vašim klientům kontaktujte naši technickou podporu na": "Aby indywidualnie dostosować treść e-maili dla klientów, skontaktuj się z naszym wsparciem technicznym",
    "Pro individuální nastavení textace emailů vašim pacientům kontaktujte naši technickou podporu na": "W celu indywidualnego dostosowania treści e-maili do Państwa klientów prosimy o kontakt z naszym działem wsparcia technicznego przez",
    "Pro nastavení časového úseku, kdy je možné tuto službu rezervovat online, kontaktujte naší podporu na": "W celu ustawienia przedziału czasowego, w którym możliwa jest rezerwacja tej usługi online, prosimy o kontakt z naszym działem wsparcia przez",
    "Pro nastavení otevírací doby místnosti kontaktujte naší podporu na": "W celu ustawienia godzin otwarcia pomieszczenia prosimy o kontakt z naszym działem wsparcia przez",
    "Pro odeslání potvrzení o platbě zadejte email pacienta": "Aby wysłać potwierdzenie płatności podaj e-mail klienta",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu %{portal}.": "Aby weryfikować kodem SMS, najpierw zapisz w profilu dane logowania do portalu %{portal}.",
    "Pro ověření SMS kódem si nejdříve v profilu uložte přihlašovací údaje k portálu pojišťovny.": "Aby weryfikować kodem SMS, najpierw zapisz w profilu dane logowania do portalu zakładu ubezpieczeń.",
    "Pro platby převodem systém automaticky vystaví fakturu namísto stvrzenky.": "W przypadku zapłaty przelewem system automatycznie wystawia fakturę zamiast paragonu.",
    "Pro přihlášení je potřeba přejít na správné URL klientského portálu. Kontaktujte svého poskytovatele služeb.": "Aby się zalogować, musisz przejść na poprawny adres URL portalu klienta. Skontaktuj się z dostawcą usług.",
    "Pro správné fungování aplikace je potřeba základní nastavení. Nebojte, základní nastavení aplikace a projití funkcí vám zabere jen pár minut!": "Dla prawidłowego działania aplikacji potrzebne jest podstawowe ustawienie. Nie martw się, podstawowa konfiguracja aplikacji i zapoznanie się z funkcjami zajmie Ci tylko kilka minut!",
    "Pro tohoto pacienta jste zatím nevytvořili žádný FT poukaz": "Dla tego klienta jescze nie utworzyłeś skierowania FT",
    "Pro tohoto pacienta jste zatím nevytvořili žádný poukaz": "Dla tego klienta jescze nie utworzyłeś skierowania FT",
    "Pro zobrazení platebního QR kódu vyplňte v": "Aby wyświetlić kod QR do płatności, wypełnij w",
    "Proběhlé návštěvy": "Zrealizowane wizyty",
    "Probíhá synchronizace Vašeho kalendáře": "Trwa synchronizacja Twojego kalendarza",
    "Procentuální": "Procentowa",
    "Prodané permanentky": "Sprzedane karnety",
    "Prodej zboží": "Sprzedaż towarów",
    "Prodejní cena (s DPH)": "Cena sprzedazy ( z VAT)",
    "Prodejní cena s DPH": "Cena sprzedaży z VAT",
    "Prodejní cena zboží za ks (s DPH)": "Cena spradaży produktu za szt. ( z VAT)",
    "Prodejní hodnota (s DPH)": "Wartość sprzedaży ( z VAT)",
    "Profil": "Profil",
    "Profilová fotografie": "Zdjęcie profilowe",
    "Profilový obrázek byl úspěšně nahrán": "Zdjęcie profilowe zostało pomyślnie przesłane",
    "Profily": "Profile",
    "Proklik na skupinovou návštěvu": "Przekierowanie do wizyty grupowej",
    "Propojené aplikace": "Połączone aplikacje",
    "Propojení": "Integracje",
    "Propojeno": "Połączono",
    "Propojit": "Połączyć",
    "Prosím": "Proszę",
    "Prosíme o její úhradu co nejdříve.": "Prosimy o jak najszybsze jej uregulowanie.",
    "Provedeme vás, nastavíme základní parametry, přidáme první klienty.": "Przeprowadzimy Cię przez proces, ustawimy podstawowe parametry i dodamy pierwszych klientów.",
    "Provedené akce": "Wykonane akcje",
    "Průměrná nákupní cena zboží na skladě za ks (s DPH)": "Średnia cena zakupu produktów w magazynie za szt. (z VAT)",
    "Průvodce": "Przewodnik",
    "Průvodce a nápovědu případně navštivte prostřednictvím odkazu v horním menu. Zde naleznete vše co vás zajímá přehledně na jednom místě.": "Przewodnik i pomoc możesz w razie potrzeby znaleźć za pomocą linku w górnym menu. Znajdziesz tam wszystko, co Cię interesuje – przejrzyście w jednym miejscu.",
    "PSČ": "Kod pocztowy",
    "Purobot API klíč": "Klucz Purobi API",
    "Původní": "Pierwotny",
    "Původní dávka": "Pierwotne zestawienie",
    "qr": "qr",
    "RČ / Datum narození": "PESEL/ Data urodzenia",
    "Recenze": "Opinia",
    "Recenze byla smazána": "Opinia została usunięta",
    "Recenze návštěv": "Opinie o wizytach",
    "recenzí": "opinii",
    "Recepční": "Pracownik recepcj",
    "Recepční vidí kalendáře uživatelů a statistiky, ale nemá přístup ke kartám klientů": "Recepcja widzi kalendarze użytkowników i statystyki, ale nie ma dostępu do kart klientów",
    "Registrace": "Rejestracja",
    "Registrace náhradníka byla úspěšně vytvořena.": "Rezerwacja rezerwowego została utworzona.",
    "Registrace proběhla úspěšně": "Rejestracja zakończona pomyślnie",
    "Registrace proběhla úspěšně. Prosím potvrďte ještě svojí emailovou adresu kliknutím na odkaz ve vašem emailu!": "Rejestracja przebiegła pomyślnie. Prosimy, potwierdź swój adres e-mail, klikając w link w otrzymanej wiadomości!",
    "Registrace se nepovedla": "Rejastracja nie powiodła się",
    "registrace-zdarma": "darmowa-rejestracja",
    "Registrace/Přihlášení": "Rejestracja/Logowanie",
    "Registrovat jako náhradník": "Zarejestrować się jako rezerwowy",
    "Registrovat se": "Zarejestruj się",
    "Resetování hesla": "Resetowanie hasła",
    "Resetovat": "Resetuj",
    "Resetovat fyzioterapeuty dle diagnózy": "Zresetuj fizjoterapeutów według diagnozy",
    "Resetovat heslo": "Resetuj hasło",
    "resetpassword/:uid/:token": "Zmień hasło /: uid /: token",
    "Řešíte jiný problém?": "Czy rozwiązujesz inny problem?",
    "Rezarvace byla úspěšně změněna na": "Rezerwacja została zmieniona na",
    "rezervace": "rezerwacja",
    "Rezervace": "Rezerwacja",
    "Rezervace byla úspěšně vytvořena.": "Rezerwacja została utworzona.",
    "Rezervace byla zrušena": "Rezerwacja została anulowana",
    "Rezervace čekajících": "Rezerwacje oczekujących",
    "Rezervace je potvrzena až po úspěšné online platbě.": "Rezerwacja zostaje potwierdzona dopiero po pomyślnej płatności online.",
    "Rezervace nejdříve": "Rezerwacje najwcześniej",
    "Rezervace nejpozději": "Rezerwacje najpóźniej",
    "Rezervace nemohla být vytvořena": "Rezerwacja nie mogła być utworzona",
    "Rezervace pacienta jsou povoleny": "Rezerwacja klienta są dozwolone",
    "Rezervace pacienta jsou zablokovány": "Rezerwacje klienta są zablokowane",
    "Rezervace úspěšně vytvořena": "Rezerwacja została utworzona",
    "rezervací": "rezerwacji",
    "Rezervaci již nelze zrušit online": "Rezerwacji nie można już anulować online",
    "Rezervaci můžete zrušit do": "Rezerwację możesz anulować do",
    "Rezervaci nebylo možné dokončit": "Zastrzeżenie nie mogło zostać zakończone",
    "Rezervaci nelze zrušit online": "Rezerwacji nie można anulować online",
    "Rezervaci se nepodařilo zrušit": "Nie powiodło się anulowanie rezerwacji",
    "Rezervační formulář": "Formularz rezerwacji",
    "Rezervační systém": "System rezerwacji",
    "Rezervační tlačítko": "Przycisk rezerwacji",
    "Rezervovat": "Rezerwuj",
    "Rezervovat jako náhradník": "Zarezerwować jako rezerwowy",
    "Rezervujte si termín": "Rezerwuj termin",
    "Rezervujte si termín online": "Rezerwuj termin online",
    "Rezervujte si termín u": "Rezerwuj termin u",
    "Režim zobrazení": "Tryb wyświetlania",
    "Roční": "Roczny",
    "Rodné číslo": "PESEL",
    "Rodné číslo pacienta": "PESEL klienta",
    "Rodné číslo:": "PESEL:",
    "Rok": "Rok",
    "Roky": "Lata",
    "Role": "Stanowisko",
    "Rozpis termínů fyzioterapie": "Rozkład terminów fizjoterapii",
    "Rozpracovaná návštěva uložena": "Niezakończona wizyta została zapisana",
    "Rozpracované podání bylo smazáno": "Niedokończone zgłoszenie zostało usunięte",
    "Rozpracované podání se nepodařilo smazat": "Nie udało się usunąć niedokończonego zgłoszenia",
    "Rozvrh místností": "Plan pokoi",
    "Rozvrh skupinových lekcí": "Harmonogram zajęć grupowych",
    "s GDPR, klikněte níže na tlačítko": "z RODO, naciśnij przycisk poniżej",
    "S jakým problémem k nám přicházíte?": "Z jakim problemem do nas przychodzisz?",
    "S nezaplacenými návštěvami": "Z nieopłaconymi wizytami",
    "Šablon na stránku": "Szablon strony",
    "Šablona": "Szablon",
    "Šablona byla úspěšně aktualizována": "Szablon został zaktualizowany",
    "Šablona byla úspěšně smazána": "Szablon został usunięty",
    "Šablona byla úspěšně upravena": "Szablon został pomyślnie zmodyfikowany",
    "Šablona byla úspěšně vytvořena": "Szablon został utworzony",
    "Šablona FT výkonů": "Szablon wyników FT",
    "Šablona neobsahuje žádné výkony": "Szablon nie zawiera żadnych wykonanych",
    "Šablona výkonů": "Szablon osiągnięć",
    "Šablona výkonů FT": "Szablon wyników FT",
    "Šablona výkonů pro návštěvy": "Szablon wyników dla odwiedzin",
    "sablony": "szablony",
    "Šablony": "Szablony",
    "Šablony výkonů FT": "Szablony usług FT",
    "Šablony výkonů pro návštěvy": "Szablony wyników dla odwiedzin",
    "Sada cviků byla odeslána klientovi": "Zestał ćwiczeń został wysłany klientowi",
    "Sazba DPH": "Stawka VAT",
    "Sdílejte": "Udostępnij",
    "SDÍLEJTE NÁS": "Udostępnij nas",
    "Sdílení": "Udostępnianie",
    "sdílet": "Udostępnij",
    "sdílet aplikaci": "udostępnij aplikację",
    "Sekundární barva události": "Drugorzędny kolor wydarzenia",
    "Shrnutí historie návštěv": "Podsumowanie historii wizyt",
    "Shrnutí návštěv": "Podsumowanie wizyt",
    "SK": "SK",
    "Sklad": "Magazyn",
    "Skrýt": "Ukryj",
    "Skupina služeb": "Grupa usług",
    "Skupinová návštěva": "Wizyta grupowa",
    "Skupinová návštěva smazána": "Wizyta grupowa usunięta",
    "Skupinové lekce se nepodařilo načíst": "Nie udało się załadować zajęć grupowych",
    "Skupinovka": "Grupówka",
    "Skutečně si přejete změnit tarif?": "Czy na pewno chcesz zmienić taryfę?",
    "Sloučení karet": "Połączenie kart",
    "Sloučit karty": "Połącz karty",
    "Služba": "Usługa",
    "Služba nenalezena": "Usługa nie została odnaleziona",
    "Služba:": "Usługa:",
    "sluzby": "usługi",
    "Služby": "Usługi",
    "Služby dle kategorií celkem za rok": "Usługi według kategorii łącznie za rok",
    "Služby nebudou smazány, kategorie jim bude pouze odebrána.": "Usługi nie zostaną usunięte, zostanie im jedynie odebrana kategoria.",
    "Služby:": "Usługi:",
    "Smazání": "Usunięcie",
    "Smazání obrázku se nezdařilo": "Usunięcie obrazu nie powiodło się",
    "Smazáno": "Usunięto",
    "Smazat": "Usuń",
    "Smazat cvik": "Usuń ćwiczenie",
    "Smazat dodavatele": "Usuń dostawcę",
    "Smazat dokument": "Usuń dokument",
    "Smazat formulář": "Usuń formularz",
    "Smazat fotku": "Usuń zdjęcie",
    "Smazat fotografii": "Usuń zdjęcie",
    "Smazat kategorii cviků": "Usuń kategorie ćwiczeń",
    "Smazat kategorii služeb": "Usuń kategorię usług",
    "Smazat místnost": "Usunąć pokój",
    "Smazat návštěvu": "Usuń wizytę",
    "Smazat nezaplacenou návštěvu před termínem": "Usuń nieopłaconą wizytę przed terminem",
    "Smazat obrázek": "Usuń obraz",
    "Smazat permanentku": "Usuń karnet",
    "Smazat pobočku": "Usuń oddział",
    "Smazat podání": "Usuń zgłoszenie",
    "Smazat podpis": "Usuń podpis",
    "Smazat pojišťovnu": "Usuń ubezpieczalnię",
    "Smazat položku": "Usuń pozycję",
    "Smazat pouze toto volno": "Usuń tylko ten wolny termin",
    "Smazat pouze tuto návštěvu": "Usuń tylko tą wizytę",
    "Smazat pouze tuto skupinovou návštěvu": "Usuń tylko tą wizytę grupową",
    "Smazat pracoviště": "Usuń placówkę",
    "Smazat předplatné": "Usuń subskrypcję",
    "Smazat přihlašovací údaje k portálu %{portal}?": "Usunąć dane logowania do portalu %{portal}?",
    "Smazat recenzi": "Usuń opinię",
    "Smazat rozpracované podání": "Usuń niedokończone zgłoszenie",
    "Smazat rozpracované podání?": "Usunąć niedokończone zgłoszenie?",
    "Smazat šablonu": "Usuń szablon",
    "Smazat službu": "Usuń usługę",
    "Smazat soubor": "Usuń plik",
    "Smazat stávající zápis": "Usuń aktualny zapis",
    "Smazat toto a všechna budoucí volna": "Usuń ten i przyszłe wolne terminy",
    "Smazat tuto a všechny budoucí návštěvy": "Usuń tą i wszystkie przyszłe wizyty",
    "Smazat tuto a všechny budoucí skupinové návštěvy": "Usuń tą i wszystkie przyszłe wizyty grupowe",
    "Smazat video": "Usuń film",
    "Smazat volno": "Usuń wolny termin",
    "Smazat zboží": "Usuń produkt",
    "Smaže rozpracované podání, např. abyste mohli dávku upravit a odeslat znovu": "Usuwa niedokończone zgłoszenie, np. abyś mógł edytować paczkę i wysłać ją ponownie",
    "Smluvní pojištění": "Ubezpieczenie na podstawie umowy",
    "SMS": "SMS",
    "SMS byla úspěšně odeslána": "SMS został wysłany",
    "SMS byly úspěšně odeslána": "SMSy zostały wysłane",
    "SMS čekajícímu": "SMS do oczekującego",
    "SMS klientům": "SMS klientom",
    "SMS kód": "Kod SMS",
    "SMS kód se nepodařilo vyžádat": "Nie udało się zażądać kodu SMS",
    "SMS odpovědi od klientů budou přeposílány na zvolený email": "Odpowiedzi SMS od klientów zostaną wysłane do wybranego e-maila",
    "SMS se nepodařilo odeslat": "Wysłanie SMS nie powiodło się",
    "SMS tento měsíc": "SMS tego miesiąca",
    "Sobota": "Sobota",
    "Soubor se nepodařilo stáhnout": "Zapisanie pliku nie powiodło się",
    "Soubor se zobrazí zákazníkům v posledním kroku online rezervace.": "Plik zostanie wyświetlony klientom w ostatnim kroku rezerwacji online.",
    "Soubory úspěšně nahrány": "Pliki zapisane",
    "Současné heslo": "Aktualne hasło",
    "Souhlas GDPR": "Zgoda RODO",
    "Souhlas s GDPR": "Zgoda RODO",
    "Souhlas s GDPR odesílat automaticky": "Automatycznie wysyłać zgodę RODO",
    "Souhlas s novinkami:": "Zgoda na przesyłanie informacji/ aktualności",
    "Souhlas se zpracováním osobních údajů": "Zgoda z zasadami przetwarzania danych osobowych",
    "Souhlas udělen": "Zgoda udzielona",
    "Souhlasil s novinkami": "Zgodził się na pzesyłanie informacji/aktualności",
    "Souhlasili": "Zgodzili się",
    "Souhlasím s vytvořením karty pacienta v souladu s": "Wyrażam zgodę na utworzenie karty klienta zgodnie z",
    "Souhlasím se": "Zgadzam się",
    "Souhlasím se zasíláním novinek a zajímavých nabídek": "Wyrażam zgodę na otrzymywanie newslettera i ciekawych ofert",
    "souhlasíte": "zgadzasz się",
    "Spis byl načten": "Plik został załadowany",
    "Spis se nepodařilo načíst": "Plik nie został wczytany",
    "Spis se nepodařilo vytvořit": "Plik nie został utworzony",
    "Spisy": "Pliki",
    "Spisy byly synchronizovány": "Pliki były synchronizowane.",
    "Spisy se nepodařilo načíst": "Pliki nie zostały wczytane",
    "Splatnost": "Termin płatności",
    "Splatnost faktury": "Termin płatności faktury",
    "Spočítat": "Oblicz",
    "Stačí": "Wystarczy",
    "Stáhnout": "Pobierz",
    "Stáhnout fakturu": "Pobierz fakturę",
    "Stáhnout soubory": "Pobierz pliki",
    "Stáhnout zálohovou fakturu": "Pobierz pro formę",
    "Start": "Start",
    "STATISTICS": "STATYSTYKI",
    "Statistiky": "Statystyki",
    "Status": "Status",
    "Stav": "Stan",
    "Stav bude změněn v obou případech. Volbou „Ano“ se doklad vystaví společně se změnou stavu.": "Status zostanie zmieniony w obu przypadkach. Wybór „Tak” spowoduje wystawienie dokumentu wraz ze zmianą statusu.",
    "Stav bude změněn v obou případech. Volbou „Ano“ se faktura vystaví společně se změnou stavu.": "Status zostanie zmieniony w obu przypadkach. Wybór „Tak” spowoduje wystawienie faktury wraz ze zmianą statusu.",
    "Stav návštěvy byl změněn": "Status wizyty został zmieniony",
    "Stav platby": "Stan płatności",
    "Stejné jako fakturační": "Takie same jak dane do faktury",
    "Štítek byl úspěšně odebrán": "Etykieta została pomyślnie usunięta",
    "Štítek byl úspěšně smazán": "Etykieta została usunięta",
    "Štítek byl úspěšně vytvořen": "Etykieta została pomyślnie utworzona",
    "Štítky": "Tagi",
    "Štítky návštěv": "Etykiety wizyt",
    "Štítky pacientů": "Etykiety klientów",
    "Storno": "Storno",
    "Storno poplatek": "Opłata za anulowanie",
    "Stornovaná faktura": "Anulowana faktura",
    "stornovanou fakturu č.": "anulowaną fakturę nr",
    "Stornovaný paragon": "Anulowany paragon",
    "stornovaný paragon č.": "anulowany paragon nr",
    "Stornovat": "Anulować",
    "stránka někam utekla...": "Ups, strona zniknęła..",
    "Stránka ordinace": "Strona gabinetu",
    "Středa": "Środa",
    "Stvrzenek na stránku": "Paragonów na stronę",
    "svůj prohlížeč nebo si nainstalujte jiný.": "swoją przeglądarkę lub zainstaluj inną.",
    "Synchronizace kalendáře byla zrušena": "Synchronizacja kalendarza została anulowana",
    "Synchronizace s Google kalendářem": "Synchronizacja z kalendarzem Google",
    "Synchronizace se nezdařila": "Synchronizacja nie powiodła się",
    "synchronizace-kalendare": "synchronizacja-kalendarza",
    "Synchronizovat události z Google kalendáře do Fyzionu": "Synchronizuj wydarzenia z Kalendarza Google z Fyzionem",
    "Synchronizujte svůj Fyzion kalendář s kalendářem Google": "Synchronizuj swój kalendarz Fyzion z kalendarzem Google",
    "Systém bude při automatickém vystavování dokladů používat výhradně fakturu místo stvrzenky.": "System będzie używał tylko faktury zamiast paragonu podczas automatycznego wydawania dokumentów.",
    "Tarif": "Taryfa",
    "Tarify": "Taryfy",
    "Tato akce může ovlivnit rezervační systém.": "To wydarzenie może wpłynąć na system rezerwacji.",
    "Tato funkce je dostupná pouze v placeném tarifu.": "Ta funkcja jest dostępna wyłącznie w płatnej taryfie.",
    "Tato funkce je dostupná pouze v placeném tarifu. Placené tarify ukrývají spoustu pokročilých funkcí, které Vám ulehčí práci.": "Ta funkcja jest dostępna tylko w płatnym planie. Płatne plany zawierają wiele zaawansowanych funkcji, które ułatwią Ci pracę.",
    "Tato karta se smaže.": "Ta karta zostanie usunięta",
    "Tato přihlašovací stránka je určena pouze terapeutům.": "Ta strona logowania jest przeznaczona wyłącznie dla terapeutów.",
    "Tato služba bude automaticky předvyplněna při vytváření nové návštěvy.": "Usługa będzie automatycznie wybierana przy tworzeniu nowej wizyty.",
    "Tato zpráva bude účtována jako 2 SMS": "Ta wiadomość zostanie pobrana jako 2 SMS",
    "Tato zpráva bude účtována jako 3 SMS": "Ta wiadomość zostanie pobrana jako 3 SMS",
    "Tel.:": "Tel.:",
    "Telefon": "Telefon",
    "Telefonní číslo": "Numer telefonu",
    "Telefonní číslo:": "Numer telefonu:",
    "Tento měsíc": "Bieżący miesiąc",
    "Tento pacient má nezaplacenou návštěvu, která nebyla omluvená.": "Ten klient ma niezapłaconą wizytę, która nie została odwołana.",
    "Tento profil zatím nemá žádné permanentky.": "Ten profil nie ma jeszcze żadnych karnetów.",
    "Tento rok": "Bieżący rok",
    "Tento týden": "Bieżący tydzień",
    "Terapeut": "Terapeuta",
    "Terapeut nemá přiřazené pracoviště pro pojišťovny. Přiřaďte pracoviště v profilu terapeuta a zkontrolujte nastavení pracoviště": "Terapeuta nie ma miejsca pracy dla firm ubezpieczeniowych. Przypisz miejsce pracy do profilu terapeuty i sprawdź ustawienia miejsca pracy",
    "Termín můžete přesunout do": "Termin możesz przenieść na",
    "Termín přidán. Nyní je možné pokračovat k potvrzení rezervací.": "Termin został dodany. Teraz możesz kontynuować potwierdzanie rezerwacji.",
    "Termín pro zaplacení": "Termin płatności",
    "termínů": "terminów",
    "Text": "Tekst",
    "Text s instrukcemi pro klienta, co má do poznámky uvést (např. Uveďte své zdravotní potíže nebo omezení).": "Tekst z instrukcjami dla klienta, co powinien wpisać w notatce (np. dolegliwości zdrowotne lub ograniczenia).",
    "Text SMS překročil maximální povolený limit znaků.": "Tekst SMS przekroczył maksymalny dopuszczalny limit znaków.",
    "Těžší varianta": "Trudniejsza wersja",
    "theme_company": "motyw_firmy",
    "Tisk": "Wydruk",
    "Tisk GDPR": "Wydruk RODO",
    "Tisk karty pacienta": "Wydruk karty klienta",
    "Tisk návštěv": "Wydruk wizyt",
    "Tisk návštěvy": "Wydruk wizyty",
    "Tisk rozpisu termínů návštěv": "Wydruk harmonogramu terminów wizyt",
    "Toto okno můžete zavřít.": "Możesz zamknąć to okno.",
    "Toto podání už na autorizaci nečeká, mezitím se dokončilo.": "To zgłoszenie nie oczekuje już na autoryzację, w międzyczasie zostało zakończone.",
    "Toto pole je povinné": "To pole jest obowiązkowe",
    "Trvání služby v minutách": "Czas trwania usługi w minutach",
    "týden": "tydzień",
    "Týdně": "Tygodniowo",
    "týdnů": "tygodni",
    "týdny": "tygodnie",
    "Týdny": "Tygodnie",
    "Typ akce": "Typ akcji",
    "Typ dávky": "Typ dawki",
    "Typ dokladu": "Typ dokumentu",
    "Typ permanentky": "Typ karnetu",
    "Typ platby": "Rodzaj płatności",
    "Typ platební brány": "Typ bramki płatniczej",
    "Typ poukazu": "Typ poukazu",
    "Typ připojištění": "Rodzaj ubezpieczenia dodatkowego",
    "Typ připojištění:": "Rodzaj ubezpieczenia dodatkowego:",
    "Typ šablony": "Typ szablonu",
    "Typ spisu": "Rodzaj pliku",
    "Typ subjektu": "Typ podmiotu",
    "Typ transakce": "Rodzaj transakcji",
    "Typ výkonu": "Rodzaj usługi",
    "Typ vyšetření": "Rodzaj badania",
    "Typ vyšetření a délka": "Typ badania i długość",
    "Typ záznamu": "Rodzaj zapisu",
    "Tyto informace jsou vaše soukromé kontaktní údaje. Změnu veřejných kontaktních údajů, které vidí pacienti, uděláte v ": "Te informacje to Twoje prywatne dane kontaktowe. Zmiany publicznych danych kontaktowych, które widzą klienci, dokonasz w ",
    "Účast pacienta": "Udział klienta",
    "Údaje": "Dane",
    "Údaje instituce": "Dane instytucji",
    "Údaje o pojištění": "Dane ubezpieczeniowe",
    "Údaje pro platbu převodem": "Dane do przelewu",
    "Údaje úspěšně změněny": "Dane zostały zmienione",
    "Úhloměr": "Kątomierz",
    "Uhradit": "Zapłacić",
    "Uhrazeno": "Zapłacone",
    "Ukázat cvik": "Pokaż ćwiczenie",
    "Ulice": "Ulica",
    "Ulice a č. p.": "Ulica i nr",
    "Ulice a č.p.": "Ulica i nr",
    "Uložené heslo vám nikdy nezobrazíme. Ponechte pole prázdné, pokud ho nechcete měnit.": "Zapisanego hasła nigdy Ci nie pokażemy. Pozostaw pole puste, jeśli nie chcesz go zmieniać.",
    "Uložené šablony": "Zapisane szablony",
    "Uloženo": "Zapisane",
    "uložit": "zapisz",
    "Uložit": "Zapisz",
    "Uložit a zamknout": "Zapisz i zamknij",
    "Uložit jako PDF do karty pacienta": "Zapisz jako PDF do karty klienta",
    "Uložit rozpracované": "Zapisz wersję roboczą",
    "Uložit změny": "Zapisz zmiany",
    "Umožní rezervaci více klientů na jeden termín.": "Pozwala więcej klientów zarezerwować na jeden termin.",
    "Umožnit rezervaci náhradníkům": "Umożliwić rezerwację zastępcom",
    "Upozornit klienta při vytvoření, změně a zrušení návštěvy": "Powiadomić klienta o utworzeniu, zmianie i anulowaniu wizyty",
    "Upozornit terapeuta na akce provedené jinym terapeutem": "Powiadomić terapeutę o działaniach wykonanych przez innego terapeutę",
    "Úprava": "Edycja",
    "Úprava příští návštěvy": "Aktualizacja przyszłej wizyty",
    "upravit": "edytuj",
    "Upravit": "Edytuj",
    "Upravit cvik": "Edytuj ćwiczenie",
    "Upravit dodavatele": "Edytuj dostawcę",
    "Upravit dostupnost": "Edytuj dostępność",
    "Upravit fakturaci": "Edytuj fakturę",
    "Upravit FT poukaz": "Edytuj skierowanie FT",
    "Upravit fyzioterapeuta": "Edytuj fizjoterapeutę",
    "Upravit kategorii": "Edetuj kategorię",
    "Upravit kategorii cviků": "Edytuj kategorie ćwiczeń",
    "Upravit kategorii služeb": "Edytuj kategorie usług",
    "Upravit místnost": "Edytuj pokój",
    "Upravit ordinační hodiny": "Edytuj godziny przyjęć",
    "Upravit pacientovu permanentku": "Edytuj karnet klienta",
    "Upravit permanentku": "Edytuj karnet",
    "Upravit platbu č.": "Edytuj płatność nr",
    "Upravit pobočku": "Edytuj oddział",
    "Upravit podkategorii": "Edytuj podkategorie",
    "Upravit pojišťovnu": "Edytuj ubezpieczalnię",
    "Upravit položku": "Edytuj pozycję",
    "Upravit pracoviště": "Edytuj placówkę",
    "Upravit pracoviště žadatele": "Edytuj placówkę kierującą",
    "Upravit šablonu": "Edytuj szablon",
    "Upravit šablonu výkonů": "Edytuj szablon osiągnięć",
    "Upravit službu": "Edytuj usługę",
    "Upravit štítky": "Edytuj etykiety",
    "Upravit uživatele": "Edytuj użytkownika",
    "Upravit žadatele": "Edytuj wnioskodawcę",
    "Upravit zboží": "Edytuj produkt",
    "upravit-ft-poukaz/:ticketId": "edytuj-skierowanie-ft/:ticketld",
    "upravit-permanentku/:ticketId": "edytuj-karnet/:ticketld",
    "upravit-volno": "edytuj-wolne",
    "Určuje maximální počet pacientů na skupinovou návštěvu. Hodnota 0 se rovná neomezenému počtu pacientů.": "Określa maksymalną liczbę klientów na wizytę grupową. Wartość 0 oznacza nieograniczoną liczbę klientów.",
    "Určuje základní stav odesílání stvrzenek. Toto nastavení můžete ještě individuálně upravovat před samotnou platbou za návštěvu.": "Określa domyślny sposób wysyłania potwierdzeń. To ustawienie można jeszcze indywidualnie zmienić przed dokonaniem płatności za wizytę.",
    "Určuje, kolik dní před návštěvou musí být provedena platba. Pokud není zaplaceno včas, návštěva se automaticky smaže. (0 dní = nikdy nedojde ke smazání)": "Określa, ile dni przed wizytą musi zostać dokonana płatność. Jeśli nie zostanie to zrobione na czas, wizyta zostanie automatycznie usunięta. (0 dni = nigdy nie dojdzie do usunięcia)",
    "Určuje, v jakém časovém rozmezí (počet dní) musí být všechny rezervace v rámci jedné objednávky.": "Określa przedział czasowy (liczbę dni), w którym muszą się mieścić wszystkie rezerwacje w jednym zamówieniu.",
    "Určuje, zda musí být během služby přítomen terapeut. Vypíná se např. u služeb bez přímé obsluhy (vana, infrasauna apod.).": "Określa, czy podczas usługi musi być obecny terapeuta.",
    "user.form.role.worker.tooltip": "user.form.roll. worker.tooltip",
    "Úspěšně jste byli zaregistrováni jako náhradník": "Zostałeś pomyślnie zarejestrowany jako rezerwowy",
    "Úspěšně nahrána dávka do Purobota": "Skutecznie załadowana dawka produktu Purobot",
    "Úterý": "Wtorek",
    "Už mám odcvičeno:": "Już przećwiczyłem/am:",
    "Územní pracoviště VZP": "Terytorialne miejsce pracy",
    "Uživatel": "Użytkownik",
    "Uživatel byl deaktivován": "Użytkowni deaktywowany",
    "Uživatel byl úspěšně přidán": "Użytkownik dodany",
    "Uživatelé": "Użytkownicy",
    "v angličtině": "po angielsku",
    "v češtině": "po polsku",
    "V historii cvičení nejsou žádné záznamy.": "W historii ćwiczeń nie ma żadnych zapisów.",
    "V historii rezervací zatím není žádná absolvovaná návštěva.": "W historii rezerwacji nie ma jeszcze żadnej zrealizowanej wizyty.",
    "V měsících, ode dne zakoupení": "W miesiącach, od dnia zakupu",
    "v nejnovější verzi Google Chrome, kterou můžete zdarma stáhnout na": "w najnowszej wersji Google Chrome, którą możesz pobrać za darmo z",
    "V ordinaci hotově/kartou": "W gabiniecie gotówką/kartą",
    "v polštině": "po polsku",
    "V případě neuhrazení může dojít k dočasnému zablokování Vašeho účtu.": "W przypadku braku płatności może dojść do tymczasowego zablokowania Twojego konta",
    "V případě, že je tato volba zapnuta, pacientům automaticky odchází i stvrzenky za zakoupené permanentky.": "W przypadku włączenia tej opcji, klientom automatycznie wysyłane są również potwierdzenia za zakupione karnety.",
    "V případě, že přejdete na některý z pokročilých tarifů spolupráce, automaticky se ruší limit na počet pacientů v aplikaci.": "W przypadku przejścia na jeden z zaawansowanych planów współpracy, limit liczby klientów w aplikacji zostaje automatycznie zniesiony",
    "V případě, že se nemůžete dostavit, volejte na": "W przypadku, gdy nie możesz się stawić, zadzwoń pod numer",
    "V tomto období se počet návštěv u každého z fyzioterapeutů rovná nule": "W tym okresie liczba wizyt u każdego z fizjoterapeutów wynosi zero",
    "V tuto chvíli není možné GDPR potvrdit. Zkuste to znovu později.": "W tej chwili nie można potwierdzić zgody RODO. Proszę spróbować ponownie później.",
    "Vám navýšíme limit kartotéky pacientů v balíčku Freemium.": "Zwiększymy limit kartoteki klientów w pakiecie Freemium.",
    "Variabilní symbol": "Symbol zmienny",
    "Variabilní symbol:": "Symbol zmienny:",
    "Váš prohlížeč nepodporuje datový formát tohoto videa.": "Twoja przeglądarka nie obsługuje formatu danych tego wideo.",
    "vaše číslo účtu nebo IBAN.": "twój numer rachnku w formacie IBAN",
    "Vaše heslo bylo úspěšně změněno.": "Hasło zostało zmienione",
    "Vaše heslo bylo úspěšně změněno. Nyní se můžete přihlásit.": "Twoje hasło zostało zmienione. Teraz możesz się zalogować.",
    "Vaše kategorie služeb byla smazána": "Twoja kategoria usług została usunięta",
    "Vaše platba proběhla v pořádku. Mockrát děkujeme, že využíváte aplikaci Fyzion.": "Twoja płatność przebiegła pomyślnie. Bardzo dziękujemy, że korzystasz z aplikacji Fyzion.",
    "Vaše platba se bohužel nezdařila. Zkuste platbu opakovat. Jestliže platba opět neproběhne v pořádku, můžete zkusit zaplatit převodem.": "Niestety Twoja płatność nie powiodła się. Proszę spróbuj dokonać płatności ponownie. Jeśli płatność ponownie się nie powiedzie, możesz spróbować zapłacić przelewem.",
    "Vaše rodné číslo potřebujeme k vytvoření vaší karty pacienta, nebo abychom ověřili, že u nás už kartu máte. S rodným číslem nakládáme v souladu s vyhláškou o zdravotnické dokumentaci.": "Twojego numeru PESEL potrzebujemy do utworzenia Twojej karty klienta lub aby sprawdzić, czy karta już u nas istnieje. Numer PESEL przetwarzamy zgodnie z rozporządzeniem dotyczącym dokumentacji medycznej.",
    "Vaše služba byla smazána": "Twoja usługa została usunięta",
    "Vaše zpráva": "Twoja wiadomość",
    "Vaši rezervaci už nelze zrušit online!": "Twojej rezerwacji nie można już anulować online!",
    "Včera": "Wczoraj",
    "včetně prodeje zboží": "łącznie ze sprzedażą towarów",
    "ve slovenštině": "po słowacku",
    "Veřejné zdravotní pojištění": "Powszechne ubezpieczenie zdrowotne",
    "Video": "Video",
    "Video a obrázky cviku": "Video i obrazy ćwiczenia",
    "Visa ikona": "ikona Visa",
    "Vítáme vás v aplikaci Fyzion": "Witamy cię w aplikacji Fyzion",
    "Vítejte na přihlašovací stránce klientského portálu CortexApp.": "Witaj na stronie logowania portalu klienta CortexApp.",
    "Vítejte v CortexApp": "Witaj CortexApp",
    "Vlastní": "Własny",
    "Vložit konečnou (zkopírovat první) zastávku": "Wstaw końcowy przystanek (skopiuj pierwszy)",
    "Vložit pod stávající zápis": "Wstawić pod istniejący wpis",
    "Vložit zastávku cesty": "Dodaj punkt na trasie",
    "Vložit zpáteční (zkopírovat předchozí) zastávku": "- Wstaw punkt powrotny (kopiuj ostatni przystanek)",
    "Volno (Dovolená)": "Wolne  Urlop)",
    "Volno odstraněno": "Wolne zostało usunięte",
    "VOP úspěšně nahrány": "Ogólne warunki zostały pomyślnie przesłane",
    "VOP úspěšně odebrány": "OWU usunięte pomyślnie",
    "Vrátit do průvodce?": "Wrócić do przewodnika?",
    "Vše": "Wszystko",
    "Všechny": "Wszystkie",
    "Všechny doklady": "Wszystkie dokumenty",
    "Všechny jeho návštěvy zůstanou nadále ve Vašem kalendáři, ale nebude již možné vytvářet nové návštěvy pacientovi ani se Vám nebude pacient nabízet v seznamu pacientů.": "Wszystkie jego wizyty pozostaną nadal w Państwa kalendarzu, jednak nie będzie już możliwe dodawanie nowych wizyt dla tego klienta, ani nie będzie się on pojawiał na liście klientów.",
    "Všechny místnosti": "Wszystkie pokoje",
    "Všechny naplánované návštěvy na této pobočce zůstanou zachovány.": "Wszystkie zaplanowane wizyty w tym oddziale zostaną utrzymane.",
    "Všechny naplánované návštěvy v této místnosti zůstanou zachovány.": "Wszystkie zaplanowane wizyty w tym pokoju zostaną utrzymane.",
    "Všechny pobočky": "Wszystkie oddziały",
    "Všechny poukazy": "Wszystkie skierowania",
    "Všechny pracoviště": "Wszystkie placówki",
    "Všechny služby": "Wszystkie usług",
    "Všechny typy služeb": "Wszystkie rodzaje usług",
    "Všeobecné obchodní podmínky": "Regulamin",
    "všeobecnými obchodními podmínkami": "regulaminem",
    "Všeobecnými obchodními podmínkami": "Regulaminem",
    "Všichni": "Wszyscy",
    "Všichni klienti": "Wszyscy klienci",
    "Všichni pacienti": "Wszyscy klienci",
    "Vyberte": "Wybierz",
    "Vyberte alespoň jednu službu": "Wybierz co najmniej jedną usługę",
    "Vyberte dokumenty": "Wybierz dokumenty",
    "Vyberte FT poukaz": "Wybierz kupon FT",
    "Vyberte kategorii služby podle jejího typu (např. masáže, skupinové cvičení). Kategorie ovlivňuje přehlednost a zobrazení služeb v online rezervacích.": "Wybierz kategorię usługi na podstawie jej rodzaju (np. masaże, ćwiczenia grupowe). Kategoria wpływa na przejrzystość i wyświetlanie usług w systemie rezerwacji online.",
    "Vyberte klienta jako náhradníka": "Wybierz klienta jako rezerwowego",
    "Vyberte obrázky": "Wybierz obrazy",
    "Vyberte pacienta": "Wybierz klienta",
    "Vyberte předplatné": "Wybierz subskrypcję",
    "Vyberte prosím alespoň 1 fotografii.": "Wybierz co najmniej 1 zdjęcie.",
    "Vyberte šablonu": "Wybierz szablon",
    "Vyberte soubor": "Wybierz plik",
    "Vyberte soubory k nahrání do systému": "Wybierz pliki do przesłania do systemu",
    "Vyberte termín": "Wybierz termin",
    "Vyberte typ poukazu": "Wybierz rodzaj kuponu",
    "Vyberte typ spisu": "Wybierz typ pliku",
    "Vyberte typ výkonu z číselníku ÚZIS. Povinné pole sloužící pro statistiky a vykazování.": "Rodzaj świadczenia wybrany z katalogu ÚZIS. Pole obowiązkowe do raportowania.",
    "Vyberte video": "Wybierz video",
    "Vyberte zboží...": "Wybierz towar...",
    "Vybraná šablona nebyla nalezena": "Nie znaleziono wybranego szablonu",
    "Vybraná šablona neobsahuje žádné výkony": "Wybrany szablon nie zawiera wyników",
    "Vybrané dávky elektronicky podepíšete v aplikaci Fyzion Signer — jedním podpisem, v němž dávky nejprve projdete. Fyzion je poté odešle zdravotní pojišťovně a o výsledku vás bude informovat e-mailem.": "Wybrane paczki podpiszesz elektronicznie w aplikacji Fyzion Signer — jednym podpisem, w którym najpierw przejrzysz paczki. Fyzion następnie wyśle je do zakładu ubezpieczeń zdrowotnych i poinformuje Cię o wyniku e-mailem.",
    "Vybrané dávky odešlete s ověřením jedním SMS kódem. Hromadně lze odeslat jen dávky pojišťoven jednoho portálu. O výsledku vás budeme informovat e-mailem.": "Wybrane paczki wyślij z weryfikacją jednym kodem SMS. Zbiorczo można wysłać tylko paczki zakładów ubezpieczeń jednego portalu. O wyniku poinformujemy Cię e-mailem.",
    "Vybrané termíny": "Wybrane terminy",
    "Vybráni všichni klienti seznamu, celkem": "Wybrano wszystkich klientów z listy, łącznie",
    "Vybráno cviků": "Wybrano ćwiczeń",
    "Vybraný terapeut neprovádí zvolenou službu. Prosím vyberte jinou službu nebo terapeuta.": "Wybrany terapeuta nie wykonuje wybranej usługi. Proszę wybrać inną usługę lub innego terapeutę.",
    "Vybrat": "Wybierz",
    "Vybrat barvu": "Wybierz kolor",
    "Vybrat barvu štítku": "Wybierz kolor etykiety",
    "Vybrat diagnózu": "Wybierz diagnozę",
    "Vybrat dodavatele": "Wybierz dostawcę",
    "Vybrat druh péče": "Wybierz rodzaj opieki",
    "Vybrat druh úhrady": "Wybierz formę płatności",
    "Vybrat IČP": "Wybierz identyfikator placówki",
    "Vybrat kategorii": "Wybierz kategorie",
    "Vybrat kód": "Wybierz kod",
    "Vybrat období": "Wybierz okres",
    "Vybrat odbornost": "Wybierz specjalizację",
    "Vybrat ostatní diagnózy": "Wybierz inne diagnozy",
    "Vybrat pacienta": "Wybierz klienta",
    "Vybrat podkategorii": "Wybierz podkategorie",
    "Vybrat pracoviště": "Wybierz placówkę",
    "Vybrat pracovníky": "Wybierz pracowników",
    "Vybrat šablonu": "Wybrać szablon",
    "Vybrat správnou kartu": "Wybierz właściwą kartę",
    "Vybrat vše": "Zaznacz wszystko",
    "Vybrat všechny klienty seznamu, celkem": "Zaznacz wszystkich klientów z listy — łącznie",
    "Vybrat výkon": "Wybierz świadczenie",
    "Výchozí": "Domyślny",
    "Výchozí šablona": "Domyślny szablon",
    "Vyčistit filtr": "Wyczyść filtr",
    "Vygenerovat fakturu": "Wygeneruj fakturę",
    "Vyhledat": "Wyszukaj",
    "Vyhledat diagnózu": "Wyszukaj diagnozę",
    "Vykázat výkon bez FT poukazu": "Wykazać wykonanie bez FT potwierdzenia",
    "Výkon": "Świadczenie",
    "Výkon je odemknutý": "Świadczenie jest otwarte",
    "Výkon je zamknutý": "Świadczenie zamknięte",
    "Výkon nelze upravit, protože je již přiřazen k návštěvě.": "Świadczenia nie można zmienić, ponieważ jest przypisane do wizyty.",
    "Výkonová": "Świadczeniowa",
    "výkonů": "świadczenia",
    "Výkonů na stránku": "Świadczeń na stronę",
    "vykony": "świadczenia",
    "Výkony": "Świadczenia",
    "Výkony nezapsané na návštěvě budou smazány.": "Świadczenia nie zapisane na wizycie będą usunięte.",
    "Vylepšení textu se nezdařilo.": "Ulepszanie tekstu nie powiodło się.",
    "Vylepšený text": "Ulepszony tekst",
    "Vylepšit s AI": "Ulepsz za pomocą AI",
    "Vylepšit zprávu": "Ulepsz wiadomość",
    "Vyplňte ve formátu +420 123 456 789": "Wypełnij w formacie +48 123 456 789",
    "Vyplňte ve formátu DD.MM.RRRR": "Wypełnij w formacie DD.MM.RRRR",
    "Vyplňte ve formátu HH:mm": "Wypełnij w formacie GG:mm",
    "Vyplňte, pokud pacient změnil pojišťovnu, abychom mohli správně vytvořit dávku.": "Wypełnij, jeśli klient zmienił ubezpieczyciela, aby było możliwe utworzenie zestawienia.",
    "Výše kreditu:": "Wysokość kredytu:",
    "Výše max. úhrady": "Wysokość maksymalnej opłaty",
    "Výše max. úhrady:": "Wysokość maksymalnej opłaty:",
    "Výše paušálu:": "Wysokość ryczałtu:",
    "Výše storno poplatku účtovaného při zrušení rezervace.": "Wysokość opłaty pobieranej przy anulowaniu rezerwacji.",
    "výskytech": "w przypadkach",
    "výskytu": "przypadku",
    "Vystavovat fakturu pro platby převodem": "Wystawiać fakturę dla płatności przelewem",
    "Vystavovat faktury místo stvrzenek": "Wystawiać faktury zamiast potwierdzeń",
    "vytisknout": "wydrukuj",
    "Vytisknout": "wydrukuj",
    "Vytváření rezervace": "Tworzenie rezerwacji",
    "Vytvoření": "Utworzenie",
    "Vytvořeno": "Utworzone",
    "Vytvořit": "Utwórz",
    "Vytvořit 3 návštěvy": "Utwórz 3 wizyty",
    "Vytvořit a tisknout": "Utwórz i wydrukuj",
    "Vytvořit dávku": "Utwórz zestawienie",
    "Vytvořit dávky": "Utwórz zestawienia",
    "Vytvořit faktury": "Utwórz faktury",
    "Vytvořit FT poukaz": "Utwórz FT pokwitowanie",
    "Vytvořit novou kategorii": "Utwórz nową kategorię",
    "Vytvořit novou podkategorii": "Utwórz nową podkategorię",
    "Vytvořit novou rezervaci": "Utwórz nową rezerwację",
    "Vytvořit novou službu": "Utwórz nową usługę",
    "Vytvořit nový cvik": "Utwórz nowe ćwiczenie",
    "Vytvořit opravnou dávku": "Utwórz zestawienie korygujące",
    "Vytvořit platbu": "Utwórz płatność",
    "Vytvořit pobočku": "Utwórz oddział",
    "Vytvořit poukaz": "Utwórz voucher",
    "Vytvořit rezervaci": "Utwórz rezerwację",
    "Vytvořit šablonu výkonů": "Utwórz szablon osiągnięć",
    "Vytvořit zprávu": "Utwórz wiadomość",
    "Využívat klientský portál": "Korzystaj z portalu klienta",
    "Vyžádat SMS kód": "Poproś o kod SMS",
    "Vyžadovat poznámku": "Wymagać notatki",
    "Vyžaduje přítomnost terapeuta": "Wymaga obecności terapeuty",
    "Vyzkoušejte Fyzion Zdarma!": "Wypróbuj Fyzion za darmo!",
    "Vyzkoušejte si Fyzion zdarma a přesvědčte se sami proč ho používá více jak 1000 fyzioterapetů v ČR. Stačí vyplnit několik údajů ve formuláři níže a můžete začít. Později můžete snadno upgradovat na vyšší tarif.": "Wypróbuj Fyzion za darmo i przekonaj się sam, dlaczego korzysta z niego ponad 3000 fizjoterapeutów. Wystarczy wypełnić kilka danych w formularzu poniżej i możesz zacząć. Później możesz łatwo przejść na wyższy pakiet.",
    "Vzdálenost (km)": "Odległość ( km)",
    "Vzdálenost od předchozí zastávky v km": "Odległość od poprzedniego przystanku w km",
    "Vždy uvádějte jméno pacienta (i v případě dítěte)": "Zawsze podawaj imię i nazwisko klienta (również w przypadku dziecka)",
    "Webinář": "Webinar",
    "white-mark": "white-mark",
    "x": "x",
    "z": "z",
    "z ceny aplikace": "z ceny aplikacji",
    "z toho v hotovosti": "z tego gotówką",
    "Z-Poukaz": "Z- voucher",
    "Začínáme": "Zaczynamy",
    "Zadané telefonní číslo je neplatné.": "Podany numer telefonu jest nieprawidłowy.",
    "zadatele": "wnioskodawcy",
    "Žadatelé": "Wnioskodawcy",
    "Žadatelé na stránku": "Wnioskodawców na stronę",
    "Zadejte název služby, kterou nabízíte (např. individuální fyzioterapie, elektroléčba, dětská fyzioterapie, zdravotní cvičení). Název se zobrazuje v kalendáři i v online rezervačním systému.": "Wprowadź nazwę oferowanej usługi (np. fizjoterapia indywidualna, elektroterapia, fizjoterapia dziecięca, ćwiczenia prozdrowotne). Nazwa będzie wyświetlana w kalendarzu i systemie rezerwacji online.",
    "Zadejte nové heslo": "Podaj nowe hasło",
    "Zadejte platnou e-mailovou adresu": "Padaj prawidłowy adres e-mail",
    "Zadejte prosím e-mail, na který Vám zašleme informace k obnovení hesla.": "Podaj e-mail, na który wyślemy dane do aktualizacji hasła.",
    "Zadejte SMS kód z portálu pojišťovny. Platný kód, který už máte, můžete použít znovu, nový si vyžádejte jen tehdy, když žádný nemáte.": "Wpisz kod SMS z portalu zakładu ubezpieczeń. Ważny kod, który już masz, możesz wykorzystać ponownie, nowy zamów tylko wtedy, gdy żadnego nie masz.",
    "Zadejte validní tel. číslo": "Wprowadź poprawny numer telefonu",
    "Žádná pobočka není k dispozici": "Żaden oddział nie jest dostępny",
    "Žádná služba není k dispozici": "Brak dostępnych usług",
    "Žádné akce k zobrazení": "Brak akcji do wyświetlenia",
    "Žádné dávky k zobrazení": "Brak zestawień do wyświetlenia",
    "Žádné doklady k zobrazení": "Brak dokumentów do wyświetlenia",
    "Žádné možnosti nebyly nalezeny": "Nie znaleziono opcji",
    "Žádné návštěvy k zobrazení": "Brak wizyt do wyświetlenia",
    "Žádné stvrzenky k zobrazení": "Brak potwierdzeń do wyświetlenia",
    "Žádné výkony k zobrazení": "Brak świadczeń do wyświetlenia",
    "Žádné výsledky": "Brak wyników",
    "Žádné zpráva k zobrazení": "Brak wiadomości do wyświetlenia",
    "Žádný fyzioterapeut není dostupný": "Brak dostępnych fizjoterapeutów",
    "Žádný typ služby není k dispozici": "Żaden typ usługi nie jest dostępny",
    "Zahrnuté služby": "Uwzględnione usługi",
    "Základní diagnóza": "POdstawowa diagnoza",
    "Zákonný zástupce": "Opiekun prawny",
    "Zákonný zástupce:": "Opiekun prawny:",
    "Zákres": "Zakres",
    "Zaměstnanci": "Pracownicy",
    "Zaměstnanec": "Pracownik",
    "Zamezit online rezervace:": "Zablokować rezerwacje online:",
    "Zamknutou návštěvu nelze měnit.": "Zablokowanej wizyty nie można zmieniać.",
    "Zaplaceno": "Zapłacone",
    "Zaplaceno:": "Zapłacone:",
    "zaplatit": "zapłacić",
    "Zaplatit": "Zapłacić",
    "Zaplatit permanentkou": "Zapłacić karnetem",
    "Zaplatit pomocí QR kódu": "Zapłać przy pomocy QR kodu",
    "Zaplatit QR kódem": "Zapłać kodem QR",
    "Zaplaťte pomocí QR kódu": "Zapłać przy użyciu kodu QR",
    "Zaplaťte předplatným, jestliže ho některá instituce poskytuje": "Opłać subskrypcję, jeśli jest ona udostępniana przez którąś instytucję",
    "Zapnutím povolíte klientům rušení rezervací této služby.": "Włączając tę opcję, zezwalasz klientom na anulowanie rezerwacji tej usługi.",
    "Zapnutím povolíte zobrazování služby v online rezervačním systému. Bez zapnutí nebude možné službu rezervovat online.": "Umożliwia wyświetlanie usługi w systemie rezerwacji online. Bez aktywacji nie będzie można zarezerwować usługi online.",
    "Zapnutím této funkce aktivujete integraci s McKenzie formuláři. Toto nastavení nelze po aktivaci vypnout.": "Włączeniem tej funkcji aktywujesz integrację z formularzami McKenziego. Po włączeniu tego ustawienia nie można go wyłączyć.",
    "Zapomněli jste heslo?": "Zapomniałeś hasła?",
    "Zapsáno": "Zapisane",
    "Zapsat cestu": "Zapisz trasę",
    "Zapsat výkon": "Zapisz śwadczenie",
    "zásadami zpracování osobních údajů": "zasadami przetwarzania danych osobowych",
    "Zásob na stránku": "Ilość produktów na stronę",
    "zasoby": "zasoby",
    "Zásoby": "Zasoby",
    "Zásoby na skladě": "Zasoby w magazynie",
    "Zastávka": "Przystanek",
    "Zatím nebyl nahrán žádný dokument.": "Nie został jeszcze zapisany żaden dokoment.",
    "Zatím nebyla nahrána žádná videa.": "Żaden film nie został jeszcze zapisany.",
    "Zatím nebyly nahrány žádné obrázky.": "Żadne obrazy nie zostały jeszcze zapisane.",
    "Zatím nebyly vytvořeny žádné permanentky": "Żadne kranety nie zostały jeszcze utworzone",
    "Zatím nejsou nahrána žádná videa.": "Żadne filmy nie są zapisane.",
    "Zatím nejsou naplánovány žádné cviky.": "Nie zaplanowano jeszcze żadnych ćwiczeń.",
    "Zatím nejsou žádné recenze.": "Nie ma jeszcze żadnych opinii.",
    "Zatím nemáte naplánované žádné pacienty": "Nie masz jeszcze zaplanowanych klientów",
    "Zatím zde nejsou žádné cviky": "Nie ma tu jeszcze żadnych ćwiczeń",
    "Zatím zde nejsou žádné položky": "Nie ma tu jeszcze żadnych pozycji",
    "Zatím zde nejsou žádné předplatné": "Nie ma tu jeszcze żadnych subskrypcji",
    "Zatím zde nejsou žádné proběhlé návštěvy": "Nie ma tu jeszcze żadnych odbytych wizyt",
    "Zatím zde nejsou žádné šablony": "Nie ma tu jeszcze żadnych szablonów",
    "Zatím zde nejsou žádné služby": "Nie ma tu jezcze żadnych usług",
    "Zatím zde nejsou žádné spisy": "Na razie nie ma tutaj żadnych akt",
    "Zatím zde nejsou žádné zásoby": "Nie ma tu jeszcze żadnych zasobów",
    "Zatím zde nejsou žádné záznamy": "Na razie nie ma tutaj żadnych zapisów",
    "Zatím zde nejsou žádní dodavatelé": "Nie ma tu jeszcze żadnych dostawców",
    "Zatím zde nejsou žádní pacienti": "Nie ma tu jeszcze żadnych klientów",
    "Zavolat do ordinace": "Zadzwoń do gabinetu",
    "Zavolat na číslo": "Zadzwonić na numer",
    "Zavolejte nám na telefon:": "Zadzwoń do nas na numer telefonu:",
    "Zavřeno": "Zamknięte",
    "Zavřít": "Zamknij",
    "Zavřít menu": "Zaknij menu",
    "Zavřít platbu": "Zamknij płatność",
    "Zavřít zboží": "Zamknij towar",
    "Záznamů na stránku": "Liczba rekordów na stronę",
    "zaznamy": "zapisy",
    "Zboží": "Towar",
    "Zboží bylo úspěšně naskladněno": "Towar został przyjęty na stan",
    "Zboží se nepodařilo naskladnit": "Nie powiodło się przyjęcie towaru na stan",
    "Zbývající počet znaků": "Pozostała liczba znaków",
    "Zbývajících vstupů": "Pozostałych wejść",
    "Zdá se, že nám hledaná": "Wygląda na to, że poszukiwana przez nas",
    "Zdarma": "Za darmo",
    "ZDARMA": "ZA DARMO",
    "ZDE": "TUTAJ",
    "Zde můžete nahrát dokumenty, které se týkají vybraného profilu.": "Tutaj możesz przesłać dokumenty dotyczące wybranego profilu.",
    "Zde prosím nahrajte svá data, která chcete nahrát do systému.": "Prześlij tutaj dane do zaimportowania do systemu.",
    "Zde se zobrazují všechny dokumenty, které jste v rámci návštěv daného pacienta nahráli": "Tutaj wyświetlane są wszystkie dokumenty, które zostały przesłane w ramach wizyt danego klienta.",
    "Zdravotní pojišťovna": "Ubezpieczalnia zdrowotna",
    "Zdravotní pojišťovna podání odmítla, protože certifikát, kterým byla dávka podepsána, není zaveden u vašeho účtu na jejím portále. Podepište podání certifikátem, který máte na portále zdravotní pojišťovny zavedený, a dávku odešlete znovu.": "Zakład ubezpieczeń zdrowotnych odrzucił zgłoszenie, ponieważ certyfikat, którym podpisano paczkę, nie jest zarejestrowany na Twoim koncie na jego portalu. Podpisz zgłoszenie certyfikatem zarejestrowanym na portalu zakładu ubezpieczeń zdrowotnych i wyślij paczkę ponownie.",
    "Zdravotní pojišťovna podání odmítla, protože SMS kód byl neplatný nebo mu vypršela platnost. Vyžádejte si nový kód a dávku odešlete znovu.": "Zakład ubezpieczeń zdrowotnych odrzucił zgłoszenie, ponieważ kod SMS był nieprawidłowy lub wygasł. Zamów nowy kod i wyślij paczkę ponownie.",
    "Zelená": "Zielona",
    "Země": "Kraj",
    "Žena": "Kobieta",
    "Ženy": "Kobiety",
    "Ženy (budoucí)": "Kobiety ( przyszłe)",
    "Zjistit více": "Dowiedz się więcej",
    "Zkontrolujte prosím zadanou adresu v prohlížeči.": "Sprawdź proszę adres wpisany w przeglądarce.",
    "Zkopírováno": "Skopiowane",
    "Zkopírovat": "Kopiuj",
    "Zkopírovat kód": "Skopiuj kod",
    "Zkopírovat odkaz do schránky": "Kopiuj link do schowka",
    "Zkopírovat odkaz na rezervaci této služby": "Kpiuj link do rezerwacji tej usługi",
    "Zkuste to znovu": "Spróbuj ponownie",
    "Žlutá": "Żółta",
    "Změna hesla": "Zmiana hasła",
    "Změna se nezdařila. Prosím zkontrolujte údaje ve formuláři": "Zmiana się nie powiodła. Sprawdź dane wprowadzone w formularzu",
    "Změna tarifu není možná": "Zmiana taryfy jest niemożliwa",
    "Změnit": "Zmień",
    "Změnit heslo": "Zmień hasło",
    "Změnit konfiguraci": "Zmień konfigurację",
    "Změnit stav": "Zmień stan",
    "Změnit stav na „%{status}“?": "Zmienić status na „%{status}”?",
    "Změnit typ platby nebo částku můžete v editaci plateb.": "Formę płatności lub kwotę możesz w edycji płatności.",
    "Zobrazit": "Wyświetl",
    "Zobrazit méně": "Wyświetl mniej",
    "Zobrazit starší": "Wyświetl starsze",
    "Zobrazit všechny recenze": "Pokaż wszystkie opinie",
    "Zobrazit všechny zaměstnance": "Pokaż wszystkich pracowników",
    "Zobrazovat bloky v kalendáři po 15 minutách": "Wyświetlać bloki w kalendarzu co 15 minut",
    "Zobrazovat jednotlivé terapeuty v online rezervačním systému": "Wyświetlać poszczególnych terapeutów w systemie rezerwacji online",
    "Zobrazovat jména ve formátu PŘÍJMENÍ JMÉNO v kartotéce": "Pokazywać imiona w formacie NAZWISKO IMIĘ w kartotece",
    "zpět": "wstecz",
    "Zpět": "Wstecz",
    "Zpět do aplikace": "Wstecz do aplikacji",
    "Zpět na cviky": "Wstecz do ćwiczeń",
    "Zpět na přihlášení": "Wstecz do logowania",
    "Zpět na seznam dávek": "Wstecz do listy zestawień",
    "Zpráva od terapeuta": "Wiadomość do terapeuty",
    "zpravy": "wiadomości",
    "Způsob platby": "Forma płatności",
    "Způsob platby při rezervaci online": "Sposób płatności przy rezerwacji online",
    "Zrušená fakturace": "Anulowana fakturacja",
    "Zrušená návštěva klienta": "Anulowana wizyta klienta",
    "Zrušení rezervace": "Anulowanie rezerwacji",
    "Zrušení rezervací se bude řídit obecným nastavením firmy.": "Anulowanie rezerwacji odbywa się zgodnie z ogólnymi ustawieniami firmy.",
    "Zrušení se storno poplatkem": "Anulowanie z opłatą za anulowanie",
    "Zrušení se storno poplatkem (před návštěvou)": "Anulowanie z opłatą manipulacyjną (przed wizytą)",
    "Zrušením platby stornujete vytvořenou stvrzenku, vrátíte vstup na permanentku nebo vrátíte kredity na předplatné. Záleží na předchozím typu platby.": "Anulowanie płatności powoduje unieważnienie wystawionego potwierdzenia, zwrot wejścia na karnet lub zwrot kredytów za subskrypcję.",
    "Zrušeno": "Anulowano",
    "Zrušeno terapeutem": "Odwołane przez terapeutę",
    "Zrušit": "Anuluj",
    "Zrušit dle storno podmínek": "Anulować zgodnie z warunkami anulowania",
    "ZRUŠIT FILTR": "USUŃ FILTR",
    "Zrušit návštěvu": "Anuluj wizytę",
    "Zrušit platbu": "Anuluj płatność",
    "Zrušit přijetí": "Anuluj przyjęcie",
    "Zrušit rezervaci": "Anuluj rezerwację",
    "Zůstat na stránce": "Zostań na stronie",
    "Zvolit": "Wybierz",
    "Zvolit fyzioterapeuta": "Wybrać fizjoterapeutę",
    "Zvolit pobočku": "Wybierz oddział",
    "Zvolit službu": "Wybierz usługę",
    "Zvolit typ služby": "Wybierz rodzaj usługi",
    "Zvolte alespoň jeden výkon": "Wybierz co najmniej jedno świadczenie",
    "Zvolte alespoň jednu pojišťovnu": "Wybierz co najmniej jedną ubezpieczalnię",
    "Zvolte ANO, pokud spolupracujete s pojišťovnami. Umožníme vám zapisování výkonů a tvorbu dávek a faktur.": "Wybierz TAK, jeśli współpracujesz z ubezpieczycielami. Pozwolimy Ci na rejestrowanie świadczeń oraz tworzenie zestawień i faktur",
    "Zvolte barvu, kterou bude služba označena v kalendáři a rezervačním systému.": "Kolor oznaczający usługę w kalendarzu i systemie rezerwacji.",
    "Zvolte čas": "Wybierz czas",
    "Zvolte datum": "Wybierz datę",
    "Zobrazovat jméno vyšetřujícího v dokumentech": "Pokazuj imię i nazwisko badającego w dokumentach",
    "Platí pro dokument návštěvy a kartu klienta. Pokud je zapnuto, zobrazí se u každé návštěvy, kdo ji vyšetřil.": "Dotyczy dokumentu wizyty i karty klienta. Jeśli włączone, przy każdej wizycie będzie widoczne, kto przeprowadził badanie.",
    "Hrazeno pojišťovnou": "Opłacone przez ubezpieczyciela"
  }
}
